/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://oss.huaxing.com/www-public/asset/build-44107/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by qingzhui on 16/12/31.
	 */
	
	__webpack_require__(175);
	
	var Highcharts = __webpack_require__(18);
	
	var up = __webpack_require__(20);
	var down = __webpack_require__(19);
	
	var common = __webpack_require__(9);
	
	var $ = __webpack_require__(2);
	
	$(function () {
	
	    $(window).scroll(function () {
	        //检测滚走的高度
	        var scrollT = $(document).scrollTop();
	        //当滚走的高度>=400(天蓝色色块的上边距)，
	        //显示返回顶部(.back)，否则隐藏返回顶部
	        //获取蓝色色块(container)距离文档顶部的距离
	        var offsetT = $("body").offset().top;
	        //进行判断
	        if (scrollT > offsetT) {
	            $(".scoll").show();
	        } else {
	            $(".scoll").hide();
	        }
	    });
	
	    //点击返回顶部，页面滚走的距离设置为0
	    $(".scoll").click(function () {
	        //生硬的返回
	        // $(document).scrollTop(0)
	        //动感的返回
	        //animate({键:值},时间) 属性：scrollTop---必须是被元素调用
	        $("html,body").animate({
	            scrollTop: 0
	        }, 1000);
	    });
	    // // 查看更多
	    // var isClick = false;
	
	    // var con1 = $('.m-business .btn-more').prev().html();
	
	    // var langInput = document.getElementById('lang');
	    // var lang = langInput ? langInput.value : undefined;
	
	    // var baseUrl = common.baseUrl();
	    // var $memberList = $('.m-leadership #list');
	
	    // // 请求的所有地址
	    // var ajaxUrl = {
	    //     memberList: baseUrl + 'v1/member?lang=' + lang
	    // };
	
	    var baseUrl = common.baseUrl();
	    var ajaxUrl = baseUrl + 'v1/ir/stock/price/history';
	    var ajaxUrlPrice = baseUrl + 'v1/ir/stock/price';
	
	    $.ajax({
	        url: ajaxUrl,
	        type: 'get',
	        dataType: 'json',
	        success: function success(data) {
	            if (!data.status) {
	                alert('读取股票数据失败！');
	                return false;
	            }
	            data = data.result.data;
	            var ohlc = [],
	                volume = [],
	                dataLength = data.length,
	                groupingUnits = [['week', [1]], ['month', [1, 2, 3, 4, 6]]],
	                i = 0;
	            for (i; i < dataLength; i += 1) {
	                ohlc.push([data[i][0], // the date
	                data[i][1], // open
	                data[i][2], // high
	                data[i][3], // low
	                data[i][4] // close
	                ]);
	                volume.push([data[i][0], // the date
	                data[i][5] // the volume
	                ]);
	            }
	            // create the chart
	            var chart = Highcharts.stockChart('containerChart', {
	                rangeSelector: {
	                    selected: 1,
	                    inputDateFormat: '%Y-%m-%d'
	                },
	
	                xAxis: {
	                    dateTimeLabelFormats: {
	                        millisecond: '%H:%M:%S.%L',
	                        second: '%H:%M:%S',
	                        minute: '%H:%M',
	                        hour: '%H:%M',
	                        day: '%m-%d',
	                        week: '%m-%d',
	                        month: '%y-%m',
	                        year: '%Y'
	                    }
	                },
	                tooltip: {
	                    split: false,
	                    shared: true
	                },
	                yAxis: [{
	                    labels: {
	                        align: 'right',
	                        x: -3
	                    },
	                    title: {
	                        text: '股价'
	                    },
	                    height: '65%',
	                    resize: {
	                        enabled: true
	                    },
	                    lineWidth: 2
	                }, {
	                    labels: {
	                        align: 'right',
	                        x: -3
	                    },
	                    title: {
	                        text: '成交量'
	                    },
	                    top: '65%',
	                    height: '35%',
	                    offset: 0,
	                    lineWidth: 2
	                }],
	                credits: { enabled: false },
	                series: [{
	                    type: 'candlestick',
	                    name: '华兴资本',
	                    color: 'red',
	                    lineColor: 'red',
	                    upColor: 'green',
	                    upLineColor: 'green',
	                    tooltip: {},
	                    navigatorOptions: {
	                        color: Highcharts.getOptions().colors[0]
	                    },
	                    data: ohlc,
	                    dataGrouping: {
	                        units: groupingUnits
	                    },
	                    id: 'sz'
	                }, {
	                    type: 'column',
	                    data: volume,
	                    yAxis: 1,
	                    dataGrouping: {
	                        units: groupingUnits
	                    }
	                }]
	            });
	        },
	        error: function error(msg) {
	            console.log(msg);
	        }
	    });
	
	    $.ajax({
	        url: ajaxUrlPrice,
	        type: 'get',
	        dataType: 'json',
	        success: function success(data) {
	            if (!data.status) {
	                alert('读取股票报价失败！');
	                return false;
	            }
	            console.log(data.result, 'url');
	
	            var res = data.result;
	
	            var today = '<span  class="smw-market-data-field smw-field-summaryDetail-dayHigh">' + res.regularMarketDayRange + '</span>';
	            var weeks = '<span  class="smw-market-data-field smw-field-summaryDetail-dayHigh">' + res.fiftyTwoWeekRange + '</span>';
	            var marketValue = '<spanclass="smw-market-data-field smw-field-summaryDetail-dayHigh">' + res.marketCap.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + '</span>';
	            var money = '<span  class="smw-market-data-field smw-field-defaultKeyStatistics-sharesOutstanding">' + res.sharesOutstanding.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + '</span>';
	            var amount = '<span  class="smw-market-data-field smw-field-quote-regularMarketVolume">' + res.regularMarketVolume.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + '</span>';
	
	            var symbol = res.symbol;
	            var currency = res.currency;
	            var regularMarketPrice = res.regularMarketPrice;
	            var regularMarketChange = res.regularMarketChange.toFixed(2);
	            var regularMarketChangePercent = res.regularMarketChangePercent.toFixed(2) + '%';
	
	            var icon = res.regularMarketChangePercent > 0 ? '<img  src=' + up + ' alt=""></img>' : '<img src=' + down + ' alt=""></img>';
	
	            res.regularMarketChangePercent < 0 ? $('.smw-rise').addClass('active') : null;
	
	            $('.today').html(today);
	            $('.weeks').html(weeks);
	            $('.marketValue').html(marketValue);
	            $('.money').html(money);
	            $('.amount').html(amount);
	            $('.symbol').html(symbol);
	            $('.currency').html(currency);
	            $('.regularMarketPrice').html(regularMarketPrice);
	            $('.regularMarketChange').html(regularMarketChange);
	            $('.regularMarketChangePercent').html(regularMarketChangePercent);
	            $('.icons').html(icon);
	        },
	        error: function error(msg) {
	            console.log(msg);
	        }
	    });
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	//使用当前的变量的文件包括： mobile.js\common.js，m-index.js,m-common.js,index.ejs
	//视频路径
	//http://website.chinarenaissance.com/
	var api = {
	    pcApi: 'https://website.huaxing.com/',
	    webApi: 'https://website.huaxing.com/',
	    // 视频链接
	    pcVideo: 'https://www.huaxing.com/',
	    webVideo: 'https://www.huaxing.com/',
	    // minio url
	    minioUrl: 'https://oss.huaxing.com/www-public'
	};
	if (process.env.API_ENV === 'test') {
	    api = {
	        pcApi: 'https://website-test.huaxing.com/',
	        webApi: 'https://website-test.huaxing.com/',
	        // 视频链接
	        pcVideo: 'https://www.huaxing.com/',
	        webVideo: 'https://www.huaxing.com/',
	        // minio url
	        minioUrl: 'https://oss-test.huaxing.com/www-public'
	    };
	}
	
	exports.api = api;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*!
	 * Bootstrap v3.4.1 (https://getbootstrap.com/)
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");!function(t){"use strict";var e=jQuery.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||3<e[0])throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(),function(n){"use strict";n.fn.emulateTransitionEnd=function(t){var e=!1,i=this;n(this).one("bsTransitionEnd",function(){e=!0});return setTimeout(function(){e||n(i).trigger(n.support.transition.end)},t),this},n(function(){n.support.transition=function o(){var t=document.createElement("bootstrap"),e={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var i in e)if(t.style[i]!==undefined)return{end:e[i]};return!1}(),n.support.transition&&(n.event.special.bsTransitionEnd={bindType:n.support.transition.end,delegateType:n.support.transition.end,handle:function(t){if(n(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}})})}(jQuery),function(s){"use strict";var e='[data-dismiss="alert"]',a=function(t){s(t).on("click",e,this.close)};a.VERSION="3.4.1",a.TRANSITION_DURATION=150,a.prototype.close=function(t){var e=s(this),i=e.attr("data-target");i||(i=(i=e.attr("href"))&&i.replace(/.*(?=#[^\s]*$)/,"")),i="#"===i?[]:i;var o=s(document).find(i);function n(){o.detach().trigger("closed.bs.alert").remove()}t&&t.preventDefault(),o.length||(o=e.closest(".alert")),o.trigger(t=s.Event("close.bs.alert")),t.isDefaultPrevented()||(o.removeClass("in"),s.support.transition&&o.hasClass("fade")?o.one("bsTransitionEnd",n).emulateTransitionEnd(a.TRANSITION_DURATION):n())};var t=s.fn.alert;s.fn.alert=function o(i){return this.each(function(){var t=s(this),e=t.data("bs.alert");e||t.data("bs.alert",e=new a(this)),"string"==typeof i&&e[i].call(t)})},s.fn.alert.Constructor=a,s.fn.alert.noConflict=function(){return s.fn.alert=t,this},s(document).on("click.bs.alert.data-api",e,a.prototype.close)}(jQuery),function(s){"use strict";var n=function(t,e){this.$element=s(t),this.options=s.extend({},n.DEFAULTS,e),this.isLoading=!1};function i(o){return this.each(function(){var t=s(this),e=t.data("bs.button"),i="object"==typeof o&&o;e||t.data("bs.button",e=new n(this,i)),"toggle"==o?e.toggle():o&&e.setState(o)})}n.VERSION="3.4.1",n.DEFAULTS={loadingText:"loading..."},n.prototype.setState=function(t){var e="disabled",i=this.$element,o=i.is("input")?"val":"html",n=i.data();t+="Text",null==n.resetText&&i.data("resetText",i[o]()),setTimeout(s.proxy(function(){i[o](null==n[t]?this.options[t]:n[t]),"loadingText"==t?(this.isLoading=!0,i.addClass(e).attr(e,e).prop(e,!0)):this.isLoading&&(this.isLoading=!1,i.removeClass(e).removeAttr(e).prop(e,!1))},this),0)},n.prototype.toggle=function(){var t=!0,e=this.$element.closest('[data-toggle="buttons"]');if(e.length){var i=this.$element.find("input");"radio"==i.prop("type")?(i.prop("checked")&&(t=!1),e.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==i.prop("type")&&(i.prop("checked")!==this.$element.hasClass("active")&&(t=!1),this.$element.toggleClass("active")),i.prop("checked",this.$element.hasClass("active")),t&&i.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var t=s.fn.button;s.fn.button=i,s.fn.button.Constructor=n,s.fn.button.noConflict=function(){return s.fn.button=t,this},s(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(t){var e=s(t.target).closest(".btn");i.call(e,"toggle"),s(t.target).is('input[type="radio"], input[type="checkbox"]')||(t.preventDefault(),e.is("input,button")?e.trigger("focus"):e.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(t){s(t.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(t.type))})}(jQuery),function(p){"use strict";var c=function(t,e){this.$element=p(t),this.$indicators=this.$element.find(".carousel-indicators"),this.options=e,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",p.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",p.proxy(this.pause,this)).on("mouseleave.bs.carousel",p.proxy(this.cycle,this))};function r(n){return this.each(function(){var t=p(this),e=t.data("bs.carousel"),i=p.extend({},c.DEFAULTS,t.data(),"object"==typeof n&&n),o="string"==typeof n?n:i.slide;e||t.data("bs.carousel",e=new c(this,i)),"number"==typeof n?e.to(n):o?e[o]():i.interval&&e.pause().cycle()})}c.VERSION="3.4.1",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(t){if(!/input|textarea/i.test(t.target.tagName)){switch(t.which){case 37:this.prev();break;case 39:this.next();break;default:return}t.preventDefault()}},c.prototype.cycle=function(t){return t||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(p.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(t){return this.$items=t.parent().children(".item"),this.$items.index(t||this.$active)},c.prototype.getItemForDirection=function(t,e){var i=this.getItemIndex(e);if(("prev"==t&&0===i||"next"==t&&i==this.$items.length-1)&&!this.options.wrap)return e;var o=(i+("prev"==t?-1:1))%this.$items.length;return this.$items.eq(o)},c.prototype.to=function(t){var e=this,i=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(t>this.$items.length-1||t<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){e.to(t)}):i==t?this.pause().cycle():this.slide(i<t?"next":"prev",this.$items.eq(t))},c.prototype.pause=function(t){return t||(this.paused=!0),this.$element.find(".next, .prev").length&&p.support.transition&&(this.$element.trigger(p.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(t,e){var i=this.$element.find(".item.active"),o=e||this.getItemForDirection(t,i),n=this.interval,s="next"==t?"left":"right",a=this;if(o.hasClass("active"))return this.sliding=!1;var r=o[0],l=p.Event("slide.bs.carousel",{relatedTarget:r,direction:s});if(this.$element.trigger(l),!l.isDefaultPrevented()){if(this.sliding=!0,n&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var h=p(this.$indicators.children()[this.getItemIndex(o)]);h&&h.addClass("active")}var d=p.Event("slid.bs.carousel",{relatedTarget:r,direction:s});return p.support.transition&&this.$element.hasClass("slide")?(o.addClass(t),"object"==typeof o&&o.length&&o[0].offsetWidth,i.addClass(s),o.addClass(s),i.one("bsTransitionEnd",function(){o.removeClass([t,s].join(" ")).addClass("active"),i.removeClass(["active",s].join(" ")),a.sliding=!1,setTimeout(function(){a.$element.trigger(d)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(i.removeClass("active"),o.addClass("active"),this.sliding=!1,this.$element.trigger(d)),n&&this.cycle(),this}};var t=p.fn.carousel;p.fn.carousel=r,p.fn.carousel.Constructor=c,p.fn.carousel.noConflict=function(){return p.fn.carousel=t,this};var e=function(t){var e=p(this),i=e.attr("href");i&&(i=i.replace(/.*(?=#[^\s]+$)/,""));var o=e.attr("data-target")||i,n=p(document).find(o);if(n.hasClass("carousel")){var s=p.extend({},n.data(),e.data()),a=e.attr("data-slide-to");a&&(s.interval=!1),r.call(n,s),a&&n.data("bs.carousel").to(a),t.preventDefault()}};p(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),p(window).on("load",function(){p('[data-ride="carousel"]').each(function(){var t=p(this);r.call(t,t.data())})})}(jQuery),function(a){"use strict";var r=function(t,e){this.$element=a(t),this.options=a.extend({},r.DEFAULTS,e),this.$trigger=a('[data-toggle="collapse"][href="#'+t.id+'"],[data-toggle="collapse"][data-target="#'+t.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};function n(t){var e,i=t.attr("data-target")||(e=t.attr("href"))&&e.replace(/.*(?=#[^\s]+$)/,"");return a(document).find(i)}function l(o){return this.each(function(){var t=a(this),e=t.data("bs.collapse"),i=a.extend({},r.DEFAULTS,t.data(),"object"==typeof o&&o);!e&&i.toggle&&/show|hide/.test(o)&&(i.toggle=!1),e||t.data("bs.collapse",e=new r(this,i)),"string"==typeof o&&e[o]()})}r.VERSION="3.4.1",r.TRANSITION_DURATION=350,r.DEFAULTS={toggle:!0},r.prototype.dimension=function(){return this.$element.hasClass("width")?"width":"height"},r.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var t,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(t=e.data("bs.collapse"))&&t.transitioning)){var i=a.Event("show.bs.collapse");if(this.$element.trigger(i),!i.isDefaultPrevented()){e&&e.length&&(l.call(e,"hide"),t||e.data("bs.collapse",null));var o=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[o](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var n=function(){this.$element.removeClass("collapsing").addClass("collapse in")[o](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return n.call(this);var s=a.camelCase(["scroll",o].join("-"));this.$element.one("bsTransitionEnd",a.proxy(n,this)).emulateTransitionEnd(r.TRANSITION_DURATION)[o](this.$element[0][s])}}}},r.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var t=a.Event("hide.bs.collapse");if(this.$element.trigger(t),!t.isDefaultPrevented()){var e=this.dimension();this.$element[e](this.$element[e]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var i=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};if(!a.support.transition)return i.call(this);this.$element[e](0).one("bsTransitionEnd",a.proxy(i,this)).emulateTransitionEnd(r.TRANSITION_DURATION)}}},r.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},r.prototype.getParent=function(){return a(document).find(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(t,e){var i=a(e);this.addAriaAndCollapsedClass(n(i),i)},this)).end()},r.prototype.addAriaAndCollapsedClass=function(t,e){var i=t.hasClass("in");t.attr("aria-expanded",i),e.toggleClass("collapsed",!i).attr("aria-expanded",i)};var t=a.fn.collapse;a.fn.collapse=l,a.fn.collapse.Constructor=r,a.fn.collapse.noConflict=function(){return a.fn.collapse=t,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(t){var e=a(this);e.attr("data-target")||t.preventDefault();var i=n(e),o=i.data("bs.collapse")?"toggle":e.data();l.call(i,o)})}(jQuery),function(a){"use strict";var r='[data-toggle="dropdown"]',o=function(t){a(t).on("click.bs.dropdown",this.toggle)};function l(t){var e=t.attr("data-target");e||(e=(e=t.attr("href"))&&/#[A-Za-z]/.test(e)&&e.replace(/.*(?=#[^\s]*$)/,""));var i="#"!==e?a(document).find(e):null;return i&&i.length?i:t.parent()}function s(o){o&&3===o.which||(a(".dropdown-backdrop").remove(),a(r).each(function(){var t=a(this),e=l(t),i={relatedTarget:this};e.hasClass("open")&&(o&&"click"==o.type&&/input|textarea/i.test(o.target.tagName)&&a.contains(e[0],o.target)||(e.trigger(o=a.Event("hide.bs.dropdown",i)),o.isDefaultPrevented()||(t.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",i)))))}))}o.VERSION="3.4.1",o.prototype.toggle=function(t){var e=a(this);if(!e.is(".disabled, :disabled")){var i=l(e),o=i.hasClass("open");if(s(),!o){"ontouchstart"in document.documentElement&&!i.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",s);var n={relatedTarget:this};if(i.trigger(t=a.Event("show.bs.dropdown",n)),t.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),i.toggleClass("open").trigger(a.Event("shown.bs.dropdown",n))}return!1}},o.prototype.keydown=function(t){if(/(38|40|27|32)/.test(t.which)&&!/input|textarea/i.test(t.target.tagName)){var e=a(this);if(t.preventDefault(),t.stopPropagation(),!e.is(".disabled, :disabled")){var i=l(e),o=i.hasClass("open");if(!o&&27!=t.which||o&&27==t.which)return 27==t.which&&i.find(r).trigger("focus"),e.trigger("click");var n=i.find(".dropdown-menu li:not(.disabled):visible a");if(n.length){var s=n.index(t.target);38==t.which&&0<s&&s--,40==t.which&&s<n.length-1&&s++,~s||(s=0),n.eq(s).trigger("focus")}}}};var t=a.fn.dropdown;a.fn.dropdown=function e(i){return this.each(function(){var t=a(this),e=t.data("bs.dropdown");e||t.data("bs.dropdown",e=new o(this)),"string"==typeof i&&e[i].call(t)})},a.fn.dropdown.Constructor=o,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=t,this},a(document).on("click.bs.dropdown.data-api",s).on("click.bs.dropdown.data-api",".dropdown form",function(t){t.stopPropagation()}).on("click.bs.dropdown.data-api",r,o.prototype.toggle).on("keydown.bs.dropdown.data-api",r,o.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",o.prototype.keydown)}(jQuery),function(a){"use strict";var s=function(t,e){this.options=e,this.$body=a(document.body),this.$element=a(t),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.fixedContent=".navbar-fixed-top, .navbar-fixed-bottom",this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};function r(o,n){return this.each(function(){var t=a(this),e=t.data("bs.modal"),i=a.extend({},s.DEFAULTS,t.data(),"object"==typeof o&&o);e||t.data("bs.modal",e=new s(this,i)),"string"==typeof o?e[o](n):i.show&&e.show(n)})}s.VERSION="3.4.1",s.TRANSITION_DURATION=300,s.BACKDROP_TRANSITION_DURATION=150,s.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},s.prototype.toggle=function(t){return this.isShown?this.hide():this.show(t)},s.prototype.show=function(i){var o=this,t=a.Event("show.bs.modal",{relatedTarget:i});this.$element.trigger(t),this.isShown||t.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){o.$element.one("mouseup.dismiss.bs.modal",function(t){a(t.target).is(o.$element)&&(o.ignoreBackdropClick=!0)})}),this.backdrop(function(){var t=a.support.transition&&o.$element.hasClass("fade");o.$element.parent().length||o.$element.appendTo(o.$body),o.$element.show().scrollTop(0),o.adjustDialog(),t&&o.$element[0].offsetWidth,o.$element.addClass("in"),o.enforceFocus();var e=a.Event("shown.bs.modal",{relatedTarget:i});t?o.$dialog.one("bsTransitionEnd",function(){o.$element.trigger("focus").trigger(e)}).emulateTransitionEnd(s.TRANSITION_DURATION):o.$element.trigger("focus").trigger(e)}))},s.prototype.hide=function(t){t&&t.preventDefault(),t=a.Event("hide.bs.modal"),this.$element.trigger(t),this.isShown&&!t.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(s.TRANSITION_DURATION):this.hideModal())},s.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(t){document===t.target||this.$element[0]===t.target||this.$element.has(t.target).length||this.$element.trigger("focus")},this))},s.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(t){27==t.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},s.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},s.prototype.hideModal=function(){var t=this;this.$element.hide(),this.backdrop(function(){t.$body.removeClass("modal-open"),t.resetAdjustments(),t.resetScrollbar(),t.$element.trigger("hidden.bs.modal")})},s.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},s.prototype.backdrop=function(t){var e=this,i=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var o=a.support.transition&&i;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+i).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(t){this.ignoreBackdropClick?this.ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide())},this)),o&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!t)return;o?this.$backdrop.one("bsTransitionEnd",t).emulateTransitionEnd(s.BACKDROP_TRANSITION_DURATION):t()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var n=function(){e.removeBackdrop(),t&&t()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",n).emulateTransitionEnd(s.BACKDROP_TRANSITION_DURATION):n()}else t&&t()},s.prototype.handleUpdate=function(){this.adjustDialog()},s.prototype.adjustDialog=function(){var t=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&t?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!t?this.scrollbarWidth:""})},s.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},s.prototype.checkScrollbar=function(){var t=window.innerWidth;if(!t){var e=document.documentElement.getBoundingClientRect();t=e.right-Math.abs(e.left)}this.bodyIsOverflowing=document.body.clientWidth<t,this.scrollbarWidth=this.measureScrollbar()},s.prototype.setScrollbar=function(){var t=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"";var n=this.scrollbarWidth;this.bodyIsOverflowing&&(this.$body.css("padding-right",t+n),a(this.fixedContent).each(function(t,e){var i=e.style.paddingRight,o=a(e).css("padding-right");a(e).data("padding-right",i).css("padding-right",parseFloat(o)+n+"px")}))},s.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad),a(this.fixedContent).each(function(t,e){var i=a(e).data("padding-right");a(e).removeData("padding-right"),e.style.paddingRight=i||""})},s.prototype.measureScrollbar=function(){var t=document.createElement("div");t.className="modal-scrollbar-measure",this.$body.append(t);var e=t.offsetWidth-t.clientWidth;return this.$body[0].removeChild(t),e};var t=a.fn.modal;a.fn.modal=r,a.fn.modal.Constructor=s,a.fn.modal.noConflict=function(){return a.fn.modal=t,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(t){var e=a(this),i=e.attr("href"),o=e.attr("data-target")||i&&i.replace(/.*(?=#[^\s]+$)/,""),n=a(document).find(o),s=n.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(i)&&i},n.data(),e.data());e.is("a")&&t.preventDefault(),n.one("show.bs.modal",function(t){t.isDefaultPrevented()||n.one("hidden.bs.modal",function(){e.is(":visible")&&e.trigger("focus")})}),r.call(n,s,this)})}(jQuery),function(g){"use strict";var o=["sanitize","whiteList","sanitizeFn"],a=["background","cite","href","itemtype","longdesc","poster","src","xlink:href"],t={"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},r=/^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi,l=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;function u(t,e){var i=t.nodeName.toLowerCase();if(-1!==g.inArray(i,e))return-1===g.inArray(i,a)||Boolean(t.nodeValue.match(r)||t.nodeValue.match(l));for(var o=g(e).filter(function(t,e){return e instanceof RegExp}),n=0,s=o.length;n<s;n++)if(i.match(o[n]))return!0;return!1}function n(t,e,i){if(0===t.length)return t;if(i&&"function"==typeof i)return i(t);if(!document.implementation||!document.implementation.createHTMLDocument)return t;var o=document.implementation.createHTMLDocument("sanitization");o.body.innerHTML=t;for(var n=g.map(e,function(t,e){return e}),s=g(o.body).find("*"),a=0,r=s.length;a<r;a++){var l=s[a],h=l.nodeName.toLowerCase();if(-1!==g.inArray(h,n))for(var d=g.map(l.attributes,function(t){return t}),p=[].concat(e["*"]||[],e[h]||[]),c=0,f=d.length;c<f;c++)u(d[c],p)||l.removeAttribute(d[c].nodeName);else l.parentNode.removeChild(l)}return o.body.innerHTML}var m=function(t,e){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",t,e)};m.VERSION="3.4.1",m.TRANSITION_DURATION=150,m.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0},sanitize:!0,sanitizeFn:null,whiteList:t},m.prototype.init=function(t,e,i){if(this.enabled=!0,this.type=t,this.$element=g(e),this.options=this.getOptions(i),this.$viewport=this.options.viewport&&g(document).find(g.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var o=this.options.trigger.split(" "),n=o.length;n--;){var s=o[n];if("click"==s)this.$element.on("click."+this.type,this.options.selector,g.proxy(this.toggle,this));else if("manual"!=s){var a="hover"==s?"mouseenter":"focusin",r="hover"==s?"mouseleave":"focusout";this.$element.on(a+"."+this.type,this.options.selector,g.proxy(this.enter,this)),this.$element.on(r+"."+this.type,this.options.selector,g.proxy(this.leave,this))}}this.options.selector?this._options=g.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},m.prototype.getDefaults=function(){return m.DEFAULTS},m.prototype.getOptions=function(t){var e=this.$element.data();for(var i in e)e.hasOwnProperty(i)&&-1!==g.inArray(i,o)&&delete e[i];return(t=g.extend({},this.getDefaults(),e,t)).delay&&"number"==typeof t.delay&&(t.delay={show:t.delay,hide:t.delay}),t.sanitize&&(t.template=n(t.template,t.whiteList,t.sanitizeFn)),t},m.prototype.getDelegateOptions=function(){var i={},o=this.getDefaults();return this._options&&g.each(this._options,function(t,e){o[t]!=e&&(i[t]=e)}),i},m.prototype.enter=function(t){var e=t instanceof this.constructor?t:g(t.currentTarget).data("bs."+this.type);if(e||(e=new this.constructor(t.currentTarget,this.getDelegateOptions()),g(t.currentTarget).data("bs."+this.type,e)),t instanceof g.Event&&(e.inState["focusin"==t.type?"focus":"hover"]=!0),e.tip().hasClass("in")||"in"==e.hoverState)e.hoverState="in";else{if(clearTimeout(e.timeout),e.hoverState="in",!e.options.delay||!e.options.delay.show)return e.show();e.timeout=setTimeout(function(){"in"==e.hoverState&&e.show()},e.options.delay.show)}},m.prototype.isInStateTrue=function(){for(var t in this.inState)if(this.inState[t])return!0;return!1},m.prototype.leave=function(t){var e=t instanceof this.constructor?t:g(t.currentTarget).data("bs."+this.type);if(e||(e=new this.constructor(t.currentTarget,this.getDelegateOptions()),g(t.currentTarget).data("bs."+this.type,e)),t instanceof g.Event&&(e.inState["focusout"==t.type?"focus":"hover"]=!1),!e.isInStateTrue()){if(clearTimeout(e.timeout),e.hoverState="out",!e.options.delay||!e.options.delay.hide)return e.hide();e.timeout=setTimeout(function(){"out"==e.hoverState&&e.hide()},e.options.delay.hide)}},m.prototype.show=function(){var t=g.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(t);var e=g.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(t.isDefaultPrevented()||!e)return;var i=this,o=this.tip(),n=this.getUID(this.type);this.setContent(),o.attr("id",n),this.$element.attr("aria-describedby",n),this.options.animation&&o.addClass("fade");var s="function"==typeof this.options.placement?this.options.placement.call(this,o[0],this.$element[0]):this.options.placement,a=/\s?auto?\s?/i,r=a.test(s);r&&(s=s.replace(a,"")||"top"),o.detach().css({top:0,left:0,display:"block"}).addClass(s).data("bs."+this.type,this),this.options.container?o.appendTo(g(document).find(this.options.container)):o.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var l=this.getPosition(),h=o[0].offsetWidth,d=o[0].offsetHeight;if(r){var p=s,c=this.getPosition(this.$viewport);s="bottom"==s&&l.bottom+d>c.bottom?"top":"top"==s&&l.top-d<c.top?"bottom":"right"==s&&l.right+h>c.width?"left":"left"==s&&l.left-h<c.left?"right":s,o.removeClass(p).addClass(s)}var f=this.getCalculatedOffset(s,l,h,d);this.applyPlacement(f,s);var u=function(){var t=i.hoverState;i.$element.trigger("shown.bs."+i.type),i.hoverState=null,"out"==t&&i.leave(i)};g.support.transition&&this.$tip.hasClass("fade")?o.one("bsTransitionEnd",u).emulateTransitionEnd(m.TRANSITION_DURATION):u()}},m.prototype.applyPlacement=function(t,e){var i=this.tip(),o=i[0].offsetWidth,n=i[0].offsetHeight,s=parseInt(i.css("margin-top"),10),a=parseInt(i.css("margin-left"),10);isNaN(s)&&(s=0),isNaN(a)&&(a=0),t.top+=s,t.left+=a,g.offset.setOffset(i[0],g.extend({using:function(t){i.css({top:Math.round(t.top),left:Math.round(t.left)})}},t),0),i.addClass("in");var r=i[0].offsetWidth,l=i[0].offsetHeight;"top"==e&&l!=n&&(t.top=t.top+n-l);var h=this.getViewportAdjustedDelta(e,t,r,l);h.left?t.left+=h.left:t.top+=h.top;var d=/top|bottom/.test(e),p=d?2*h.left-o+r:2*h.top-n+l,c=d?"offsetWidth":"offsetHeight";i.offset(t),this.replaceArrow(p,i[0][c],d)},m.prototype.replaceArrow=function(t,e,i){this.arrow().css(i?"left":"top",50*(1-t/e)+"%").css(i?"top":"left","")},m.prototype.setContent=function(){var t=this.tip(),e=this.getTitle();this.options.html?(this.options.sanitize&&(e=n(e,this.options.whiteList,this.options.sanitizeFn)),t.find(".tooltip-inner").html(e)):t.find(".tooltip-inner").text(e),t.removeClass("fade in top bottom left right")},m.prototype.hide=function(t){var e=this,i=g(this.$tip),o=g.Event("hide.bs."+this.type);function n(){"in"!=e.hoverState&&i.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),t&&t()}if(this.$element.trigger(o),!o.isDefaultPrevented())return i.removeClass("in"),g.support.transition&&i.hasClass("fade")?i.one("bsTransitionEnd",n).emulateTransitionEnd(m.TRANSITION_DURATION):n(),this.hoverState=null,this},m.prototype.fixTitle=function(){var t=this.$element;(t.attr("title")||"string"!=typeof t.attr("data-original-title"))&&t.attr("data-original-title",t.attr("title")||"").attr("title","")},m.prototype.hasContent=function(){return this.getTitle()},m.prototype.getPosition=function(t){var e=(t=t||this.$element)[0],i="BODY"==e.tagName,o=e.getBoundingClientRect();null==o.width&&(o=g.extend({},o,{width:o.right-o.left,height:o.bottom-o.top}));var n=window.SVGElement&&e instanceof window.SVGElement,s=i?{top:0,left:0}:n?null:t.offset(),a={scroll:i?document.documentElement.scrollTop||document.body.scrollTop:t.scrollTop()},r=i?{width:g(window).width(),height:g(window).height()}:null;return g.extend({},o,a,r,s)},m.prototype.getCalculatedOffset=function(t,e,i,o){return"bottom"==t?{top:e.top+e.height,left:e.left+e.width/2-i/2}:"top"==t?{top:e.top-o,left:e.left+e.width/2-i/2}:"left"==t?{top:e.top+e.height/2-o/2,left:e.left-i}:{top:e.top+e.height/2-o/2,left:e.left+e.width}},m.prototype.getViewportAdjustedDelta=function(t,e,i,o){var n={top:0,left:0};if(!this.$viewport)return n;var s=this.options.viewport&&this.options.viewport.padding||0,a=this.getPosition(this.$viewport);if(/right|left/.test(t)){var r=e.top-s-a.scroll,l=e.top+s-a.scroll+o;r<a.top?n.top=a.top-r:l>a.top+a.height&&(n.top=a.top+a.height-l)}else{var h=e.left-s,d=e.left+s+i;h<a.left?n.left=a.left-h:d>a.right&&(n.left=a.left+a.width-d)}return n},m.prototype.getTitle=function(){var t=this.$element,e=this.options;return t.attr("data-original-title")||("function"==typeof e.title?e.title.call(t[0]):e.title)},m.prototype.getUID=function(t){for(;t+=~~(1e6*Math.random()),document.getElementById(t););return t},m.prototype.tip=function(){if(!this.$tip&&(this.$tip=g(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},m.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},m.prototype.enable=function(){this.enabled=!0},m.prototype.disable=function(){this.enabled=!1},m.prototype.toggleEnabled=function(){this.enabled=!this.enabled},m.prototype.toggle=function(t){var e=this;t&&((e=g(t.currentTarget).data("bs."+this.type))||(e=new this.constructor(t.currentTarget,this.getDelegateOptions()),g(t.currentTarget).data("bs."+this.type,e))),t?(e.inState.click=!e.inState.click,e.isInStateTrue()?e.enter(e):e.leave(e)):e.tip().hasClass("in")?e.leave(e):e.enter(e)},m.prototype.destroy=function(){var t=this;clearTimeout(this.timeout),this.hide(function(){t.$element.off("."+t.type).removeData("bs."+t.type),t.$tip&&t.$tip.detach(),t.$tip=null,t.$arrow=null,t.$viewport=null,t.$element=null})},m.prototype.sanitizeHtml=function(t){return n(t,this.options.whiteList,this.options.sanitizeFn)};var e=g.fn.tooltip;g.fn.tooltip=function i(o){return this.each(function(){var t=g(this),e=t.data("bs.tooltip"),i="object"==typeof o&&o;!e&&/destroy|hide/.test(o)||(e||t.data("bs.tooltip",e=new m(this,i)),"string"==typeof o&&e[o]())})},g.fn.tooltip.Constructor=m,g.fn.tooltip.noConflict=function(){return g.fn.tooltip=e,this}}(jQuery),function(n){"use strict";var s=function(t,e){this.init("popover",t,e)};if(!n.fn.tooltip)throw new Error("Popover requires tooltip.js");s.VERSION="3.4.1",s.DEFAULTS=n.extend({},n.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),((s.prototype=n.extend({},n.fn.tooltip.Constructor.prototype)).constructor=s).prototype.getDefaults=function(){return s.DEFAULTS},s.prototype.setContent=function(){var t=this.tip(),e=this.getTitle(),i=this.getContent();if(this.options.html){var o=typeof i;this.options.sanitize&&(e=this.sanitizeHtml(e),"string"===o&&(i=this.sanitizeHtml(i))),t.find(".popover-title").html(e),t.find(".popover-content").children().detach().end()["string"===o?"html":"append"](i)}else t.find(".popover-title").text(e),t.find(".popover-content").children().detach().end().text(i);t.removeClass("fade top bottom left right in"),t.find(".popover-title").html()||t.find(".popover-title").hide()},s.prototype.hasContent=function(){return this.getTitle()||this.getContent()},s.prototype.getContent=function(){var t=this.$element,e=this.options;return t.attr("data-content")||("function"==typeof e.content?e.content.call(t[0]):e.content)},s.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var t=n.fn.popover;n.fn.popover=function e(o){return this.each(function(){var t=n(this),e=t.data("bs.popover"),i="object"==typeof o&&o;!e&&/destroy|hide/.test(o)||(e||t.data("bs.popover",e=new s(this,i)),"string"==typeof o&&e[o]())})},n.fn.popover.Constructor=s,n.fn.popover.noConflict=function(){return n.fn.popover=t,this}}(jQuery),function(s){"use strict";function n(t,e){this.$body=s(document.body),this.$scrollElement=s(t).is(document.body)?s(window):s(t),this.options=s.extend({},n.DEFAULTS,e),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",s.proxy(this.process,this)),this.refresh(),this.process()}function e(o){return this.each(function(){var t=s(this),e=t.data("bs.scrollspy"),i="object"==typeof o&&o;e||t.data("bs.scrollspy",e=new n(this,i)),"string"==typeof o&&e[o]()})}n.VERSION="3.4.1",n.DEFAULTS={offset:10},n.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},n.prototype.refresh=function(){var t=this,o="offset",n=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),s.isWindow(this.$scrollElement[0])||(o="position",n=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var t=s(this),e=t.data("target")||t.attr("href"),i=/^#./.test(e)&&s(e);return i&&i.length&&i.is(":visible")&&[[i[o]().top+n,e]]||null}).sort(function(t,e){return t[0]-e[0]}).each(function(){t.offsets.push(this[0]),t.targets.push(this[1])})},n.prototype.process=function(){var t,e=this.$scrollElement.scrollTop()+this.options.offset,i=this.getScrollHeight(),o=this.options.offset+i-this.$scrollElement.height(),n=this.offsets,s=this.targets,a=this.activeTarget;if(this.scrollHeight!=i&&this.refresh(),o<=e)return a!=(t=s[s.length-1])&&this.activate(t);if(a&&e<n[0])return this.activeTarget=null,this.clear();for(t=n.length;t--;)a!=s[t]&&e>=n[t]&&(n[t+1]===undefined||e<n[t+1])&&this.activate(s[t])},n.prototype.activate=function(t){this.activeTarget=t,this.clear();var e=this.selector+'[data-target="'+t+'"],'+this.selector+'[href="'+t+'"]',i=s(e).parents("li").addClass("active");i.parent(".dropdown-menu").length&&(i=i.closest("li.dropdown").addClass("active")),i.trigger("activate.bs.scrollspy")},n.prototype.clear=function(){s(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var t=s.fn.scrollspy;s.fn.scrollspy=e,s.fn.scrollspy.Constructor=n,s.fn.scrollspy.noConflict=function(){return s.fn.scrollspy=t,this},s(window).on("load.bs.scrollspy.data-api",function(){s('[data-spy="scroll"]').each(function(){var t=s(this);e.call(t,t.data())})})}(jQuery),function(r){"use strict";var a=function(t){this.element=r(t)};function e(i){return this.each(function(){var t=r(this),e=t.data("bs.tab");e||t.data("bs.tab",e=new a(this)),"string"==typeof i&&e[i]()})}a.VERSION="3.4.1",a.TRANSITION_DURATION=150,a.prototype.show=function(){var t=this.element,e=t.closest("ul:not(.dropdown-menu)"),i=t.data("target");if(i||(i=(i=t.attr("href"))&&i.replace(/.*(?=#[^\s]*$)/,"")),!t.parent("li").hasClass("active")){var o=e.find(".active:last a"),n=r.Event("hide.bs.tab",{relatedTarget:t[0]}),s=r.Event("show.bs.tab",{relatedTarget:o[0]});if(o.trigger(n),t.trigger(s),!s.isDefaultPrevented()&&!n.isDefaultPrevented()){var a=r(document).find(i);this.activate(t.closest("li"),e),this.activate(a,a.parent(),function(){o.trigger({type:"hidden.bs.tab",relatedTarget:t[0]}),t.trigger({type:"shown.bs.tab",relatedTarget:o[0]})})}}},a.prototype.activate=function(t,e,i){var o=e.find("> .active"),n=i&&r.support.transition&&(o.length&&o.hasClass("fade")||!!e.find("> .fade").length);function s(){o.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),t.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),n?(t[0].offsetWidth,t.addClass("in")):t.removeClass("fade"),t.parent(".dropdown-menu").length&&t.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),i&&i()}o.length&&n?o.one("bsTransitionEnd",s).emulateTransitionEnd(a.TRANSITION_DURATION):s(),o.removeClass("in")};var t=r.fn.tab;r.fn.tab=e,r.fn.tab.Constructor=a,r.fn.tab.noConflict=function(){return r.fn.tab=t,this};var i=function(t){t.preventDefault(),e.call(r(this),"show")};r(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',i).on("click.bs.tab.data-api",'[data-toggle="pill"]',i)}(jQuery),function(l){"use strict";var h=function(t,e){this.options=l.extend({},h.DEFAULTS,e);var i=this.options.target===h.DEFAULTS.target?l(this.options.target):l(document).find(this.options.target);this.$target=i.on("scroll.bs.affix.data-api",l.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",l.proxy(this.checkPositionWithEventLoop,this)),this.$element=l(t),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};function i(o){return this.each(function(){var t=l(this),e=t.data("bs.affix"),i="object"==typeof o&&o;e||t.data("bs.affix",e=new h(this,i)),"string"==typeof o&&e[o]()})}h.VERSION="3.4.1",h.RESET="affix affix-top affix-bottom",h.DEFAULTS={offset:0,target:window},h.prototype.getState=function(t,e,i,o){var n=this.$target.scrollTop(),s=this.$element.offset(),a=this.$target.height();if(null!=i&&"top"==this.affixed)return n<i&&"top";if("bottom"==this.affixed)return null!=i?!(n+this.unpin<=s.top)&&"bottom":!(n+a<=t-o)&&"bottom";var r=null==this.affixed,l=r?n:s.top;return null!=i&&n<=i?"top":null!=o&&t-o<=l+(r?a:e)&&"bottom"},h.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(h.RESET).addClass("affix");var t=this.$target.scrollTop(),e=this.$element.offset();return this.pinnedOffset=e.top-t},h.prototype.checkPositionWithEventLoop=function(){setTimeout(l.proxy(this.checkPosition,this),1)},h.prototype.checkPosition=function(){if(this.$element.is(":visible")){var t=this.$element.height(),e=this.options.offset,i=e.top,o=e.bottom,n=Math.max(l(document).height(),l(document.body).height());"object"!=typeof e&&(o=i=e),"function"==typeof i&&(i=e.top(this.$element)),"function"==typeof o&&(o=e.bottom(this.$element));var s=this.getState(n,t,i,o);if(this.affixed!=s){null!=this.unpin&&this.$element.css("top","");var a="affix"+(s?"-"+s:""),r=l.Event(a+".bs.affix");if(this.$element.trigger(r),r.isDefaultPrevented())return;this.affixed=s,this.unpin="bottom"==s?this.getPinnedOffset():null,this.$element.removeClass(h.RESET).addClass(a).trigger(a.replace("affix","affixed")+".bs.affix")}"bottom"==s&&this.$element.offset({top:n-t-o})}};var t=l.fn.affix;l.fn.affix=i,l.fn.affix.Constructor=h,l.fn.affix.noConflict=function(){return l.fn.affix=t,this},l(window).on("load",function(){l('[data-spy="affix"]').each(function(){var t=l(this),e=t.data();e.offset=e.offset||{},null!=e.offsetBottom&&(e.offset.bottom=e.offsetBottom),null!=e.offsetTop&&(e.offset.top=e.offsetTop),i.call(t,e)})})}(jQuery);

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by qingzhui on 17/1/3.
	 */
	
	var $ = __webpack_require__(2);
	var commonApi = __webpack_require__(3);
	window.jQuery = $;
	__webpack_require__(5);
	var apiWeb = commonApi.api.webApi;
	$(function () {
	    // 根据中英文选择不同的图片
	    var langInput = document.getElementById('lang');
	    var lang = getCookie('lang') || (langInput ? langInput.value : undefined);
	    lang == 'en' ? $('.en-img').show() : $('.cn-img').show();
	
	    // 导航
	    $('.m-nav').click(function () {
	        var dis = $(this).find('.sub-nav').css('display');
	        if (dis == 'none') {
	            $(this).find('.sub-nav').show();
	        } else {
	            $(this).find('.sub-nav').hide();
	        }
	    });
	
	    // 微信
	    $('.weixin').click(function () {
	        var dis = $(this).next().css('display');
	        if (dis == 'none') {
	            $(this).next().show();
	        } else {
	            $(this).next().hide();
	        }
	    });
	
	    // 切换语言
	    $('.btn-lang').click(function (e) {
	        e.preventDefault();
	        var lang = getCookie('lang');
	
	        if (lang == 'en') {
	            lang = 'zh';
	        } else {
	            lang = 'en';
	        }
	
	        changeLocale(lang);
	        window.location = '/m';
	        // $.ajax({
	        //     url: '/api/change-locale',
	        //     type: 'get',
	        //     dataType: 'json',
	        //     data: {
	        //         locale: lang
	        //     },
	        //     success: function (data) {
	        //         if (!data.ok) {
	        //             return;
	        //         }
	
	        //         setTimeout(() => {
	        //             window.location = window.location.href;
	        //         }, 200);
	        //     }
	        // })
	    });
	
	    //IR 语言切换 （包括简体、繁体、英文）
	    $('.lang-btn-ir').click(function () {
	        lang = $(this).attr('data-lang');
	
	        // if(lang == 'en') {
	        // 	lang = 'zh';
	        // 	// $('.zh').hide();
	        // } else {
	        // 	lang = 'en';
	        // }
	
	        changeLocale(lang);
	        window.location = '/m/ir';
	    });
	
	    function changeLocale(locale) {
	        var Cookies = __webpack_require__(6);
	        Cookies.set('lang', locale);
	    }
	});
	
	function getCookie(cname) {
	    var name = cname + '=';
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i].trim();
	        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	    }
	    return '';
	}
	
	function baseUrl() {
	    //	var url = 'http://10.101.194.3';
	    // var url = 'http://website.huaxing.com';
	    var url = apiWeb;
	    // var api = 'http://10.101.96.2:8091/';
	    //var url = 'http://huaxing-admin-backend.limijiaoyin.com';
	    return url;
	}
	
	exports.baseUrl = baseUrl;
	exports.minioUrl = commonApi.api.minioUrl;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highstock JS v10.3.3 (2023-01-20)
	
	 (c) 2009-2021 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(X,J){"object"===typeof module&&module.exports?(J["default"]=J,module.exports=X.document?J(X):J): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return J(X)}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(X.Highcharts&&X.Highcharts.error(16,!0),X.Highcharts=J(X))})("undefined"!==typeof window?window:this,function(X){function J(a,q,A,E){a.hasOwnProperty(q)||(a[q]=E.apply(null,A),"function"===typeof CustomEvent&&X.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:q,module:a[q]}})))}var a=
	{};J(a,"Core/Globals.js",[],function(){var a;(function(a){a.SVG_NS="http://www.w3.org/2000/svg";a.product="Highcharts";a.version="10.3.3";a.win="undefined"!==typeof X?X:{};a.doc=a.win.document;a.svg=a.doc&&a.doc.createElementNS&&!!a.doc.createElementNS(a.SVG_NS,"svg").createSVGRect;a.userAgent=a.win.navigator&&a.win.navigator.userAgent||"";a.isChrome=-1!==a.userAgent.indexOf("Chrome");a.isFirefox=-1!==a.userAgent.indexOf("Firefox");a.isMS=/(edge|msie|trident)/i.test(a.userAgent)&&!a.win.opera;a.isSafari=
	!a.isChrome&&-1!==a.userAgent.indexOf("Safari");a.isTouchDevice=/(Mobile|Android|Windows Phone)/.test(a.userAgent);a.isWebKit=-1!==a.userAgent.indexOf("AppleWebKit");a.deg2rad=2*Math.PI/360;a.hasBidiBug=a.isFirefox&&4>parseInt(a.userAgent.split("Firefox/")[1],10);a.hasTouch=!!a.win.TouchEvent;a.marginNames=["plotTop","marginRight","marginBottom","plotLeft"];a.noop=function(){};a.supportsPassiveEvents=function(){var v=!1;if(!a.isMS){var q=Object.defineProperty({},"passive",{get:function(){v=!0}});
	a.win.addEventListener&&a.win.removeEventListener&&(a.win.addEventListener("testPassive",a.noop,q),a.win.removeEventListener("testPassive",a.noop,q))}return v}();a.charts=[];a.dateFormats={};a.seriesTypes={};a.symbolSizes={};a.chartCount=0})(a||(a={}));"";return a});J(a,"Core/Utilities.js",[a["Core/Globals.js"]],function(a){function v(d,b,e,g){var r=b?"Highcharts error":"Highcharts warning";32===d&&(d=""+r+": Deprecated member");var I=n(d),z=I?""+r+" #"+d+": www.highcharts.com/errors/"+d+"/":d.toString();
	if("undefined"!==typeof g){var t="";I&&(z+="?");H(g,function(d,b){t+="\n - ".concat(b,": ").concat(d);I&&(z+=encodeURI(b)+"="+encodeURI(d))});z+=t}y(a,"displayError",{chart:e,code:d,message:z,params:g},function(){if(b)throw Error(z);k.console&&-1===v.messages.indexOf(z)&&console.warn(z)});v.messages.push(z)}function A(d,b){var r={};H(d,function(e,g){if(F(d[g],!0)&&!d.nodeType&&b[g])e=A(d[g],b[g]),Object.keys(e).length&&(r[g]=e);else if(F(d[g])||d[g]!==b[g]||g in d&&!(g in b))r[g]=d[g]});return r}
	function E(d,b){return parseInt(d,b||10)}function B(d){return"string"===typeof d}function C(d){d=Object.prototype.toString.call(d);return"[object Array]"===d||"[object Array Iterator]"===d}function F(d,b){return!!d&&"object"===typeof d&&(!b||!C(d))}function x(d){return F(d)&&"number"===typeof d.nodeType}function u(d){var b=d&&d.constructor;return!(!F(d,!0)||x(d)||!b||!b.name||"Object"===b.name)}function n(d){return"number"===typeof d&&!isNaN(d)&&Infinity>d&&-Infinity<d}function c(d){return"undefined"!==
	typeof d&&null!==d}function h(d,b,e){var r=B(b)&&!c(e),g,k=function(b,e){c(b)?d.setAttribute(e,b):r?(g=d.getAttribute(e))||"class"!==e||(g=d.getAttribute(e+"Name")):d.removeAttribute(e)};B(b)?k(e,b):H(b,k);return g}function m(d,b){var r;d||(d={});for(r in b)d[r]=b[r];return d}function l(){for(var d=arguments,b=d.length,e=0;e<b;e++){var g=d[e];if("undefined"!==typeof g&&null!==g)return g}}function p(d,b){a.isMS&&!a.svg&&b&&c(b.opacity)&&(b.filter="alpha(opacity=".concat(100*b.opacity,")"));m(d.style,
	b)}function f(d){return Math.pow(10,Math.floor(Math.log(d)/Math.LN10))}function D(d,b){return 1E14<d?d:parseFloat(d.toPrecision(b||14))}function G(d,b,e){var r=a.getStyle||G;if("width"===b)return b=Math.min(d.offsetWidth,d.scrollWidth),e=d.getBoundingClientRect&&d.getBoundingClientRect().width,e<b&&e>=b-1&&(b=Math.floor(e)),Math.max(0,b-(r(d,"padding-left",!0)||0)-(r(d,"padding-right",!0)||0));if("height"===b)return Math.max(0,Math.min(d.offsetHeight,d.scrollHeight)-(r(d,"padding-top",!0)||0)-(r(d,
	"padding-bottom",!0)||0));k.getComputedStyle||v(27,!0);if(d=k.getComputedStyle(d,void 0)){var g=d.getPropertyValue(b);l(e,"opacity"!==b)&&(g=E(g))}return g}function H(d,b,e){for(var r in d)Object.hasOwnProperty.call(d,r)&&b.call(e||d[r],d[r],r,d)}function K(d,b,e){function r(b,e){var r=d.removeEventListener||a.removeEventListenerPolyfill;r&&r.call(d,b,e,!1)}function g(e){var g;if(d.nodeName){if(b){var I={};I[b]=!0}else I=e;H(I,function(d,b){if(e[b])for(g=e[b].length;g--;)r(b,e[b][g].fn)})}}var k=
	"function"===typeof d&&d.prototype||d;if(Object.hasOwnProperty.call(k,"hcEvents")){var z=k.hcEvents;b?(k=z[b]||[],e?(z[b]=k.filter(function(d){return e!==d.fn}),r(b,e)):(g(z),z[b]=[])):(g(z),delete k.hcEvents)}}function y(d,b,e,g){e=e||{};if(w.createEvent&&(d.dispatchEvent||d.fireEvent&&d!==a)){var r=w.createEvent("Events");r.initEvent(b,!0,!0);e=m(r,e);d.dispatchEvent?d.dispatchEvent(e):d.fireEvent(b,e)}else if(d.hcEvents){e.target||m(e,{preventDefault:function(){e.defaultPrevented=!0},target:d,
	type:b});r=[];for(var I=d,k=!1;I.hcEvents;)Object.hasOwnProperty.call(I,"hcEvents")&&I.hcEvents[b]&&(r.length&&(k=!0),r.unshift.apply(r,I.hcEvents[b])),I=Object.getPrototypeOf(I);k&&r.sort(function(d,b){return d.order-b.order});r.forEach(function(b){!1===b.fn.call(d,e)&&e.preventDefault()})}g&&!e.defaultPrevented&&g.call(d,e)}var t=a.charts,w=a.doc,k=a.win;(v||(v={})).messages=[];Math.easeInOutSine=function(d){return-.5*(Math.cos(Math.PI*d)-1)};var g=Array.prototype.find?function(d,b){return d.find(b)}:
	function(d,b){var e,r=d.length;for(e=0;e<r;e++)if(b(d[e],e))return d[e]};H({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(d,b){a[b]=function(e){var r;v(32,!1,void 0,(r={},r["Highcharts.".concat(b)]="use Array.".concat(d),r));return Array.prototype[d].apply(e,[].slice.call(arguments,1))}});var e,b=function(){var d=Math.random().toString(36).substring(2,9)+"-",b=0;return function(){return"highcharts-"+(e?"":d)+b++}}();k.jQuery&&(k.jQuery.fn.highcharts=function(){var d=
	[].slice.call(arguments);if(this[0])return d[0]?(new (a[B(d[0])?d.shift():"Chart"])(this[0],d[0],d[1]),this):t[h(this[0],"data-highcharts-chart")]});g={addEvent:function(d,b,e,g){void 0===g&&(g={});var r="function"===typeof d&&d.prototype||d;Object.hasOwnProperty.call(r,"hcEvents")||(r.hcEvents={});r=r.hcEvents;a.Point&&d instanceof a.Point&&d.series&&d.series.chart&&(d.series.chart.runTrackerClick=!0);var k=d.addEventListener||a.addEventListenerPolyfill;k&&k.call(d,b,e,a.supportsPassiveEvents?{passive:void 0===
	g.passive?-1!==b.indexOf("touch"):g.passive,capture:!1}:!1);r[b]||(r[b]=[]);r[b].push({fn:e,order:"number"===typeof g.order?g.order:Infinity});r[b].sort(function(d,b){return d.order-b.order});return function(){K(d,b,e)}},arrayMax:function(d){for(var b=d.length,e=d[0];b--;)d[b]>e&&(e=d[b]);return e},arrayMin:function(d){for(var b=d.length,e=d[0];b--;)d[b]<e&&(e=d[b]);return e},attr:h,clamp:function(d,b,e){return d>b?d<e?d:e:b},cleanRecursively:A,clearTimeout:function(d){c(d)&&clearTimeout(d)},correctFloat:D,
	createElement:function(d,b,e,g,k){d=w.createElement(d);b&&m(d,b);k&&p(d,{padding:"0",border:"none",margin:"0"});e&&p(d,e);g&&g.appendChild(d);return d},css:p,defined:c,destroyObjectProperties:function(d,b){H(d,function(e,r){e&&e!==b&&e.destroy&&e.destroy();delete d[r]})},discardElement:function(d){d&&d.parentElement&&d.parentElement.removeChild(d)},erase:function(d,b){for(var e=d.length;e--;)if(d[e]===b){d.splice(e,1);break}},error:v,extend:m,extendClass:function(d,b){var e=function(){};e.prototype=
	new d;m(e.prototype,b);return e},find:g,fireEvent:y,getMagnitude:f,getNestedProperty:function(d,b){for(d=d.split(".");d.length&&c(b);){var e=d.shift();if("undefined"===typeof e||"__proto__"===e)return;b=b[e];if(!c(b)||"function"===typeof b||"number"===typeof b.nodeType||b===k)return}return b},getStyle:G,inArray:function(d,b,e){v(32,!1,void 0,{"Highcharts.inArray":"use Array.indexOf"});return b.indexOf(d,e)},isArray:C,isClass:u,isDOMElement:x,isFunction:function(d){return"function"===typeof d},isNumber:n,
	isObject:F,isString:B,keys:function(d){v(32,!1,void 0,{"Highcharts.keys":"use Object.keys"});return Object.keys(d)},merge:function(){var d,b=arguments,e={},g=function(d,b){"object"!==typeof d&&(d={});H(b,function(e,r){"__proto__"!==r&&"constructor"!==r&&(!F(e,!0)||u(e)||x(e)?d[r]=b[r]:d[r]=g(d[r]||{},e))});return d};!0===b[0]&&(e=b[1],b=Array.prototype.slice.call(b,2));var k=b.length;for(d=0;d<k;d++)e=g(e,b[d]);return e},normalizeTickInterval:function(d,b,e,g,k){var r=d;e=l(e,f(d));var I=d/e;b||(b=
	k?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===g&&(1===e?b=b.filter(function(b){return 0===b%1}):.1>=e&&(b=[1/e])));for(g=0;g<b.length&&!(r=b[g],k&&r*e>=d||!k&&I<=(b[g]+(b[g+1]||b[g]))/2);g++);return r=D(r*e,-Math.round(Math.log(.001)/Math.LN10))},objectEach:H,offset:function(b){var d=w.documentElement;b=b.parentElement||b.parentNode?b.getBoundingClientRect():{top:0,left:0,width:0,height:0};return{top:b.top+(k.pageYOffset||d.scrollTop)-(d.clientTop||0),left:b.left+(k.pageXOffset||d.scrollLeft)-
	(d.clientLeft||0),width:b.width,height:b.height}},pad:function(b,e,g){return Array((e||2)+1-String(b).replace("-","").length).join(g||"0")+b},pick:l,pInt:E,relativeLength:function(b,e,g){return/%$/.test(b)?e*parseFloat(b)/100+(g||0):parseFloat(b)},removeEvent:K,splat:function(b){return C(b)?b:[b]},stableSort:function(b,e){var d=b.length,g,r;for(r=0;r<d;r++)b[r].safeI=r;b.sort(function(b,d){g=e(b,d);return 0===g?b.safeI-d.safeI:g});for(r=0;r<d;r++)delete b[r].safeI},syncTimeout:function(b,e,g){if(0<
	e)return setTimeout(b,e,g);b.call(0,g);return-1},timeUnits:{millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5},uniqueKey:b,useSerialIds:function(b){return e=l(b,e)},wrap:function(b,e,g){var d=b[e];b[e]=function(){var b=arguments,e=this;return g.apply(this,[function(){return d.apply(e,arguments.length?arguments:b)}].concat([].slice.call(arguments)))}}};"";return g});J(a,"Core/Chart/ChartDefaults.js",[],function(){return{alignThresholds:!1,panning:{enabled:!1,
	type:"x"},styledMode:!1,borderRadius:0,colorCount:10,allowMutatingData:!0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},zoomBySingleTouch:!1,zooming:{singleTouch:!1,resetButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"}});J(a,"Core/Color/Color.js",[a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,
	q){var v=q.isNumber,E=q.merge,B=q.pInt;q=function(){function q(v){this.rgba=[NaN,NaN,NaN,NaN];this.input=v;var x=a.Color;if(x&&x!==q)return new x(v);if(!(this instanceof q))return new q(v);this.init(v)}q.parse=function(a){return a?new q(a):q.None};q.prototype.init=function(a){var x;if("object"===typeof a&&"undefined"!==typeof a.stops)this.stops=a.stops.map(function(c){return new q(c[1])});else if("string"===typeof a){this.input=a=q.names[a.toLowerCase()]||a;if("#"===a.charAt(0)){var u=a.length;var n=
	parseInt(a.substr(1),16);7===u?x=[(n&16711680)>>16,(n&65280)>>8,n&255,1]:4===u&&(x=[(n&3840)>>4|(n&3840)>>8,(n&240)>>4|n&240,(n&15)<<4|n&15,1])}if(!x)for(n=q.parsers.length;n--&&!x;){var c=q.parsers[n];(u=c.regex.exec(a))&&(x=c.parse(u))}}x&&(this.rgba=x)};q.prototype.get=function(a){var x=this.input,u=this.rgba;if("object"===typeof x&&"undefined"!==typeof this.stops){var n=E(x);n.stops=[].slice.call(n.stops);this.stops.forEach(function(c,h){n.stops[h]=[n.stops[h][0],c.get(a)]});return n}return u&&
	v(u[0])?"rgb"===a||!a&&1===u[3]?"rgb("+u[0]+","+u[1]+","+u[2]+")":"a"===a?"".concat(u[3]):"rgba("+u.join(",")+")":x};q.prototype.brighten=function(a){var x=this.rgba;if(this.stops)this.stops.forEach(function(n){n.brighten(a)});else if(v(a)&&0!==a)for(var u=0;3>u;u++)x[u]+=B(255*a),0>x[u]&&(x[u]=0),255<x[u]&&(x[u]=255);return this};q.prototype.setOpacity=function(a){this.rgba[3]=a;return this};q.prototype.tweenTo=function(a,x){var u=this.rgba,n=a.rgba;if(!v(u[0])||!v(n[0]))return a.input||"none";a=
	1!==n[3]||1!==u[3];return(a?"rgba(":"rgb(")+Math.round(n[0]+(u[0]-n[0])*(1-x))+","+Math.round(n[1]+(u[1]-n[1])*(1-x))+","+Math.round(n[2]+(u[2]-n[2])*(1-x))+(a?","+(n[3]+(u[3]-n[3])*(1-x)):"")+")"};q.names={white:"#ffffff",black:"#000000"};q.parsers=[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[B(a[1]),B(a[2]),B(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[B(a[1]),
	B(a[2]),B(a[3]),1]}}];q.None=new q("");return q}();"";return q});J(a,"Core/Color/Palettes.js",[],function(){return{colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" ")}});J(a,"Core/Time.js",[a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q){var v=a.win,E=q.defined,B=q.error,C=q.extend,F=q.isObject,x=q.merge,u=q.objectEach,n=q.pad,c=q.pick,h=q.splat,m=q.timeUnits,l=a.isSafari&&v.Intl&&v.Intl.DateTimeFormat.prototype.formatRange,p=a.isSafari&&
	v.Intl&&!v.Intl.DateTimeFormat.prototype.formatRange;q=function(){function f(f){this.options={};this.variableTimezone=this.useUTC=!1;this.Date=v.Date;this.getTimezoneOffset=this.timezoneOffsetFunction();this.update(f)}f.prototype.get=function(f,c){if(this.variableTimezone||this.timezoneOffset){var l=c.getTime(),m=l-this.getTimezoneOffset(c);c.setTime(m);f=c["getUTC"+f]();c.setTime(l);return f}return this.useUTC?c["getUTC"+f]():c["get"+f]()};f.prototype.set=function(f,c,m){if(this.variableTimezone||
	this.timezoneOffset){if("Milliseconds"===f||"Seconds"===f||"Minutes"===f&&0===this.getTimezoneOffset(c)%36E5)return c["setUTC"+f](m);var h=this.getTimezoneOffset(c);h=c.getTime()-h;c.setTime(h);c["setUTC"+f](m);f=this.getTimezoneOffset(c);h=c.getTime()+f;return c.setTime(h)}return this.useUTC||l&&"FullYear"===f?c["setUTC"+f](m):c["set"+f](m)};f.prototype.update=function(f){void 0===f&&(f={});var l=c(f.useUTC,!0);this.options=f=x(!0,this.options,f);this.Date=f.Date||v.Date||Date;this.timezoneOffset=
	(this.useUTC=l)&&f.timezoneOffset||void 0;this.getTimezoneOffset=this.timezoneOffsetFunction();this.variableTimezone=l&&!(!f.getTimezoneOffset&&!f.timezone)};f.prototype.makeTime=function(f,l,m,h,y,t){if(this.useUTC){var w=this.Date.UTC.apply(0,arguments);var k=this.getTimezoneOffset(w);w+=k;var g=this.getTimezoneOffset(w);k!==g?w+=g-k:k-36E5!==this.getTimezoneOffset(w-36E5)||p||(w-=36E5)}else w=(new this.Date(f,l,c(m,1),c(h,0),c(y,0),c(t,0))).getTime();return w};f.prototype.timezoneOffsetFunction=
	function(){var f=this,c=this.options,l=c.getTimezoneOffset,m=c.moment||v.moment;if(!this.useUTC)return function(f){return 6E4*(new Date(f.toString())).getTimezoneOffset()};if(c.timezone){if(m)return function(f){return 6E4*-m.tz(f,c.timezone).utcOffset()};B(25)}return this.useUTC&&l?function(f){return 6E4*l(f.valueOf())}:function(){return 6E4*(f.timezoneOffset||0)}};f.prototype.dateFormat=function(f,l,m){if(!E(l)||isNaN(l))return a.defaultOptions.lang&&a.defaultOptions.lang.invalidDate||"";f=c(f,"%Y-%m-%d %H:%M:%S");
	var h=this,y=new this.Date(l),t=this.get("Hours",y),w=this.get("Day",y),k=this.get("Date",y),g=this.get("Month",y),e=this.get("FullYear",y),b=a.defaultOptions.lang,d=b&&b.weekdays,r=b&&b.shortWeekdays;y=C({a:r?r[w]:d[w].substr(0,3),A:d[w],d:n(k),e:n(k,2," "),w:w,b:b.shortMonths[g],B:b.months[g],m:n(g+1),o:g+1,y:e.toString().substr(2,2),Y:e,H:n(t),k:t,I:n(t%12||12),l:t%12||12,M:n(this.get("Minutes",y)),p:12>t?"AM":"PM",P:12>t?"am":"pm",S:n(y.getSeconds()),L:n(Math.floor(l%1E3),3)},a.dateFormats);u(y,
	function(b,d){for(;-1!==f.indexOf("%"+d);)f=f.replace("%"+d,"function"===typeof b?b.call(h,l):b)});return m?f.substr(0,1).toUpperCase()+f.substr(1):f};f.prototype.resolveDTLFormat=function(f){return F(f,!0)?f:(f=h(f),{main:f[0],from:f[1],to:f[2]})};f.prototype.getTimeTicks=function(f,l,h,p){var y=this,t=[],w={},k=new y.Date(l),g=f.unitRange,e=f.count||1,b;p=c(p,1);if(E(l)){y.set("Milliseconds",k,g>=m.second?0:e*Math.floor(y.get("Milliseconds",k)/e));g>=m.second&&y.set("Seconds",k,g>=m.minute?0:e*
	Math.floor(y.get("Seconds",k)/e));g>=m.minute&&y.set("Minutes",k,g>=m.hour?0:e*Math.floor(y.get("Minutes",k)/e));g>=m.hour&&y.set("Hours",k,g>=m.day?0:e*Math.floor(y.get("Hours",k)/e));g>=m.day&&y.set("Date",k,g>=m.month?1:Math.max(1,e*Math.floor(y.get("Date",k)/e)));if(g>=m.month){y.set("Month",k,g>=m.year?0:e*Math.floor(y.get("Month",k)/e));var d=y.get("FullYear",k)}g>=m.year&&y.set("FullYear",k,d-d%e);g===m.week&&(d=y.get("Day",k),y.set("Date",k,y.get("Date",k)-d+p+(d<p?-7:0)));d=y.get("FullYear",
	k);p=y.get("Month",k);var r=y.get("Date",k),z=y.get("Hours",k);l=k.getTime();!y.variableTimezone&&y.useUTC||!E(h)||(b=h-l>4*m.month||y.getTimezoneOffset(l)!==y.getTimezoneOffset(h));l=k.getTime();for(k=1;l<h;)t.push(l),l=g===m.year?y.makeTime(d+k*e,0):g===m.month?y.makeTime(d,p+k*e):!b||g!==m.day&&g!==m.week?b&&g===m.hour&&1<e?y.makeTime(d,p,r,z+k*e):l+g*e:y.makeTime(d,p,r+k*e*(g===m.day?1:7)),k++;t.push(l);g<=m.hour&&1E4>t.length&&t.forEach(function(b){0===b%18E5&&"000000000"===y.dateFormat("%H%M%S%L",
	b)&&(w[b]="day")})}t.info=C(f,{higherRanks:w,totalRange:g*e});return t};f.prototype.getDateFormat=function(f,c,l,h){var y=this.dateFormat("%m-%d %H:%M:%S.%L",c),t={millisecond:15,second:12,minute:9,hour:6,day:3},w="millisecond";for(k in m){if(f===m.week&&+this.dateFormat("%w",c)===l&&"00:00:00.000"===y.substr(6)){var k="week";break}if(m[k]>f){k=w;break}if(t[k]&&y.substr(t[k])!=="01-01 00:00:00.000".substr(t[k]))break;"week"!==k&&(w=k)}return this.resolveDTLFormat(h[k]).main};return f}();"";return q});
	J(a,"Core/Defaults.js",[a["Core/Chart/ChartDefaults.js"],a["Core/Color/Color.js"],a["Core/Globals.js"],a["Core/Color/Palettes.js"],a["Core/Time.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C){q=q.parse;var v=C.merge,x={colors:E.colors,symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
	weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:{Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0},chart:a,title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},
	labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,className:"highcharts-no-tooltip",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",
	width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:A.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",
	month:"%B %Y",year:"%Y"},footerFormat:"",headerShape:"callout",hideDelay:500,padding:8,shape:"callout",shared:!1,snap:A.isTouchDevice?25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:q("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,stickOnContact:!1,style:{color:"#333333",cursor:"default",fontSize:"12px",whiteSpace:"nowrap"},useHTML:!1},credits:{enabled:!0,
	href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};x.chart.styledMode=!1;"";var u=new B(v(x.global,x.time));a={defaultOptions:x,defaultTime:u,getOptions:function(){return x},setOptions:function(n){v(!0,x,n);if(n.time||n.global)A.time?A.time.update(v(x.global,x.time,n.global,n.time)):A.time=u;return x}};"";return a});J(a,"Core/Animation/Fx.js",[a["Core/Color/Color.js"],
	a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q,A){var v=a.parse,B=q.win,C=A.isNumber,F=A.objectEach;return function(){function a(a,n,c){this.pos=NaN;this.options=n;this.elem=a;this.prop=c}a.prototype.dSetter=function(){var a=this.paths,n=a&&a[0];a=a&&a[1];var c=this.now||0,h=[];if(1!==c&&n&&a)if(n.length===a.length&&1>c)for(var m=0;m<a.length;m++){for(var l=n[m],p=a[m],f=[],D=0;D<p.length;D++){var G=l[D],H=p[D];C(G)&&C(H)&&("A"!==p[0]||4!==D&&5!==D)?f[D]=G+c*(H-G):f[D]=H}h.push(f)}else h=
	a;else h=this.toD||[];this.elem.attr("d",h,void 0,!0)};a.prototype.update=function(){var a=this.elem,n=this.prop,c=this.now,h=this.options.step;if(this[n+"Setter"])this[n+"Setter"]();else a.attr?a.element&&a.attr(n,c,null,!0):a.style[n]=c+this.unit;h&&h.call(a,c,this)};a.prototype.run=function(u,n,c){var h=this,m=h.options,l=function(f){return l.stopped?!1:h.step(f)},p=B.requestAnimationFrame||function(f){setTimeout(f,13)},f=function(){for(var c=0;c<a.timers.length;c++)a.timers[c]()||a.timers.splice(c--,
	1);a.timers.length&&p(f)};u!==n||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=u,this.end=n,this.unit=c,this.now=this.start,this.pos=0,l.elem=this.elem,l.prop=this.prop,l()&&1===a.timers.push(l)&&p(f)):(delete m.curAnim[this.prop],m.complete&&0===Object.keys(m.curAnim).length&&m.complete.call(this.elem))};a.prototype.step=function(a){var n=+new Date,c=this.options,h=this.elem,m=c.complete,l=c.duration,p=c.curAnim;if(h.attr&&!h.element)a=!1;else if(a||n>=l+this.startTime){this.now=
	this.end;this.pos=1;this.update();var f=p[this.prop]=!0;F(p,function(c){!0!==c&&(f=!1)});f&&m&&m.call(h);a=!1}else this.pos=c.easing((n-this.startTime)/l),this.now=this.start+(this.end-this.start)*this.pos,this.update(),a=!0;return a};a.prototype.initPath=function(a,n,c){function h(c,t){for(;c.length<K;){var w=c[0],k=t[K-c.length];k&&"M"===w[0]&&(c[0]="C"===k[0]?["C",w[1],w[2],w[1],w[2],w[1],w[2]]:["L",w[1],w[2]]);c.unshift(w);f&&(w=c.pop(),c.push(c[c.length-1],w))}}function m(c,t){for(;c.length<
	K;)if(t=c[Math.floor(c.length/D)-1].slice(),"C"===t[0]&&(t[1]=t[5],t[2]=t[6]),f){var w=c[Math.floor(c.length/D)].slice();c.splice(c.length/2,0,t,w)}else c.push(t)}var l=a.startX,p=a.endX;c=c.slice();var f=a.isArea,D=f?2:1;n=n&&n.slice();if(!n)return[c,c];if(l&&p&&p.length){for(a=0;a<l.length;a++)if(l[a]===p[0]){var G=a;break}else if(l[0]===p[p.length-l.length+a]){G=a;var u=!0;break}else if(l[l.length-1]===p[p.length-l.length+a]){G=l.length-a;break}"undefined"===typeof G&&(n=[])}if(n.length&&C(G)){var K=
	c.length+G*D;u?(h(n,c),m(c,n)):(h(c,n),m(n,c))}return[n,c]};a.prototype.fillSetter=function(){a.prototype.strokeSetter.apply(this,arguments)};a.prototype.strokeSetter=function(){this.elem.attr(this.prop,v(this.start).tweenTo(v(this.end),this.pos),void 0,!0)};a.timers=[];return a}()});J(a,"Core/Animation/AnimationUtilities.js",[a["Core/Animation/Fx.js"],a["Core/Utilities.js"]],function(a,q){function v(c){return u(c)?n({duration:500,defer:0},c):{duration:c?500:0,defer:0}}function E(c,l){for(var h=a.timers.length;h--;)a.timers[h].elem!==
	c||l&&l!==a.timers[h].prop||(a.timers[h].stopped=!0)}var B=q.defined,C=q.getStyle,F=q.isArray,x=q.isNumber,u=q.isObject,n=q.merge,c=q.objectEach,h=q.pick;return{animate:function(h,l,p){var f,m="",G,H;if(!u(p)){var K=arguments;p={duration:K[2],easing:K[3],complete:K[4]}}x(p.duration)||(p.duration=400);p.easing="function"===typeof p.easing?p.easing:Math[p.easing]||Math.easeInOutSine;p.curAnim=n(l);c(l,function(c,t){E(h,t);H=new a(h,p,t);G=void 0;"d"===t&&F(l.d)?(H.paths=H.initPath(h,h.pathArray,l.d),
	H.toD=l.d,f=0,G=1):h.attr?f=h.attr(t):(f=parseFloat(C(h,t))||0,"opacity"!==t&&(m="px"));G||(G=c);"string"===typeof G&&G.match("px")&&(G=G.replace(/px/g,""));H.run(f,G,m)})},animObject:v,getDeferredAnimation:function(c,l,h){var f=v(l),m=0,p=0;(h?[h]:c.series).forEach(function(c){c=v(c.options.animation);m=l&&B(l.defer)?f.defer:Math.max(m,c.duration+c.defer);p=Math.min(f.duration,c.duration)});c.renderer.forExport&&(m=0);return{defer:Math.max(0,m-p),duration:Math.min(m,p)}},setAnimation:function(c,
	l){l.renderer.globalAnimation=h(c,l.options.chart.animation,!0)},stop:E}});J(a,"Core/Renderer/HTML/AST.js",[a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q){var v=a.SVG_NS,E=q.attr,B=q.createElement,C=q.css,F=q.error,x=q.isFunction,u=q.isString,n=q.objectEach,c=q.splat,h=(q=a.win.trustedTypes)&&x(q.createPolicy)&&q.createPolicy("highcharts",{createHTML:function(c){return c}}),m=h?h.createHTML(""):"";try{var l=!!(new DOMParser).parseFromString(m,"text/html")}catch(p){l=!1}x=function(){function p(f){this.nodes=
	"string"===typeof f?this.parseMarkup(f):f}p.filterUserAttributes=function(f){n(f,function(c,l){var h=!0;-1===p.allowedAttributes.indexOf(l)&&(h=!1);-1!==["background","dynsrc","href","lowsrc","src"].indexOf(l)&&(h=u(c)&&p.allowedReferences.some(function(f){return 0===c.indexOf(f)}));h||(F(33,!1,void 0,{"Invalid attribute in config":"".concat(l)}),delete f[l]);u(c)&&f[l]&&(f[l]=c.replace(/</g,"&lt;"))});return f};p.parseStyle=function(f){return f.split(";").reduce(function(f,c){c=c.split(":").map(function(f){return f.trim()});
	var l=c.shift();l&&c.length&&(f[l.replace(/-([a-z])/g,function(f){return f[1].toUpperCase()})]=c.join(":"));return f},{})};p.setElementHTML=function(f,c){f.innerHTML=p.emptyHTML;c&&(new p(c)).addToDOM(f)};p.prototype.addToDOM=function(f){function l(f,h){var m;c(f).forEach(function(f){var t=f.tagName,c=f.textContent?a.doc.createTextNode(f.textContent):void 0,k=p.bypassHTMLFiltering;if(t)if("#text"===t)var g=c;else if(-1!==p.allowedTags.indexOf(t)||k){t=a.doc.createElementNS("svg"===t?v:h.namespaceURI||
	v,t);var e=f.attributes||{};n(f,function(b,d){"tagName"!==d&&"attributes"!==d&&"children"!==d&&"style"!==d&&"textContent"!==d&&(e[d]=b)});E(t,k?e:p.filterUserAttributes(e));f.style&&C(t,f.style);c&&t.appendChild(c);l(f.children||[],t);g=t}else F(33,!1,void 0,{"Invalid tagName in config":t});g&&h.appendChild(g);m=g});return m}return l(this.nodes,f)};p.prototype.parseMarkup=function(f){var c=[];f=f.trim().replace(/ style=(["'])/g," data-style=$1");if(l)f=(new DOMParser).parseFromString(h?h.createHTML(f):
	f,"text/html");else{var m=B("div");m.innerHTML=f;f={body:m}}var a=function(f,c){var t=f.nodeName.toLowerCase(),w={tagName:t};"#text"===t&&(w.textContent=f.textContent||"");if(t=f.attributes){var k={};[].forEach.call(t,function(e){"data-style"===e.name?w.style=p.parseStyle(e.value):k[e.name]=e.value});w.attributes=k}if(f.childNodes.length){var g=[];[].forEach.call(f.childNodes,function(e){a(e,g)});g.length&&(w.children=g)}c.push(w)};[].forEach.call(f.body.childNodes,function(f){return a(f,c)});return c};
	p.allowedAttributes="aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align text-anchor textAnchor textLength title type valign width x x1 x2 xlink:href y y1 y2 zIndex".split(" ");
	p.allowedReferences="https:// http:// mailto: / ../ ./ #".split(" ");p.allowedTags="a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text textPath thead title tbody tspan td th tr u ul #text".split(" ");p.emptyHTML=m;p.bypassHTMLFiltering=!1;return p}();
	"";return x});J(a,"Core/FormatUtilities.js",[a["Core/Defaults.js"],a["Core/Utilities.js"]],function(a,q){function v(a,c,h,m){a=+a||0;c=+c;var l=E.lang,p=(a.toString().split(".")[1]||"").split("e")[0].length,f=a.toString().split("e"),n=c;if(-1===c)c=Math.min(p,20);else if(!F(c))c=2;else if(c&&f[1]&&0>f[1]){var G=c+ +f[1];0<=G?(f[0]=(+f[0]).toExponential(G).split("e")[0],c=G):(f[0]=f[0].split(".")[0]||0,a=20>c?(f[0]*Math.pow(10,f[1])).toFixed(c):0,f[1]=0)}G=(Math.abs(f[1]?f[0]:a)+Math.pow(10,-Math.max(c,
	p)-1)).toFixed(c);p=String(u(G));var H=3<p.length?p.length%3:0;h=x(h,l.decimalPoint);m=x(m,l.thousandsSep);a=(0>a?"-":"")+(H?p.substr(0,H)+m:"");a=0>+f[1]&&!n?"0":a+p.substr(H).replace(/(\d{3})(?=\d)/g,"$1"+m);c&&(a+=h+G.slice(-c));f[1]&&0!==+a&&(a+="e"+f[1]);return a}var E=a.defaultOptions,B=a.defaultTime,C=q.getNestedProperty,F=q.isNumber,x=q.pick,u=q.pInt;return{dateFormat:function(a,c,h){return B.dateFormat(a,c,h)},format:function(a,c,h){var m="{",l=!1,p=/f$/,f=/\.([0-9])/,n=E.lang,G=h&&h.time||
	B;h=h&&h.numberFormatter||v;for(var u=[];a;){var x=a.indexOf(m);if(-1===x)break;var y=a.slice(0,x);if(l){y=y.split(":");m=C(y.shift()||"",c);if(y.length&&"number"===typeof m)if(y=y.join(":"),p.test(y)){var t=parseInt((y.match(f)||["","-1"])[1],10);null!==m&&(m=h(m,t,n.decimalPoint,-1<y.indexOf(",")?n.thousandsSep:""))}else m=G.dateFormat(y,m);u.push(m)}else u.push(y);a=a.slice(x+1);m=(l=!l)?"}":"{"}u.push(a);return u.join("")},numberFormat:v}});J(a,"Core/Renderer/RendererUtilities.js",[a["Core/Utilities.js"]],
	function(a){var v=a.clamp,A=a.pick,E=a.stableSort,B;(function(a){function q(a,u,n){var c=a,h=c.reducedLen||u,m=function(f,c){return(c.rank||0)-(f.rank||0)},l=function(f,c){return f.target-c.target},p,f=!0,D=[],G=0;for(p=a.length;p--;)G+=a[p].size;if(G>h){E(a,m);for(G=p=0;G<=h;)G+=a[p].size,p++;D=a.splice(p-1,a.length)}E(a,l);for(a=a.map(function(f){return{size:f.size,targets:[f.target],align:A(f.align,.5)}});f;){for(p=a.length;p--;)h=a[p],m=(Math.min.apply(0,h.targets)+Math.max.apply(0,h.targets))/
	2,h.pos=v(m-h.size*h.align,0,u-h.size);p=a.length;for(f=!1;p--;)0<p&&a[p-1].pos+a[p-1].size>a[p].pos&&(a[p-1].size+=a[p].size,a[p-1].targets=a[p-1].targets.concat(a[p].targets),a[p-1].align=.5,a[p-1].pos+a[p-1].size>u&&(a[p-1].pos=u-a[p-1].size),a.splice(p,1),f=!0)}c.push.apply(c,D);p=0;a.some(function(f){var l=0;return(f.targets||[]).some(function(){c[p].pos=f.pos+l;if("undefined"!==typeof n&&Math.abs(c[p].pos-c[p].target)>n)return c.slice(0,p+1).forEach(function(f){return delete f.pos}),c.reducedLen=
	(c.reducedLen||u)-.1*u,c.reducedLen>.1*u&&q(c,u,n),!0;l+=c[p].size;p++;return!1})});E(c,l);return c}a.distribute=q})(B||(B={}));return B});J(a,"Core/Renderer/SVG/SVGElement.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/Color/Color.js"],a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=a.animate,C=a.animObject,F=a.stop,x=A.deg2rad,u=A.doc,n=A.svg,c=A.SVG_NS,h=A.win,m=E.addEvent,l=E.attr,p=E.createElement,f=E.css,D=E.defined,G=E.erase,H=E.extend,K=E.fireEvent,y=E.isArray,
	t=E.isFunction,w=E.isString,k=E.merge,g=E.objectEach,e=E.pick,b=E.pInt,d=E.syncTimeout,r=E.uniqueKey;a=function(){function z(){this.element=void 0;this.onEvents={};this.opacity=1;this.renderer=void 0;this.SVG_NS=c;this.symbolCustomAttribs="x y width height r start end innerR anchorX anchorY rounded".split(" ")}z.prototype._defaultGetter=function(b){b=e(this[b+"Value"],this[b],this.element?this.element.getAttribute(b):null,0);/^[\-0-9\.]+$/.test(b)&&(b=parseFloat(b));return b};z.prototype._defaultSetter=
	function(b,d,e){e.setAttribute(d,b)};z.prototype.add=function(b){var d=this.renderer,e=this.element;b&&(this.parentGroup=b);"undefined"!==typeof this.textStr&&"text"===this.element.nodeName&&d.buildText(this);this.added=!0;if(!b||b.handleZ||this.zIndex)var g=this.zIndexSetter();g||(b?b.element:d.box).appendChild(e);if(this.onAdd)this.onAdd();return this};z.prototype.addClass=function(b,d){var e=d?"":this.attr("class")||"";b=(b||"").split(/ /g).reduce(function(b,d){-1===e.indexOf(d)&&b.push(d);return b},
	e?[e]:[]).join(" ");b!==e&&this.attr("class",b);return this};z.prototype.afterSetters=function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)};z.prototype.align=function(b,d,g){var r={},k=this.renderer,I=k.alignedObjects,t,f,z;if(b){if(this.alignOptions=b,this.alignByTranslate=d,!g||w(g))this.alignTo=t=g||"renderer",G(I,this),I.push(this),g=void 0}else b=this.alignOptions,d=this.alignByTranslate,t=this.alignTo;g=e(g,k[t],"scrollablePlotBox"===t?k.plotBox:void 0,k);t=b.align;var c=
	b.verticalAlign;k=(g.x||0)+(b.x||0);I=(g.y||0)+(b.y||0);"right"===t?f=1:"center"===t&&(f=2);f&&(k+=(g.width-(b.width||0))/f);r[d?"translateX":"x"]=Math.round(k);"bottom"===c?z=1:"middle"===c&&(z=2);z&&(I+=(g.height-(b.height||0))/z);r[d?"translateY":"y"]=Math.round(I);this[this.placed?"animate":"attr"](r);this.placed=!0;this.alignAttr=r;return this};z.prototype.alignSetter=function(b){var d={left:"start",center:"middle",right:"end"};d[b]&&(this.alignValue=b,this.element.setAttribute("text-anchor",
	d[b]))};z.prototype.animate=function(b,r,k){var I=this,t=C(e(r,this.renderer.globalAnimation,!0));r=t.defer;e(u.hidden,u.msHidden,u.webkitHidden,!1)&&(t.duration=0);0!==t.duration?(k&&(t.complete=k),d(function(){I.element&&v(I,b,t)},r)):(this.attr(b,void 0,k||t.complete),g(b,function(b,d){t.step&&t.step.call(this,b,{prop:d,pos:1,elem:this})},this));return this};z.prototype.applyTextOutline=function(b){var d=this.element;-1!==b.indexOf("contrast")&&(b=b.replace(/contrast/g,this.renderer.getContrast(d.style.fill)));
	var e=b.split(" ");b=e[e.length-1];if((e=e[0])&&"none"!==e&&A.svg){this.fakeTS=!0;e=e.replace(/(^[\d\.]+)(.*?)$/g,function(b,d,e){return 2*Number(d)+e});this.removeTextOutline();var g=u.createElementNS(c,"tspan");l(g,{"class":"highcharts-text-outline",fill:b,stroke:b,"stroke-width":e,"stroke-linejoin":"round"});b=d.querySelector("textPath")||d;[].forEach.call(b.childNodes,function(b){var d=b.cloneNode(!0);d.removeAttribute&&["fill","stroke","stroke-width","stroke"].forEach(function(b){return d.removeAttribute(b)});
	g.appendChild(d)});var r=0;[].forEach.call(b.querySelectorAll("text tspan"),function(b){r+=Number(b.getAttribute("dy"))});e=u.createElementNS(c,"tspan");e.textContent="\u200b";l(e,{x:Number(d.getAttribute("x")),dy:-r});g.appendChild(e);b.insertBefore(g,b.firstChild)}};z.prototype.attr=function(b,d,e,r){var k=this.element,L=this.symbolCustomAttribs,t,I=this,f,z;if("string"===typeof b&&"undefined"!==typeof d){var c=b;b={};b[c]=d}"string"===typeof b?I=(this[b+"Getter"]||this._defaultGetter).call(this,
	b,k):(g(b,function(d,e){f=!1;r||F(this,e);this.symbolName&&-1!==L.indexOf(e)&&(t||(this.symbolAttr(b),t=!0),f=!0);!this.rotation||"x"!==e&&"y"!==e||(this.doTransform=!0);f||(z=this[e+"Setter"]||this._defaultSetter,z.call(this,d,e,k),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(e)&&this.updateShadows(e,d,z))},this),this.afterSetters());e&&e.call(this);return I};z.prototype.clip=function(b){return this.attr("clip-path",b?"url("+this.renderer.url+"#"+b.id+
	")":"none")};z.prototype.crisp=function(b,d){d=d||b.strokeWidth||0;var e=Math.round(d)%2/2;b.x=Math.floor(b.x||this.x||0)+e;b.y=Math.floor(b.y||this.y||0)+e;b.width=Math.floor((b.width||this.width||0)-2*e);b.height=Math.floor((b.height||this.height||0)-2*e);D(b.strokeWidth)&&(b.strokeWidth=d);return b};z.prototype.complexColor=function(b,d,e){var t=this.renderer,I,L,f,z,c,w,M,l,h,a,m=[],p;K(this.renderer,"complexColor",{args:arguments},function(){b.radialGradient?L="radialGradient":b.linearGradient&&
	(L="linearGradient");if(L){f=b[L];c=t.gradients;w=b.stops;h=e.radialReference;y(f)&&(b[L]=f={x1:f[0],y1:f[1],x2:f[2],y2:f[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===L&&h&&!D(f.gradientUnits)&&(z=f,f=k(f,t.getRadialAttr(h,z),{gradientUnits:"userSpaceOnUse"}));g(f,function(b,d){"id"!==d&&m.push(d,b)});g(w,function(b){m.push(b)});m=m.join(",");if(c[m])a=c[m].attr("id");else{f.id=a=r();var S=c[m]=t.createElement(L).attr(f).add(t.defs);S.radAttr=z;S.stops=[];w.forEach(function(b){0===b[1].indexOf("rgba")?
	(I=q.parse(b[1]),M=I.get("rgb"),l=I.get("a")):(M=b[1],l=1);b=t.createElement("stop").attr({offset:b[0],"stop-color":M,"stop-opacity":l}).add(S);S.stops.push(b)})}p="url("+t.url+"#"+a+")";e.setAttribute(d,p);e.gradient=m;b.toString=function(){return p}}})};z.prototype.css=function(d){var e=this.styles,r={},t=this.element,z=!e;d.color&&(d.fill=d.color);e&&g(d,function(b,d){e&&e[d]!==b&&(r[d]=b,z=!0)});if(z){e&&(d=H(e,r));if(null===d.width||"auto"===d.width)delete this.textWidth;else if("text"===t.nodeName.toLowerCase()&&
	d.width)var L=this.textWidth=b(d.width);this.styles=d;L&&!n&&this.renderer.forExport&&delete d.width;var I=k(d);t.namespaceURI===this.SVG_NS&&["textOutline","textOverflow","width"].forEach(function(b){return I&&delete I[b]});f(t,I);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),d.textOutline&&this.applyTextOutline(d.textOutline))}return this};z.prototype.dashstyleSetter=function(d){var g=this["stroke-width"];"inherit"===g&&(g=1);if(d=d&&d.toLowerCase()){var r=d.replace("shortdashdotdot",
	"3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(d=r.length;d--;)r[d]=""+b(r[d])*e(g,NaN);d=r.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",d)}};z.prototype.destroy=function(){var b=this,d=b.element||{},e=b.renderer,r=d.ownerSVGElement,k=e.isSVG&&"SPAN"===d.nodeName&&b.parentGroup||void 0;d.onclick=d.onmouseout=
	d.onmouseover=d.onmousemove=d.point=null;F(b);if(b.clipPath&&r){var t=b.clipPath;[].forEach.call(r.querySelectorAll("[clip-path],[CLIP-PATH]"),function(b){-1<b.getAttribute("clip-path").indexOf(t.element.id)&&b.removeAttribute("clip-path")});b.clipPath=t.destroy()}if(b.stops){for(r=0;r<b.stops.length;r++)b.stops[r].destroy();b.stops.length=0;b.stops=void 0}b.safeRemoveChild(d);for(e.styledMode||b.destroyShadows();k&&k.div&&0===k.div.childNodes.length;)d=k.parentGroup,b.safeRemoveChild(k.div),delete k.div,
	k=d;b.alignTo&&G(e.alignedObjects,b);g(b,function(d,e){b[e]&&b[e].parentGroup===b&&b[e].destroy&&b[e].destroy();delete b[e]})};z.prototype.destroyShadows=function(){(this.shadows||[]).forEach(function(b){this.safeRemoveChild(b)},this);this.shadows=void 0};z.prototype.dSetter=function(b,d,e){y(b)&&("string"===typeof b[0]&&(b=this.renderer.pathToSegments(b)),this.pathArray=b,b=b.reduce(function(b,d,e){return d&&d.join?(e?b+" ":"")+d.join(" "):(d||"").toString()},""));/(NaN| {2}|^$)/.test(b)&&(b="M 0 0");
	this[d]!==b&&(e.setAttribute(d,b),this[d]=b)};z.prototype.fadeOut=function(b){var d=this;d.animate({opacity:0},{duration:e(b,150),complete:function(){d.hide()}})};z.prototype.fillSetter=function(b,d,e){"string"===typeof b?e.setAttribute(d,b):b&&this.complexColor(b,d,e)};z.prototype.getBBox=function(b,d){var r=this.alignValue,g=this.element,k=this.renderer,L=this.styles,c=this.textStr,I=k.cache,w=k.cacheKeys,l=g.namespaceURI===this.SVG_NS;d=e(d,this.rotation,0);var M=k.styledMode?g&&z.prototype.getStyle.call(g,
	"font-size"):L&&L.fontSize,h;if(D(c)){var a=c.toString();-1===a.indexOf("<")&&(a=a.replace(/[0-9]/g,"0"));a+=["",d,M,this.textWidth,r,L&&L.textOverflow,L&&L.fontWeight].join()}a&&!b&&(h=I[a]);if(!h){if(l||k.forExport){try{var m=this.fakeTS&&function(b){var d=g.querySelector(".highcharts-text-outline");d&&f(d,{display:b})};t(m)&&m("none");h=g.getBBox?H({},g.getBBox()):{width:g.offsetWidth,height:g.offsetHeight,x:0,y:0};t(m)&&m("")}catch(W){""}if(!h||0>h.width)h={x:0,y:0,width:0,height:0}}else h=this.htmlGetBBox();
	if(k.isSVG&&(k=h.width,b=h.height,l&&(h.height=b={"11px,17":14,"13px,20":16}[""+(M||"")+",".concat(Math.round(b))]||b),d)){l=Number(g.getAttribute("y")||0)-h.y;r={right:1,center:.5}[r||0]||0;L=d*x;M=(d-90)*x;var p=k*Math.cos(L);d=k*Math.sin(L);m=Math.cos(M);L=Math.sin(M);k=h.x+r*(k-p)+l*m;M=k+p;m=M-b*m;p=m-p;l=h.y+l-r*d+l*L;r=l+d;b=r-b*L;d=b-d;h.x=Math.min(k,M,m,p);h.y=Math.min(l,r,b,d);h.width=Math.max(k,M,m,p)-h.x;h.height=Math.max(l,r,b,d)-h.y}if(a&&(""===c||0<h.height)){for(;250<w.length;)delete I[w.shift()];
	I[a]||w.push(a);I[a]=h}}return h};z.prototype.getStyle=function(b){return h.getComputedStyle(this.element||this,"").getPropertyValue(b)};z.prototype.hasClass=function(b){return-1!==(""+this.attr("class")).split(" ").indexOf(b)};z.prototype.hide=function(){return this.attr({visibility:"hidden"})};z.prototype.htmlGetBBox=function(){return{height:0,width:0,x:0,y:0}};z.prototype.init=function(b,d){this.element="span"===d?p(d):u.createElementNS(this.SVG_NS,d);this.renderer=b;K(this,"afterInit")};z.prototype.on=
	function(b,d){var e=this.onEvents;if(e[b])e[b]();e[b]=m(this.element,b,d);return this};z.prototype.opacitySetter=function(b,d,e){this.opacity=b=Number(Number(b).toFixed(3));e.setAttribute(d,b)};z.prototype.removeClass=function(b){return this.attr("class",(""+this.attr("class")).replace(w(b)?new RegExp("(^| )".concat(b,"( |$)")):b," ").replace(/ +/g," ").trim())};z.prototype.removeTextOutline=function(){var b=this.element.querySelector("tspan.highcharts-text-outline");b&&this.safeRemoveChild(b)};z.prototype.safeRemoveChild=
	function(b){var d=b.parentNode;d&&d.removeChild(b)};z.prototype.setRadialReference=function(b){var d=this.element.gradient&&this.renderer.gradients[this.element.gradient];this.element.radialReference=b;d&&d.radAttr&&d.animate(this.renderer.getRadialAttr(b,d.radAttr));return this};z.prototype.setTextPath=function(b,d){var e=this;d=k(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},d);var g=this.renderer.url,t=this.text||this,L=t.textPath,f=d.attributes,z=d.enabled;b=b||L&&L.path;
	L&&L.undo();b&&z?(d=m(t,"afterModifyTree",function(d){if(b&&z){var k=b.attr("id");k||b.attr("id",k=r());var L={x:0,y:0};D(f.dx)&&(L.dx=f.dx,delete f.dx);D(f.dy)&&(L.dy=f.dy,delete f.dy);t.attr(L);e.attr({transform:""});e.box&&(e.box=e.box.destroy());L=d.nodes.slice(0);d.nodes.length=0;d.nodes[0]={tagName:"textPath",attributes:H(f,{"text-anchor":f.textAnchor,href:""+g+"#".concat(k)}),children:L}}}),t.textPath={path:b,undo:d}):(t.attr({dx:0,dy:0}),delete t.textPath);this.added&&(t.textCache="",this.renderer.buildText(t));
	return this};z.prototype.shadow=function(b,d,e){var r=[],k=this.element,t=this.oldShadowOptions,f=this.parentGroup,z=f&&90===f.rotation;f={color:"#000000",offsetX:z?-1:1,offsetY:z?-1:1,opacity:.15,width:3};var c=!1,w;!0===b?w=f:"object"===typeof b&&(w=H(f,b));w&&(w&&t&&g(w,function(b,d){b!==t[d]&&(c=!0)}),c&&this.destroyShadows(),this.oldShadowOptions=w);if(!w)this.destroyShadows();else if(!this.shadows){f=w.opacity/w.width;var M=z?"translate(".concat(w.offsetY,", ").concat(w.offsetX,")"):"translate(".concat(w.offsetX,
	", ").concat(w.offsetY,")");for(z=1;z<=w.width;z++){var h=k.cloneNode(!1);var I=2*w.width+1-2*z;l(h,{stroke:b.color||"#000000","stroke-opacity":f*z,"stroke-width":I,transform:M,fill:"none"});h.setAttribute("class",(h.getAttribute("class")||"")+" highcharts-shadow");e&&(l(h,"height",Math.max(l(h,"height")-I,0)),h.cutHeight=I);d?d.element.appendChild(h):k.parentNode&&k.parentNode.insertBefore(h,k);r.push(h)}this.shadows=r}return this};z.prototype.show=function(b){void 0===b&&(b=!0);return this.attr({visibility:b?
	"inherit":"visible"})};z.prototype["stroke-widthSetter"]=function(b,d,e){this[d]=b;e.setAttribute(d,b)};z.prototype.strokeWidth=function(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var d=this.getStyle("stroke-width"),e=0;if(d.indexOf("px")===d.length-2)e=b(d);else if(""!==d){var r=u.createElementNS(c,"rect");l(r,{width:d,"stroke-width":0});this.element.parentNode.appendChild(r);e=r.getBBox().width;r.parentNode.removeChild(r)}return e};z.prototype.symbolAttr=function(b){var d=this;
	"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(r){d[r]=e(b[r],d[r])});d.attr({d:d.renderer.symbols[d.symbolName](d.x,d.y,d.width,d.height,d)})};z.prototype.textSetter=function(b){b!==this.textStr&&(delete this.textPxLength,this.textStr=b,this.added&&this.renderer.buildText(this))};z.prototype.titleSetter=function(b){var d=this.element,r=d.getElementsByTagName("title")[0]||u.createElementNS(this.SVG_NS,"title");d.insertBefore?d.insertBefore(r,d.firstChild):
	d.appendChild(r);r.textContent=String(e(b,"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")};z.prototype.toFront=function(){var b=this.element;b.parentNode.appendChild(b);return this};z.prototype.translate=function(b,d){return this.attr({translateX:b,translateY:d})};z.prototype.updateShadows=function(b,d,e){var r=this.shadows;if(r)for(var g=r.length;g--;)e.call(r[g],"height"===b?Math.max(d-(r[g].cutHeight||0),0):"d"===b?this.d:d,b,r[g])};z.prototype.updateTransform=function(){var b=
	this.element,d=this.matrix,r=this.rotation;r=void 0===r?0:r;var g=this.scaleX,k=this.scaleY,t=this.translateX,f=this.translateY;t=["translate("+(void 0===t?0:t)+","+(void 0===f?0:f)+")"];D(d)&&t.push("matrix("+d.join(",")+")");r&&t.push("rotate("+r+" "+e(this.rotationOriginX,b.getAttribute("x"),0)+" "+e(this.rotationOriginY,b.getAttribute("y")||0)+")");(D(g)||D(k))&&t.push("scale("+e(g,1)+" "+e(k,1)+")");t.length&&!(this.text||this).textPath&&b.setAttribute("transform",t.join(" "))};z.prototype.visibilitySetter=
	function(b,d,e){"inherit"===b?e.removeAttribute(d):this[d]!==b&&e.setAttribute(d,b);this[d]=b};z.prototype.xGetter=function(b){"circle"===this.element.nodeName&&("x"===b?b="cx":"y"===b&&(b="cy"));return this._defaultGetter(b)};z.prototype.zIndexSetter=function(d,e){var r=this.renderer,g=this.parentGroup,k=(g||r).element||r.box,t=this.element;r=k===r.box;var f=!1;var z=this.added;var c;D(d)?(t.setAttribute("data-z-index",d),d=+d,this[e]===d&&(z=!1)):D(this[e])&&t.removeAttribute("data-z-index");this[e]=
	d;if(z){(d=this.zIndex)&&g&&(g.handleZ=!0);e=k.childNodes;for(c=e.length-1;0<=c&&!f;c--){g=e[c];z=g.getAttribute("data-z-index");var w=!D(z);if(g!==t)if(0>d&&w&&!r&&!c)k.insertBefore(t,e[c]),f=!0;else if(b(z)<=d||w&&(!D(d)||0<=d))k.insertBefore(t,e[c+1]||null),f=!0}f||(k.insertBefore(t,e[r?3:0]||null),f=!0)}return f};return z}();a.prototype.strokeSetter=a.prototype.fillSetter;a.prototype.yGetter=a.prototype.xGetter;a.prototype.matrixSetter=a.prototype.rotationOriginXSetter=a.prototype.rotationOriginYSetter=
	a.prototype.rotationSetter=a.prototype.scaleXSetter=a.prototype.scaleYSetter=a.prototype.translateXSetter=a.prototype.translateYSetter=a.prototype.verticalAlignSetter=function(b,d){this[d]=b;this.doTransform=!0};"";return a});J(a,"Core/Renderer/RendererRegistry.js",[a["Core/Globals.js"]],function(a){var v;(function(v){v.rendererTypes={};var q;v.getRendererType=function(a){void 0===a&&(a=q);return v.rendererTypes[a]||v.rendererTypes[q]};v.registerRendererType=function(A,E,F){v.rendererTypes[A]=E;if(!q||
	F)q=A,a.Renderer=E}})(v||(v={}));return v});J(a,"Core/Renderer/SVG/SVGLabel.js",[a["Core/Renderer/SVG/SVGElement.js"],a["Core/Utilities.js"]],function(a,q){var v=this&&this.__extends||function(){var a=function(c,h){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(c,h){c.__proto__=h}||function(c,h){for(var l in h)h.hasOwnProperty(l)&&(c[l]=h[l])};return a(c,h)};return function(c,h){function m(){this.constructor=c}a(c,h);c.prototype=null===h?Object.create(h):(m.prototype=h.prototype,
	new m)}}(),E=q.defined,B=q.extend,C=q.isNumber,F=q.merge,x=q.pick,u=q.removeEvent;return function(n){function c(h,a,l,p,f,D,G,u,K,y){var t=n.call(this)||this;t.paddingLeftSetter=t.paddingSetter;t.paddingRightSetter=t.paddingSetter;t.init(h,"g");t.textStr=a;t.x=l;t.y=p;t.anchorX=D;t.anchorY=G;t.baseline=K;t.className=y;t.addClass("button"===y?"highcharts-no-tooltip":"highcharts-label");y&&t.addClass("highcharts-"+y);t.text=h.text(void 0,0,0,u).attr({zIndex:1});var w;"string"===typeof f&&((w=/^url\((.*?)\)$/.test(f))||
	t.renderer.symbols[f])&&(t.symbolKey=f);t.bBox=c.emptyBBox;t.padding=3;t.baselineOffset=0;t.needsBox=h.styledMode||w;t.deferredAttr={};t.alignFactor=0;return t}v(c,n);c.prototype.alignSetter=function(c){c={left:0,center:.5,right:1}[c];c!==this.alignFactor&&(this.alignFactor=c,this.bBox&&C(this.xSetting)&&this.attr({x:this.xSetting}))};c.prototype.anchorXSetter=function(c,a){this.anchorX=c;this.boxAttr(a,Math.round(c)-this.getCrispAdjust()-this.xSetting)};c.prototype.anchorYSetter=function(c,a){this.anchorY=
	c;this.boxAttr(a,c-this.ySetting)};c.prototype.boxAttr=function(c,a){this.box?this.box.attr(c,a):this.deferredAttr[c]=a};c.prototype.css=function(h){if(h){var m={};h=F(h);c.textProps.forEach(function(c){"undefined"!==typeof h[c]&&(m[c]=h[c],delete h[c])});this.text.css(m);"fontSize"in m||"fontWeight"in m?this.updateTextPadding():("width"in m||"textOverflow"in m)&&this.updateBoxSize()}return a.prototype.css.call(this,h)};c.prototype.destroy=function(){u(this.element,"mouseenter");u(this.element,"mouseleave");
	this.text&&this.text.destroy();this.box&&(this.box=this.box.destroy());a.prototype.destroy.call(this)};c.prototype.fillSetter=function(c,a){c&&(this.needsBox=!0);this.fill=c;this.boxAttr(a,c)};c.prototype.getBBox=function(){this.textStr&&0===this.bBox.width&&0===this.bBox.height&&this.updateBoxSize();var c=this.padding,a=x(this.paddingLeft,c);return{width:this.width,height:this.height,x:this.bBox.x-a,y:this.bBox.y-c}};c.prototype.getCrispAdjust=function(){return this.renderer.styledMode&&this.box?
	this.box.strokeWidth()%2/2:(this["stroke-width"]?parseInt(this["stroke-width"],10):0)%2/2};c.prototype.heightSetter=function(c){this.heightSetting=c};c.prototype.onAdd=function(){this.text.add(this);this.attr({text:x(this.textStr,""),x:this.x||0,y:this.y||0});this.box&&E(this.anchorX)&&this.attr({anchorX:this.anchorX,anchorY:this.anchorY})};c.prototype.paddingSetter=function(c,a){C(c)?c!==this[a]&&(this[a]=c,this.updateTextPadding()):this[a]=void 0};c.prototype.rSetter=function(c,a){this.boxAttr(a,
	c)};c.prototype.shadow=function(c){c&&!this.renderer.styledMode&&(this.updateBoxSize(),this.box&&this.box.shadow(c));return this};c.prototype.strokeSetter=function(c,a){this.stroke=c;this.boxAttr(a,c)};c.prototype["stroke-widthSetter"]=function(c,a){c&&(this.needsBox=!0);this["stroke-width"]=c;this.boxAttr(a,c)};c.prototype["text-alignSetter"]=function(c){this.textAlign=c};c.prototype.textSetter=function(c){"undefined"!==typeof c&&this.text.attr({text:c});this.updateTextPadding()};c.prototype.updateBoxSize=
	function(){var a=this.text,m=a.element.style,l={},p=this.padding,f=this.bBox=C(this.widthSetting)&&C(this.heightSetting)&&!this.textAlign||!E(a.textStr)?c.emptyBBox:a.getBBox();this.width=this.getPaddedWidth();this.height=(this.heightSetting||f.height||0)+2*p;m=this.renderer.fontMetrics(m&&m.fontSize,a);this.baselineOffset=p+Math.min((this.text.firstLineMetrics||m).b,f.height||Infinity);this.heightSetting&&(this.baselineOffset+=(this.heightSetting-m.h)/2);this.needsBox&&!a.textPath&&(this.box||(a=
	this.box=this.symbolKey?this.renderer.symbol(this.symbolKey):this.renderer.rect(),a.addClass(("button"===this.className?"":"highcharts-label-box")+(this.className?" highcharts-"+this.className+"-box":"")),a.add(this)),a=this.getCrispAdjust(),l.x=a,l.y=(this.baseline?-this.baselineOffset:0)+a,l.width=Math.round(this.width),l.height=Math.round(this.height),this.box.attr(B(l,this.deferredAttr)),this.deferredAttr={})};c.prototype.updateTextPadding=function(){var c=this.text;if(!c.textPath){this.updateBoxSize();
	var a=this.baseline?0:this.baselineOffset,l=x(this.paddingLeft,this.padding);E(this.widthSetting)&&this.bBox&&("center"===this.textAlign||"right"===this.textAlign)&&(l+={center:.5,right:1}[this.textAlign]*(this.widthSetting-this.bBox.width));if(l!==c.x||a!==c.y)c.attr("x",l),c.hasBoxWidthChanged&&(this.bBox=c.getBBox(!0)),"undefined"!==typeof a&&c.attr("y",a);c.x=l;c.y=a}};c.prototype.widthSetter=function(c){this.widthSetting=C(c)?c:void 0};c.prototype.getPaddedWidth=function(){var c=this.padding,
	a=x(this.paddingLeft,c);c=x(this.paddingRight,c);return(this.widthSetting||this.bBox.width||0)+a+c};c.prototype.xSetter=function(c){this.x=c;this.alignFactor&&(c-=this.alignFactor*this.getPaddedWidth(),this["forceAnimate:x"]=!0);this.xSetting=Math.round(c);this.attr("translateX",this.xSetting)};c.prototype.ySetter=function(c){this.ySetting=this.y=Math.round(c);this.attr("translateY",this.ySetting)};c.emptyBBox={width:0,height:0,x:0,y:0};c.textProps="color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" ");
	return c}(a)});J(a,"Core/Renderer/SVG/Symbols.js",[a["Core/Utilities.js"]],function(a){function v(a,u,n,c,h){var m=[];if(h){var l=h.start||0,p=F(h.r,n);n=F(h.r,c||n);var f=(h.end||0)-.001;c=h.innerR;var D=F(h.open,.001>Math.abs((h.end||0)-l-2*Math.PI)),G=Math.cos(l),H=Math.sin(l),K=Math.cos(f),y=Math.sin(f);l=F(h.longArc,.001>f-l-Math.PI?0:1);m.push(["M",a+p*G,u+n*H],["A",p,n,0,l,F(h.clockwise,1),a+p*K,u+n*y]);B(c)&&m.push(D?["M",a+c*K,u+c*y]:["L",a+c*K,u+c*y],["A",c,c,0,l,B(h.clockwise)?1-h.clockwise:
	0,a+c*G,u+c*H]);D||m.push(["Z"])}return m}function A(a,u,n,c,h){return h&&h.r?E(a,u,n,c,h):[["M",a,u],["L",a+n,u],["L",a+n,u+c],["L",a,u+c],["Z"]]}function E(a,u,n,c,h){h=h&&h.r||0;return[["M",a+h,u],["L",a+n-h,u],["C",a+n,u,a+n,u,a+n,u+h],["L",a+n,u+c-h],["C",a+n,u+c,a+n,u+c,a+n-h,u+c],["L",a+h,u+c],["C",a,u+c,a,u+c,a,u+c-h],["L",a,u+h],["C",a,u,a,u,a+h,u]]}var B=a.defined,C=a.isNumber,F=a.pick;return{arc:v,callout:function(a,u,n,c,h){var m=Math.min(h&&h.r||0,n,c),l=m+6,p=h&&h.anchorX;h=h&&h.anchorY||
	0;var f=E(a,u,n,c,{r:m});if(!C(p))return f;a+p>=n?h>u+l&&h<u+c-l?f.splice(3,1,["L",a+n,h-6],["L",a+n+6,h],["L",a+n,h+6],["L",a+n,u+c-m]):f.splice(3,1,["L",a+n,c/2],["L",p,h],["L",a+n,c/2],["L",a+n,u+c-m]):0>=a+p?h>u+l&&h<u+c-l?f.splice(7,1,["L",a,h+6],["L",a-6,h],["L",a,h-6],["L",a,u+m]):f.splice(7,1,["L",a,c/2],["L",p,h],["L",a,c/2],["L",a,u+m]):h&&h>c&&p>a+l&&p<a+n-l?f.splice(5,1,["L",p+6,u+c],["L",p,u+c+6],["L",p-6,u+c],["L",a+m,u+c]):h&&0>h&&p>a+l&&p<a+n-l&&f.splice(1,1,["L",p-6,u],["L",p,u-6],
	["L",p+6,u],["L",n-m,u]);return f},circle:function(a,u,n,c){return v(a+n/2,u+c/2,n/2,c/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},diamond:function(a,u,n,c){return[["M",a+n/2,u],["L",a+n,u+c/2],["L",a+n/2,u+c],["L",a,u+c/2],["Z"]]},rect:A,roundedRect:E,square:A,triangle:function(a,u,n,c){return[["M",a+n/2,u],["L",a+n,u+c],["L",a,u+c],["Z"]]},"triangle-down":function(a,u,n,c){return[["M",a,u],["L",a+n,u],["L",a+n/2,u+c],["Z"]]}}});J(a,"Core/Renderer/SVG/TextBuilder.js",[a["Core/Renderer/HTML/AST.js"],
	a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q,A){var v=q.doc,B=q.SVG_NS,C=q.win,F=A.attr,x=A.extend,u=A.fireEvent,n=A.isString,c=A.objectEach,h=A.pick;return function(){function m(c){var a=c.styles;this.renderer=c.renderer;this.svgElement=c;this.width=c.textWidth;this.textLineHeight=a&&a.lineHeight;this.textOutline=a&&a.textOutline;this.ellipsis=!(!a||"ellipsis"!==a.textOverflow);this.noWrap=!(!a||"nowrap"!==a.whiteSpace);this.fontSize=a&&a.fontSize}m.prototype.buildSVG=function(){var c=
	this.svgElement,m=c.element,f=c.renderer,D=h(c.textStr,"").toString(),G=-1!==D.indexOf("<"),u=m.childNodes;f=this.width&&!c.added&&f.box;var K=/<br.*?>/g,y=[D,this.ellipsis,this.noWrap,this.textLineHeight,this.textOutline,this.fontSize,this.width].join();if(y!==c.textCache){c.textCache=y;delete c.actualWidth;for(y=u.length;y--;)m.removeChild(u[y]);G||this.ellipsis||this.width||c.textPath||-1!==D.indexOf(" ")&&(!this.noWrap||K.test(D))?""!==D&&(f&&f.appendChild(m),D=new a(D),this.modifyTree(D.nodes),
	D.addToDOM(m),this.modifyDOM(),this.ellipsis&&-1!==(m.textContent||"").indexOf("\u2026")&&c.attr("title",this.unescapeEntities(c.textStr||"",["&lt;","&gt;"])),f&&f.removeChild(m)):m.appendChild(v.createTextNode(this.unescapeEntities(D)));n(this.textOutline)&&c.applyTextOutline&&c.applyTextOutline(this.textOutline)}};m.prototype.modifyDOM=function(){var c=this,a=this.svgElement,f=F(a.element,"x");a.firstLineMetrics=void 0;for(var m;m=a.element.firstChild;)if(/^[\s\u200B]*$/.test(m.textContent||" "))a.element.removeChild(m);
	else break;[].forEach.call(a.element.querySelectorAll("tspan.highcharts-br"),function(l,t){l.nextSibling&&l.previousSibling&&(0===t&&1===l.previousSibling.nodeType&&(a.firstLineMetrics=a.renderer.fontMetrics(void 0,l.previousSibling)),F(l,{dy:c.getLineHeight(l.nextSibling),x:f}))});var h=this.width||0;if(h){var n=function(l,t){var w=l.textContent||"",k=w.replace(/([^\^])-/g,"$1- ").split(" "),g=!c.noWrap&&(1<k.length||1<a.element.childNodes.length),e=c.getLineHeight(t),b=0,d=a.actualWidth;if(c.ellipsis)w&&
	c.truncate(l,w,void 0,0,Math.max(0,h-parseInt(c.fontSize||12,10)),function(b,d){return b.substring(0,d)+"\u2026"});else if(g){w=[];for(g=[];t.firstChild&&t.firstChild!==l;)g.push(t.firstChild),t.removeChild(t.firstChild);for(;k.length;)k.length&&!c.noWrap&&0<b&&(w.push(l.textContent||""),l.textContent=k.join(" ").replace(/- /g,"-")),c.truncate(l,void 0,k,0===b?d||0:0,h,function(b,d){return k.slice(0,d).join(" ").replace(/- /g,"-")}),d=a.actualWidth,b++;g.forEach(function(b){t.insertBefore(b,l)});
	w.forEach(function(b){t.insertBefore(v.createTextNode(b),l);b=v.createElementNS(B,"tspan");b.textContent="\u200b";F(b,{dy:e,x:f});t.insertBefore(b,l)})}},u=function(c){[].slice.call(c.childNodes).forEach(function(t){t.nodeType===C.Node.TEXT_NODE?n(t,c):(-1!==t.className.baseVal.indexOf("highcharts-br")&&(a.actualWidth=0),u(t))})};u(a.element)}};m.prototype.getLineHeight=function(c){var a;c=c.nodeType===C.Node.TEXT_NODE?c.parentElement:c;this.renderer.styledMode||(a=c&&/(px|em)$/.test(c.style.fontSize)?
	c.style.fontSize:this.fontSize||this.renderer.style.fontSize||12);return this.textLineHeight?parseInt(this.textLineHeight.toString(),10):this.renderer.fontMetrics(a,c||this.svgElement.element).h};m.prototype.modifyTree=function(c){var a=this,f=function(l,m){var h=l.attributes;h=void 0===h?{}:h;var p=l.children,y=l.style;y=void 0===y?{}:y;var t=l.tagName,w=a.renderer.styledMode;if("b"===t||"strong"===t)w?h["class"]="highcharts-strong":y.fontWeight="bold";else if("i"===t||"em"===t)w?h["class"]="highcharts-emphasized":
	y.fontStyle="italic";y&&y.color&&(y.fill=y.color);"br"===t?(h["class"]="highcharts-br",l.textContent="\u200b",(m=c[m+1])&&m.textContent&&(m.textContent=m.textContent.replace(/^ +/gm,""))):"a"===t&&p&&p.some(function(k){return"#text"===k.tagName})&&(l.children=[{children:p,tagName:"tspan"}]);"#text"!==t&&"a"!==t&&(l.tagName="tspan");x(l,{attributes:h,style:y});p&&p.filter(function(k){return"#text"!==k.tagName}).forEach(f)};c.forEach(f);u(this.svgElement,"afterModifyTree",{nodes:c})};m.prototype.truncate=
	function(c,a,f,m,h,n){var l=this.svgElement,p=l.renderer,t=l.rotation,w=[],k=f?1:0,g=(a||f||"").length,e=g,b,d=function(b,d){d=d||b;var e=c.parentNode;if(e&&"undefined"===typeof w[d])if(e.getSubStringLength)try{w[d]=m+e.getSubStringLength(0,f?d+1:d)}catch(P){""}else p.getSpanWidth&&(c.textContent=n(a||f,b),w[d]=m+p.getSpanWidth(l,c));return w[d]};l.rotation=0;var r=d(c.textContent.length);if(m+r>h){for(;k<=g;)e=Math.ceil((k+g)/2),f&&(b=n(f,e)),r=d(e,b&&b.length-1),k===g?k=g+1:r>h?g=e-1:k=e;0===g?
	c.textContent="":a&&g===a.length-1||(c.textContent=b||n(a||f,e))}f&&f.splice(0,e);l.actualWidth=r;l.rotation=t};m.prototype.unescapeEntities=function(a,m){c(this.renderer.escapes,function(c,l){m&&-1!==m.indexOf(c)||(a=a.toString().replace(new RegExp(c,"g"),l))});return a};return m}()});J(a,"Core/Renderer/SVG/SVGRenderer.js",[a["Core/Renderer/HTML/AST.js"],a["Core/Color/Color.js"],a["Core/Globals.js"],a["Core/Renderer/RendererRegistry.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Renderer/SVG/SVGLabel.js"],
	a["Core/Renderer/SVG/Symbols.js"],a["Core/Renderer/SVG/TextBuilder.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x,u){var n=A.charts,c=A.deg2rad,h=A.doc,m=A.isFirefox,l=A.isMS,p=A.isWebKit,f=A.noop,D=A.SVG_NS,G=A.symbolSizes,H=A.win,K=u.addEvent,y=u.attr,t=u.createElement,w=u.css,k=u.defined,g=u.destroyObjectProperties,e=u.extend,b=u.isArray,d=u.isNumber,r=u.isObject,z=u.isString,I=u.merge,N=u.pick,P=u.pInt,O=u.uniqueKey,U;A=function(){function f(b,d,e,r,g,k,c){this.width=this.url=this.style=
	this.isSVG=this.imgCount=this.height=this.gradients=this.globalAnimation=this.defs=this.chartIndex=this.cacheKeys=this.cache=this.boxWrapper=this.box=this.alignedObjects=void 0;this.init(b,d,e,r,g,k,c)}f.prototype.init=function(b,d,e,r,g,k,c){var t=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}),f=t.element;c||t.css(this.getStyle(r));b.appendChild(f);y(b,"dir","ltr");-1===b.innerHTML.indexOf("xmlns")&&y(f,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=f;this.boxWrapper=t;this.alignedObjects=
	[];this.url=this.getReferenceURL();this.createElement("desc").add().element.appendChild(h.createTextNode("Created with Highcharts 10.3.3"));this.defs=this.createElement("defs").add();this.allowHTML=k;this.forExport=g;this.styledMode=c;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(d,e,!1);var a;m&&b.getBoundingClientRect&&(d=function(){w(b,{left:0,top:0});a=b.getBoundingClientRect();w(b,{left:Math.ceil(a.left)-a.left+"px",top:Math.ceil(a.top)-a.top+"px"})},d(),this.unSubPixelFix=
	K(H,"resize",d))};f.prototype.definition=function(b){return(new a([b])).addToDOM(this.defs.element)};f.prototype.getReferenceURL=function(){if((m||p)&&h.getElementsByTagName("base").length){if(!k(U)){var b=O();b=(new a([{tagName:"svg",attributes:{width:8,height:8},children:[{tagName:"defs",children:[{tagName:"clipPath",attributes:{id:b},children:[{tagName:"rect",attributes:{width:4,height:4}}]}]},{tagName:"rect",attributes:{id:"hitme",width:8,height:8,"clip-path":"url(#".concat(b,")"),fill:"rgba(0,0,0,0.001)"}}]}])).addToDOM(h.body);
	w(b,{position:"fixed",top:0,left:0,zIndex:9E5});var d=h.elementFromPoint(6,6);U="hitme"===(d&&d.id);h.body.removeChild(b)}if(U)return H.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20")}return""};f.prototype.getStyle=function(b){return this.style=e({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},b)};f.prototype.setStyle=function(b){this.boxWrapper.css(this.getStyle(b))};f.prototype.isHidden=function(){return!this.boxWrapper.getBBox().width};
	f.prototype.destroy=function(){var b=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();g(this.gradients||{});this.gradients=null;b&&(this.defs=b.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null};f.prototype.createElement=function(b){var d=new this.Element;d.init(this,b);return d};f.prototype.getRadialAttr=function(b,d){return{cx:b[0]-b[2]/2+(d.cx||0)*b[2],cy:b[1]-b[2]/2+(d.cy||0)*b[2],r:(d.r||0)*b[2]}};f.prototype.buildText=function(b){(new x(b)).buildSVG()};
	f.prototype.getContrast=function(b){b=q.parse(b).rgba.map(function(b){b/=255;return.03928>=b?b/12.92:Math.pow((b+.055)/1.055,2.4)});b=.2126*b[0]+.7152*b[1]+.0722*b[2];return 1.05/(b+.05)>(b+.05)/.05?"#FFFFFF":"#000000"};f.prototype.button=function(b,d,g,k,c,t,f,z,L,w){void 0===c&&(c={});var M=this.label(b,d,g,L,void 0,void 0,w,void 0,"button"),m=this.styledMode;b=c.states||{};var h=0;c=I(c);delete c.states;var S=I({color:"#333333",cursor:"pointer",fontWeight:"normal"},c.style);delete c.style;var p=
	a.filterUserAttributes(c);M.attr(I({padding:8,r:2},p));if(!m){p=I({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1},p);t=I(p,{fill:"#e6e6e6"},a.filterUserAttributes(t||b.hover||{}));var y=t.style;delete t.style;f=I(p,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},a.filterUserAttributes(f||b.select||{}));var Q=f.style;delete f.style;z=I(p,{style:{color:"#cccccc"}},a.filterUserAttributes(z||b.disabled||{}));var n=z.style;delete z.style}K(M.element,l?"mouseover":"mouseenter",function(){3!==
	h&&M.setState(1)});K(M.element,l?"mouseout":"mouseleave",function(){3!==h&&M.setState(h)});M.setState=function(b){1!==b&&(M.state=h=b);M.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][b||0]);m||(M.attr([p,t,f,z][b||0]),b=[S,y,Q,n][b||0],r(b)&&M.css(b))};m||(M.attr(p).css(e({cursor:"default"},S)),w&&M.text.css({pointerEvents:"none"}));return M.on("touchstart",function(b){return b.stopPropagation()}).on("click",
	function(b){3!==h&&k.call(M,b)})};f.prototype.crispLine=function(b,d,e){void 0===e&&(e="round");var r=b[0],g=b[1];k(r[1])&&r[1]===g[1]&&(r[1]=g[1]=Math[e](r[1])-d%2/2);k(r[2])&&r[2]===g[2]&&(r[2]=g[2]=Math[e](r[2])+d%2/2);return b};f.prototype.path=function(d){var g=this.styledMode?{}:{fill:"none"};b(d)?g.d=d:r(d)&&e(g,d);return this.createElement("path").attr(g)};f.prototype.circle=function(b,d,e){b=r(b)?b:"undefined"===typeof b?{}:{x:b,y:d,r:e};d=this.createElement("circle");d.xSetter=d.ySetter=
	function(b,d,e){e.setAttribute("c"+d,b)};return d.attr(b)};f.prototype.arc=function(b,d,e,g,k,c){r(b)?(g=b,d=g.y,e=g.r,b=g.x):g={innerR:g,start:k,end:c};b=this.symbol("arc",b,d,e,e,g);b.r=e;return b};f.prototype.rect=function(b,d,e,g,k,c){k=r(b)?b.r:k;var t=this.createElement("rect");b=r(b)?b:"undefined"===typeof b?{}:{x:b,y:d,width:Math.max(e,0),height:Math.max(g,0)};this.styledMode||("undefined"!==typeof c&&(b["stroke-width"]=c,b=t.crisp(b)),b.fill="none");k&&(b.r=k);t.rSetter=function(b,d,e){t.r=
	b;y(e,{rx:b,ry:b})};t.rGetter=function(){return t.r||0};return t.attr(b)};f.prototype.setSize=function(b,d,e){this.width=b;this.height=d;this.boxWrapper.animate({width:b,height:d},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:N(e,!0)?void 0:0});this.alignElements()};f.prototype.g=function(b){var d=this.createElement("g");return b?d.attr({"class":"highcharts-"+b}):d};f.prototype.image=function(b,e,g,r,k,c){var t={preserveAspectRatio:"none"},f=function(b,
	d){b.setAttributeNS?b.setAttributeNS("http://www.w3.org/1999/xlink","href",d):b.setAttribute("hc-svg-href",d)};d(e)&&(t.x=e);d(g)&&(t.y=g);d(r)&&(t.width=r);d(k)&&(t.height=k);var a=this.createElement("image").attr(t);e=function(d){f(a.element,b);c.call(a,d)};c?(f(a.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),g=new H.Image,K(g,"load",e),g.src=b,g.complete&&e({})):f(a.element,b);return a};f.prototype.symbol=function(b,d,g,r,c,f){var a=this,z=/^url\((.*?)\)$/,
	L=z.test(b),M=!L&&(this.symbols[b]?b:"circle"),l=M&&this.symbols[M],m;if(l){"number"===typeof d&&(m=l.call(this.symbols,Math.round(d||0),Math.round(g||0),r||0,c||0,f));var I=this.path(m);a.styledMode||I.attr("fill","none");e(I,{symbolName:M||void 0,x:d,y:g,width:r,height:c});f&&e(I,f)}else if(L){var p=b.match(z)[1];var S=I=this.image(p);S.imgwidth=N(G[p]&&G[p].width,f&&f.width);S.imgheight=N(G[p]&&G[p].height,f&&f.height);var D=function(b){return b.attr({width:b.width,height:b.height})};["width",
	"height"].forEach(function(b){S[b+"Setter"]=function(b,d){this[d]=b;b=this.alignByTranslate;var e=this.element,g=this.width,r=this.height,c=this.imgwidth,t=this.imgheight,a=this["img"+d];if(k(a)){var z=1;f&&"within"===f.backgroundSize&&g&&r?(z=Math.min(g/c,r/t),a=Math.round(a*z),y(e,{width:Math.round(c*z),height:Math.round(t*z)})):e&&e.setAttribute(d,a);b||this.translate(((g||0)-a*z)/2,((r||0)-a*z)/2)}}});k(d)&&S.attr({x:d,y:g});S.isImg=!0;k(S.imgwidth)&&k(S.imgheight)?D(S):(S.attr({width:0,height:0}),
	t("img",{onload:function(){var b=n[a.chartIndex];0===this.width&&(w(this,{position:"absolute",top:"-999em"}),h.body.appendChild(this));G[p]={width:this.width,height:this.height};S.imgwidth=this.width;S.imgheight=this.height;S.element&&D(S);this.parentNode&&this.parentNode.removeChild(this);a.imgCount--;if(!a.imgCount&&b&&!b.hasLoaded)b.onload()},src:p}),this.imgCount++)}return I};f.prototype.clipRect=function(b,d,e,g){var r=O()+"-",k=this.createElement("clipPath").attr({id:r}).add(this.defs);b=this.rect(b,
	d,e,g,0).add(k);b.id=r;b.clipPath=k;b.count=0;return b};f.prototype.text=function(b,d,e,g){var r={};if(g&&(this.allowHTML||!this.forExport))return this.html(b,d,e);r.x=Math.round(d||0);e&&(r.y=Math.round(e));k(b)&&(r.text=b);b=this.createElement("text").attr(r);if(!g||this.forExport&&!this.allowHTML)b.xSetter=function(b,d,e){for(var g=e.getElementsByTagName("tspan"),r=e.getAttribute(d),k=0,c;k<g.length;k++)c=g[k],c.getAttribute(d)===r&&c.setAttribute(d,b);e.setAttribute(d,b)};return b};f.prototype.fontMetrics=
	function(b,d){b=!this.styledMode&&/px/.test(b)||!H.getComputedStyle?b||d&&d.style&&d.style.fontSize||this.style&&this.style.fontSize:d&&B.prototype.getStyle.call(d,"font-size");b=/px/.test(b)?P(b):12;d=24>b?b+3:Math.round(1.2*b);return{h:d,b:Math.round(.8*d),f:b}};f.prototype.rotCorr=function(b,d,e){var g=b;d&&e&&(g=Math.max(g*Math.cos(d*c),4));return{x:-b/3*Math.sin(d*c),y:g}};f.prototype.pathToSegments=function(b){for(var e=[],g=[],r={A:8,C:7,H:2,L:3,M:3,Q:5,S:5,T:3,V:2},k=0;k<b.length;k++)z(g[0])&&
	d(b[k])&&g.length===r[g[0].toUpperCase()]&&b.splice(k,0,g[0].replace("M","L").replace("m","l")),"string"===typeof b[k]&&(g.length&&e.push(g.slice(0)),g.length=0),g.push(b[k]);e.push(g.slice(0));return e};f.prototype.label=function(b,d,e,g,r,k,c,t,f){return new C(this,b,d,e,g,r,k,c,t,f)};f.prototype.alignElements=function(){this.alignedObjects.forEach(function(b){return b.align()})};return f}();e(A.prototype,{Element:B,SVG_NS:D,escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},symbols:F,
	draw:f});E.registerRendererType("svg",A,!0);"";return A});J(a,"Core/Renderer/HTML/HTMLElement.js",[a["Core/Globals.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Utilities.js"]],function(a,q,A){var v=this&&this.__extends||function(){var c=function(a,f){c=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(c,f){c.__proto__=f}||function(c,f){for(var a in f)f.hasOwnProperty(a)&&(c[a]=f[a])};return c(a,f)};return function(a,f){function l(){this.constructor=a}c(a,f);a.prototype=null===f?
	Object.create(f):(l.prototype=f.prototype,new l)}}(),B=a.isFirefox,C=a.isMS,F=a.isWebKit,x=a.win,u=A.css,n=A.defined,c=A.extend,h=A.pick,m=A.pInt;return function(a){function l(){return null!==a&&a.apply(this,arguments)||this}v(l,a);l.compose=function(c){if(-1===l.composedClasses.indexOf(c)){l.composedClasses.push(c);var a=l.prototype,f=c.prototype;f.getSpanCorrection=a.getSpanCorrection;f.htmlCss=a.htmlCss;f.htmlGetBBox=a.htmlGetBBox;f.htmlUpdateTransform=a.htmlUpdateTransform;f.setSpanRotation=a.setSpanRotation}return c};
	l.prototype.getSpanCorrection=function(c,a,l){this.xCorr=-c*l;this.yCorr=-a};l.prototype.htmlCss=function(a){var f="SPAN"===this.element.tagName&&a&&"width"in a,l=h(f&&a.width,void 0);if(f){delete a.width;this.textWidth=l;var m=!0}a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=c(this.styles,a);u(this.element,a);m&&this.htmlUpdateTransform();return this};l.prototype.htmlGetBBox=function(){var c=this.element;return{x:c.offsetLeft,y:c.offsetTop,width:c.offsetWidth,
	height:c.offsetHeight}};l.prototype.htmlUpdateTransform=function(){if(this.added){var c=this.renderer,a=this.element,l=this.translateX||0,h=this.translateY||0,p=this.x||0,y=this.y||0,t=this.textAlign||"left",w={left:0,center:.5,right:1}[t],k=this.styles;k=k&&k.whiteSpace;u(a,{marginLeft:l,marginTop:h});!c.styledMode&&this.shadows&&this.shadows.forEach(function(b){u(b,{marginLeft:l+1,marginTop:h+1})});this.inverted&&[].forEach.call(a.childNodes,function(b){c.invertChild(b,a)});if("SPAN"===a.tagName){var g=
	this.rotation,e=this.textWidth&&m(this.textWidth),b=[g,t,a.innerHTML,this.textWidth,this.textAlign].join(),d=void 0;d=!1;if(e!==this.oldTextWidth){if(this.textPxLength)var r=this.textPxLength;else u(a,{width:"",whiteSpace:k||"nowrap"}),r=a.offsetWidth;(e>this.oldTextWidth||r>e)&&(/[ \-]/.test(a.textContent||a.innerText)||"ellipsis"===a.style.textOverflow)&&(u(a,{width:r>e||g?e+"px":"auto",display:"block",whiteSpace:k||"normal"}),this.oldTextWidth=e,d=!0)}this.hasBoxWidthChanged=d;b!==this.cTT&&(d=
	c.fontMetrics(a.style.fontSize,a).b,!n(g)||g===(this.oldRotation||0)&&t===this.oldAlign||this.setSpanRotation(g,w,d),this.getSpanCorrection(!n(g)&&this.textPxLength||a.offsetWidth,d,w,g,t));u(a,{left:p+(this.xCorr||0)+"px",top:y+(this.yCorr||0)+"px"});this.cTT=b;this.oldRotation=g;this.oldAlign=t}}else this.alignOnAdd=!0};l.prototype.setSpanRotation=function(c,a,l){var f={},m=C&&!/Edge/.test(x.navigator.userAgent)?"-ms-transform":F?"-webkit-transform":B?"MozTransform":x.opera?"-o-transform":void 0;
	m&&(f[m]=f.transform="rotate("+c+"deg)",f[m+(B?"Origin":"-origin")]=f.transformOrigin=100*a+"% "+l+"px",u(this.element,f))};l.composedClasses=[];return l}(q)});J(a,"Core/Renderer/HTML/HTMLRenderer.js",[a["Core/Renderer/HTML/AST.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Renderer/SVG/SVGRenderer.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=this&&this.__extends||function(){var a=function(c,h){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(c,a){c.__proto__=a}||function(c,
	a){for(var l in a)a.hasOwnProperty(l)&&(c[l]=a[l])};return a(c,h)};return function(c,h){function m(){this.constructor=c}a(c,h);c.prototype=null===h?Object.create(h):(m.prototype=h.prototype,new m)}}(),C=E.attr,F=E.createElement,x=E.extend,u=E.pick;return function(n){function c(){return null!==n&&n.apply(this,arguments)||this}v(c,n);c.compose=function(a){-1===c.composedClasses.indexOf(a)&&(c.composedClasses.push(a),a.prototype.html=c.prototype.html);return a};c.prototype.html=function(c,m,l){var h=
	this.createElement("span"),f=h.element,n=h.renderer,G=n.isSVG,v=function(c,a){["opacity","visibility"].forEach(function(t){c[t+"Setter"]=function(f,k,g){var e=c.div?c.div.style:a;q.prototype[t+"Setter"].call(this,f,k,g);e&&(e[k]=f)}});c.addedSetters=!0};h.textSetter=function(c){c!==this.textStr&&(delete this.bBox,delete this.oldTextWidth,a.setElementHTML(this.element,u(c,"")),this.textStr=c,h.doTransform=!0)};G&&v(h,h.element.style);h.xSetter=h.ySetter=h.alignSetter=h.rotationSetter=function(c,a){"align"===
	a?h.alignValue=h.textAlign=c:h[a]=c;h.doTransform=!0};h.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};h.attr({text:c,x:Math.round(m),y:Math.round(l)}).css({position:"absolute"});n.styledMode||h.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});f.style.whiteSpace="nowrap";h.css=h.htmlCss;G&&(h.add=function(c){var a=n.box.parentNode,t=[];if(this.parentGroup=c){var w=c.div;if(!w){for(;c;)t.push(c),c=c.parentGroup;t.reverse().forEach(function(k){function g(b,
	e){k[e]=b;"translateX"===e?d.left=b+"px":d.top=b+"px";k.doTransform=!0}var e=C(k.element,"class"),b=k.styles||{};w=k.div=k.div||F("div",e?{className:e}:void 0,{position:"absolute",left:(k.translateX||0)+"px",top:(k.translateY||0)+"px",display:k.display,opacity:k.opacity,cursor:b.cursor,pointerEvents:b.pointerEvents,visibility:k.visibility},w||a);var d=w.style;x(k,{classSetter:function(b){return function(d){this.element.setAttribute("class",d);b.className=d}}(w),on:function(){t[0].div&&h.on.apply({element:t[0].div,
	onEvents:k.onEvents},arguments);return k},translateXSetter:g,translateYSetter:g});k.addedSetters||v(k)})}}else w=a;w.appendChild(f);h.added=!0;h.alignOnAdd&&h.htmlUpdateTransform();return h});return h};c.composedClasses=[];return c}(A)});J(a,"Core/Axis/AxisDefaults.js",[],function(){var a;(function(a){a.defaultXAxisOptions={alignTicks:!0,allowDecimals:void 0,panningEnabled:!0,zIndex:2,zoomEnabled:!0,dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",range:!1},second:{main:"%H:%M:%S",range:!1},
	minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,gridLineDashStyle:"Solid",gridZIndex:1,labels:{autoRotation:void 0,autoRotationLimit:80,distance:void 0,enabled:!0,indentation:10,overflow:"justify",padding:5,reserveSpace:void 0,rotation:void 0,staggerLines:0,step:0,useHTML:!1,x:0,zIndex:7,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorGridLineDashStyle:"Solid",minorTickLength:2,
	minorTickPosition:"outside",minPadding:.01,offset:void 0,opposite:!1,reversed:void 0,reversedStacks:!1,showEmpty:!0,showFirstLabel:!0,showLastLabel:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",rotation:0,useHTML:!1,x:0,y:0,style:{color:"#666666"}},type:"linear",uniqueNames:!0,visible:!0,minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",
	gridLineWidth:void 0,tickColor:"#ccd6eb"};a.defaultYAxisOptions={reversedStacks:!0,endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{animation:{},allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){var a=this.axis.chart.numberFormatter;return a(this.total||0,-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0};
	a.defaultLeftAxisOptions={labels:{x:-15},title:{rotation:270}};a.defaultRightAxisOptions={labels:{x:15},title:{rotation:90}};a.defaultBottomAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};a.defaultTopAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}}})(a||(a={}));return a});J(a,"Core/Foundation.js",[a["Core/Utilities.js"]],function(a){var v=a.addEvent,A=a.isFunction,E=a.objectEach,B=a.removeEvent,C;(function(a){a.registerEventOptions=function(a,u){a.eventOptions=
	a.eventOptions||{};E(u.events,function(n,c){a.eventOptions[c]!==n&&(a.eventOptions[c]&&(B(a,c,a.eventOptions[c]),delete a.eventOptions[c]),A(n)&&(a.eventOptions[c]=n,v(a,c,n)))})}})(C||(C={}));return C});J(a,"Core/Axis/Tick.js",[a["Core/FormatUtilities.js"],a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q,A){var v=q.deg2rad,B=A.clamp,C=A.correctFloat,F=A.defined,x=A.destroyObjectProperties,u=A.extend,n=A.fireEvent,c=A.isNumber,h=A.merge,m=A.objectEach,l=A.pick;q=function(){function p(a,c,
	l,h,m){this.isNewLabel=this.isNew=!0;this.axis=a;this.pos=c;this.type=l||"";this.parameters=m||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;n(this,"init");l||h||this.addLabel()}p.prototype.addLabel=function(){var f=this,h=f.axis,m=h.options,p=h.chart,v=h.categories,y=h.logarithmic,t=h.names,w=f.pos,k=l(f.options&&f.options.labels,m.labels),g=h.tickPositions,e=w===g[0],b=w===g[g.length-1],d=(!k.step||1===k.step)&&1===h.tickInterval;g=g.info;var r=f.label,
	z;v=this.parameters.category||(v?l(v[w],t[w],w):w);y&&c(v)&&(v=C(y.lin2log(v)));if(h.dateTime)if(g){var I=p.time.resolveDTLFormat(m.dateTimeLabelFormats[!m.grid&&g.higherRanks[w]||g.unitName]);var N=I.main}else c(v)&&(N=h.dateTime.getXDateFormat(v,m.dateTimeLabelFormats||{}));f.isFirst=e;f.isLast=b;var P={axis:h,chart:p,dateTimeLabelFormat:N,isFirst:e,isLast:b,pos:w,tick:f,tickPositionInfo:g,value:v};n(this,"labelFormat",P);var O=function(b){return k.formatter?k.formatter.call(b,b):k.format?(b.text=
	h.defaultLabelFormatter.call(b,b),a.format(k.format,b,p)):h.defaultLabelFormatter.call(b,b)};m=O.call(P,P);var U=I&&I.list;f.shortenLabel=U?function(){for(z=0;z<U.length;z++)if(u(P,{dateTimeLabelFormat:U[z]}),r.attr({text:O.call(P,P)}),r.getBBox().width<h.getSlotWidth(f)-2*k.padding)return;r.attr({text:""})}:void 0;d&&h._addedPlotLB&&f.moveLabel(m,k);F(r)||f.movedLabel?r&&r.textStr!==m&&!d&&(!r.textWidth||k.style.width||r.styles.width||r.css({width:null}),r.attr({text:m}),r.textPxLength=r.getBBox().width):
	(f.label=r=f.createLabel({x:0,y:0},m,k),f.rotation=0)};p.prototype.createLabel=function(a,c,l){var f=this.axis,m=f.chart;if(a=F(c)&&l.enabled?m.renderer.text(c,a.x,a.y,l.useHTML).add(f.labelGroup):null)m.styledMode||a.css(h(l.style)),a.textPxLength=a.getBBox().width;return a};p.prototype.destroy=function(){x(this,this.axis)};p.prototype.getPosition=function(a,c,l,h){var f=this.axis,m=f.chart,t=h&&m.oldChartHeight||m.chartHeight;a={x:a?C(f.translate(c+l,void 0,void 0,h)+f.transB):f.left+f.offset+(f.opposite?
	(h&&m.oldChartWidth||m.chartWidth)-f.right-f.left:0),y:a?t-f.bottom+f.offset-(f.opposite?f.height:0):C(t-f.translate(c+l,void 0,void 0,h)-f.transB)};a.y=B(a.y,-1E5,1E5);n(this,"afterGetPosition",{pos:a});return a};p.prototype.getLabelPosition=function(a,c,l,h,m,p,t,w){var k=this.axis,g=k.transA,e=k.isLinked&&k.linkedParent?k.linkedParent.reversed:k.reversed,b=k.staggerLines,d=k.tickRotCorr||{x:0,y:0},r=h||k.reserveSpaceDefault?0:-k.labelOffset*("center"===k.labelAlign?.5:1),f={};l=0===k.side?l.rotation?
	-8:-l.getBBox().height:2===k.side?d.y+8:Math.cos(l.rotation*v)*(d.y-l.getBBox(!1,0).height/2);F(m.y)&&(l=0===k.side&&k.horiz?m.y+l:m.y);a=a+m.x+r+d.x-(p&&h?p*g*(e?-1:1):0);c=c+l-(p&&!h?p*g*(e?1:-1):0);b&&(h=t/(w||1)%b,k.opposite&&(h=b-h-1),c+=k.labelOffset/b*h);f.x=a;f.y=Math.round(c);n(this,"afterGetLabelPosition",{pos:f,tickmarkOffset:p,index:t});return f};p.prototype.getLabelSize=function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0};p.prototype.getMarkPath=function(a,
	c,l,h,m,p){return p.crispLine([["M",a,c],["L",a+(m?0:-l),c+(m?l:0)]],h)};p.prototype.handleOverflow=function(a){var c=this.axis,f=c.options.labels,h=a.x,m=c.chart.chartWidth,p=c.chart.spacing,t=l(c.labelLeft,Math.min(c.pos,p[3]));p=l(c.labelRight,Math.max(c.isRadial?0:c.pos+c.len,m-p[1]));var w=this.label,k=this.rotation,g={left:0,center:.5,right:1}[c.labelAlign||w.attr("align")],e=w.getBBox().width,b=c.getSlotWidth(this),d={},r=b,z=1,I;if(k||"justify"!==f.overflow)0>k&&h-g*e<t?I=Math.round(h/Math.cos(k*
	v)-t):0<k&&h+g*e>p&&(I=Math.round((m-h)/Math.cos(k*v)));else if(m=h+(1-g)*e,h-g*e<t?r=a.x+r*(1-g)-t:m>p&&(r=p-a.x+r*g,z=-1),r=Math.min(b,r),r<b&&"center"===c.labelAlign&&(a.x+=z*(b-r-g*(b-Math.min(e,r)))),e>r||c.autoRotation&&(w.styles||{}).width)I=r;I&&(this.shortenLabel?this.shortenLabel():(d.width=Math.floor(I)+"px",(f.style||{}).textOverflow||(d.textOverflow="ellipsis"),w.css(d)))};p.prototype.moveLabel=function(a,c){var f=this,l=f.label,h=f.axis,p=h.reversed,t=!1;l&&l.textStr===a?(f.movedLabel=
	l,t=!0,delete f.label):m(h.ticks,function(c){t||c.isNew||c===f||!c.label||c.label.textStr!==a||(f.movedLabel=c.label,t=!0,c.labelPos=f.movedLabel.xy,delete c.label)});if(!t&&(f.labelPos||l)){var w=f.labelPos||l.xy;l=h.horiz?p?0:h.width+h.left:w.x;h=h.horiz?w.y:p?h.width+h.left:0;f.movedLabel=f.createLabel({x:l,y:h},a,c);f.movedLabel&&f.movedLabel.attr({opacity:0})}};p.prototype.render=function(c,a,h){var f=this.axis,m=f.horiz,p=this.pos,t=l(this.tickmarkOffset,f.tickmarkOffset);p=this.getPosition(m,
	p,t,a);t=p.x;var w=p.y;f=m&&t===f.pos+f.len||!m&&w===f.pos?-1:1;m=l(h,this.label&&this.label.newOpacity,1);h=l(h,1);this.isActive=!0;this.renderGridLine(a,h,f);this.renderMark(p,h,f);this.renderLabel(p,a,m,c);this.isNew=!1;n(this,"afterRender")};p.prototype.renderGridLine=function(c,a,h){var f=this.axis,m=f.options,p={},t=this.pos,w=this.type,k=l(this.tickmarkOffset,f.tickmarkOffset),g=f.chart.renderer,e=this.gridLine,b=m.gridLineWidth,d=m.gridLineColor,r=m.gridLineDashStyle;"minor"===this.type&&
	(b=m.minorGridLineWidth,d=m.minorGridLineColor,r=m.minorGridLineDashStyle);e||(f.chart.styledMode||(p.stroke=d,p["stroke-width"]=b||0,p.dashstyle=r),w||(p.zIndex=1),c&&(a=0),this.gridLine=e=g.path().attr(p).addClass("highcharts-"+(w?w+"-":"")+"grid-line").add(f.gridGroup));if(e&&(h=f.getPlotLinePath({value:t+k,lineWidth:e.strokeWidth()*h,force:"pass",old:c,acrossPanes:!1})))e[c||this.isNew?"attr":"animate"]({d:h,opacity:a})};p.prototype.renderMark=function(c,a,h){var f=this.axis,m=f.options,p=f.chart.renderer,
	t=this.type,w=f.tickSize(t?t+"Tick":"tick"),k=c.x;c=c.y;var g=l(m["minor"!==t?"tickWidth":"minorTickWidth"],!t&&f.isXAxis?1:0);m=m["minor"!==t?"tickColor":"minorTickColor"];var e=this.mark,b=!e;w&&(f.opposite&&(w[0]=-w[0]),e||(this.mark=e=p.path().addClass("highcharts-"+(t?t+"-":"")+"tick").add(f.axisGroup),f.chart.styledMode||e.attr({stroke:m,"stroke-width":g})),e[b?"attr":"animate"]({d:this.getMarkPath(k,c,w[0],e.strokeWidth()*h,f.horiz,p),opacity:a}))};p.prototype.renderLabel=function(a,h,m,p){var f=
	this.axis,y=f.horiz,t=f.options,w=this.label,k=t.labels,g=k.step;f=l(this.tickmarkOffset,f.tickmarkOffset);var e=a.x;a=a.y;var b=!0;w&&c(e)&&(w.xy=a=this.getLabelPosition(e,a,w,y,k,f,p,g),this.isFirst&&!this.isLast&&!t.showFirstLabel||this.isLast&&!this.isFirst&&!t.showLastLabel?b=!1:!y||k.step||k.rotation||h||0===m||this.handleOverflow(a),g&&p%g&&(b=!1),b&&c(a.y)?(a.opacity=m,w[this.isNewLabel?"attr":"animate"](a).show(!0),this.isNewLabel=!1):(w.hide(),this.isNewLabel=!0))};p.prototype.replaceMovedLabel=
	function(){var a=this.label,c=this.axis,h=c.reversed;if(a&&!this.isNew){var l=c.horiz?h?c.left:c.width+c.left:a.xy.x;h=c.horiz?a.xy.y:h?c.width+c.top:c.top;a.animate({x:l,y:h,opacity:0},void 0,a.destroy);delete this.label}c.isDirty=!0;this.label=this.movedLabel;delete this.movedLabel};return p}();"";return q});J(a,"Core/Axis/Axis.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/Axis/AxisDefaults.js"],a["Core/Color/Color.js"],a["Core/Defaults.js"],a["Core/Foundation.js"],a["Core/Globals.js"],
	a["Core/Axis/Tick.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x){var u=a.animObject,n=E.defaultOptions,c=B.registerEventOptions,h=C.deg2rad,m=x.arrayMax,l=x.arrayMin,p=x.clamp,f=x.correctFloat,D=x.defined,v=x.destroyObjectProperties,H=x.erase,K=x.error,y=x.extend,t=x.fireEvent,w=x.isArray,k=x.isNumber,g=x.isString,e=x.merge,b=x.normalizeTickInterval,d=x.objectEach,r=x.pick,z=x.relativeLength,I=x.removeEvent,N=x.splat,P=x.syncTimeout,O=function(d,e){return b(e,void 0,void 0,r(d.options.allowDecimals,
	.5>e||void 0!==d.tickAmount),!!d.tickAmount)};a=function(){function b(b,d){this.zoomEnabled=this.width=this.visible=this.userOptions=this.translationSlope=this.transB=this.transA=this.top=this.ticks=this.tickRotCorr=this.tickPositions=this.tickmarkOffset=this.tickInterval=this.tickAmount=this.side=this.series=this.right=this.positiveValuesOnly=this.pos=this.pointRangePadding=this.pointRange=this.plotLinesAndBandsGroups=this.plotLinesAndBands=this.paddedTicks=this.overlap=this.options=this.offset=
	this.names=this.minPixelPadding=this.minorTicks=this.minorTickInterval=this.min=this.maxLabelLength=this.max=this.len=this.left=this.labelFormatter=this.labelEdge=this.isLinked=this.height=this.hasVisibleSeries=this.hasNames=this.eventOptions=this.coll=this.closestPointRange=this.chart=this.bottom=this.alternateBands=void 0;this.init(b,d)}b.prototype.init=function(b,d){var e=d.isX;this.chart=b;this.horiz=b.inverted&&!this.isZAxis?!e:e;this.isXAxis=e;this.coll=this.coll||(e?"xAxis":"yAxis");t(this,
	"init",{userOptions:d});this.opposite=r(d.opposite,this.opposite);this.side=r(d.side,this.side,this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(d);var g=this.options,a=g.labels,f=g.type;this.userOptions=d;this.minPixelPadding=0;this.reversed=r(g.reversed,this.reversed);this.visible=g.visible;this.zoomEnabled=g.zoomEnabled;this.hasNames="category"===f||!0===g.categories;this.categories=g.categories||(this.hasNames?[]:void 0);this.names||(this.names=[],this.names.keys={});this.plotLinesAndBandsGroups=
	{};this.positiveValuesOnly=!!this.logarithmic;this.isLinked=D(g.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=g.minRange||g.maxZoom;this.range=g.range;this.offset=g.offset||0;this.min=this.max=null;d=r(g.crosshair,N(b.options.tooltip.crosshairs)[e?0:1]);this.crosshair=!0===d?{}:d;-1===b.axes.indexOf(this)&&(e?b.axes.splice(b.xAxis.length,0,this):b.axes.push(this),b[this.coll].push(this));this.series=
	this.series||[];b.inverted&&!this.isZAxis&&e&&"undefined"===typeof this.reversed&&(this.reversed=!0);this.labelRotation=k(a.rotation)?a.rotation:void 0;c(this,g);t(this,"afterInit")};b.prototype.setOptions=function(b){this.options=e(q.defaultXAxisOptions,"yAxis"===this.coll&&q.defaultYAxisOptions,[q.defaultTopAxisOptions,q.defaultRightAxisOptions,q.defaultBottomAxisOptions,q.defaultLeftAxisOptions][this.side],e(n[this.coll],b));t(this,"afterSetOptions",{userOptions:b})};b.prototype.defaultLabelFormatter=
	function(b){var d=this.axis;b=this.chart.numberFormatter;var e=k(this.value)?this.value:NaN,g=d.chart.time,r=this.dateTimeLabelFormat,a=n.lang,c=a.numericSymbols;a=a.numericSymbolMagnitude||1E3;var f=d.logarithmic?Math.abs(e):d.tickInterval,t=c&&c.length;if(d.categories)var z="".concat(this.value);else if(r)z=g.dateFormat(r,e);else if(t&&1E3<=f)for(;t--&&"undefined"===typeof z;)d=Math.pow(a,t+1),f>=d&&0===10*e%d&&null!==c[t]&&0!==e&&(z=b(e/d,-1)+c[t]);"undefined"===typeof z&&(z=1E4<=Math.abs(e)?b(e,
	-1):b(e,-1,void 0,""));return z};b.prototype.getSeriesExtremes=function(){var b=this,d=b.chart,e;t(this,"getSeriesExtremes",null,function(){b.hasVisibleSeries=!1;b.dataMin=b.dataMax=b.threshold=null;b.softThreshold=!b.isXAxis;b.series.forEach(function(g){if(g.visible||!d.options.chart.ignoreHiddenSeries){var a=g.options,c=a.threshold;b.hasVisibleSeries=!0;b.positiveValuesOnly&&0>=c&&(c=null);if(b.isXAxis){if(a=g.xData,a.length){a=b.logarithmic?a.filter(b.validatePositiveValue):a;e=g.getXExtremes(a);
	var f=e.min;var t=e.max;k(f)||f instanceof Date||(a=a.filter(k),e=g.getXExtremes(a),f=e.min,t=e.max);a.length&&(b.dataMin=Math.min(r(b.dataMin,f),f),b.dataMax=Math.max(r(b.dataMax,t),t))}}else if(g=g.applyExtremes(),k(g.dataMin)&&(f=g.dataMin,b.dataMin=Math.min(r(b.dataMin,f),f)),k(g.dataMax)&&(t=g.dataMax,b.dataMax=Math.max(r(b.dataMax,t),t)),D(c)&&(b.threshold=c),!a.softThreshold||b.positiveValuesOnly)b.softThreshold=!1}})});t(this,"afterGetSeriesExtremes")};b.prototype.translate=function(b,d,e,
	g,r,a){var c=this.linkedParent||this,t=g&&c.old?c.old.min:c.min;if(!k(t))return NaN;var z=c.minPixelPadding;r=(c.isOrdinal||c.brokenAxis&&c.brokenAxis.hasBreaks||c.logarithmic&&r)&&c.lin2val;var h=1,l=0;g=g&&c.old?c.old.transA:c.transA;g||(g=c.transA);e&&(h*=-1,l=c.len);c.reversed&&(h*=-1,l-=h*(c.sector||c.len));d?(a=(b*h+l-z)/g+t,r&&(a=c.lin2val(a))):(r&&(b=c.val2lin(b)),b=h*(b-t)*g,a=(c.isRadial?b:f(b))+l+h*z+(k(a)?g*a:0));return a};b.prototype.toPixels=function(b,d){return this.translate(b,!1,
	!this.horiz,void 0,!0)+(d?0:this.pos)};b.prototype.toValue=function(b,d){return this.translate(b-(d?0:this.pos),!0,!this.horiz,void 0,!0)};b.prototype.getPlotLinePath=function(b){function d(b,d,e){"pass"!==I&&(b<d||b>e)&&(I?b=p(b,d,e):P=!0);return b}var e=this,g=e.chart,a=e.left,c=e.top,f=b.old,z=b.value,h=b.lineWidth,l=f&&g.oldChartHeight||g.chartHeight,w=f&&g.oldChartWidth||g.chartWidth,m=e.transB,L=b.translatedValue,I=b.force,y,n,N,u,P;b={value:z,lineWidth:h,old:f,force:I,acrossPanes:b.acrossPanes,
	translatedValue:L};t(this,"getPlotLinePath",b,function(b){L=r(L,e.translate(z,void 0,void 0,f));L=p(L,-1E5,1E5);y=N=Math.round(L+m);n=u=Math.round(l-L-m);k(L)?e.horiz?(n=c,u=l-e.bottom,y=N=d(y,a,a+e.width)):(y=a,N=w-e.right,n=u=d(n,c,c+e.height)):(P=!0,I=!1);b.path=P&&!I?null:g.renderer.crispLine([["M",y,n],["L",N,u]],h||1)});return b.path};b.prototype.getLinearTickPositions=function(b,d,e){var g=f(Math.floor(d/b)*b);e=f(Math.ceil(e/b)*b);var r=[],a;f(g+b)===g&&(a=20);if(this.single)return[d];for(d=
	g;d<=e;){r.push(d);d=f(d+b,a);if(d===c)break;var c=d}return r};b.prototype.getMinorTickInterval=function(){var b=this.options;return!0===b.minorTicks?r(b.minorTickInterval,"auto"):!1===b.minorTicks?null:b.minorTickInterval};b.prototype.getMinorTickPositions=function(){var b=this.options,d=this.tickPositions,e=this.minorTickInterval,g=this.pointRangePadding||0,r=this.min-g;g=this.max+g;var a=g-r,c=[];if(a&&a/e<this.len/3){var k=this.logarithmic;if(k)this.paddedTicks.forEach(function(b,d,g){d&&c.push.apply(c,
	k.getLogTickPositions(e,g[d-1],g[d],!0))});else if(this.dateTime&&"auto"===this.getMinorTickInterval())c=c.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(e),r,g,b.startOfWeek));else for(b=r+(d[0]-r)%e;b<=g&&b!==c[0];b+=e)c.push(b)}0!==c.length&&this.trimTicks(c);return c};b.prototype.adjustForMinRange=function(){var b=this.options,d=this.logarithmic,e=this.min,g=this.max,c=0,a,k,f,t;this.isXAxis&&"undefined"===typeof this.minRange&&!d&&(D(b.min)||D(b.max)||D(b.floor)||D(b.ceiling)?
	this.minRange=null:(this.series.forEach(function(b){f=b.xData;t=b.xIncrement?1:f.length-1;if(1<f.length)for(a=t;0<a;a--)if(k=f[a]-f[a-1],!c||k<c)c=k}),this.minRange=Math.min(5*c,this.dataMax-this.dataMin)));if(g-e<this.minRange){var z=this.dataMax-this.dataMin>=this.minRange;var h=this.minRange;var w=(h-g+e)/2;w=[e-w,r(b.min,e-w)];z&&(w[2]=this.logarithmic?this.logarithmic.log2lin(this.dataMin):this.dataMin);e=m(w);g=[e+h,r(b.max,e+h)];z&&(g[2]=d?d.log2lin(this.dataMax):this.dataMax);g=l(g);g-e<h&&
	(w[0]=g-h,w[1]=r(b.min,g-h),e=m(w))}this.min=e;this.max=g};b.prototype.getClosest=function(){var b;this.categories?b=1:this.series.forEach(function(d){var e=d.closestPointRange,g=d.visible||!d.chart.options.chart.ignoreHiddenSeries;!d.noSharedTooltip&&D(e)&&g&&(b=D(b)?Math.min(b,e):e)});return b};b.prototype.nameToX=function(b){var d=w(this.options.categories),e=d?this.categories:this.names,g=b.options.x;b.series.requireSorting=!1;D(g)||(g=this.options.uniqueNames&&e?d?e.indexOf(b.name):r(e.keys[b.name],
	-1):b.series.autoIncrement());if(-1===g){if(!d&&e)var c=e.length}else c=g;"undefined"!==typeof c?(this.names[c]=b.name,this.names.keys[b.name]=c):b.x&&(c=b.x);return c};b.prototype.updateNames=function(){var b=this,d=this.names;0<d.length&&(Object.keys(d.keys).forEach(function(b){delete d.keys[b]}),d.length=0,this.minRange=this.userMinRange,(this.series||[]).forEach(function(d){d.xIncrement=null;if(!d.points||d.isDirtyData)b.max=Math.max(b.max,d.xData.length-1),d.processData(),d.generatePoints();
	d.data.forEach(function(e,g){if(e&&e.options&&"undefined"!==typeof e.name){var r=b.nameToX(e);"undefined"!==typeof r&&r!==e.x&&(e.x=r,d.xData[g]=r)}})}))};b.prototype.setAxisTranslation=function(){var b=this,d=b.max-b.min,e=b.linkedParent,c=!!b.categories,a=b.isXAxis,k=b.axisPointRange||0,f=0,z=0,h=b.transA;if(a||c||k){var l=b.getClosest();e?(f=e.minPointOffset,z=e.pointRangePadding):b.series.forEach(function(d){var e=c?1:a?r(d.options.pointRange,l,0):b.axisPointRange||0,t=d.options.pointPlacement;
	k=Math.max(k,e);if(!b.single||c)d=d.is("xrange")?!a:a,f=Math.max(f,d&&g(t)?0:e/2),z=Math.max(z,d&&"on"===t?0:e)});e=b.ordinal&&b.ordinal.slope&&l?b.ordinal.slope/l:1;b.minPointOffset=f*=e;b.pointRangePadding=z*=e;b.pointRange=Math.min(k,b.single&&c?1:d);a&&(b.closestPointRange=l)}b.translationSlope=b.transA=h=b.staticScale||b.len/(d+z||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=h*f;t(this,"afterSetAxisTranslation")};b.prototype.minFromRange=function(){return this.max-this.range};b.prototype.setTickInterval=
	function(b){var d=this.chart,e=this.logarithmic,g=this.options,c=this.isXAxis,a=this.isLinked,z=g.tickPixelInterval,h=this.categories,l=this.softThreshold,w=g.maxPadding,m=g.minPadding,I=k(g.tickInterval)&&0<=g.tickInterval?g.tickInterval:void 0,L=k(this.threshold)?this.threshold:null;this.dateTime||h||a||this.getTickAmount();var p=r(this.userMin,g.min);var y=r(this.userMax,g.max);if(a){this.linkedParent=d[this.coll][g.linkedTo];var n=this.linkedParent.getExtremes();this.min=r(n.min,n.dataMin);this.max=
	r(n.max,n.dataMax);g.type!==this.linkedParent.options.type&&K(11,1,d)}else{if(l&&D(L))if(this.dataMin>=L)n=L,m=0;else if(this.dataMax<=L){var N=L;w=0}this.min=r(p,n,this.dataMin);this.max=r(y,N,this.dataMax)}e&&(this.positiveValuesOnly&&!b&&0>=Math.min(this.min,r(this.dataMin,this.min))&&K(10,1,d),this.min=f(e.log2lin(this.min),16),this.max=f(e.log2lin(this.max),16));this.range&&D(this.max)&&(this.userMin=this.min=p=Math.max(this.dataMin,this.minFromRange()),this.userMax=y=this.max,this.range=null);
	t(this,"foundExtremes");this.beforePadding&&this.beforePadding();this.adjustForMinRange();!(h||this.axisPointRange||this.stacking&&this.stacking.usePercentage||a)&&D(this.min)&&D(this.max)&&(d=this.max-this.min)&&(!D(p)&&m&&(this.min-=d*m),!D(y)&&w&&(this.max+=d*w));k(this.userMin)||(k(g.softMin)&&g.softMin<this.min&&(this.min=p=g.softMin),k(g.floor)&&(this.min=Math.max(this.min,g.floor)));k(this.userMax)||(k(g.softMax)&&g.softMax>this.max&&(this.max=y=g.softMax),k(g.ceiling)&&(this.max=Math.min(this.max,
	g.ceiling)));l&&D(this.dataMin)&&(L=L||0,!D(p)&&this.min<L&&this.dataMin>=L?this.min=this.options.minRange?Math.min(L,this.max-this.minRange):L:!D(y)&&this.max>L&&this.dataMax<=L&&(this.max=this.options.minRange?Math.max(L,this.min+this.minRange):L));k(this.min)&&k(this.max)&&!this.chart.polar&&this.min>this.max&&(D(this.options.min)?this.max=this.min:D(this.options.max)&&(this.min=this.max));this.tickInterval=this.min===this.max||"undefined"===typeof this.min||"undefined"===typeof this.max?1:a&&
	this.linkedParent&&!I&&z===this.linkedParent.options.tickPixelInterval?I=this.linkedParent.tickInterval:r(I,this.tickAmount?(this.max-this.min)/Math.max(this.tickAmount-1,1):void 0,h?1:(this.max-this.min)*z/Math.max(this.len,z));if(c&&!b){var u=this.min!==(this.old&&this.old.min)||this.max!==(this.old&&this.old.max);this.series.forEach(function(b){b.forceCrop=b.forceCropping&&b.forceCropping();b.processData(u)});t(this,"postProcessData",{hasExtremesChanged:u})}this.setAxisTranslation();t(this,"initialAxisTranslation");
	this.pointRange&&!I&&(this.tickInterval=Math.max(this.pointRange,this.tickInterval));b=r(g.minTickInterval,this.dateTime&&!this.series.some(function(b){return b.noSharedTooltip})?this.closestPointRange:0);!I&&this.tickInterval<b&&(this.tickInterval=b);this.dateTime||this.logarithmic||I||(this.tickInterval=O(this,this.tickInterval));this.tickAmount||(this.tickInterval=this.unsquish());this.setTickPositions()};b.prototype.setTickPositions=function(){var b=this.options,d=b.tickPositions,e=b.tickPositioner,
	g=this.getMinorTickInterval(),r=this.hasVerticalPanning(),c="colorAxis"===this.coll,a=(c||!r)&&b.startOnTick;r=(c||!r)&&b.endOnTick;c=[];var f;this.tickmarkOffset=this.categories&&"between"===b.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===g&&this.tickInterval?this.tickInterval/5:g;this.single=this.min===this.max&&D(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==b.allowDecimals);if(d)c=d.slice();else if(k(this.min)&&k(this.max)){if(this.ordinal&&
	this.ordinal.positions||!((this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)))if(this.dateTime)c=this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval,b.units),this.min,this.max,b.startOfWeek,this.ordinal&&this.ordinal.positions,this.closestPointRange,!0);else if(this.logarithmic)c=this.logarithmic.getLogTickPositions(this.tickInterval,this.min,this.max);else for(g=b=this.tickInterval;g<=2*b;)if(c=this.getLinearTickPositions(this.tickInterval,this.min,this.max),this.tickAmount&&
	c.length>this.tickAmount)this.tickInterval=O(this,g*=1.1);else break;else c=[this.min,this.max],K(19,!1,this.chart);c.length>this.len&&(c=[c[0],c[c.length-1]],c[0]===c[1]&&(c.length=1));e&&(this.tickPositions=c,(f=e.apply(this,[this.min,this.max]))&&(c=f))}this.tickPositions=c;this.paddedTicks=c.slice(0);this.trimTicks(c,a,r);!this.isLinked&&k(this.min)&&k(this.max)&&(this.single&&2>c.length&&!this.categories&&!this.series.some(function(b){return b.is("heatmap")&&"between"===b.options.pointPlacement})&&
	(this.min-=.5,this.max+=.5),d||f||this.adjustTickAmount());t(this,"afterSetTickPositions")};b.prototype.trimTicks=function(b,d,e){var g=b[0],r=b[b.length-1],c=!this.isOrdinal&&this.minPointOffset||0;t(this,"trimTicks");if(!this.isLinked){if(d&&-Infinity!==g)this.min=g;else for(;this.min-c>b[0];)b.shift();if(e)this.max=r;else for(;this.max+c<b[b.length-1];)b.pop();0===b.length&&D(g)&&!this.options.tickPositions&&b.push((r+g)/2)}};b.prototype.alignToOthers=function(){var b=this,d=[this],e=b.options,
	g="yAxis"===this.coll&&this.chart.options.chart.alignThresholds,r=[],c;b.thresholdAlignment=void 0;if((!1!==this.chart.options.chart.alignTicks&&e.alignTicks||g)&&!1!==e.startOnTick&&!1!==e.endOnTick&&!b.logarithmic){var a=function(b){var d=b.options;return[b.horiz?d.left:d.top,d.width,d.height,d.pane].join()},f=a(this);this.chart[this.coll].forEach(function(e){var g=e.series;g.length&&g.some(function(b){return b.visible})&&e!==b&&a(e)===f&&(c=!0,d.push(e))})}if(c&&g){d.forEach(function(d){d=d.getThresholdAlignment(b);
	k(d)&&r.push(d)});var t=1<r.length?r.reduce(function(b,d){return b+d},0)/r.length:void 0;d.forEach(function(b){b.thresholdAlignment=t})}return c};b.prototype.getThresholdAlignment=function(b){(!k(this.dataMin)||this!==b&&this.series.some(function(b){return b.isDirty||b.isDirtyData}))&&this.getSeriesExtremes();if(k(this.threshold))return b=p((this.threshold-(this.dataMin||0))/((this.dataMax||0)-(this.dataMin||0)),0,1),this.options.reversed&&(b=1-b),b};b.prototype.getTickAmount=function(){var b=this.options,
	d=b.tickPixelInterval,e=b.tickAmount;!D(b.tickInterval)&&!e&&this.len<d&&!this.isRadial&&!this.logarithmic&&b.startOnTick&&b.endOnTick&&(e=2);!e&&this.alignToOthers()&&(e=Math.ceil(this.len/d)+1);4>e&&(this.finalTickAmt=e,e=5);this.tickAmount=e};b.prototype.adjustTickAmount=function(){var b=this,d=b.finalTickAmt,e=b.max,g=b.min,c=b.options,a=b.tickPositions,t=b.tickAmount,z=b.thresholdAlignment,h=a&&a.length,l=r(b.threshold,b.softThreshold?0:null);var w=b.tickInterval;if(k(z)){var m=.5>z?Math.ceil(z*
	(t-1)):Math.floor(z*(t-1));c.reversed&&(m=t-1-m)}if(b.hasData()&&k(g)&&k(e)){z=function(){b.transA*=(h-1)/(t-1);b.min=c.startOnTick?a[0]:Math.min(g,a[0]);b.max=c.endOnTick?a[a.length-1]:Math.max(e,a[a.length-1])};if(k(m)&&k(b.threshold)){for(;a[m]!==l||a.length!==t||a[0]>g||a[a.length-1]<e;){a.length=0;for(a.push(b.threshold);a.length<t;)void 0===a[m]||a[m]>b.threshold?a.unshift(f(a[0]-w)):a.push(f(a[a.length-1]+w));if(w>8*b.tickInterval)break;w*=2}z()}else if(h<t){for(;a.length<t;)a.length%2||g===
	l?a.push(f(a[a.length-1]+w)):a.unshift(f(a[0]-w));z()}if(D(d)){for(w=l=a.length;w--;)(3===d&&1===w%2||2>=d&&0<w&&w<l-1)&&a.splice(w,1);b.finalTickAmt=void 0}}};b.prototype.setScale=function(){var b=!1,d=!1;this.series.forEach(function(e){b=b||e.isDirtyData||e.isDirty;d=d||e.xAxis&&e.xAxis.isDirty||!1});this.setAxisSize();var e=this.len!==(this.old&&this.old.len);e||b||d||this.isLinked||this.forceRedraw||this.userMin!==(this.old&&this.old.userMin)||this.userMax!==(this.old&&this.old.userMax)||this.alignToOthers()?
	(this.stacking&&(this.stacking.resetStacks(),this.stacking.buildStacks()),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.isDirty||(this.isDirty=e||this.min!==(this.old&&this.old.min)||this.max!==(this.old&&this.old.max))):this.stacking&&this.stacking.cleanStacks();b&&this.panningState&&(this.panningState.isDirty=!0);t(this,"afterSetScale")};b.prototype.setExtremes=function(b,d,e,g,c){var a=this,k=a.chart;e=r(e,!0);a.series.forEach(function(b){delete b.kdTree});c=y(c,{min:b,
	max:d});t(a,"setExtremes",c,function(){a.userMin=b;a.userMax=d;a.eventArgs=c;e&&k.redraw(g)})};b.prototype.zoom=function(b,d){var e=this,g=this.dataMin,c=this.dataMax,a=this.options,k=Math.min(g,r(a.min,g)),f=Math.max(c,r(a.max,c));b={newMin:b,newMax:d};t(this,"zoom",b,function(b){var d=b.newMin,r=b.newMax;if(d!==e.min||r!==e.max)e.allowZoomOutside||(D(g)&&(d<k&&(d=k),d>f&&(d=f)),D(c)&&(r<k&&(r=k),r>f&&(r=f))),e.displayBtn="undefined"!==typeof d||"undefined"!==typeof r,e.setExtremes(d,r,!1,void 0,
	{trigger:"zoom"});b.zoomed=!0});return b.zoomed};b.prototype.setAxisSize=function(){var b=this.chart,d=this.options,e=d.offsets||[0,0,0,0],g=this.horiz,c=this.width=Math.round(z(r(d.width,b.plotWidth-e[3]+e[1]),b.plotWidth)),a=this.height=Math.round(z(r(d.height,b.plotHeight-e[0]+e[2]),b.plotHeight)),k=this.top=Math.round(z(r(d.top,b.plotTop+e[0]),b.plotHeight,b.plotTop));d=this.left=Math.round(z(r(d.left,b.plotLeft+e[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-a-k;this.right=b.chartWidth-
	c-d;this.len=Math.max(g?c:a,0);this.pos=g?d:k};b.prototype.getExtremes=function(){var b=this.logarithmic;return{min:b?f(b.lin2log(this.min)):this.min,max:b?f(b.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}};b.prototype.getThreshold=function(b){var d=this.logarithmic,e=d?d.lin2log(this.min):this.min;d=d?d.lin2log(this.max):this.max;null===b||-Infinity===b?b=e:Infinity===b?b=d:e>b?b=e:d<b&&(b=d);return this.translate(b,0,1,0,1)};b.prototype.autoLabelAlign=
	function(b){var d=(r(b,0)-90*this.side+720)%360;b={align:"center"};t(this,"autoLabelAlign",b,function(b){15<d&&165>d?b.align="right":195<d&&345>d&&(b.align="left")});return b.align};b.prototype.tickSize=function(b){var d=this.options,e=r(d["tick"===b?"tickWidth":"minorTickWidth"],"tick"===b&&this.isXAxis&&!this.categories?1:0),g=d["tick"===b?"tickLength":"minorTickLength"];if(e&&g){"inside"===d[b+"Position"]&&(g=-g);var c=[g,e]}b={tickSize:c};t(this,"afterTickSize",b);return b.tickSize};b.prototype.labelMetrics=
	function(){var b=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize,this.ticks[b]&&this.ticks[b].label)};b.prototype.unsquish=function(){var b=this.options.labels,d=this.horiz,e=this.tickInterval,g=this.len/(((this.categories?1:0)+this.max-this.min)/e),c=b.rotation,a=this.labelMetrics(),t=Math.max(this.max-this.min,0),z=function(b){var d=b/(g||1);d=1<d?Math.ceil(d):1;d*e>t&&Infinity!==b&&Infinity!==g&&t&&(d=Math.ceil(t/e));return f(d*
	e)},w=e,l=Number.MAX_VALUE;if(d){if(!b.staggerLines)if(k(c))var m=[c];else g<b.autoRotationLimit&&(m=b.autoRotation);if(m)for(var I=d=void 0,p=0,y=m;p<y.length;p++){var n=y[p];if(n===c||n&&-90<=n&&90>=n)if(d=z(Math.abs(a.h/Math.sin(h*n))),I=d+Math.abs(n/360),I<l){l=I;var N=n;w=d}}}else w=z(a.h);this.autoRotation=m;this.labelRotation=r(N,k(c)?c:0);return b.step?e:w};b.prototype.getSlotWidth=function(b){var d=this.chart,e=this.horiz,g=this.options.labels,r=Math.max(this.tickPositions.length-(this.categories?
	0:1),1),c=d.margin[3];if(b&&k(b.slotWidth))return b.slotWidth;if(e&&2>g.step)return g.rotation?0:(this.staggerLines||1)*this.len/r;if(!e){b=g.style.width;if(void 0!==b)return parseInt(String(b),10);if(c)return c-d.spacing[3]}return.33*d.chartWidth};b.prototype.renderUnsquish=function(){var b=this.chart,d=b.renderer,e=this.tickPositions,r=this.ticks,c=this.options.labels,a=c.style,k=this.horiz,f=this.getSlotWidth(),t=Math.max(1,Math.round(f-2*c.padding)),z={},h=this.labelMetrics(),w=a.textOverflow,
	l=0;g(c.rotation)||(z.rotation=c.rotation||0);e.forEach(function(b){b=r[b];b.movedLabel&&b.replaceMovedLabel();b&&b.label&&b.label.textPxLength>l&&(l=b.label.textPxLength)});this.maxLabelLength=l;if(this.autoRotation)l>t&&l>h.h?z.rotation=this.labelRotation:this.labelRotation=0;else if(f){var m=t;if(!w){var I="clip";for(t=e.length;!k&&t--;){var p=e[t];if(p=r[p].label)p.styles&&"ellipsis"===p.styles.textOverflow?p.css({textOverflow:"clip"}):p.textPxLength>f&&p.css({width:f+"px"}),p.getBBox().height>
	this.len/e.length-(h.h-h.f)&&(p.specificTextOverflow="ellipsis")}}}z.rotation&&(m=l>.5*b.chartHeight?.33*b.chartHeight:l,w||(I="ellipsis"));if(this.labelAlign=c.align||this.autoLabelAlign(this.labelRotation))z.align=this.labelAlign;e.forEach(function(b){var d=(b=r[b])&&b.label,e=a.width,g={};d&&(d.attr(z),b.shortenLabel?b.shortenLabel():m&&!e&&"nowrap"!==a.whiteSpace&&(m<d.textPxLength||"SPAN"===d.element.tagName)?(g.width=m+"px",w||(g.textOverflow=d.specificTextOverflow||I),d.css(g)):d.styles&&d.styles.width&&
	!g.width&&!e&&d.css({width:null}),delete d.specificTextOverflow,b.rotation=z.rotation)},this);this.tickRotCorr=d.rotCorr(h.b,this.labelRotation||0,0!==this.side)};b.prototype.hasData=function(){return this.series.some(function(b){return b.hasData()})||this.options.showEmpty&&D(this.min)&&D(this.max)};b.prototype.addTitle=function(b){var d=this.chart.renderer,g=this.horiz,r=this.opposite,c=this.options.title,a=this.chart.styledMode,k;this.axisTitle||((k=c.textAlign)||(k=(g?{low:"left",middle:"center",
	high:"right"}:{low:r?"right":"left",middle:"center",high:r?"left":"right"})[c.align]),this.axisTitle=d.text(c.text||"",0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation,align:k}).addClass("highcharts-axis-title"),a||this.axisTitle.css(e(c.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);a||c.style.width||this.isRadial||this.axisTitle.css({width:this.len+"px"});this.axisTitle[b?"show":"hide"](b)};b.prototype.generateTick=function(b){var d=this.ticks;d[b]?d[b].addLabel():d[b]=new F(this,
	b)};b.prototype.getOffset=function(){var b=this,e=this,g=e.chart,c=e.horiz,a=e.options,k=e.side,f=e.ticks,z=e.tickPositions,h=e.coll,w=e.axisParent,l=g.renderer,m=g.inverted&&!e.isZAxis?[1,0,3,2][k]:k,I=e.hasData(),p=a.title,n=a.labels,y=g.axisOffset;g=g.clipOffset;var N=[-1,1,1,-1][k],u=a.className,P,O=0,v=0,G=0;e.showAxis=P=I||a.showEmpty;e.staggerLines=e.horiz&&n.staggerLines||void 0;if(!e.axisGroup){var q=function(d,e,g){return l.g(d).attr({zIndex:g}).addClass("highcharts-".concat(h.toLowerCase()).concat(e,
	" ")+(b.isRadial?"highcharts-radial-axis".concat(e," "):"")+(u||"")).add(w)};e.gridGroup=q("grid","-grid",a.gridZIndex);e.axisGroup=q("axis","",a.zIndex);e.labelGroup=q("axis-labels","-labels",n.zIndex)}I||e.isLinked?(z.forEach(function(b){e.generateTick(b)}),e.renderUnsquish(),e.reserveSpaceDefault=0===k||2===k||{1:"left",3:"right"}[k]===e.labelAlign,r(n.reserveSpace,"center"===e.labelAlign?!0:null,e.reserveSpaceDefault)&&z.forEach(function(b){G=Math.max(f[b].getLabelSize(),G)}),e.staggerLines&&
	(G*=e.staggerLines),e.labelOffset=G*(e.opposite?-1:1)):d(f,function(b,d){b.destroy();delete f[d]});if(p&&p.text&&!1!==p.enabled&&(e.addTitle(P),P&&!1!==p.reserveSpace)){e.titleOffset=O=e.axisTitle.getBBox()[c?"height":"width"];var U=p.offset;v=D(U)?0:r(p.margin,c?5:10)}e.renderLine();e.offset=N*r(a.offset,y[k]?y[k]+(a.margin||0):0);e.tickRotCorr=e.tickRotCorr||{x:0,y:0};p=0===k?-e.labelMetrics().h:2===k?e.tickRotCorr.y:0;I=Math.abs(G)+v;G&&(I=I-p+N*(c?r(n.y,e.tickRotCorr.y+8*N):n.x));e.axisTitleMargin=
	r(U,I);e.getMaxLabelDimensions&&(e.maxLabelDimensions=e.getMaxLabelDimensions(f,z));"colorAxis"!==h&&(c=this.tickSize("tick"),y[k]=Math.max(y[k],(e.axisTitleMargin||0)+O+N*e.offset,I,z&&z.length&&c?c[0]+N*e.offset:0),a=!e.axisLine||a.offset?0:2*Math.floor(e.axisLine.strokeWidth()/2),g[m]=Math.max(g[m],a));t(this,"afterGetOffset")};b.prototype.getLinePath=function(b){var d=this.chart,e=this.opposite,g=this.offset,c=this.horiz,r=this.left+(e?this.width:0)+g;g=d.chartHeight-this.bottom-(e?this.height:
	0)+g;e&&(b*=-1);return d.renderer.crispLine([["M",c?this.left:r,c?g:this.top],["L",c?d.chartWidth-this.right:r,c?g:d.chartHeight-this.bottom]],b)};b.prototype.renderLine=function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))};b.prototype.getTitlePosition=function(){var b=this.horiz,d=this.left,e=this.top,g=this.len,
	c=this.options.title,r=b?d:e,a=this.opposite,k=this.offset,f=c.x,z=c.y,h=this.axisTitle,w=this.chart.renderer.fontMetrics(c.style.fontSize,h);h=h?Math.max(h.getBBox(!1,0).height-w.h-1,0):0;g={low:r+(b?0:g),middle:r+g/2,high:r+(b?g:0)}[c.align];d=(b?e+this.height:d)+(b?1:-1)*(a?-1:1)*(this.axisTitleMargin||0)+[-h,h,w.f,-h][this.side];b={x:b?g+f:d+(a?this.width:0)+k+f,y:b?d+z-(a?this.height:0)+k:g+z};t(this,"afterGetTitlePosition",{titlePosition:b});return b};b.prototype.renderMinorTick=function(b,
	d){var e=this.minorTicks;e[b]||(e[b]=new F(this,b,"minor"));d&&e[b].isNew&&e[b].render(null,!0);e[b].render(null,!1,1)};b.prototype.renderTick=function(b,d,e){var g=this.ticks;if(!this.isLinked||b>=this.min&&b<=this.max||this.grid&&this.grid.isColumn)g[b]||(g[b]=new F(this,b)),e&&g[b].isNew&&g[b].render(d,!0,-1),g[b].render(d)};b.prototype.render=function(){var b=this,e=b.chart,g=b.logarithmic,c=b.options,r=b.isLinked,a=b.tickPositions,f=b.axisTitle,z=b.ticks,h=b.minorTicks,w=b.alternateBands,l=c.stackLabels,
	m=c.alternateGridColor,I=b.tickmarkOffset,p=b.axisLine,n=b.showAxis,y=u(e.renderer.globalAnimation),N,O;b.labelEdge.length=0;b.overlap=!1;[z,h,w].forEach(function(b){d(b,function(b){b.isActive=!1})});if(b.hasData()||r){var D=b.chart.hasRendered&&b.old&&k(b.old.min);b.minorTickInterval&&!b.categories&&b.getMinorTickPositions().forEach(function(d){b.renderMinorTick(d,D)});a.length&&(a.forEach(function(d,e){b.renderTick(d,e,D)}),I&&(0===b.min||b.single)&&(z[-1]||(z[-1]=new F(b,-1,null,!0)),z[-1].render(-1)));
	m&&a.forEach(function(d,c){O="undefined"!==typeof a[c+1]?a[c+1]+I:b.max-I;0===c%2&&d<b.max&&O<=b.max+(e.polar?-I:I)&&(w[d]||(w[d]=new C.PlotLineOrBand(b)),N=d+I,w[d].options={from:g?g.lin2log(N):N,to:g?g.lin2log(O):O,color:m,className:"highcharts-alternate-grid"},w[d].render(),w[d].isActive=!0)});b._addedPlotLB||(b._addedPlotLB=!0,(c.plotLines||[]).concat(c.plotBands||[]).forEach(function(d){b.addPlotBandOrLine(d)}))}[z,h,w].forEach(function(b){var g=[],c=y.duration;d(b,function(b,d){b.isActive||
	(b.render(d,!1,0),b.isActive=!1,g.push(d))});P(function(){for(var d=g.length;d--;)b[g[d]]&&!b[g[d]].isActive&&(b[g[d]].destroy(),delete b[g[d]])},b!==w&&e.hasRendered&&c?c:0)});p&&(p[p.isPlaced?"animate":"attr"]({d:this.getLinePath(p.strokeWidth())}),p.isPlaced=!0,p[n?"show":"hide"](n));f&&n&&(c=b.getTitlePosition(),f[f.isNew?"attr":"animate"](c),f.isNew=!1);l&&l.enabled&&b.stacking&&b.stacking.renderStackTotals();b.old={len:b.len,max:b.max,min:b.min,transA:b.transA,userMax:b.userMax,userMin:b.userMin};
	b.isDirty=!1;t(this,"afterRender")};b.prototype.redraw=function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(b){b.render()}));this.series.forEach(function(b){b.isDirty=!0})};b.prototype.getKeepProps=function(){return this.keepProps||b.keepProps};b.prototype.destroy=function(b){var e=this,g=e.plotLinesAndBands,c=this.eventOptions;t(this,"destroy",{keepEvents:b});b||I(e);[e.ticks,e.minorTicks,e.alternateBands].forEach(function(b){v(b)});if(g)for(b=g.length;b--;)g[b].destroy();
	"axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(b){e[b]&&(e[b]=e[b].destroy())});for(var r in e.plotLinesAndBandsGroups)e.plotLinesAndBandsGroups[r]=e.plotLinesAndBandsGroups[r].destroy();d(e,function(b,d){-1===e.getKeepProps().indexOf(d)&&delete e[d]});this.eventOptions=c};b.prototype.drawCrosshair=function(b,d){var e=this.crosshair,g=r(e&&e.snap,!0),c=this.chart,a,k=this.cross;t(this,"drawCrosshair",{e:b,point:d});b||(b=this.cross&&this.cross.e);if(e&&
	!1!==(D(d)||!g)){g?D(d)&&(a=r("colorAxis"!==this.coll?d.crosshairPos:null,this.isXAxis?d.plotX:this.len-d.plotY)):a=b&&(this.horiz?b.chartX-this.pos:this.len-b.chartY+this.pos);if(D(a)){var f={value:d&&(this.isXAxis?d.x:r(d.stackY,d.y)),translatedValue:a};c.polar&&y(f,{isCrosshair:!0,chartX:b&&b.chartX,chartY:b&&b.chartY,point:d});f=this.getPlotLinePath(f)||null}if(!D(f)){this.hideCrosshair();return}g=this.categories&&!this.isRadial;k||(this.cross=k=c.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+
	(g?"category ":"thin ")+(e.className||"")).attr({zIndex:r(e.zIndex,2)}).add(),c.styledMode||(k.attr({stroke:e.color||(g?A.parse("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":r(e.width,1)}).css({"pointer-events":"none"}),e.dashStyle&&k.attr({dashstyle:e.dashStyle})));k.show().attr({d:f});g&&!e.width&&k.attr({"stroke-width":this.transA});this.cross.e=b}else this.hideCrosshair();t(this,"afterDrawCrosshair",{e:b,point:d})};b.prototype.hideCrosshair=function(){this.cross&&this.cross.hide();
	t(this,"afterHideCrosshair")};b.prototype.hasVerticalPanning=function(){var b=this.chart.options.chart.panning;return!!(b&&b.enabled&&/y/.test(b.type))};b.prototype.validatePositiveValue=function(b){return k(b)&&0<b};b.prototype.update=function(b,d){var g=this.chart;b=e(this.userOptions,b);this.destroy(!0);this.init(g,b);g.isDirtyBox=!0;r(d,!0)&&g.redraw()};b.prototype.remove=function(b){for(var d=this.chart,e=this.coll,g=this.series,c=g.length;c--;)g[c]&&g[c].remove(!1);H(d.axes,this);H(d[e],this);
	d[e].forEach(function(b,d){b.options.index=b.userOptions.index=d});this.destroy();d.isDirtyBox=!0;r(b,!0)&&d.redraw()};b.prototype.setTitle=function(b,d){this.update({title:b},d)};b.prototype.setCategories=function(b,d){this.update({categories:b},d)};b.defaultOptions=q.defaultXAxisOptions;b.keepProps="extKey hcEvents names series userMax userMin".split(" ");return b}();"";return a});J(a,"Core/Axis/DateTimeAxis.js",[a["Core/Utilities.js"]],function(a){var v=a.addEvent,A=a.getMagnitude,E=a.normalizeTickInterval,
	B=a.timeUnits,C;(function(a){function q(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)}function u(a){"datetime"!==a.userOptions.type?this.dateTime=void 0:this.dateTime||(this.dateTime=new c(this))}var n=[];a.compose=function(c){-1===n.indexOf(c)&&(n.push(c),c.keepProps.push("dateTime"),c.prototype.getTimeTicks=q,v(c,"init",u));return c};var c=function(){function c(c){this.axis=c}c.prototype.normalizeTimeTickInterval=function(c,a){var h=a||[["millisecond",[1,2,5,10,20,25,50,
	100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];a=h[h.length-1];var f=B[a[0]],l=a[1],m;for(m=0;m<h.length&&!(a=h[m],f=B[a[0]],l=a[1],h[m+1]&&c<=(f*l[l.length-1]+B[h[m+1][0]])/2);m++);f===B.year&&c<5*f&&(l=[1,2,5]);c=E(c/f,l,"year"===a[0]?Math.max(A(c/f),1):1);return{unitRange:f,count:c,unitName:a[0]}};c.prototype.getXDateFormat=function(c,a){var h=this.axis,f=h.chart.time;return h.closestPointRange?
	f.getDateFormat(h.closestPointRange,c,h.options.startOfWeek,a)||f.resolveDTLFormat(a.year).main:f.resolveDTLFormat(a.day).main};return c}();a.Additions=c})(C||(C={}));return C});J(a,"Core/Axis/LogarithmicAxis.js",[a["Core/Utilities.js"]],function(a){var v=a.addEvent,A=a.normalizeTickInterval,E=a.pick,B;(function(a){function q(c){var a=this.logarithmic;"logarithmic"!==c.userOptions.type?this.logarithmic=void 0:a||(this.logarithmic=new n(this))}function x(){var c=this.logarithmic;c&&(this.lin2val=function(a){return c.lin2log(a)},
	this.val2lin=function(a){return c.log2lin(a)})}var u=[];a.compose=function(c){-1===u.indexOf(c)&&(u.push(c),c.keepProps.push("logarithmic"),v(c,"init",q),v(c,"afterInit",x));return c};var n=function(){function c(c){this.axis=c}c.prototype.getLogTickPositions=function(c,a,l,p){var f=this.axis,h=f.len,m=f.options,n=[];p||(this.minorAutoInterval=void 0);if(.5<=c)c=Math.round(c),n=f.getLinearTickPositions(c,a,l);else if(.08<=c){var u=Math.floor(a),y,t=m=void 0;for(h=.3<c?[1,2,4]:.15<c?[1,2,4,6,8]:[1,
	2,3,4,5,6,7,8,9];u<l+1&&!t;u++){var w=h.length;for(y=0;y<w&&!t;y++){var k=this.log2lin(this.lin2log(u)*h[y]);k>a&&(!p||m<=l)&&"undefined"!==typeof m&&n.push(m);m>l&&(t=!0);m=k}}}else a=this.lin2log(a),l=this.lin2log(l),c=p?f.getMinorTickInterval():m.tickInterval,c=E("auto"===c?null:c,this.minorAutoInterval,m.tickPixelInterval/(p?5:1)*(l-a)/((p?h/f.tickPositions.length:h)||1)),c=A(c),n=f.getLinearTickPositions(c,a,l).map(this.log2lin),p||(this.minorAutoInterval=c/5);p||(f.tickInterval=c);return n};
	c.prototype.lin2log=function(c){return Math.pow(10,c)};c.prototype.log2lin=function(c){return Math.log(c)/Math.LN10};return c}();a.Additions=n})(B||(B={}));return B});J(a,"Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js",[a["Core/Utilities.js"]],function(a){var v=a.erase,A=a.extend,E=a.isNumber,B;(function(a){var q=[],x;a.compose=function(a,c){x||(x=a);-1===q.indexOf(c)&&(q.push(c),A(c.prototype,u.prototype));return c};var u=function(){function a(){}a.prototype.getPlotBandPath=function(c,a,m){void 0===
	m&&(m=this.options);var l=this.getPlotLinePath({value:a,force:!0,acrossPanes:m.acrossPanes}),h=[],f=this.horiz;a=!E(this.min)||!E(this.max)||c<this.min&&a<this.min||c>this.max&&a>this.max;c=this.getPlotLinePath({value:c,force:!0,acrossPanes:m.acrossPanes});m=1;if(c&&l){if(a){var n=c.toString()===l.toString();m=0}for(a=0;a<c.length;a+=2){var u=c[a],v=c[a+1],q=l[a],y=l[a+1];"M"!==u[0]&&"L"!==u[0]||"M"!==v[0]&&"L"!==v[0]||"M"!==q[0]&&"L"!==q[0]||"M"!==y[0]&&"L"!==y[0]||(f&&q[1]===u[1]?(q[1]+=m,y[1]+=
	m):f||q[2]!==u[2]||(q[2]+=m,y[2]+=m),h.push(["M",u[1],u[2]],["L",v[1],v[2]],["L",y[1],y[2]],["L",q[1],q[2]],["Z"]));h.isFlat=n}}return h};a.prototype.addPlotBand=function(c){return this.addPlotBandOrLine(c,"plotBands")};a.prototype.addPlotLine=function(c){return this.addPlotBandOrLine(c,"plotLines")};a.prototype.addPlotBandOrLine=function(c,a){var h=this,l=this.userOptions,p=new x(this,c);this.visible&&(p=p.render());if(p){this._addedPlotLB||(this._addedPlotLB=!0,(l.plotLines||[]).concat(l.plotBands||
	[]).forEach(function(a){h.addPlotBandOrLine(a)}));if(a){var f=l[a]||[];f.push(c);l[a]=f}this.plotLinesAndBands.push(p)}return p};a.prototype.removePlotBandOrLine=function(a){var c=this.plotLinesAndBands,m=this.options,l=this.userOptions;if(c){for(var p=c.length;p--;)c[p].id===a&&c[p].destroy();[m.plotLines||[],l.plotLines||[],m.plotBands||[],l.plotBands||[]].forEach(function(c){for(p=c.length;p--;)(c[p]||{}).id===a&&v(c,c[p])})}};a.prototype.removePlotBand=function(c){this.removePlotBandOrLine(c)};
	a.prototype.removePlotLine=function(c){this.removePlotBandOrLine(c)};return a}()})(B||(B={}));return B});J(a,"Core/Axis/PlotLineOrBand/PlotLineOrBand.js",[a["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],a["Core/Utilities.js"]],function(a,q){var v=q.arrayMax,E=q.arrayMin,B=q.defined,C=q.destroyObjectProperties,F=q.erase,x=q.fireEvent,u=q.merge,n=q.objectEach,c=q.pick;q=function(){function h(a,c){this.axis=a;c&&(this.options=c,this.id=c.id)}h.compose=function(c){return a.compose(h,c)};h.prototype.render=
	function(){x(this,"render");var a=this,l=a.axis,h=l.horiz,f=l.logarithmic,D=a.options,v=D.color,q=c(D.zIndex,0),K=D.events,y={},t=l.chart.renderer,w=D.label,k=a.label,g=D.to,e=D.from,b=D.value,d=a.svgElem,r=[],z=B(e)&&B(g);r=B(b);var I=!d,N={"class":"highcharts-plot-"+(z?"band ":"line ")+(D.className||"")},P=z?"bands":"lines";f&&(e=f.log2lin(e),g=f.log2lin(g),b=f.log2lin(b));l.chart.styledMode||(r?(N.stroke=v||"#999999",N["stroke-width"]=c(D.width,1),D.dashStyle&&(N.dashstyle=D.dashStyle)):z&&(N.fill=
	v||"#e6ebf5",D.borderWidth&&(N.stroke=D.borderColor,N["stroke-width"]=D.borderWidth)));y.zIndex=q;P+="-"+q;(f=l.plotLinesAndBandsGroups[P])||(l.plotLinesAndBandsGroups[P]=f=t.g("plot-"+P).attr(y).add());I&&(a.svgElem=d=t.path().attr(N).add(f));if(r)r=l.getPlotLinePath({value:b,lineWidth:d.strokeWidth(),acrossPanes:D.acrossPanes});else if(z)r=l.getPlotBandPath(e,g,D);else return;!a.eventsAdded&&K&&(n(K,function(b,e){d.on(e,function(b){K[e].apply(a,[b])})}),a.eventsAdded=!0);(I||!d.d)&&r&&r.length?
	d.attr({d:r}):d&&(r?(d.show(),d.animate({d:r})):d.d&&(d.hide(),k&&(a.label=k=k.destroy())));w&&(B(w.text)||B(w.formatter))&&r&&r.length&&0<l.width&&0<l.height&&!r.isFlat?(w=u({align:h&&z&&"center",x:h?!z&&4:10,verticalAlign:!h&&z&&"middle",y:h?z?16:10:z?6:-4,rotation:h&&!z&&90},w),this.renderLabel(w,r,z,q)):k&&k.hide();return a};h.prototype.renderLabel=function(a,c,h,f){var l=this.axis,m=l.chart.renderer,p=this.label;p||(this.label=p=m.text(this.getLabelText(a),0,0,a.useHTML).attr({align:a.textAlign||
	a.align,rotation:a.rotation,"class":"highcharts-plot-"+(h?"band":"line")+"-label "+(a.className||""),zIndex:f}).add(),l.chart.styledMode||p.css(u({textOverflow:"ellipsis"},a.style)));f=c.xBounds||[c[0][1],c[1][1],h?c[2][1]:c[0][1]];c=c.yBounds||[c[0][2],c[1][2],h?c[2][2]:c[0][2]];h=E(f);m=E(c);p.align(a,!1,{x:h,y:m,width:v(f)-h,height:v(c)-m});p.alignValue&&"left"!==p.alignValue||(a=a.clip?l.width:l.chart.chartWidth,p.css({width:(90===p.rotation?l.height-(p.alignAttr.y-l.top):a-(p.alignAttr.x-l.left))+
	"px"}));p.show(!0)};h.prototype.getLabelText=function(a){return B(a.formatter)?a.formatter.call(this):a.text};h.prototype.destroy=function(){F(this.axis.plotLinesAndBands,this);delete this.axis;C(this)};return h}();"";"";return q});J(a,"Core/Tooltip.js",[a["Core/FormatUtilities.js"],a["Core/Globals.js"],a["Core/Renderer/RendererUtilities.js"],a["Core/Renderer/RendererRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E,B){var v=a.format,F=q.doc,x=A.distribute,u=B.clamp,n=B.css,c=B.discardElement,
	h=B.extend,m=B.fireEvent,l=B.isArray,p=B.isNumber,f=B.isString,D=B.merge,G=B.pick,H=B.splat,K=B.syncTimeout;a=function(){function a(a,c){this.allowShared=!0;this.container=void 0;this.crosshairs=[];this.distance=0;this.isHidden=!0;this.isSticky=!1;this.now={};this.options={};this.outside=!1;this.chart=a;this.init(a,c)}a.prototype.applyFilter=function(){var a=this.chart;a.renderer.definition({tagName:"filter",attributes:{id:"drop-shadow-"+a.index,opacity:.5},children:[{tagName:"feGaussianBlur",attributes:{"in":"SourceAlpha",
	stdDeviation:1}},{tagName:"feOffset",attributes:{dx:1,dy:1}},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",attributes:{type:"linear",slope:.3}}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode",attributes:{"in":"SourceGraphic"}}]}]})};a.prototype.bodyFormatter=function(a){return a.map(function(a){var c=a.series.tooltipOptions;return(c[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,c[(a.point.formatPrefix||"point")+"Format"]||
	"")})};a.prototype.cleanSplit=function(a){this.chart.series.forEach(function(c){var k=c&&c.tt;k&&(!k.isActive||a?c.tt=k.destroy():k.isActive=!1)})};a.prototype.defaultFormatter=function(a){var c=this.points||H(this);var k=[a.tooltipFooterHeaderFormatter(c[0])];k=k.concat(a.bodyFormatter(c));k.push(a.tooltipFooterHeaderFormatter(c[0],!0));return k};a.prototype.destroy=function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(!0),this.tt=this.tt.destroy());this.renderer&&
	(this.renderer=this.renderer.destroy(),c(this.container));B.clearTimeout(this.hideTimer);B.clearTimeout(this.tooltipTimeout)};a.prototype.getAnchor=function(a,c){var k=this.chart,g=k.pointer,e=k.inverted,b=k.plotTop;k=k.plotLeft;a=H(a);a[0].series&&a[0].series.yAxis&&!a[0].series.yAxis.options.reversedStacks&&(a=a.slice().reverse());if(this.followPointer&&c)"undefined"===typeof c.chartX&&(c=g.normalize(c)),a=[c.chartX-k,c.chartY-b];else if(a[0].tooltipPos)a=a[0].tooltipPos;else{var d=0,r=0;a.forEach(function(b){if(b=
	b.pos(!0))d+=b[0],r+=b[1]});d/=a.length;r/=a.length;this.shared&&1<a.length&&c&&(e?d=c.chartX:r=c.chartY);a=[d-k,r-b]}return a.map(Math.round)};a.prototype.getClassName=function(a,c,k){var g=a.series,e=g.options;return[this.options.className,"highcharts-label",k&&"highcharts-tooltip-header",c?"highcharts-tooltip-box":"highcharts-tooltip",!k&&"highcharts-color-"+G(a.colorIndex,g.colorIndex),e&&e.className].filter(f).join(" ")};a.prototype.getLabel=function(){var a=this,c=this.chart.styledMode,k=this.options,
	g=this.split&&this.allowShared,e=k.style.pointerEvents||(this.shouldStickOnContact()?"auto":"none"),b,d=this.chart.renderer;if(a.label){var r=!a.label.hasClass("highcharts-label");(g&&!r||!g&&r)&&a.destroy()}if(!this.label){if(this.outside){r=this.chart.options.chart.style;var f=E.getRendererType();this.container=b=q.doc.createElement("div");b.className="highcharts-tooltip-container";n(b,{position:"absolute",top:"1px",pointerEvents:e,zIndex:Math.max(this.options.style.zIndex||0,(r&&r.zIndex||0)+3)});
	q.doc.body.appendChild(b);this.renderer=d=new f(b,0,0,r,void 0,void 0,d.styledMode)}g?this.label=d.g("tooltip"):(this.label=d.label("",0,0,k.shape,void 0,void 0,k.useHTML,void 0,"tooltip").attr({padding:k.padding,r:k.borderRadius}),c||this.label.attr({fill:k.backgroundColor,"stroke-width":k.borderWidth}).css(k.style).css({pointerEvents:e}).shadow(k.shadow));c&&k.shadow&&(this.applyFilter(),this.label.attr({filter:"url(#drop-shadow-"+this.chart.index+")"}));if(a.outside&&!a.split){var h=this.label,
	l=h.xSetter,m=h.ySetter;h.xSetter=function(d){l.call(h,a.distance);b.style.left=d+"px"};h.ySetter=function(d){m.call(h,a.distance);b.style.top=d+"px"}}this.label.attr({zIndex:8}).add()}return this.label};a.prototype.getPosition=function(a,c,k){var g=this.chart,e=this.distance,b={},d=g.inverted&&k.h||0,r=this.outside,f=r?F.documentElement.clientWidth-2*e:g.chartWidth,t=r?Math.max(F.body.scrollHeight,F.documentElement.scrollHeight,F.body.offsetHeight,F.documentElement.offsetHeight,F.documentElement.clientHeight):
	g.chartHeight,h=g.pointer.getChartPosition(),l=function(b){var d="x"===b;return[b,d?f:t,d?a:c].concat(r?[d?a*h.scaleX:c*h.scaleY,d?h.left-e+(k.plotX+g.plotLeft)*h.scaleX:h.top-e+(k.plotY+g.plotTop)*h.scaleY,0,d?f:t]:[d?a:c,d?k.plotX+g.plotLeft:k.plotY+g.plotTop,d?g.plotLeft:g.plotTop,d?g.plotLeft+g.plotWidth:g.plotTop+g.plotHeight])},w=l("y"),m=l("x"),p;l=!!k.negative;!g.polar&&g.hoverSeries&&g.hoverSeries.yAxis&&g.hoverSeries.yAxis.reversed&&(l=!l);var n=!this.followPointer&&G(k.ttBelow,!g.inverted===
	l),y=function(a,g,c,k,f,t,z){var l=r?"y"===a?e*h.scaleY:e*h.scaleX:e,w=(c-k)/2,m=k<f-e,I=f+e+k<g,p=f-l-c+w;f=f+l-w;if(n&&I)b[a]=f;else if(!n&&m)b[a]=p;else if(m)b[a]=Math.min(z-k,0>p-d?p:p-d);else if(I)b[a]=Math.max(t,f+d+c>g?f:f+d);else return!1},u=function(d,a,g,c,r){var k;r<e||r>a-e?k=!1:b[d]=r<g/2?1:r>a-c/2?a-c-2:r-g/2;return k},D=function(b){var d=w;w=m;m=d;p=b},M=function(){!1!==y.apply(0,w)?!1!==u.apply(0,m)||p||(D(!0),M()):p?b.x=b.y=0:(D(!0),M())};(g.inverted||1<this.len)&&D();M();return b};
	a.prototype.hide=function(a){var c=this;B.clearTimeout(this.hideTimer);a=G(a,this.options.hideDelay);this.isHidden||(this.hideTimer=K(function(){c.getLabel().fadeOut(a?void 0:a);c.isHidden=!0},a))};a.prototype.init=function(a,c){this.chart=a;this.options=c;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=c.split&&!a.inverted&&!a.polar;this.shared=c.shared||this.split;this.outside=G(c.outside,!(!a.scrollablePixelsX&&!a.scrollablePixelsY))};a.prototype.shouldStickOnContact=function(a){return!(this.followPointer||
	!this.options.stickOnContact||a&&!this.chart.pointer.inClass(a.target,"highcharts-tooltip"))};a.prototype.move=function(a,c,k,g){var e=this,b=e.now,d=!1!==e.options.animation&&!e.isHidden&&(1<Math.abs(a-b.x)||1<Math.abs(c-b.y)),r=e.followPointer||1<e.len;h(b,{x:d?(2*b.x+a)/3:a,y:d?(b.y+c)/2:c,anchorX:r?void 0:d?(2*b.anchorX+k)/3:k,anchorY:r?void 0:d?(b.anchorY+g)/2:g});e.getLabel().attr(b);e.drawTracker();d&&(B.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(a,
	c,k,g)},32))};a.prototype.refresh=function(a,c){var k=this.chart,g=this.options,e=k.pointer,b=H(a),d=b[0],r=[],f=g.formatter||this.defaultFormatter,t=this.shared,h=k.styledMode,w={};if(g.enabled&&d.series){B.clearTimeout(this.hideTimer);this.allowShared=!(!l(a)&&a.series&&a.series.noSharedTooltip);this.followPointer=!this.split&&d.series.tooltipOptions.followPointer;a=this.getAnchor(a,c);var p=a[0],n=a[1];t&&this.allowShared?(e.applyInactiveState(b),b.forEach(function(b){b.setState("hover");r.push(b.getLabelConfig())}),
	w={x:d.category,y:d.y},w.points=r):w=d.getLabelConfig();this.len=r.length;f=f.call(w,this);t=d.series;this.distance=G(t.tooltipOptions.distance,16);if(!1===f)this.hide();else{if(this.split&&this.allowShared)this.renderSplit(f,b);else{var y=p,u=n;c&&e.isDirectTouch&&(y=c.chartX-k.plotLeft,u=c.chartY-k.plotTop);if(k.polar||!1===t.options.clip||b.some(function(b){return e.isDirectTouch||b.series.shouldShowTooltip(y,u)}))c=this.getLabel(),g.style.width&&!h||c.css({width:k.spacingBox.width+"px"}),c.attr({text:f&&
	f.join?f.join(""):f}),c.addClass(this.getClassName(d),!0),h||c.attr({stroke:g.borderColor||d.color||t.color||"#666666"}),this.updatePosition({plotX:p,plotY:n,negative:d.negative,ttBelow:d.ttBelow,h:a[2]||0});else{this.hide();return}}this.isHidden&&this.label&&this.label.attr({opacity:1}).show();this.isHidden=!1}m(this,"refresh")}};a.prototype.renderSplit=function(a,c){function k(b,d,e,a,c){void 0===c&&(c=!0);e?(d=V?0:E,b=u(b-a/2,Y.left,Y.right-a-(g.outside?H:0))):(d-=A,b=c?b-a-q:b+q,b=u(b,c?b:Y.left,
	Y.right));return{x:b,y:d}}var g=this,e=g.chart,b=g.chart,d=b.chartWidth,r=b.chartHeight,t=b.plotHeight,l=b.plotLeft,w=b.plotTop,m=b.pointer,p=b.scrollablePixelsY;p=void 0===p?0:p;var n=b.scrollablePixelsX,y=b.scrollingContainer;y=void 0===y?{scrollLeft:0,scrollTop:0}:y;var D=y.scrollLeft;y=y.scrollTop;var v=b.styledMode,q=g.distance,K=g.options,M=g.options.positioner,Y=g.outside&&"number"!==typeof n?F.documentElement.getBoundingClientRect():{left:D,right:D+d,top:y,bottom:y+r},Q=g.getLabel(),ca=this.renderer||
	e.renderer,V=!(!e.xAxis[0]||!e.xAxis[0].opposite);e=m.getChartPosition();var H=e.left;e=e.top;var A=w+y,B=0,E=t-p;f(a)&&(a=[!1,a]);a=a.slice(0,c.length+1).reduce(function(b,d,e){if(!1!==d&&""!==d){e=c[e-1]||{isHeader:!0,plotX:c[0].plotX,plotY:t,series:{}};var a=e.isHeader,r=a?g:e.series;d=d.toString();var f=r.tt,z=e.isHeader;var h=e.series;f||(f={padding:K.padding,r:K.borderRadius},v||(f.fill=K.backgroundColor,f["stroke-width"]=K.borderWidth),f=ca.label("",0,0,K[z?"headerShape":"shape"],void 0,void 0,
	K.useHTML).addClass(g.getClassName(e,!0,z)).attr(f).add(Q));f.isActive=!0;f.attr({text:d});v||f.css(K.style).shadow(K.shadow).attr({stroke:K.borderColor||e.color||h.color||"#333333"});r=r.tt=f;z=r.getBBox();d=z.width+r.strokeWidth();a&&(B=z.height,E+=B,V&&(A-=B));h=e.plotX;h=void 0===h?0:h;f=e.plotY;f=void 0===f?0:f;var m=e.series;if(e.isHeader){h=l+h;var I=w+t/2}else{var p=m.xAxis,n=m.yAxis;h=p.pos+u(h,-q,p.len+q);m.shouldShowTooltip(0,n.pos-w+f,{ignoreX:!0})&&(I=n.pos+f)}h=u(h,Y.left-q,Y.right+
	q);"number"===typeof I?(z=z.height+1,f=M?M.call(g,d,z,e):k(h,I,a,d),b.push({align:M?0:void 0,anchorX:h,anchorY:I,boxWidth:d,point:e,rank:G(f.rank,a?1:0),size:z,target:f.y,tt:r,x:f.x})):r.isActive=!1}return b},[]);!M&&a.some(function(b){var d=(g.outside?H:0)+b.anchorX;return d<Y.left&&d+b.boxWidth<Y.right?!0:d<H-Y.left+b.boxWidth&&Y.right-d>d})&&(a=a.map(function(b){var d=k(b.anchorX,b.anchorY,b.point.isHeader,b.boxWidth,!1);return h(b,{target:d.y,x:d.x})}));g.cleanSplit();x(a,E);var C=H,J=H;a.forEach(function(b){var d=
	b.x,e=b.boxWidth;b=b.isHeader;b||(g.outside&&H+d<C&&(C=H+d),!b&&g.outside&&C+e>J&&(J=H+d))});a.forEach(function(b){var d=b.x,e=b.anchorX,a=b.pos,c=b.point.isHeader;a={visibility:"undefined"===typeof a?"hidden":"inherit",x:d,y:(a||0)+A,anchorX:e,anchorY:b.anchorY};if(g.outside&&d<e){var r=H-C;0<r&&(c||(a.x=d+r,a.anchorX=e+r),c&&(a.x=(J-C)/2,a.anchorX=e+r))}b.tt.attr(a)});a=g.container;p=g.renderer;g.outside&&a&&p&&(b=Q.getBBox(),p.setSize(b.width+b.x,b.height+b.y,!1),a.style.left=C+"px",a.style.top=
	e+"px")};a.prototype.drawTracker=function(){if(this.shouldStickOnContact()){var a=this.chart,c=this.label,k=this.shared?a.hoverPoints:a.hoverPoint;if(c&&k){var g={x:0,y:0,width:0,height:0};k=this.getAnchor(k);var e=c.getBBox();k[0]+=a.plotLeft-c.translateX;k[1]+=a.plotTop-c.translateY;g.x=Math.min(0,k[0]);g.y=Math.min(0,k[1]);g.width=0>k[0]?Math.max(Math.abs(k[0]),e.width-k[0]):Math.max(Math.abs(k[0]),e.width);g.height=0>k[1]?Math.max(Math.abs(k[1]),e.height-Math.abs(k[1])):Math.max(Math.abs(k[1]),
	e.height);this.tracker?this.tracker.attr(g):(this.tracker=c.renderer.rect(g).addClass("highcharts-tracker").add(c),a.styledMode||this.tracker.attr({fill:"rgba(0,0,0,0)"}))}}else this.tracker&&this.tracker.destroy()};a.prototype.styledModeFormat=function(a){return a.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"')};a.prototype.tooltipFooterHeaderFormatter=
	function(a,c){var k=a.series,g=k.tooltipOptions,e=k.xAxis,b=e&&e.dateTime;e={isFooter:c,labelConfig:a};var d=g.xDateFormat,r=g[c?"footerFormat":"headerFormat"];m(this,"headerFormatter",e,function(e){b&&!d&&p(a.key)&&(d=b.getXDateFormat(a.key,g.dateTimeLabelFormats));b&&d&&(a.point&&a.point.tooltipDateKeys||["key"]).forEach(function(b){r=r.replace("{point."+b+"}","{point."+b+":"+d+"}")});k.chart.styledMode&&(r=this.styledModeFormat(r));e.text=v(r,{point:a,series:k},this.chart)});return e.text};a.prototype.update=
	function(a){this.destroy();D(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,D(!0,this.options,a))};a.prototype.updatePosition=function(a){var c=this.chart,k=this.distance,g=this.options,e=c.pointer,b=this.getLabel(),d=e.getChartPosition();e=d.left;var r=d.top,f=d.scaleX;d=d.scaleY;var t=(g.positioner||this.getPosition).call(this,b.width,b.height,a),h=(a.plotX||0)+c.plotLeft;a=(a.plotY||0)+c.plotTop;if(this.outside){g.positioner&&(t.x+=e-k,t.y+=r-k);k=g.borderWidth+2*k;this.renderer.setSize(b.width+
	k,b.height+k,!1);if(1!==f||1!==d)n(this.container,{transform:"scale(".concat(f,", ").concat(d,")")}),h*=f,a*=d;h+=e-t.x;a+=r-t.y}this.move(Math.round(t.x),Math.round(t.y||0),h,a)};return a}();"";return a});J(a,"Core/Series/Point.js",[a["Core/Renderer/HTML/AST.js"],a["Core/Animation/AnimationUtilities.js"],a["Core/Defaults.js"],a["Core/FormatUtilities.js"],a["Core/Utilities.js"]],function(a,q,A,E,B){var v=q.animObject,F=A.defaultOptions,x=E.format,u=B.addEvent,n=B.defined,c=B.erase,h=B.extend,m=B.fireEvent,
	l=B.getNestedProperty,p=B.isArray,f=B.isFunction,D=B.isNumber,G=B.isObject,H=B.merge,K=B.objectEach,y=B.pick,t=B.syncTimeout,w=B.removeEvent,k=B.uniqueKey;q=function(){function g(){this.category=void 0;this.formatPrefix="point";this.id=void 0;this.isNull=!1;this.percentage=this.options=this.name=void 0;this.selected=!1;this.total=this.shapeArgs=this.series=void 0;this.visible=!0;this.x=void 0}g.prototype.animateBeforeDestroy=function(){var e=this,b={x:e.startXPos,opacity:0},d=e.getGraphicalProps();
	d.singular.forEach(function(d){e[d]=e[d].animate("dataLabel"===d?{x:e[d].startXPos,y:e[d].startYPos,opacity:0}:b)});d.plural.forEach(function(b){e[b].forEach(function(b){b.element&&b.animate(h({x:e.startXPos},b.startYPos?{x:b.startXPos,y:b.startYPos}:{}))})})};g.prototype.applyOptions=function(e,b){var d=this.series,a=d.options.pointValKey||d.pointValKey;e=g.prototype.optionsToObject.call(this,e);h(this,e);this.options=this.options?h(this.options,e):e;e.group&&delete this.group;e.dataLabels&&delete this.dataLabels;
	a&&(this.y=g.prototype.getNestedProperty.call(this,a));this.formatPrefix=(this.isNull=this.isValid&&!this.isValid())?"null":"point";this.selected&&(this.state="select");"name"in this&&"undefined"===typeof b&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));"undefined"===typeof this.x&&d?this.x="undefined"===typeof b?d.autoIncrement():b:D(e.x)&&d.options.relativeXValue&&(this.x=d.autoIncrement(e.x));return this};g.prototype.destroy=function(){function e(){if(b.graphic||b.graphics||b.dataLabel||
	b.dataLabels)w(b),b.destroyElements();for(f in b)b[f]=null}var b=this,d=b.series,a=d.chart;d=d.options.dataSorting;var g=a.hoverPoints,k=v(b.series.chart.renderer.globalAnimation),f;b.legendItem&&a.legend.destroyItem(b);g&&(b.setState(),c(g,b),g.length||(a.hoverPoints=null));if(b===a.hoverPoint)b.onMouseOut();d&&d.enabled?(this.animateBeforeDestroy(),t(e,k.duration)):e();a.pointCount--};g.prototype.destroyElements=function(e){var b=this;e=b.getGraphicalProps(e);e.singular.forEach(function(d){b[d]=
	b[d].destroy()});e.plural.forEach(function(d){b[d].forEach(function(b){b&&b.element&&b.destroy()});delete b[d]})};g.prototype.firePointEvent=function(e,b,d){var a=this,c=this.series.options;(c.point.events[e]||a.options&&a.options.events&&a.options.events[e])&&a.importEvents();"click"===e&&c.allowPointSelect&&(d=function(b){a.select&&a.select(null,b.ctrlKey||b.metaKey||b.shiftKey)});m(a,e,b,d)};g.prototype.getClassName=function(){return"highcharts-point"+(this.selected?" highcharts-point-select":
	"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+("undefined"!==typeof this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")};g.prototype.getGraphicalProps=function(e){var b=this,d=[],a={singular:[],plural:[]},c;e=e||{graphic:1,dataLabel:1};e.graphic&&d.push("graphic","shadowGroup");e.dataLabel&&d.push("dataLabel",
	"dataLabelPath","dataLabelUpper","connector");for(c=d.length;c--;){var g=d[c];b[g]&&a.singular.push(g)}["graphic","dataLabel","connector"].forEach(function(d){var c=d+"s";e[d]&&b[c]&&a.plural.push(c)});return a};g.prototype.getLabelConfig=function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}};g.prototype.getNestedProperty=function(e){if(e)return 0===
	e.indexOf("custom.")?l(e,this.options):this[e]};g.prototype.getZone=function(){var e=this.series,b=e.zones;e=e.zoneAxis||"y";var d,a=0;for(d=b[a];this[e]>=d.value;)d=b[++a];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=d&&d.color&&!this.options.color?d.color:this.nonZonedColor;return d};g.prototype.hasNewShapeType=function(){return(this.graphic&&(this.graphic.symbolName||this.graphic.element.nodeName))!==this.shapeType};g.prototype.init=function(e,b,d){this.series=e;this.applyOptions(b,
	d);this.id=n(this.id)?this.id:k();this.resolveColor();e.chart.pointCount++;m(this,"afterInit");return this};g.prototype.isValid=function(){return null!==this.x&&D(this.y)};g.prototype.optionsToObject=function(e){var b=this.series,d=b.options.keys,a=d||b.pointArrayMap||["y"],c=a.length,k={},f=0,t=0;if(D(e)||null===e)k[a[0]]=e;else if(p(e))for(!d&&e.length>c&&(b=typeof e[0],"string"===b?k.name=e[0]:"number"===b&&(k.x=e[0]),f++);t<c;)d&&"undefined"===typeof e[f]||(0<a[t].indexOf(".")?g.prototype.setNestedProperty(k,
	e[f],a[t]):k[a[t]]=e[f]),f++,t++;else"object"===typeof e&&(k=e,e.dataLabels&&(b._hasPointLabels=!0),e.marker&&(b._hasPointMarkers=!0));return k};g.prototype.pos=function(e,b){void 0===b&&(b=this.plotY);var d=this.plotX,a=this.series,c=a.chart,g=a.xAxis;a=a.yAxis;var k=0,f=0;if(D(d)&&D(b))return e&&(k=g?g.pos:c.plotLeft,f=a?a.pos:c.plotTop),c.inverted&&g&&a?[a.len-b+f,g.len-d+k]:[d+k,b+f]};g.prototype.resolveColor=function(){var e=this.series,b=e.chart.styledMode;var d=e.chart.options.chart.colorCount;
	delete this.nonZonedColor;if(e.options.colorByPoint){if(!b){d=e.options.colors||e.chart.options.colors;var a=d[e.colorCounter];d=d.length}b=e.colorCounter;e.colorCounter++;e.colorCounter===d&&(e.colorCounter=0)}else b||(a=e.color),b=e.colorIndex;this.colorIndex=y(this.options.colorIndex,b);this.color=y(this.options.color,a)};g.prototype.setNestedProperty=function(e,b,d){d.split(".").reduce(function(d,e,a,c){d[e]=c.length-1===a?b:G(d[e],!0)?d[e]:{};return d[e]},e);return e};g.prototype.shouldDraw=
	function(){return!this.isNull};g.prototype.tooltipFormatter=function(e){var b=this.series,d=b.tooltipOptions,a=y(d.valueDecimals,""),c=d.valuePrefix||"",g=d.valueSuffix||"";b.chart.styledMode&&(e=b.chart.tooltip.styledModeFormat(e));(b.pointArrayMap||["y"]).forEach(function(b){b="{point."+b;if(c||g)e=e.replace(RegExp(b+"}","g"),c+b+"}"+g);e=e.replace(RegExp(b+"}","g"),b+":,."+a+"f}")});return x(e,{point:this,series:this.series},b.chart)};g.prototype.update=function(e,b,d,a){function c(){g.applyOptions(e);
	var a=k&&g.hasMockGraphic;a=null===g.y?!a:a;k&&a&&(g.graphic=k.destroy(),delete g.hasMockGraphic);G(e,!0)&&(k&&k.element&&e&&e.marker&&"undefined"!==typeof e.marker.symbol&&(g.graphic=k.destroy()),e&&e.dataLabels&&g.dataLabel&&(g.dataLabel=g.dataLabel.destroy()),g.connector&&(g.connector=g.connector.destroy()));h=g.index;r.updateParallelArrays(g,h);t.data[h]=G(t.data[h],!0)||G(e,!0)?g.options:y(e,t.data[h]);r.isDirty=r.isDirtyData=!0;!r.fixedBox&&r.hasCartesianSeries&&(f.isDirtyBox=!0);"point"===
	t.legendType&&(f.isDirtyLegend=!0);b&&f.redraw(d)}var g=this,r=g.series,k=g.graphic,f=r.chart,t=r.options,h;b=y(b,!0);!1===a?c():g.firePointEvent("update",{options:e},c)};g.prototype.remove=function(e,b){this.series.removePoint(this.series.data.indexOf(this),e,b)};g.prototype.select=function(e,b){var d=this,a=d.series,g=a.chart;this.selectedStaging=e=y(e,!d.selected);d.firePointEvent(e?"select":"unselect",{accumulate:b},function(){d.selected=d.options.selected=e;a.options.data[a.data.indexOf(d)]=
	d.options;d.setState(e&&"select");b||g.getSelectedPoints().forEach(function(b){var e=b.series;b.selected&&b!==d&&(b.selected=b.options.selected=!1,e.options.data[e.data.indexOf(b)]=b.options,b.setState(g.hoverPoints&&e.options.inactiveOtherPoints?"inactive":""),b.firePointEvent("unselect"))})});delete this.selectedStaging};g.prototype.onMouseOver=function(e){var b=this.series.chart,d=b.pointer;e=e?d.normalize(e):d.getChartCoordinatesFromPoint(this,b.inverted);d.runPointActions(e,this)};g.prototype.onMouseOut=
	function(){var e=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(e.hoverPoints||[]).forEach(function(b){b.setState()});e.hoverPoints=e.hoverPoint=null};g.prototype.importEvents=function(){if(!this.hasImportedEvents){var e=this,b=H(e.series.options.point,e.options).events;e.events=b;K(b,function(b,a){f(b)&&u(e,a,b)});this.hasImportedEvents=!0}};g.prototype.setState=function(e,b){var d=this.series,g=this.state,c=d.options.states[e||"normal"]||{},k=F.plotOptions[d.type].marker&&
	d.options.marker,f=k&&!1===k.enabled,t=k&&k.states&&k.states[e||"normal"]||{},l=!1===t.enabled,w=this.marker||{},p=d.chart,n=k&&d.markerAttribs,u=d.halo,v,q=d.stateMarkerGraphic;e=e||"";if(!(e===this.state&&!b||this.selected&&"select"!==e||!1===c.enabled||e&&(l||f&&!1===t.enabled)||e&&w.states&&w.states[e]&&!1===w.states[e].enabled)){this.state=e;n&&(v=d.markerAttribs(this,e));if(this.graphic&&!this.hasMockGraphic){g&&this.graphic.removeClass("highcharts-point-"+g);e&&this.graphic.addClass("highcharts-point-"+
	e);if(!p.styledMode){g=d.pointAttribs(this,e);var M=y(p.options.chart.animation,c.animation);var G=g.opacity;d.options.inactiveOtherPoints&&D(G)&&((this.dataLabels||[]).forEach(function(b){b&&!b.hasClass("highcharts-data-label-hidden")&&b.animate({opacity:G},M)}),this.connector&&this.connector.animate({opacity:G},M));this.graphic.animate(g,M)}v&&this.graphic.animate(v,y(p.options.chart.animation,t.animation,k.animation));q&&q.hide()}else{if(e&&t){k=w.symbol||d.symbol;q&&q.currentSymbol!==k&&(q=q.destroy());
	if(v)if(q)q[b?"animate":"attr"]({x:v.x,y:v.y});else k&&(d.stateMarkerGraphic=q=p.renderer.symbol(k,v.x,v.y,v.width,v.height).add(d.markerGroup),q.currentSymbol=k);!p.styledMode&&q&&"inactive"!==this.state&&q.attr(d.pointAttribs(this,e))}q&&(q[e&&this.isInside?"show":"hide"](),q.element.point=this,q.addClass(this.getClassName(),!0))}c=c.halo;v=(q=this.graphic||q)&&q.visibility||"inherit";c&&c.size&&q&&"hidden"!==v&&!this.isCluster?(u||(d.halo=u=p.renderer.path().add(q.parentGroup)),u.show()[b?"animate":
	"attr"]({d:this.haloPath(c.size)}),u.attr({"class":"highcharts-halo highcharts-color-"+y(this.colorIndex,d.colorIndex)+(this.className?" "+this.className:""),visibility:v,zIndex:-1}),u.point=this,p.styledMode||u.attr(h({fill:this.color||d.color,"fill-opacity":c.opacity},a.filterUserAttributes(c.attributes||{})))):u&&u.point&&u.point.haloPath&&u.animate({d:u.point.haloPath(0)},null,u.hide);m(this,"afterSetState",{state:e})}};g.prototype.haloPath=function(e){var b=this.pos();return b?this.series.chart.renderer.symbols.circle(Math.floor(b[0])-
	e,b[1]-e,2*e,2*e):[]};return g}();"";return q});J(a,"Core/Pointer.js",[a["Core/Color/Color.js"],a["Core/Globals.js"],a["Core/Tooltip.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=a.parse,C=q.charts,F=q.noop,x=E.addEvent,u=E.attr,n=E.css,c=E.defined,h=E.extend,m=E.find,l=E.fireEvent,p=E.isNumber,f=E.isObject,D=E.objectEach,G=E.offset,H=E.pick,K=E.splat;a=function(){function a(a,c){this.lastValidTouch={};this.pinchDown=[];this.runChartClick=!1;this.eventsToUnbind=[];this.chart=a;this.hasDragged=
	!1;this.options=c;this.init(a,c)}a.prototype.applyInactiveState=function(a){var c=[],k;(a||[]).forEach(function(a){k=a.series;c.push(k);k.linkedParent&&c.push(k.linkedParent);k.linkedSeries&&(c=c.concat(k.linkedSeries));k.navigatorSeries&&c.push(k.navigatorSeries)});this.chart.series.forEach(function(a){-1===c.indexOf(a)?a.setState("inactive",!0):a.options.inactiveOtherPoints&&a.setAllPointsToState("inactive")})};a.prototype.destroy=function(){var c=this;this.eventsToUnbind.forEach(function(a){return a()});
	this.eventsToUnbind=[];q.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(c.tooltipTimeout);D(c,function(a,k){c[k]=void 0})};a.prototype.getSelectionMarkerAttrs=function(a,c){var k=this,g={args:{chartX:a,chartY:c},attrs:{},shapeType:"rect"};l(this,"getSelectionMarkerAttrs",g,function(e){var b=k.chart,d=k.mouseDownX;d=void 0===d?0:d;var g=k.mouseDownY;g=void 0===g?
	0:g;var f=k.zoomHor,t=k.zoomVert;e=e.attrs;e.x=b.plotLeft;e.y=b.plotTop;e.width=f?1:b.plotWidth;e.height=t?1:b.plotHeight;f&&(b=a-d,e.width=Math.abs(b),e.x=(0<b?0:b)+d);t&&(b=c-g,e.height=Math.abs(b),e.y=(0<b?0:b)+g)});return g};a.prototype.drag=function(a){var c=this.chart,k=c.options.chart,g=c.plotLeft,e=c.plotTop,b=c.plotWidth,d=c.plotHeight,r=this.mouseDownX||0,t=this.mouseDownY||0,h=f(k.panning)?k.panning&&k.panning.enabled:k.panning,l=k.panKey&&a[k.panKey+"Key"],m=a.chartX,p=a.chartY,n=this.selectionMarker;
	n&&n.touch||(m<g?m=g:m>g+b&&(m=g+b),p<e?p=e:p>e+d&&(p=e+d),this.hasDragged=Math.sqrt(Math.pow(r-m,2)+Math.pow(t-p,2)),10<this.hasDragged&&(g=c.isInsidePlot(r-g,t-e,{visiblePlotOnly:!0}),p=this.getSelectionMarkerAttrs(m,p),m=p.shapeType,p=p.attrs,!c.hasCartesianSeries&&!c.mapView||!this.zoomX&&!this.zoomY||!g||l||n||(this.selectionMarker=n=c.renderer[m](),n.attr({"class":"highcharts-selection-marker",zIndex:7}).add(),c.styledMode||n.attr({fill:k.selectionMarkerFill||v("#335cad").setOpacity(.25).get()})),
	n&&n.attr(p),g&&!n&&h&&c.pan(a,k.panning)))};a.prototype.dragStart=function(a){var c=this.chart;c.mouseIsDown=a.type;c.cancelClick=!1;c.mouseDownX=this.mouseDownX=a.chartX;c.mouseDownY=this.mouseDownY=a.chartY};a.prototype.getSelectionBox=function(a){var c={args:{marker:a},result:{}};l(this,"getSelectionBox",c,function(c){c.result={x:a.attr?+a.attr("x"):a.x,y:a.attr?+a.attr("y"):a.y,width:a.attr?a.attr("width"):a.width,height:a.attr?a.attr("height"):a.height}});return c.result};a.prototype.drop=function(a){var f=
	this,k=this.chart,g=this.hasPinched;if(this.selectionMarker){var e=this.getSelectionBox(this.selectionMarker),b=e.x,d=e.y,r=e.width,t=e.height,m={originalEvent:a,xAxis:[],yAxis:[],x:b,y:d,width:r,height:t},u=!!k.mapView;if(this.hasDragged||g)k.axes.forEach(function(e){if(e.zoomEnabled&&c(e.min)&&(g||f[{xAxis:"zoomX",yAxis:"zoomY"}[e.coll]])&&p(b)&&p(d)&&p(r)&&p(t)){var k=e.horiz,h="touchend"===a.type?e.minPixelPadding:0,z=e.toValue((k?b:d)+h);k=e.toValue((k?b+r:d+t)-h);m[e.coll].push({axis:e,min:Math.min(z,
	k),max:Math.max(z,k)});u=!0}}),u&&l(k,"selection",m,function(b){k.zoom(h(b,g?{animation:!1}:null))});p(k.index)&&(this.selectionMarker=this.selectionMarker.destroy());g&&this.scaleGroups()}k&&p(k.index)&&(n(k.container,{cursor:k._cursor}),k.cancelClick=10<this.hasDragged,k.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])};a.prototype.findNearestKDPoint=function(a,c,k){var g;a.forEach(function(e){var b=!(e.noSharedTooltip&&c)&&0>e.options.findNearestPointBy.indexOf("y");e=e.searchPoint(k,
	b);if((b=f(e,!0)&&e.series)&&!(b=!f(g,!0))){b=g.distX-e.distX;var d=g.dist-e.dist,a=(e.series.group&&e.series.group.zIndex)-(g.series.group&&g.series.group.zIndex);b=0<(0!==b&&c?b:0!==d?d:0!==a?a:g.series.index>e.series.index?-1:1)}b&&(g=e)});return g};a.prototype.getChartCoordinatesFromPoint=function(a,c){var k=a.series,g=k.xAxis;k=k.yAxis;var e=a.shapeArgs;if(g&&k){var b=H(a.clientX,a.plotX),d=a.plotY||0;a.isNode&&e&&p(e.x)&&p(e.y)&&(b=e.x,d=e.y);return c?{chartX:k.len+k.pos-d,chartY:g.len+g.pos-
	b}:{chartX:b+g.pos,chartY:d+k.pos}}if(e&&e.x&&e.y)return{chartX:e.x,chartY:e.y}};a.prototype.getChartPosition=function(){if(this.chartPosition)return this.chartPosition;var a=this.chart.container,c=G(a);this.chartPosition={left:c.left,top:c.top,scaleX:1,scaleY:1};var k=a.offsetWidth;a=a.offsetHeight;2<k&&2<a&&(this.chartPosition.scaleX=c.width/k,this.chartPosition.scaleY=c.height/a);return this.chartPosition};a.prototype.getCoordinates=function(a){var c={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(k){c[k.isXAxis?
	"xAxis":"yAxis"].push({axis:k,value:k.toValue(a[k.horiz?"chartX":"chartY"])})});return c};a.prototype.getHoverData=function(a,c,k,g,e,b){var d=[];g=!(!g||!a);var r=function(b){return b.visible&&!(!e&&b.directTouch)&&H(b.options.enableMouseTracking,!0)},h={chartX:b?b.chartX:void 0,chartY:b?b.chartY:void 0,shared:e};l(this,"beforeGetHoverData",h);var t=c&&!c.stickyTracking?[c]:k.filter(function(b){return b.stickyTracking&&(h.filter||r)(b)});var w=g||!b?a:this.findNearestKDPoint(t,e,b);c=w&&w.series;
	w&&(e&&!c.noSharedTooltip?(t=k.filter(function(b){return h.filter?h.filter(b):r(b)&&!b.noSharedTooltip}),t.forEach(function(b){var a=m(b.points,function(b){return b.x===w.x&&!b.isNull});f(a)&&(b.boosted&&b.boost&&(a=b.boost.getPoint(a)),d.push(a))})):d.push(w));h={hoverPoint:w};l(this,"afterGetHoverData",h);return{hoverPoint:h.hoverPoint,hoverSeries:c,hoverPoints:d}};a.prototype.getPointFromEvent=function(a){a=a.target;for(var c;a&&!c;)c=a.point,a=a.parentNode;return c};a.prototype.onTrackerMouseOut=
	function(a){a=a.relatedTarget||a.toElement;var c=this.chart.hoverSeries;this.isDirectTouch=!1;if(!(!c||!a||c.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+c.index)&&this.inClass(a,"highcharts-tracker")))c.onMouseOut()};a.prototype.inClass=function(a,c){for(var k;a;){if(k=u(a,"class")){if(-1!==k.indexOf(c))return!0;if(-1!==k.indexOf("highcharts-container"))return!1}a=a.parentElement}};a.prototype.init=function(a,c){this.options=c;this.chart=a;this.runChartClick=
	!(!c.chart.events||!c.chart.events.click);this.pinchDown=[];this.lastValidTouch={};A&&(a.tooltip=new A(a,c.tooltip));this.setDOMEvents()};a.prototype.normalize=function(a,c){var k=a.touches,g=k?k.length?k.item(0):H(k.changedTouches,a.changedTouches)[0]:a;c||(c=this.getChartPosition());k=g.pageX-c.left;g=g.pageY-c.top;k/=c.scaleX;g/=c.scaleY;return h(a,{chartX:Math.round(k),chartY:Math.round(g)})};a.prototype.onContainerClick=function(a){var c=this.chart,k=c.hoverPoint;a=this.normalize(a);var g=c.plotLeft,
	e=c.plotTop;c.cancelClick||(k&&this.inClass(a.target,"highcharts-tracker")?(l(k.series,"click",h(a,{point:k})),c.hoverPoint&&k.firePointEvent("click",a)):(h(a,this.getCoordinates(a)),c.isInsidePlot(a.chartX-g,a.chartY-e,{visiblePlotOnly:!0})&&l(c,"click",a)))};a.prototype.onContainerMouseDown=function(a){var c=1===((a.buttons||a.button)&1);a=this.normalize(a);if(q.isFirefox&&0!==a.button)this.onContainerMouseMove(a);if("undefined"===typeof a.button||c)this.zoomOption(a),c&&a.preventDefault&&a.preventDefault(),
	this.dragStart(a)};a.prototype.onContainerMouseLeave=function(c){var f=C[H(a.hoverChartIndex,-1)],k=this.chart.tooltip;c=this.normalize(c);f&&(c.relatedTarget||c.toElement)&&(f.pointer.reset(),f.pointer.chartPosition=void 0);k&&!k.isHidden&&this.reset()};a.prototype.onContainerMouseEnter=function(a){delete this.chartPosition};a.prototype.onContainerMouseMove=function(a){var c=this.chart,k=c.tooltip;a=this.normalize(a);this.setHoverChartIndex();a.preventDefault||(a.returnValue=!1);("mousedown"===c.mouseIsDown||
	this.touchSelect(a))&&this.drag(a);c.openMenu||!this.inClass(a.target,"highcharts-tracker")&&!c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop,{visiblePlotOnly:!0})||k&&k.shouldStickOnContact(a)||(this.inClass(a.target,"highcharts-no-tooltip")?this.reset(!1,0):this.runPointActions(a))};a.prototype.onDocumentTouchEnd=function(c){var f=C[H(a.hoverChartIndex,-1)];f&&f.pointer.drop(c)};a.prototype.onContainerTouchMove=function(a){if(this.touchSelect(a))this.onContainerMouseMove(a);else this.touch(a)};
	a.prototype.onContainerTouchStart=function(a){if(this.touchSelect(a))this.onContainerMouseDown(a);else this.zoomOption(a),this.touch(a,!0)};a.prototype.onDocumentMouseMove=function(a){var c=this.chart,k=c.tooltip,g=this.chartPosition;a=this.normalize(a,g);!g||c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop,{visiblePlotOnly:!0})||k&&k.shouldStickOnContact(a)||this.inClass(a.target,"highcharts-tracker")||this.reset()};a.prototype.onDocumentMouseUp=function(c){var f=C[H(a.hoverChartIndex,-1)];
	f&&f.pointer.drop(c)};a.prototype.pinch=function(a){var c=this,k=c.chart,g=c.pinchDown,e=a.touches||[],b=e.length,d=c.lastValidTouch,r=c.hasZoom,f={},m=1===b&&(c.inClass(a.target,"highcharts-tracker")&&k.runTrackerClick||c.runChartClick),t={},p=c.chart.tooltip;p=1===b&&H(p&&p.options.followTouchMove,!0);var n=c.selectionMarker;1<b?c.initiated=!0:p&&(c.initiated=!1);r&&c.initiated&&!m&&!1!==a.cancelable&&a.preventDefault();[].map.call(e,function(b){return c.normalize(b)});"touchstart"===a.type?([].forEach.call(e,
	function(b,d){g[d]={chartX:b.chartX,chartY:b.chartY}}),d.x=[g[0].chartX,g[1]&&g[1].chartX],d.y=[g[0].chartY,g[1]&&g[1].chartY],k.axes.forEach(function(b){if(b.zoomEnabled){var d=k.bounds[b.horiz?"h":"v"],a=b.minPixelPadding,e=b.toPixels(Math.min(H(b.options.min,b.dataMin),b.dataMin)),c=b.toPixels(Math.max(H(b.options.max,b.dataMax),b.dataMax)),g=Math.max(e,c);d.min=Math.min(b.pos,Math.min(e,c)-a);d.max=Math.max(b.pos+b.len,g+a)}}),c.res=!0):p?this.runPointActions(c.normalize(a)):g.length&&(l(k,"touchpan",
	{originalEvent:a},function(){n||(c.selectionMarker=n=h({destroy:F,touch:!0},k.plotBox));c.pinchTranslate(g,e,f,n,t,d);c.hasPinched=r;c.scaleGroups(f,t)}),c.res&&(c.res=!1,this.reset(!1,0)))};a.prototype.pinchTranslate=function(a,c,k,g,e,b){this.zoomHor&&this.pinchTranslateDirection(!0,a,c,k,g,e,b);this.zoomVert&&this.pinchTranslateDirection(!1,a,c,k,g,e,b)};a.prototype.pinchTranslateDirection=function(a,c,k,g,e,b,d,r){var f=this.chart,h=a?"x":"y",l=a?"X":"Y",m="chart"+l,t=a?"width":"height",p=f["plot"+
	(a?"Left":"Top")],w=f.inverted,n=f.bounds[a?"h":"v"],u=1===c.length,y=c[0][m],v=!u&&c[1][m];c=function(){"number"===typeof G&&20<Math.abs(y-v)&&(Q=r||Math.abs(q-G)/Math.abs(y-v));D=(p-q)/Q+y;M=f["plot"+(a?"Width":"Height")]/Q};var M,D,Q=r||1,q=k[0][m],G=!u&&k[1][m];c();k=D;if(k<n.min){k=n.min;var x=!0}else k+M>n.max&&(k=n.max-M,x=!0);x?(q-=.8*(q-d[h][0]),"number"===typeof G&&(G-=.8*(G-d[h][1])),c()):d[h]=[q,G];w||(b[h]=D-p,b[t]=M);b=w?1/Q:Q;e[t]=M;e[h]=k;g[w?a?"scaleY":"scaleX":"scale"+l]=Q;g["translate"+
	l]=b*p+(q-b*y)};a.prototype.reset=function(a,c){var k=this.chart,g=k.hoverSeries,e=k.hoverPoint,b=k.hoverPoints,d=k.tooltip,r=d&&d.shared?b:e;a&&r&&K(r).forEach(function(b){b.series.isCartesian&&"undefined"===typeof b.plotX&&(a=!1)});if(a)d&&r&&K(r).length&&(d.refresh(r),d.shared&&b?b.forEach(function(b){b.setState(b.state,!0);b.series.isCartesian&&(b.series.xAxis.crosshair&&b.series.xAxis.drawCrosshair(null,b),b.series.yAxis.crosshair&&b.series.yAxis.drawCrosshair(null,b))}):e&&(e.setState(e.state,
	!0),k.axes.forEach(function(b){b.crosshair&&e.series[b.coll]===b&&b.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();b&&b.forEach(function(b){b.setState()});if(g)g.onMouseOut();d&&d.hide(c);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());k.axes.forEach(function(b){b.hideCrosshair()});this.hoverX=k.hoverPoints=k.hoverPoint=null}};a.prototype.runPointActions=function(c,f,k){var g=this.chart,e=g.tooltip&&g.tooltip.options.enabled?g.tooltip:void 0,b=e?e.shared:!1,d=f||g.hoverPoint,
	r=d&&d.series||g.hoverSeries;f=this.getHoverData(d,r,g.series,(!c||"touchmove"!==c.type)&&(!!f||r&&r.directTouch&&this.isDirectTouch),b,c);d=f.hoverPoint;r=f.hoverSeries;var h=f.hoverPoints;f=r&&r.tooltipOptions.followPointer&&!r.tooltipOptions.split;var l=b&&r&&!r.noSharedTooltip;if(d&&(k||d!==g.hoverPoint||e&&e.isHidden)){(g.hoverPoints||[]).forEach(function(b){-1===h.indexOf(b)&&b.setState()});if(g.hoverSeries!==r)r.onMouseOver();this.applyInactiveState(h);(h||[]).forEach(function(b){b.setState("hover")});
	g.hoverPoint&&g.hoverPoint.firePointEvent("mouseOut");if(!d.series)return;g.hoverPoints=h;g.hoverPoint=d;d.firePointEvent("mouseOver",void 0,function(){e&&d&&e.refresh(l?h:d,c)})}else f&&e&&!e.isHidden&&(k=e.getAnchor([{}],c),g.isInsidePlot(k[0],k[1],{visiblePlotOnly:!0})&&e.updatePosition({plotX:k[0],plotY:k[1]}));this.unDocMouseMove||(this.unDocMouseMove=x(g.container.ownerDocument,"mousemove",function(b){var d=C[a.hoverChartIndex];if(d)d.pointer.onDocumentMouseMove(b)}),this.eventsToUnbind.push(this.unDocMouseMove));
	g.axes.forEach(function(b){var d=H((b.crosshair||{}).snap,!0),a;d&&((a=g.hoverPoint)&&a.series[b.coll]===b||(a=m(h,function(d){return d.series&&d.series[b.coll]===b})));a||!d?b.drawCrosshair(c,a):b.hideCrosshair()})};a.prototype.scaleGroups=function(a,c){var k=this.chart;k.series.forEach(function(g){var e=a||g.getPlotBox();g.group&&(g.xAxis&&g.xAxis.zoomEnabled||k.mapView)&&(g.group.attr(e),g.markerGroup&&(g.markerGroup.attr(e),g.markerGroup.clip(c?k.clipRect:null)),g.dataLabelsGroup&&g.dataLabelsGroup.attr(e))});
	k.clipRect.attr(c||k.clipBox)};a.prototype.setDOMEvents=function(){var c=this,f=this.chart.container,k=f.ownerDocument;f.onmousedown=this.onContainerMouseDown.bind(this);f.onmousemove=this.onContainerMouseMove.bind(this);f.onclick=this.onContainerClick.bind(this);this.eventsToUnbind.push(x(f,"mouseenter",this.onContainerMouseEnter.bind(this)));this.eventsToUnbind.push(x(f,"mouseleave",this.onContainerMouseLeave.bind(this)));a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=x(k,"mouseup",this.onDocumentMouseUp.bind(this)));
	for(var g=this.chart.renderTo.parentElement;g&&"BODY"!==g.tagName;)this.eventsToUnbind.push(x(g,"scroll",function(){delete c.chartPosition})),g=g.parentElement;q.hasTouch&&(this.eventsToUnbind.push(x(f,"touchstart",this.onContainerTouchStart.bind(this),{passive:!1})),this.eventsToUnbind.push(x(f,"touchmove",this.onContainerTouchMove.bind(this),{passive:!1})),a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=x(k,"touchend",this.onDocumentTouchEnd.bind(this),{passive:!1})))};a.prototype.setHoverChartIndex=
	function(){var c=this.chart,f=q.charts[H(a.hoverChartIndex,-1)];if(f&&f!==c)f.pointer.onContainerMouseLeave({relatedTarget:c.container});f&&f.mouseIsDown||(a.hoverChartIndex=c.index)};a.prototype.touch=function(a,c){var k=this.chart,g;this.setHoverChartIndex();if(1===a.touches.length)if(a=this.normalize(a),(g=k.isInsidePlot(a.chartX-k.plotLeft,a.chartY-k.plotTop,{visiblePlotOnly:!0}))&&!k.openMenu){c&&this.runPointActions(a);if("touchmove"===a.type){c=this.pinchDown;var e=c[0]?4<=Math.sqrt(Math.pow(c[0].chartX-
	a.chartX,2)+Math.pow(c[0].chartY-a.chartY,2)):!1}H(e,!0)&&this.pinch(a)}else c&&this.reset();else 2===a.touches.length&&this.pinch(a)};a.prototype.touchSelect=function(a){return!(!this.chart.options.chart.zooming.singleTouch||!a.touches||1!==a.touches.length)};a.prototype.zoomOption=function(a){var c=this.chart,k=c.options.chart;c=c.inverted;var g=k.zooming.type||"";/touch/.test(a.type)&&(g=H(k.zooming.pinchType,g));this.zoomX=a=/x/.test(g);this.zoomY=k=/y/.test(g);this.zoomHor=a&&!c||k&&c;this.zoomVert=
	k&&!c||a&&c;this.hasZoom=a||k};return a}();"";return a});J(a,"Core/MSPointer.js",[a["Core/Globals.js"],a["Core/Pointer.js"],a["Core/Utilities.js"]],function(a,q,A){function v(){var a=[];a.item=function(a){return this[a]};m(f,function(c){a.push({pageX:c.pageX,pageY:c.pageY,target:c.target})});return a}function B(a,c,f,h){var l=F[q.hoverChartIndex||NaN];"touch"!==a.pointerType&&a.pointerType!==a.MSPOINTER_TYPE_TOUCH||!l||(l=l.pointer,h(a),l[c]({type:f,target:a.currentTarget,preventDefault:u,touches:v()}))}
	var C=this&&this.__extends||function(){var a=function(c,f){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var f in c)c.hasOwnProperty(f)&&(a[f]=c[f])};return a(c,f)};return function(c,f){function h(){this.constructor=c}a(c,f);c.prototype=null===f?Object.create(f):(h.prototype=f.prototype,new h)}}(),F=a.charts,x=a.doc,u=a.noop,n=a.win,c=A.addEvent,h=A.css,m=A.objectEach,l=A.pick,p=A.removeEvent,f={},D=!!n.PointerEvent;return function(m){function u(){return null!==
	m&&m.apply(this,arguments)||this}C(u,m);u.isRequired=function(){return!(a.hasTouch||!n.PointerEvent&&!n.MSPointerEvent)};u.prototype.batchMSEvents=function(a){a(this.chart.container,D?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,D?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(x,D?"pointerup":"MSPointerUp",this.onDocumentPointerUp)};u.prototype.destroy=function(){this.batchMSEvents(p);m.prototype.destroy.call(this)};u.prototype.init=function(a,c){m.prototype.init.call(this,
	a,c);this.hasZoom&&h(a.container,{"-ms-touch-action":"none","touch-action":"none"})};u.prototype.onContainerPointerDown=function(a){B(a,"onContainerTouchStart","touchstart",function(a){f[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})};u.prototype.onContainerPointerMove=function(a){B(a,"onContainerTouchMove","touchmove",function(a){f[a.pointerId]={pageX:a.pageX,pageY:a.pageY};f[a.pointerId].target||(f[a.pointerId].target=a.currentTarget)})};u.prototype.onDocumentPointerUp=function(a){B(a,
	"onDocumentTouchEnd","touchend",function(a){delete f[a.pointerId]})};u.prototype.setDOMEvents=function(){var a=this.chart.tooltip;m.prototype.setDOMEvents.call(this);(this.hasZoom||l(a&&a.options.followTouchMove,!0))&&this.batchMSEvents(c)};return u}(q)});J(a,"Core/Legend/Legend.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/FormatUtilities.js"],a["Core/Globals.js"],a["Core/Series/Point.js"],a["Core/Renderer/RendererUtilities.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C){var v=a.animObject,
	x=a.setAnimation,u=q.format,n=A.marginNames,c=B.distribute,h=C.addEvent,m=C.createElement,l=C.css,p=C.defined,f=C.discardElement,D=C.find,G=C.fireEvent,H=C.isNumber,K=C.merge,y=C.pick,t=C.relativeLength,w=C.stableSort,k=C.syncTimeout;a=function(){function a(a,b){this.allItems=[];this.contentGroup=this.box=void 0;this.display=!1;this.group=void 0;this.offsetWidth=this.maxLegendWidth=this.maxItemWidth=this.legendWidth=this.legendHeight=this.lastLineHeight=this.lastItemY=this.itemY=this.itemX=this.itemMarginTop=
	this.itemMarginBottom=this.itemHeight=this.initialItemY=0;this.options=void 0;this.padding=0;this.pages=[];this.proximate=!1;this.scrollGroup=void 0;this.widthOption=this.totalItemWidth=this.titleHeight=this.symbolWidth=this.symbolHeight=0;this.chart=a;this.init(a,b)}a.prototype.init=function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),h(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=h(this.chart,"render",function(){this.legend.proximatePositions();
	this.legend.positionItems()}):this.unchartrender&&this.unchartrender())};a.prototype.setOptions=function(a){var b=y(a.padding,8);this.options=a;this.chart.styledMode||(this.itemStyle=a.itemStyle,this.itemHiddenStyle=K(this.itemStyle,a.itemHiddenStyle));this.itemMarginTop=a.itemMarginTop||0;this.itemMarginBottom=a.itemMarginBottom||0;this.padding=b;this.initialItemY=b-5;this.symbolWidth=y(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted;this.baseline=void 0};
	a.prototype.update=function(a,b){var d=this.chart;this.setOptions(K(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;y(b,!0)&&d.redraw();G(this,"afterUpdate")};a.prototype.colorizeItem=function(a,b){var d=a.legendItem||{},e=d.group,c=d.label,g=d.line;d=d.symbol;if(e)e[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var k=this.options;e=this.itemHiddenStyle.color;k=b?k.itemStyle.color:e;var f=b?a.color||e:e,h=a.options&&a.options.marker,l={fill:f};
	c&&c.css({fill:k,color:k});g&&g.attr({stroke:f});d&&(h&&d.isMarker&&(l=a.pointAttribs(),b||(l.stroke=l.fill=e)),d.attr(l))}G(this,"afterColorizeItem",{item:a,visible:b})};a.prototype.positionItems=function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()};a.prototype.positionItem=function(a){var b=this,d=a.legendItem||{},e=d.group,c=d.x;c=void 0===c?0:c;d=d.y;d=void 0===d?0:d;var g=this.options,k=g.symbolPadding,f=!g.rtl;g=a.checkbox;e&&e.element&&(k=
	{translateX:f?c:this.legendWidth-c-2*k-4,translateY:d},e[p(e.translateY)?"animate":"attr"](k,void 0,function(){G(b,"afterPositionItem",{item:a})}));g&&(g.x=c,g.y=d)};a.prototype.destroyItem=function(a){for(var b=a.checkbox,d=a.legendItem||{},e=0,c=["group","label","line","symbol"];e<c.length;e++){var g=c[e];d[g]&&(d[g]=d[g].destroy())}b&&f(b);a.legendItem=void 0};a.prototype.destroy=function(){for(var a=0,b=this.getAllItems();a<b.length;a++)this.destroyItem(b[a]);a=0;for(b="clipRect up down pager nav box title group".split(" ");a<
	b.length;a++){var d=b[a];this[d]&&(this[d]=this[d].destroy())}this.display=null};a.prototype.positionCheckboxes=function(){var a=this.group&&this.group.alignAttr,b=this.clipHeight||this.legendHeight,d=this.titleHeight;if(a){var c=a.translateY;this.allItems.forEach(function(e){var g=e.checkbox;if(g){var r=c+d+g.y+(this.scrollOffset||0)+3;l(g,{left:a.translateX+e.checkboxOffset+g.x-20+"px",top:r+"px",display:this.proximate||r>c-6&&r<c+b-6?"":"none"})}},this)}};a.prototype.renderTitle=function(){var a=
	this.options,b=this.padding,d=a.title,c=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,b-3,b-4,void 0,void 0,void 0,a.useHTML,void 0,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(d.style),this.title.add(this.group)),d.width||this.title.css({width:this.maxLegendWidth+"px"}),a=this.title.getBBox(),c=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:c}));this.titleHeight=c};a.prototype.setText=function(a){var b=this.options;a.legendItem.label.attr({text:b.labelFormat?
	u(b.labelFormat,a,this.chart):b.labelFormatter.call(a)})};a.prototype.renderItem=function(a){var b=a.legendItem=a.legendItem||{},d=this.chart,c=d.renderer,e=this.options,g=this.symbolWidth,k=e.symbolPadding||0,f=this.itemStyle,h=this.itemHiddenStyle,l="horizontal"===e.layout?y(e.itemDistance,20):0,m=!e.rtl,p=!a.series,t=!p&&a.series.drawLegendSymbol?a.series:a,n=t.options,w=this.createCheckboxForItem&&n&&n.showCheckbox,u=e.useHTML,D=a.options.className,Q=b.label;n=g+k+l+(w?20:0);Q||(b.group=c.g("legend-item").addClass("highcharts-"+
	t.type+"-series highcharts-color-"+a.colorIndex+(D?" "+D:"")+(p?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),b.label=Q=c.text("",m?g+k:-k,this.baseline||0,u),d.styledMode||Q.css(K(a.visible?f:h)),Q.attr({align:m?"left":"right",zIndex:2}).add(b.group),this.baseline||(this.fontMetrics=c.fontMetrics(d.styledMode?12:f.fontSize,Q),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,Q.attr("y",this.baseline),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,e.squareSymbol&&
	(this.symbolWidth=y(e.symbolWidth,Math.max(this.symbolHeight,16)),n=this.symbolWidth+k+l+(w?20:0),m&&Q.attr("x",this.symbolWidth+k))),t.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,Q,u));w&&!a.checkbox&&this.createCheckboxForItem&&this.createCheckboxForItem(a);this.colorizeItem(a,a.visible);!d.styledMode&&f.width||Q.css({width:(e.itemWidth||this.widthOption||d.spacingBox.width)-n+"px"});this.setText(a);d=Q.getBBox();c=this.fontMetrics&&this.fontMetrics.h||0;a.itemWidth=a.checkboxOffset=
	e.itemWidth||b.labelWidth||d.width+n;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(b.labelHeight||(d.height>1.5*c?d.height:c))};a.prototype.layoutItem=function(a){var b=this.options,d=this.padding,c="horizontal"===b.layout,e=a.itemHeight,g=this.itemMarginBottom,k=this.itemMarginTop,f=c?y(b.itemDistance,20):0,h=this.maxLegendWidth;b=b.alignColumns&&this.totalItemWidth>h?this.maxItemWidth:a.itemWidth;var l=a.legendItem||
	{};c&&this.itemX-d+b>h&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=k+this.lastLineHeight+g),this.lastLineHeight=0);this.lastItemY=k+this.itemY+g;this.lastLineHeight=Math.max(e,this.lastLineHeight);l.x=this.itemX;l.y=this.itemY;c?this.itemX+=b:(this.itemY+=k+e+g,this.lastLineHeight=e);this.offsetWidth=this.widthOption||Math.max((c?this.itemX-d-(a.checkbox?0:f):b)+d,this.offsetWidth)};a.prototype.getAllItems=function(){var a=[];this.chart.series.forEach(function(b){var d=b&&b.options;b&&y(d.showInLegend,
	p(d.linkedTo)?!1:void 0,!0)&&(a=a.concat((b.legendItem||{}).labels||("point"===d.legendType?b.data:b)))});G(this,"afterGetAllItems",{allItems:a});return a};a.prototype.getAlignment=function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)};a.prototype.adjustMargins=function(a,b){var d=this.chart,c=this.options,e=this.getAlignment();e&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(g,
	r){g.test(e)&&!p(a[r])&&(d[n[r]]=Math.max(d[n[r]],d.legend[(r+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][r]*c[r%2?"x":"y"]+y(c.margin,12)+b[r]+(d.titleOffset[r]||0)))})};a.prototype.proximatePositions=function(){var a=this.chart,b=[],d="left"===this.options.align;this.allItems.forEach(function(c){var e;var g=d;if(c.yAxis){c.xAxis.options.reversed&&(g=!g);c.points&&(e=D(g?c.points:c.points.slice(0).reverse(),function(b){return H(b.plotY)}));g=this.itemMarginTop+c.legendItem.label.getBBox().height+
	this.itemMarginBottom;var r=c.yAxis.top-a.plotTop;c.visible?(e=e?e.plotY:c.yAxis.height,e+=r-.3*g):e=r+c.yAxis.height;b.push({target:e,size:g,item:c})}},this);for(var g,k=0,f=c(b,a.plotHeight);k<f.length;k++){var h=f[k];g=h.item.legendItem||{};H(h.pos)&&(g.y=a.plotTop-a.spacing[0]+h.pos)}};a.prototype.render=function(){var a=this.chart,b=a.renderer,d=this.options,c=this.padding,g=this.getAllItems(),k=this.group,f=this.box;this.itemX=c;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;
	this.widthOption=t(d.width,a.spacingBox.width-c);var h=a.spacingBox.width-2*c-d.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(h/=2);this.maxLegendWidth=this.widthOption||h;k||(this.group=k=b.g("legend").addClass(d.className||"").attr({zIndex:7}).add(),this.contentGroup=b.g().attr({zIndex:1}).add(k),this.scrollGroup=b.g().add(this.contentGroup));this.renderTitle();w(g,function(b,a){return(b.options&&b.options.legendIndex||0)-(a.options&&a.options.legendIndex||0)});d.reversed&&g.reverse();
	this.allItems=g;this.display=h=!!g.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;g.forEach(this.renderItem,this);g.forEach(this.layoutItem,this);g=(this.widthOption||this.offsetWidth)+c;var l=this.lastItemY+this.lastLineHeight+this.titleHeight;l=this.handleOverflow(l);l+=c;f||(this.box=f=b.rect().addClass("highcharts-legend-box").attr({r:d.borderRadius}).add(k));a.styledMode||f.attr({stroke:d.borderColor,"stroke-width":d.borderWidth||0,fill:d.backgroundColor||
	"none"}).shadow(d.shadow);if(0<g&&0<l)f[f.placed?"animate":"attr"](f.crisp.call({},{x:0,y:0,width:g,height:l},f.strokeWidth()));k[h?"show":"hide"]();a.styledMode&&"none"===k.getStyle("display")&&(g=l=0);this.legendWidth=g;this.legendHeight=l;h&&this.align();this.proximate||this.positionItems();G(this,"afterRender")};a.prototype.align=function(a){void 0===a&&(a=this.chart.spacingBox);var b=this.chart,d=this.options,c=a.y;/(lth|ct|rth)/.test(this.getAlignment())&&0<b.titleOffset[0]?c+=b.titleOffset[0]:
	/(lbh|cb|rbh)/.test(this.getAlignment())&&0<b.titleOffset[2]&&(c-=b.titleOffset[2]);c!==a.y&&(a=K(a,{y:c}));b.hasRendered||(this.group.placed=!1);this.group.align(K(d,{width:this.legendWidth,height:this.legendHeight,verticalAlign:this.proximate?"top":d.verticalAlign}),!0,a)};a.prototype.handleOverflow=function(a){var b=this,d=this.chart,c=d.renderer,e=this.options,g=e.y,k="top"===e.verticalAlign,f=this.padding,h=e.maxHeight,l=e.navigation,m=y(l.animation,!0),p=l.arrowSize||12,t=this.pages,n=this.allItems,
	w=function(a){"number"===typeof a?G.attr({height:a}):G&&(b.clipRect=G.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+f+"px,9999px,"+(f+a)+"px,0)":"auto")},u=function(a){b[a]=c.circle(0,0,1.3*p).translate(p/2,p/2).add(q);d.styledMode||b[a].attr("fill","rgba(0,0,0,0.0001)");return b[a]},D,Q,v;g=d.spacingBox.height+(k?-g:g)-f;var q=this.nav,G=this.clipRect;"horizontal"!==e.layout||"middle"===e.verticalAlign||e.floating||(g/=2);h&&(g=Math.min(g,h));t.length=
	0;a&&0<g&&a>g&&!1!==l.enabled?(this.clipHeight=D=Math.max(g-20-this.titleHeight-f,0),this.currentPage=y(this.currentPage,1),this.fullHeight=a,n.forEach(function(b,a){v=b.legendItem||{};b=v.y||0;var d=Math.round(v.label.getBBox().height),c=t.length;if(!c||b-t[c-1]>D&&(Q||b)!==t[c-1])t.push(Q||b),c++;v.pageIx=c-1;Q&&((n[a-1].legendItem||{}).pageIx=c-1);a===n.length-1&&b+d-t[c-1]>D&&d<=D&&(t.push(b),v.pageIx=c);b!==Q&&(Q=b)}),G||(G=b.clipRect=c.clipRect(0,f,9999,0),b.contentGroup.clip(G)),w(D),q||(this.nav=
	q=c.g().attr({zIndex:1}).add(this.group),this.up=c.symbol("triangle",0,0,p,p).add(q),u("upTracker").on("click",function(){b.scroll(-1,m)}),this.pager=c.text("",15,10).addClass("highcharts-legend-navigation"),!d.styledMode&&l.style&&this.pager.css(l.style),this.pager.add(q),this.down=c.symbol("triangle-down",0,0,p,p).add(q),u("downTracker").on("click",function(){b.scroll(1,m)})),b.scroll(0),a=g):q&&(w(),this.nav=q.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a};a.prototype.scroll=
	function(a,b){var d=this,c=this.chart,e=this.pages,g=e.length,f=this.clipHeight,h=this.options.navigation,l=this.pager,m=this.padding,p=this.currentPage+a;p>g&&(p=g);0<p&&("undefined"!==typeof b&&x(b,c),this.nav.attr({translateX:m,translateY:f+this.padding+7+this.titleHeight,visibility:"inherit"}),[this.up,this.upTracker].forEach(function(b){b.attr({"class":1===p?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),l.attr({text:p+"/"+g}),[this.down,this.downTracker].forEach(function(b){b.attr({x:18+
	this.pager.getBBox().width,"class":p===g?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),c.styledMode||(this.up.attr({fill:1===p?h.inactiveColor:h.activeColor}),this.upTracker.css({cursor:1===p?"default":"pointer"}),this.down.attr({fill:p===g?h.inactiveColor:h.activeColor}),this.downTracker.css({cursor:p===g?"default":"pointer"})),this.scrollOffset=-e[p-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=p,this.positionCheckboxes(),
	a=v(y(b,c.renderer.globalAnimation,!0)),k(function(){G(d,"afterScroll",{currentPage:p})},a.duration))};a.prototype.setItemEvents=function(a,b,d){var c=this,e=a.legendItem||{},g=c.chart.renderer.boxWrapper,k=a instanceof E,f="highcharts-legend-"+(k?"point":"series")+"-active",h=c.chart.styledMode,l=function(b){c.allItems.forEach(function(d){a!==d&&[d].concat(d.linkedSeries||[]).forEach(function(a){a.setState(b,!k)})})},m=0;for(d=d?[b,e.symbol]:[e.group];m<d.length;m++)if(e=d[m])e.on("mouseover",function(){a.visible&&
	l("inactive");a.setState("hover");a.visible&&g.addClass(f);h||b.css(c.options.itemHoverStyle)}).on("mouseout",function(){c.chart.styledMode||b.css(K(a.visible?c.itemStyle:c.itemHiddenStyle));l("");g.removeClass(f);a.setState()}).on("click",function(b){var d=function(){a.setVisible&&a.setVisible();l(a.visible?"inactive":"")};g.removeClass(f);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,d):G(a,"legendItemClick",b,d)})};a.prototype.createCheckboxForItem=function(a){a.checkbox=
	m("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);h(a.checkbox,"click",function(b){G(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})};return a}();"";return a});J(a,"Core/Series/SeriesRegistry.js",[a["Core/Globals.js"],a["Core/Defaults.js"],a["Core/Series/Point.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=q.defaultOptions,C=E.extendClass,
	F=E.merge,x;(function(u){function n(a,h){var c=v.plotOptions||{},l=h.defaultOptions,p=h.prototype;p.type=a;p.pointClass||(p.pointClass=A);l&&(c[a]=l);u.seriesTypes[a]=h}u.seriesTypes=a.seriesTypes;u.registerSeriesType=n;u.seriesType=function(a,h,m,l,p){var c=v.plotOptions||{};h=h||"";c[a]=F(c[h],m);n(a,C(u.seriesTypes[h]||function(){},l));u.seriesTypes[a].prototype.type=a;p&&(u.seriesTypes[a].prototype.pointClass=C(A,p));return u.seriesTypes[a]}})(x||(x={}));return x});J(a,"Core/Chart/Chart.js",[a["Core/Animation/AnimationUtilities.js"],
	a["Core/Axis/Axis.js"],a["Core/Defaults.js"],a["Core/FormatUtilities.js"],a["Core/Foundation.js"],a["Core/Globals.js"],a["Core/Legend/Legend.js"],a["Core/MSPointer.js"],a["Core/Pointer.js"],a["Core/Renderer/RendererRegistry.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Renderer/SVG/SVGRenderer.js"],a["Core/Time.js"],a["Core/Utilities.js"],a["Core/Renderer/HTML/AST.js"]],function(a,q,A,E,B,C,F,x,u,n,c,h,m,l,p){var f=a.animate,D=a.animObject,v=a.setAnimation,H=A.defaultOptions,K=A.defaultTime,y=E.numberFormat,
	t=B.registerEventOptions,w=C.charts,k=C.doc,g=C.marginNames,e=C.svg,b=C.win,d=c.seriesTypes,r=l.addEvent,z=l.attr,I=l.cleanRecursively,N=l.createElement,P=l.css,O=l.defined,U=l.discardElement,L=l.erase,S=l.error,aa=l.extend,ba=l.find,R=l.fireEvent,M=l.getStyle,Y=l.isArray,Q=l.isNumber,ca=l.isObject,V=l.isString,W=l.merge,Z=l.objectEach,T=l.pick,da=l.pInt,J=l.relativeLength,fa=l.removeEvent,ea=l.splat,ha=l.syncTimeout,ia=l.uniqueKey;a=function(){function a(b,a,d){this.series=this.renderTo=this.renderer=
	this.pointer=this.pointCount=this.plotWidth=this.plotTop=this.plotLeft=this.plotHeight=this.plotBox=this.options=this.numberFormatter=this.margin=this.legend=this.labelCollectors=this.isResizing=this.index=this.eventOptions=this.container=this.colorCounter=this.clipBox=this.chartWidth=this.chartHeight=this.bounds=this.axisOffset=this.axes=void 0;this.sharedClips={};this.yAxis=this.xAxis=this.userOptions=this.titleOffset=this.time=this.symbolCounter=this.spacingBox=this.spacing=void 0;this.getArgs(b,
	a,d)}a.chart=function(b,d,c){return new a(b,d,c)};a.prototype.getArgs=function(b,a,d){V(b)||b.nodeName?(this.renderTo=b,this.init(a,d)):this.init(b,a)};a.prototype.init=function(b,a){var d=b.plotOptions||{};R(this,"init",{args:arguments},function(){var c=W(H,b),e=c.chart;Z(c.plotOptions,function(b,a){ca(b)&&(b.tooltip=d[a]&&W(d[a].tooltip)||void 0)});c.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;this.userOptions=b;this.margin=[];this.spacing=[];this.bounds={h:{},
	v:{}};this.labelCollectors=[];this.callback=a;this.isResizing=0;var g=e.zooming=e.zooming||{};b.chart&&!b.chart.zooming&&(g.resetButton=e.resetZoomButton);g.key=T(g.key,e.zoomKey);g.pinchType=T(g.pinchType,e.pinchType);g.singleTouch=T(g.singleTouch,e.zoomBySingleTouch);g.type=T(g.type,e.zoomType);this.options=c;this.axes=[];this.series=[];this.time=b.time&&Object.keys(b.time).length?new m(b.time):C.time;this.numberFormatter=e.numberFormatter||y;this.styledMode=e.styledMode;this.hasCartesianSeries=
	e.showAxes;this.index=w.length;w.push(this);C.chartCount++;t(this,e);this.xAxis=[];this.yAxis=[];this.pointCount=this.colorCounter=this.symbolCounter=0;R(this,"afterInit");this.firstRender()})};a.prototype.initSeries=function(b){var a=this.options.chart;a=b.type||a.type||a.defaultSeriesType;var c=d[a];c||S(17,!0,this,{missingModuleFor:a});a=new c;"function"===typeof a.init&&a.init(this,b);return a};a.prototype.setSeriesData=function(){this.getSeriesOrderByLinks().forEach(function(b){b.points||b.data||
	!b.enabledDataSorting||b.setData(b.options.data,!1)})};a.prototype.getSeriesOrderByLinks=function(){return this.series.concat().sort(function(b,a){return b.linkedSeries.length||a.linkedSeries.length?a.linkedSeries.length-b.linkedSeries.length:0})};a.prototype.orderSeries=function(b){var a=this.series;b=b||0;for(var d=a.length;b<d;++b)a[b]&&(a[b].index=b,a[b].name=a[b].getName())};a.prototype.isInsidePlot=function(b,a,d){void 0===d&&(d={});var c=this.inverted,e=this.plotBox,g=this.plotLeft,k=this.plotTop,
	f=this.scrollablePlotBox,r=0;var h=0;d.visiblePlotOnly&&this.scrollingContainer&&(h=this.scrollingContainer,r=h.scrollLeft,h=h.scrollTop);var l=d.series;e=d.visiblePlotOnly&&f||e;f=d.inverted?a:b;a=d.inverted?b:a;b={x:f,y:a,isInsidePlot:!0,options:d};if(!d.ignoreX){var m=l&&(c&&!this.polar?l.yAxis:l.xAxis)||{pos:g,len:Infinity};f=d.paneCoordinates?m.pos+f:g+f;f>=Math.max(r+g,m.pos)&&f<=Math.min(r+g+e.width,m.pos+m.len)||(b.isInsidePlot=!1)}!d.ignoreY&&b.isInsidePlot&&(c=d.axis&&!d.axis.isXAxis&&d.axis||
	l&&(c?l.xAxis:l.yAxis)||{pos:k,len:Infinity},d=d.paneCoordinates?c.pos+a:k+a,d>=Math.max(h+k,c.pos)&&d<=Math.min(h+k+e.height,c.pos+c.len)||(b.isInsidePlot=!1));R(this,"afterIsInsidePlot",b);return b.isInsidePlot};a.prototype.redraw=function(b){R(this,"beforeRedraw");var a=this.hasCartesianSeries?this.axes:this.colorAxis||[],d=this.series,c=this.pointer,e=this.legend,g=this.userOptions.legend,k=this.renderer,f=k.isHidden(),r=[],h=this.isDirtyBox,l=this.isDirtyLegend;this.setResponsive&&this.setResponsive(!1);
	v(this.hasRendered?b:!1,this);f&&this.temporaryDisplay();this.layOutTitles();for(b=d.length;b--;){var m=d[b];if(m.options.stacking||m.options.centerInCategory){var p=!0;if(m.isDirty){var z=!0;break}}}if(z)for(b=d.length;b--;)m=d[b],m.options.stacking&&(m.isDirty=!0);d.forEach(function(b){b.isDirty&&("point"===b.options.legendType?("function"===typeof b.updateTotals&&b.updateTotals(),l=!0):g&&(g.labelFormatter||g.labelFormat)&&(l=!0));b.isDirtyData&&R(b,"updatedData")});l&&e&&e.options.enabled&&(e.render(),
	this.isDirtyLegend=!1);p&&this.getStacks();a.forEach(function(b){b.updateNames();b.setScale()});this.getMargins();a.forEach(function(b){b.isDirty&&(h=!0)});a.forEach(function(b){var a=b.min+","+b.max;b.extKey!==a&&(b.extKey=a,r.push(function(){R(b,"afterSetExtremes",aa(b.eventArgs,b.getExtremes()));delete b.eventArgs}));(h||p)&&b.redraw()});h&&this.drawChartBox();R(this,"predraw");d.forEach(function(b){(h||b.isDirty)&&b.visible&&b.redraw();b.isDirtyData=!1});c&&c.reset(!0);k.draw();R(this,"redraw");
	R(this,"render");f&&this.temporaryDisplay(!0);r.forEach(function(b){b.call()})};a.prototype.get=function(b){function a(a){return a.id===b||a.options&&a.options.id===b}for(var d=this.series,c=ba(this.axes,a)||ba(this.series,a),e=0;!c&&e<d.length;e++)c=ba(d[e].points||[],a);return c};a.prototype.getAxes=function(){var b=this,a=this.options,d=a.xAxis=ea(a.xAxis||{});a=a.yAxis=ea(a.yAxis||{});R(this,"getAxes");d.forEach(function(b,a){b.index=a;b.isX=!0});a.forEach(function(b,a){b.index=a});d.concat(a).forEach(function(a){new q(b,
	a)});R(this,"afterGetAxes")};a.prototype.getSelectedPoints=function(){return this.series.reduce(function(b,a){a.getPointsCollection().forEach(function(a){T(a.selectedStaging,a.selected)&&b.push(a)});return b},[])};a.prototype.getSelectedSeries=function(){return this.series.filter(function(b){return b.selected})};a.prototype.setTitle=function(b,a,d){this.applyDescription("title",b);this.applyDescription("subtitle",a);this.applyDescription("caption",void 0);this.layOutTitles(d)};a.prototype.applyDescription=
	function(b,a){var d=this,c="title"===b?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:{color:"#666666"};c=this.options[b]=W(!this.styledMode&&{style:c},this.options[b],a);var e=this[b];e&&a&&(this[b]=e=e.destroy());c&&!e&&(e=this.renderer.text(c.text,0,0,c.useHTML).attr({align:c.align,"class":"highcharts-"+b,zIndex:c.zIndex||4}).add(),e.update=function(a){d[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[b]](a)},this.styledMode||e.css(c.style),this[b]=e)};a.prototype.layOutTitles=
	function(b){var a=[0,0,0],d=this.renderer,c=this.spacingBox;["title","subtitle","caption"].forEach(function(b){var e=this[b],g=this.options[b],k=g.verticalAlign||"top";b="title"===b?"top"===k?-3:0:"top"===k?a[0]+2:0;var f;if(e){this.styledMode||(f=g.style&&g.style.fontSize);f=d.fontMetrics(f,e).b;e.css({width:(g.width||c.width+(g.widthAdjust||0))+"px"});var r=Math.round(e.getBBox(g.useHTML).height);e.align(aa({y:"bottom"===k?f:b+f,height:r},g),!1,"spacingBox");g.floating||("top"===k?a[0]=Math.ceil(a[0]+
	r):"bottom"===k&&(a[2]=Math.ceil(a[2]+r)))}},this);a[0]&&"top"===(this.options.title.verticalAlign||"top")&&(a[0]+=this.options.title.margin);a[2]&&"bottom"===this.options.caption.verticalAlign&&(a[2]+=this.options.caption.margin);var e=!this.titleOffset||this.titleOffset.join(",")!==a.join(",");this.titleOffset=a;R(this,"afterLayOutTitles");!this.isDirtyBox&&e&&(this.isDirtyBox=this.isDirtyLegend=e,this.hasRendered&&T(b,!0)&&this.isDirtyBox&&this.redraw())};a.prototype.getChartSize=function(){var b=
	this.options.chart,a=b.width;b=b.height;var d=this.renderTo;O(a)||(this.containerWidth=M(d,"width"));O(b)||(this.containerHeight=M(d,"height"));this.chartWidth=Math.max(0,a||this.containerWidth||600);this.chartHeight=Math.max(0,J(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))};a.prototype.temporaryDisplay=function(b){var a=this.renderTo;if(b)for(;a&&a.style;)a.hcOrigStyle&&(P(a,a.hcOrigStyle),delete a.hcOrigStyle),a.hcOrigDetached&&(k.body.removeChild(a),a.hcOrigDetached=!1),
	a=a.parentNode;else for(;a&&a.style;){k.body.contains(a)||a.parentNode||(a.hcOrigDetached=!0,k.body.appendChild(a));if("none"===M(a,"display",!1)||a.hcOricDetached)a.hcOrigStyle={display:a.style.display,height:a.style.height,overflow:a.style.overflow},b={display:"block",overflow:"hidden"},a!==this.renderTo&&(b.height=0),P(a,b),a.offsetWidth||a.style.setProperty("display","block","important");a=a.parentNode;if(a===k.body)break}};a.prototype.setClassName=function(b){this.container.className="highcharts-container "+
	(b||"")};a.prototype.getContainer=function(){var b=this.options,a=b.chart,d=ia(),c,g=this.renderTo;g||(this.renderTo=g=a.renderTo);V(g)&&(this.renderTo=g=k.getElementById(g));g||S(13,!0,this);var f=da(z(g,"data-highcharts-chart"));Q(f)&&w[f]&&w[f].hasRendered&&w[f].destroy();z(g,"data-highcharts-chart",this.index);g.innerHTML=p.emptyHTML;a.skipClone||g.offsetWidth||this.temporaryDisplay();this.getChartSize();f=this.chartWidth;var r=this.chartHeight;P(g,{overflow:"hidden"});this.styledMode||(c=aa({position:"relative",
	overflow:"hidden",width:f+"px",height:r+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)",userSelect:"none","touch-action":"manipulation",outline:"none"},a.style||{}));this.container=d=N("div",{id:d},c,g);this._cursor=d.style.cursor;this.renderer=new (a.renderer||!e?n.getRendererType(a.renderer):h)(d,f,r,void 0,a.forExport,b.exporting&&b.exporting.allowHTML,this.styledMode);v(void 0,this);this.setClassName(a.className);if(this.styledMode)for(var l in b.defs)this.renderer.definition(b.defs[l]);
	else this.renderer.setStyle(a.style);this.renderer.chartIndex=this.index;R(this,"afterGetContainer")};a.prototype.getMargins=function(b){var a=this.spacing,d=this.margin,c=this.titleOffset;this.resetMargins();c[0]&&!O(d[0])&&(this.plotTop=Math.max(this.plotTop,c[0]+a[0]));c[2]&&!O(d[2])&&(this.marginBottom=Math.max(this.marginBottom,c[2]+a[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(d,a);R(this,"getMargins");b||this.getAxisMargins()};a.prototype.getAxisMargins=function(){var b=
	this,a=b.axisOffset=[0,0,0,0],d=b.colorAxis,c=b.margin,e=function(b){b.forEach(function(b){b.visible&&b.getOffset()})};b.hasCartesianSeries?e(b.axes):d&&d.length&&e(d);g.forEach(function(d,e){O(c[e])||(b[d]+=a[e])});b.setChartSize()};a.prototype.reflow=function(a){var d=this,c=d.options.chart,e=d.renderTo,g=O(c.width)&&O(c.height),f=c.width||M(e,"width");c=c.height||M(e,"height");e=a?a.target:b;delete d.pointer.chartPosition;if(!g&&!d.isPrinting&&f&&c&&(e===b||e===k)){if(f!==d.containerWidth||c!==
	d.containerHeight)l.clearTimeout(d.reflowTimeout),d.reflowTimeout=ha(function(){d.container&&d.setSize(void 0,void 0,!1)},a?100:0);d.containerWidth=f;d.containerHeight=c}};a.prototype.setReflow=function(a){var d=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=r(b,"resize",function(b){d.options&&d.reflow(b)}),r(this,"destroy",this.unbindReflow))};a.prototype.setSize=function(b,a,d){var c=this,e=c.renderer;c.isResizing+=1;v(d,c);d=
	e.globalAnimation;c.oldChartHeight=c.chartHeight;c.oldChartWidth=c.chartWidth;"undefined"!==typeof b&&(c.options.chart.width=b);"undefined"!==typeof a&&(c.options.chart.height=a);c.getChartSize();c.styledMode||(d?f:P)(c.container,{width:c.chartWidth+"px",height:c.chartHeight+"px"},d);c.setChartSize(!0);e.setSize(c.chartWidth,c.chartHeight,d);c.axes.forEach(function(b){b.isDirty=!0;b.setScale()});c.isDirtyLegend=!0;c.isDirtyBox=!0;c.layOutTitles();c.getMargins();c.redraw(d);c.oldChartHeight=null;R(c,
	"resize");ha(function(){c&&R(c,"endResize",null,function(){--c.isResizing})},D(d).duration)};a.prototype.setChartSize=function(b){var a=this.inverted,d=this.renderer,c=this.chartWidth,e=this.chartHeight,g=this.options.chart,f=this.spacing,k=this.clipOffset,r,h,l,m;this.plotLeft=r=Math.round(this.plotLeft);this.plotTop=h=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(c-r-this.marginRight));this.plotHeight=m=Math.max(0,Math.round(e-h-this.marginBottom));this.plotSizeX=a?m:l;this.plotSizeY=
	a?l:m;this.plotBorderWidth=g.plotBorderWidth||0;this.spacingBox=d.spacingBox={x:f[3],y:f[0],width:c-f[3]-f[1],height:e-f[0]-f[2]};this.plotBox=d.plotBox={x:r,y:h,width:l,height:m};a=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(Math.max(a,k[3])/2);e=Math.ceil(Math.max(a,k[0])/2);this.clipBox={x:c,y:e,width:Math.floor(this.plotSizeX-Math.max(a,k[1])/2-c),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(a,k[2])/2-e))};b||(this.axes.forEach(function(b){b.setAxisSize();b.setAxisTranslation()}),
	d.alignElements());R(this,"afterSetChartSize",{skipAxes:b})};a.prototype.resetMargins=function(){R(this,"resetMargins");var b=this,a=b.options.chart;["margin","spacing"].forEach(function(d){var c=a[d],e=ca(c)?c:[c,c,c,c];["Top","Right","Bottom","Left"].forEach(function(c,g){b[d][g]=T(a[d+c],e[g])})});g.forEach(function(a,d){b[a]=T(b.margin[d],b.spacing[d])});b.axisOffset=[0,0,0,0];b.clipOffset=[0,0,0,0]};a.prototype.drawChartBox=function(){var b=this.options.chart,a=this.renderer,d=this.chartWidth,
	c=this.chartHeight,e=this.styledMode,g=this.plotBGImage,f=b.backgroundColor,k=b.plotBackgroundColor,r=b.plotBackgroundImage,h=this.plotLeft,l=this.plotTop,m=this.plotWidth,p=this.plotHeight,z=this.plotBox,t=this.clipRect,n=this.clipBox,w=this.chartBackground,u=this.plotBackground,I=this.plotBorder,M,y="animate";w||(this.chartBackground=w=a.rect().addClass("highcharts-background").add(),y="attr");if(e)var Q=M=w.strokeWidth();else{Q=b.borderWidth||0;M=Q+(b.shadow?8:0);f={fill:f||"none"};if(Q||w["stroke-width"])f.stroke=
	b.borderColor,f["stroke-width"]=Q;w.attr(f).shadow(b.shadow)}w[y]({x:M/2,y:M/2,width:d-M-Q%2,height:c-M-Q%2,r:b.borderRadius});y="animate";u||(y="attr",this.plotBackground=u=a.rect().addClass("highcharts-plot-background").add());u[y](z);e||(u.attr({fill:k||"none"}).shadow(b.plotShadow),r&&(g?(r!==g.attr("href")&&g.attr("href",r),g.animate(z)):this.plotBGImage=a.image(r,h,l,m,p).add()));t?t.animate({width:n.width,height:n.height}):this.clipRect=a.clipRect(n);y="animate";I||(y="attr",this.plotBorder=
	I=a.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());e||I.attr({stroke:b.plotBorderColor,"stroke-width":b.plotBorderWidth||0,fill:"none"});I[y](I.crisp({x:h,y:l,width:m,height:p},-I.strokeWidth()));this.isDirtyBox=!1;R(this,"afterDrawChartBox")};a.prototype.propFromSeries=function(){var b=this,a=b.options.chart,c=b.options.series,e,g,f;["inverted","angular","polar"].forEach(function(k){g=d[a.type||a.defaultSeriesType];f=a[k]||g&&g.prototype[k];for(e=c&&c.length;!f&&e--;)(g=d[c[e].type])&&
	g.prototype[k]&&(f=!0);b[k]=f})};a.prototype.linkSeries=function(){var b=this,a=b.series;a.forEach(function(b){b.linkedSeries.length=0});a.forEach(function(a){var d=a.options.linkedTo;V(d)&&(d=":previous"===d?b.series[a.index-1]:b.get(d))&&d.linkedParent!==a&&(d.linkedSeries.push(a),a.linkedParent=d,d.enabledDataSorting&&a.setDataSortingOptions(),a.visible=T(a.options.visible,d.options.visible,a.visible))});R(this,"afterLinkSeries")};a.prototype.renderSeries=function(){this.series.forEach(function(b){b.translate();
	b.render()})};a.prototype.renderLabels=function(){var b=this,a=b.options.labels;a.items&&a.items.forEach(function(d){var c=aa(a.style,d.style),e=da(c.left)+b.plotLeft,g=da(c.top)+b.plotTop+12;delete c.left;delete c.top;b.renderer.text(d.html,e,g).attr({zIndex:2}).css(c).add()})};a.prototype.render=function(){var b=this.axes,a=this.colorAxis,d=this.renderer,c=this.options,e=function(b){b.forEach(function(b){b.visible&&b.render()})},g=0;this.setTitle();this.legend=new F(this,c.legend);this.getStacks&&
	this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;b.some(function(b){if(b.horiz&&b.visible&&b.options.labels.enabled&&b.series.length)return g=21,!0});var f=this.plotHeight=Math.max(this.plotHeight-g,0);b.forEach(function(b){b.setScale()});this.getAxisMargins();var k=1.1<c/this.plotWidth,r=1.05<f/this.plotHeight;if(k||r)b.forEach(function(b){(b.horiz&&k||!b.horiz&&r)&&b.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?e(b):a&&a.length&&e(a);
	this.seriesGroup||(this.seriesGroup=d.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0};a.prototype.addCredits=function(a){var d=this,c=W(!0,this.options.credits,a);c.enabled&&!this.credits&&(this.credits=this.renderer.text(c.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){c.href&&(b.location.href=c.href)}).attr({align:c.position.align,zIndex:8}),d.styledMode||
	this.credits.css(c.style),this.credits.add().align(c.position),this.credits.update=function(b){d.credits=d.credits.destroy();d.addCredits(b)})};a.prototype.destroy=function(){var b=this,a=b.axes,d=b.series,c=b.container,e=c&&c.parentNode,g;R(b,"destroy");b.renderer.forExport?L(w,b):w[b.index]=void 0;C.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");fa(b);for(g=a.length;g--;)a[g]=a[g].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(g=d.length;g--;)d[g]=
	d[g].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(a){var d=b[a];d&&d.destroy&&(b[a]=d.destroy())});c&&(c.innerHTML=p.emptyHTML,fa(c),e&&U(c));Z(b,function(a,d){delete b[d]})};a.prototype.firstRender=function(){var b=this,a=b.options;if(!b.isReadyToRender||b.isReadyToRender()){b.getContainer();b.resetMargins();b.setChartSize();b.propFromSeries();
	b.getAxes();(Y(a.series)?a.series:[]).forEach(function(a){b.initSeries(a)});b.linkSeries();b.setSeriesData();R(b,"beforeRender");u&&(x.isRequired()?b.pointer=new x(b,a):b.pointer=new u(b,a));b.render();b.pointer.getChartPosition();if(!b.renderer.imgCount&&!b.hasLoaded)b.onload();b.temporaryDisplay(!0)}};a.prototype.onload=function(){this.callbacks.concat([this.callback]).forEach(function(b){b&&"undefined"!==typeof this.index&&b.apply(this,[this])},this);R(this,"load");R(this,"render");O(this.index)&&
	this.setReflow(this.options.chart.reflow);this.warnIfA11yModuleNotLoaded();this.hasLoaded=!0};a.prototype.warnIfA11yModuleNotLoaded=function(){var b=this.options,a=this.title;b&&!this.accessibility&&(this.renderer.boxWrapper.attr({role:"img","aria-label":(a&&a.element.textContent||"").replace(/</g,"&lt;")}),b.accessibility&&!1===b.accessibility.enabled||S('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.',
	!1,this))};a.prototype.addSeries=function(b,a,d){var c=this,e;b&&(a=T(a,!0),R(c,"addSeries",{options:b},function(){e=c.initSeries(b);c.isDirtyLegend=!0;c.linkSeries();e.enabledDataSorting&&e.setData(b.data,!1);R(c,"afterAddSeries",{series:e});a&&c.redraw(d)}));return e};a.prototype.addAxis=function(b,a,d,c){return this.createAxis(a?"xAxis":"yAxis",{axis:b,redraw:d,animation:c})};a.prototype.addColorAxis=function(b,a,d){return this.createAxis("colorAxis",{axis:b,redraw:a,animation:d})};a.prototype.createAxis=
	function(b,a){b=new q(this,W(a.axis,{index:this[b].length,isX:"xAxis"===b}));T(a.redraw,!0)&&this.redraw(a.animation);return b};a.prototype.showLoading=function(b){var a=this,d=a.options,c=d.loading,e=function(){g&&P(g,{left:a.plotLeft+"px",top:a.plotTop+"px",width:a.plotWidth+"px",height:a.plotHeight+"px"})},g=a.loadingDiv,k=a.loadingSpan;g||(a.loadingDiv=g=N("div",{className:"highcharts-loading highcharts-loading-hidden"},null,a.container));k||(a.loadingSpan=k=N("span",{className:"highcharts-loading-inner"},
	null,g),r(a,"redraw",e));g.className="highcharts-loading";p.setElementHTML(k,T(b,d.lang.loading,""));a.styledMode||(P(g,aa(c.style,{zIndex:10})),P(k,c.labelStyle),a.loadingShown||(P(g,{opacity:0,display:""}),f(g,{opacity:c.style.opacity||.5},{duration:c.showDuration||0})));a.loadingShown=!0;e()};a.prototype.hideLoading=function(){var b=this.options,a=this.loadingDiv;a&&(a.className="highcharts-loading highcharts-loading-hidden",this.styledMode||f(a,{opacity:0},{duration:b.loading.hideDuration||100,
	complete:function(){P(a,{display:"none"})}}));this.loadingShown=!1};a.prototype.update=function(b,a,d,c){var e=this,g={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},f=b.isResponsiveOptions,k=[],r,h;R(e,"update",{options:b});f||e.setResponsive(!1,!0);b=I(b,e.options);e.userOptions=W(e.userOptions,b);var l=b.chart;if(l){W(!0,e.options.chart,l);"className"in l&&e.setClassName(l.className);"reflow"in l&&e.setReflow(l.reflow);if("inverted"in l||"polar"in l||"type"in
	l){e.propFromSeries();var p=!0}"alignTicks"in l&&(p=!0);"events"in l&&t(this,l);Z(l,function(b,a){-1!==e.propsRequireUpdateSeries.indexOf("chart."+a)&&(r=!0);-1!==e.propsRequireDirtyBox.indexOf(a)&&(e.isDirtyBox=!0);-1!==e.propsRequireReflow.indexOf(a)&&(f?e.isDirtyBox=!0:h=!0)});!e.styledMode&&l.style&&e.renderer.setStyle(e.options.chart.style||{})}!e.styledMode&&b.colors&&(this.options.colors=b.colors);b.time&&(this.time===K&&(this.time=new m(b.time)),W(!0,e.options.time,b.time));Z(b,function(a,
	d){if(e[d]&&"function"===typeof e[d].update)e[d].update(a,!1);else if("function"===typeof e[g[d]])e[g[d]](a);else"colors"!==d&&-1===e.collectionsWithUpdate.indexOf(d)&&W(!0,e.options[d],b[d]);"chart"!==d&&-1!==e.propsRequireUpdateSeries.indexOf(d)&&(r=!0)});this.collectionsWithUpdate.forEach(function(a){if(b[a]){var c=[];e[a].forEach(function(b,a){b.options.isInternal||c.push(T(b.options.index,a))});ea(b[a]).forEach(function(b,g){var f=O(b.id),k;f&&(k=e.get(b.id));!k&&e[a]&&(k=e[a][c?c[g]:g])&&f&&
	O(k.options.id)&&(k=void 0);k&&k.coll===a&&(k.update(b,!1),d&&(k.touched=!0));!k&&d&&e.collectionsWithInit[a]&&(e.collectionsWithInit[a][0].apply(e,[b].concat(e.collectionsWithInit[a][1]||[]).concat([!1])).touched=!0)});d&&e[a].forEach(function(b){b.touched||b.options.isInternal?delete b.touched:k.push(b)})}});k.forEach(function(b){b.chart&&b.remove&&b.remove(!1)});p&&e.axes.forEach(function(b){b.update({},!1)});r&&e.getSeriesOrderByLinks().forEach(function(b){b.chart&&b.update({},!1)},this);p=l&&
	l.width;l=l&&(V(l.height)?J(l.height,p||e.chartWidth):l.height);h||Q(p)&&p!==e.chartWidth||Q(l)&&l!==e.chartHeight?e.setSize(p,l,c):T(a,!0)&&e.redraw(c);R(e,"afterUpdate",{options:b,redraw:a,animation:c})};a.prototype.setSubtitle=function(b,a){this.applyDescription("subtitle",b);this.layOutTitles(a)};a.prototype.setCaption=function(b,a){this.applyDescription("caption",b);this.layOutTitles(a)};a.prototype.showResetZoom=function(){function b(){a.zoomOut()}var a=this,d=H.lang,c=a.options.chart.zooming.resetButton,
	e=c.theme,g="chart"===c.relativeTo||"spacingBox"===c.relativeTo?null:"scrollablePlotBox";R(this,"beforeShowResetZoom",null,function(){a.resetZoomButton=a.renderer.button(d.resetZoom,null,null,b,e).attr({align:c.position.align,title:d.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,g)});R(this,"afterShowResetZoom")};a.prototype.zoomOut=function(){R(this,"selection",{resetSelection:!0},this.zoom)};a.prototype.zoom=function(b){var a=this,d=a.pointer,c=!1,e;!b||b.resetSelection?
	(a.axes.forEach(function(b){e=b.zoom()}),d.initiated=!1):b.xAxis.concat(b.yAxis).forEach(function(b){var g=b.axis;if(d[g.isXAxis?"zoomX":"zoomY"]&&O(d.mouseDownX)&&O(d.mouseDownY)&&a.isInsidePlot(d.mouseDownX-a.plotLeft,d.mouseDownY-a.plotTop,{axis:g})||!O(a.inverted?d.mouseDownX:d.mouseDownY))e=g.zoom(b.min,b.max),g.displayBtn&&(c=!0)});var g=a.resetZoomButton;c&&!g?a.showResetZoom():!c&&ca(g)&&(a.resetZoomButton=g.destroy());e&&a.redraw(T(a.options.chart.animation,b&&b.animation,100>a.pointCount))};
	a.prototype.pan=function(b,a){var d=this,c=d.hoverPoints;a="object"===typeof a?a:{enabled:a,type:"x"};var e=d.options.chart;e&&e.panning&&(e.panning=a);var g=a.type,k;R(this,"pan",{originalEvent:b},function(){c&&c.forEach(function(b){b.setState()});var a=d.xAxis;"xy"===g?a=a.concat(d.yAxis):"y"===g&&(a=d.yAxis);var e={};a.forEach(function(a){if(a.options.panningEnabled&&!a.options.isInternal){var c=a.horiz,f=b[c?"chartX":"chartY"];c=c?"mouseDownX":"mouseDownY";var r=d[c],h=a.minPointOffset||0,l=a.reversed&&
	!d.inverted||!a.reversed&&d.inverted?-1:1,m=a.getExtremes(),p=a.toValue(r-f,!0)+h*l,z=a.toValue(r+a.len-f,!0)-(h*l||a.isXAxis&&a.pointRangePadding||0),t=z<p;l=a.hasVerticalPanning();r=t?z:p;p=t?p:z;var n=a.panningState;!l||a.isXAxis||n&&!n.isDirty||a.series.forEach(function(b){var a=b.getProcessedData(!0);a=b.getExtremes(a.yData,!0);n||(n={startMin:Number.MAX_VALUE,startMax:-Number.MAX_VALUE});Q(a.dataMin)&&Q(a.dataMax)&&(n.startMin=Math.min(T(b.options.threshold,Infinity),a.dataMin,n.startMin),n.startMax=
	Math.max(T(b.options.threshold,-Infinity),a.dataMax,n.startMax))});l=Math.min(T(n&&n.startMin,m.dataMin),h?m.min:a.toValue(a.toPixels(m.min)-a.minPixelPadding));z=Math.max(T(n&&n.startMax,m.dataMax),h?m.max:a.toValue(a.toPixels(m.max)+a.minPixelPadding));a.panningState=n;a.isOrdinal||(h=l-r,0<h&&(p+=h,r=l),h=p-z,0<h&&(p=z,r-=h),a.series.length&&r!==m.min&&p!==m.max&&r>=l&&p<=z&&(a.setExtremes(r,p,!1,!1,{trigger:"pan"}),!d.resetZoomButton&&r!==l&&p!==z&&g.match("y")&&(d.showResetZoom(),a.displayBtn=
	!1),k=!0),e[c]=f)}});Z(e,function(b,a){d[a]=b});k&&d.redraw(!1);P(d.container,{cursor:"move"})})};return a}();aa(a.prototype,{callbacks:[],collectionsWithInit:{xAxis:[a.prototype.addAxis,[!0]],yAxis:[a.prototype.addAxis,[!1]],series:[a.prototype.addSeries]},collectionsWithUpdate:["xAxis","yAxis","series"],propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ")});"";return a});J(a,"Core/Legend/LegendSymbol.js",[a["Core/Utilities.js"]],function(a){var q=a.extend,v=a.merge,E=a.pick,B;(function(a){a.drawLineMarker=function(a){var x=this.legendItem=this.legendItem||{},u=this.options,n=a.symbolWidth,c=a.symbolHeight,h=c/2,m=this.chart.renderer,l=x.group;a=a.baseline-Math.round(.3*a.fontMetrics.b);var p={},f=u.marker,D=0;this.chart.styledMode||
	(p={"stroke-width":Math.min(u.lineWidth||0,24)},u.dashStyle?p.dashstyle=u.dashStyle:"square"!==u.linecap&&(p["stroke-linecap"]="round"));x.line=m.path().addClass("highcharts-graph").attr(p).add(l);p["stroke-linecap"]&&(D=Math.min(x.line.strokeWidth(),n)/2);x.line.attr({d:[["M",D,a],["L",n-D,a]]});f&&!1!==f.enabled&&n&&(u=Math.min(E(f.radius,h),h),0===this.symbol.indexOf("url")&&(f=v(f,{width:c,height:c}),u=0),x.symbol=x=m.symbol(this.symbol,n/2-u,a-u,2*u,2*u,q({context:"legend"},f)).addClass("highcharts-point").add(l),
	x.isMarker=!0)};a.drawRectangle=function(a,q){q=q.legendItem||{};var u=a.symbolHeight,n=a.options.squareSymbol;q.symbol=this.chart.renderer.rect(n?(a.symbolWidth-u)/2:0,a.baseline-u+1,n?u:a.symbolWidth,u,E(a.options.symbolRadius,u/2)).addClass("highcharts-point").attr({zIndex:3}).add(q.group)}})(B||(B={}));return B});J(a,"Core/Series/SeriesDefaults.js",[],function(){return{lineWidth:2,allowPointSelect:!1,crisp:!0,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{enabledThreshold:2,lineColor:"#ffffff",
	lineWidth:0,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{animation:{},align:"center",borderWidth:0,defer:!0,formatter:function(){var a=this.series.chart.numberFormatter;return"number"!==typeof this.y?"":a(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},
	cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"}});J(a,"Core/Series/Series.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/Defaults.js"],a["Core/Foundation.js"],a["Core/Globals.js"],a["Core/Legend/LegendSymbol.js"],a["Core/Series/Point.js"],
	a["Core/Series/SeriesDefaults.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x,u,n){var c=a.animObject,h=a.setAnimation,m=q.defaultOptions,l=A.registerEventOptions,p=E.hasTouch,f=E.svg,D=E.win,v=x.seriesTypes,H=n.arrayMax,K=n.arrayMin,y=n.clamp,t=n.cleanRecursively,w=n.correctFloat,k=n.defined,g=n.erase,e=n.error,b=n.extend,d=n.find,r=n.fireEvent,z=n.getNestedProperty,I=n.isArray,N=n.isNumber,P=n.isString,O=n.merge,U=n.objectEach,
	L=n.pick,S=n.removeEvent,aa=n.splat,ba=n.syncTimeout;a=function(){function a(){this.zones=this.yAxis=this.xAxis=this.userOptions=this.tooltipOptions=this.processedYData=this.processedXData=this.points=this.options=this.linkedSeries=this.index=this.eventsToUnbind=this.eventOptions=this.data=this.chart=this._i=void 0}a.prototype.init=function(a,d){r(this,"init",{options:d});var c=this,e=a.series;this.eventsToUnbind=[];c.chart=a;c.options=c.setOptions(d);d=c.options;c.linkedSeries=[];c.bindAxes();b(c,
	{name:d.name,state:"",visible:!1!==d.visible,selected:!0===d.selected});l(this,d);var g=d.events;if(g&&g.click||d.point&&d.point.events&&d.point.events.click||d.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();c.parallelArrays.forEach(function(b){c[b+"Data"]||(c[b+"Data"]=[])});c.isCartesian&&(a.hasCartesianSeries=!0);var k;e.length&&(k=e[e.length-1]);c._i=L(k&&k._i,-1)+1;c.opacity=c.options.opacity;a.orderSeries(this.insert(e));d.dataSorting&&d.dataSorting.enabled?c.setDataSortingOptions():
	c.points||c.data||c.setData(d.data,!1);r(this,"afterInit")};a.prototype.is=function(b){return v[b]&&this instanceof v[b]};a.prototype.insert=function(b){var a=this.options.index,d;if(N(a)){for(d=b.length;d--;)if(a>=L(b[d].options.index,b[d]._i)){b.splice(d+1,0,this);break}-1===d&&b.unshift(this);d+=1}else b.push(this);return L(d,b.length-1)};a.prototype.bindAxes=function(){var b=this,a=b.options,d=b.chart,c;r(this,"bindAxes",null,function(){(b.axisTypes||[]).forEach(function(g){var k=0;d[g].forEach(function(d){c=
	d.options;if(a[g]===k&&!c.isInternal||"undefined"!==typeof a[g]&&a[g]===c.id||"undefined"===typeof a[g]&&0===c.index)b.insert(d.series),b[g]=d,d.isDirty=!0;c.isInternal||k++});b[g]||b.optionalAxis===g||e(18,!0,d)})});r(this,"afterBindAxes")};a.prototype.updateParallelArrays=function(b,a){var d=b.series,c=arguments,e=N(a)?function(c){var e="y"===c&&d.toYData?d.toYData(b):b[c];d[c+"Data"][a]=e}:function(b){Array.prototype[a].apply(d[b+"Data"],Array.prototype.slice.call(c,2))};d.parallelArrays.forEach(e)};
	a.prototype.hasData=function(){return this.visible&&"undefined"!==typeof this.dataMax&&"undefined"!==typeof this.dataMin||this.visible&&this.yData&&0<this.yData.length};a.prototype.autoIncrement=function(b){var a=this.options,d=a.pointIntervalUnit,c=a.relativeXValue,e=this.chart.time,g=this.xIncrement,k;g=L(g,a.pointStart,0);this.pointInterval=k=L(this.pointInterval,a.pointInterval,1);c&&N(b)&&(k*=b);d&&(a=new e.Date(g),"day"===d?e.set("Date",a,e.get("Date",a)+k):"month"===d?e.set("Month",a,e.get("Month",
	a)+k):"year"===d&&e.set("FullYear",a,e.get("FullYear",a)+k),k=a.getTime()-g);if(c&&N(b))return g+k;this.xIncrement=g+k;return g};a.prototype.setDataSortingOptions=function(){var a=this.options;b(this,{requireSorting:!1,sorted:!1,enabledDataSorting:!0,allowDG:!1});k(a.pointRange)||(a.pointRange=1)};a.prototype.setOptions=function(b){var a=this.chart,d=a.options,c=d.plotOptions,e=a.userOptions||{};b=O(b);a=a.styledMode;var g={plotOptions:c,userOptions:b};r(this,"setOptions",g);var f=g.plotOptions[this.type],
	h=e.plotOptions||{};this.userOptions=g.userOptions;e=O(f,c.series,e.plotOptions&&e.plotOptions[this.type],b);this.tooltipOptions=O(m.tooltip,m.plotOptions.series&&m.plotOptions.series.tooltip,m.plotOptions[this.type].tooltip,d.tooltip.userOptions,c.series&&c.series.tooltip,c[this.type].tooltip,b.tooltip);this.stickyTracking=L(b.stickyTracking,h[this.type]&&h[this.type].stickyTracking,h.series&&h.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:e.stickyTracking);null===f.marker&&
	delete e.marker;this.zoneAxis=e.zoneAxis;c=this.zones=(e.zones||[]).slice();!e.negativeColor&&!e.negativeFillColor||e.zones||(d={value:e[this.zoneAxis+"Threshold"]||e.threshold||0,className:"highcharts-negative"},a||(d.color=e.negativeColor,d.fillColor=e.negativeFillColor),c.push(d));c.length&&k(c[c.length-1].value)&&c.push(a?{}:{color:this.color,fillColor:this.fillColor});r(this,"afterSetOptions",{options:e});return e};a.prototype.getName=function(){return L(this.options.name,"Series "+(this.index+
	1))};a.prototype.getCyclic=function(b,a,d){var c=this.chart,e=this.userOptions,g=b+"Index",f=b+"Counter",r=d?d.length:L(c.options.chart[b+"Count"],c[b+"Count"]);if(!a){var h=L(e[g],e["_"+g]);k(h)||(c.series.length||(c[f]=0),e["_"+g]=h=c[f]%r,c[f]+=1);d&&(a=d[h])}"undefined"!==typeof h&&(this[g]=h);this[b]=a};a.prototype.getColor=function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.color="#cccccc":this.getCyclic("color",this.options.color||m.plotOptions[this.type].color,
	this.chart.options.colors)};a.prototype.getPointsCollection=function(){return(this.hasGroupedData?this.points:this.data)||[]};a.prototype.getSymbol=function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)};a.prototype.findPointIndex=function(b,a){var c=b.id,e=b.x,g=this.points,k=this.options.dataSorting,f,r;if(c)k=this.chart.get(c),k instanceof C&&(f=k);else if(this.linkedParent||this.enabledDataSorting||this.options.relativeXValue)if(f=function(a){return!a.touched&&
	a.index===b.index},k&&k.matchByName?f=function(a){return!a.touched&&a.name===b.name}:this.options.relativeXValue&&(f=function(a){return!a.touched&&a.options.x===b.x}),f=d(g,f),!f)return;if(f){var h=f&&f.index;"undefined"!==typeof h&&(r=!0)}"undefined"===typeof h&&N(e)&&(h=this.xData.indexOf(e,a));-1!==h&&"undefined"!==typeof h&&this.cropped&&(h=h>=this.cropStart?h-this.cropStart:h);!r&&N(h)&&g[h]&&g[h].touched&&(h=void 0);return h};a.prototype.updateData=function(b,a){var d=this.options,c=d.dataSorting,
	e=this.points,g=[],f=this.requireSorting,r=b.length===e.length,h,l,m,p=!0;this.xIncrement=null;b.forEach(function(b,a){var l=k(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b)||{},p=l.x;if(l.id||N(p)){if(l=this.findPointIndex(l,m),-1===l||"undefined"===typeof l?g.push(b):e[l]&&b!==d.data[l]?(e[l].update(b,!1,null,!1),e[l].touched=!0,f&&(m=l+1)):e[l]&&(e[l].touched=!0),!r||a!==l||c&&c.enabled||this.hasDerivedData)h=!0}else g.push(b)},this);if(h)for(b=e.length;b--;)(l=e[b])&&!l.touched&&
	l.remove&&l.remove(!1,a);else!r||c&&c.enabled?p=!1:(b.forEach(function(b,a){b!==e[a].y&&e[a].update&&e[a].update(b,!1,null,!1)}),g.length=0);e.forEach(function(b){b&&(b.touched=!1)});if(!p)return!1;g.forEach(function(b){this.addPoint(b,!1,null,null,!1)},this);null===this.xIncrement&&this.xData&&this.xData.length&&(this.xIncrement=H(this.xData),this.autoIncrement());return!0};a.prototype.setData=function(b,a,d,c){void 0===a&&(a=!0);var g=this,k=g.points,f=k&&k.length||0,r=g.options,h=g.chart,l=r.dataSorting,
	m=g.xAxis,p=r.turboThreshold,z=this.xData,t=this.yData,n=g.pointArrayMap;n=n&&n.length;var w=r.keys,u,y=0,M=1,D=null;if(!h.options.chart.allowMutatingData){r.data&&delete g.options.data;g.userOptions.data&&delete g.userOptions.data;var q=O(!0,b)}b=q||b||[];q=b.length;l&&l.enabled&&(b=this.sortData(b));h.options.chart.allowMutatingData&&!1!==c&&q&&f&&!g.cropped&&!g.hasGroupedData&&g.visible&&!g.boosted&&(u=this.updateData(b,d));if(!u){g.xIncrement=null;g.colorCounter=0;this.parallelArrays.forEach(function(b){g[b+
	"Data"].length=0});if(p&&q>p)if(D=g.getFirstValidPoint(b),N(D))for(d=0;d<q;d++)z[d]=this.autoIncrement(),t[d]=b[d];else if(I(D))if(n)if(D.length===n)for(d=0;d<q;d++)z[d]=this.autoIncrement(),t[d]=b[d];else for(d=0;d<q;d++)c=b[d],z[d]=c[0],t[d]=c.slice(1,n+1);else if(w&&(y=w.indexOf("x"),M=w.indexOf("y"),y=0<=y?y:0,M=0<=M?M:1),1===D.length&&(M=0),y===M)for(d=0;d<q;d++)z[d]=this.autoIncrement(),t[d]=b[d][M];else for(d=0;d<q;d++)c=b[d],z[d]=c[y],t[d]=c[M];else e(12,!1,h);else for(d=0;d<q;d++)"undefined"!==
	typeof b[d]&&(c={series:g},g.pointClass.prototype.applyOptions.apply(c,[b[d]]),g.updateParallelArrays(c,d));t&&P(t[0])&&e(14,!0,h);g.data=[];g.options.data=g.userOptions.data=b;for(d=f;d--;)k[d]&&k[d].destroy&&k[d].destroy();m&&(m.minRange=m.userMinRange);g.isDirty=h.isDirtyBox=!0;g.isDirtyData=!!k;d=!1}"point"===r.legendType&&(this.processData(),this.generatePoints());a&&h.redraw(d)};a.prototype.sortData=function(b){var a=this,d=a.options.dataSorting.sortKey||"y",c=function(b,a){return k(a)&&b.pointClass.prototype.optionsToObject.call({series:b},
	a)||{}};b.forEach(function(d,e){b[e]=c(a,d);b[e].index=e},this);b.concat().sort(function(b,a){b=z(d,b);a=z(d,a);return a<b?-1:a>b?1:0}).forEach(function(b,a){b.x=a},this);a.linkedSeries&&a.linkedSeries.forEach(function(a){var d=a.options,e=d.data;d.dataSorting&&d.dataSorting.enabled||!e||(e.forEach(function(d,g){e[g]=c(a,d);b[g]&&(e[g].x=b[g].x,e[g].index=g)}),a.setData(e,!1))});return b};a.prototype.getProcessedData=function(b){var a=this.xAxis,d=this.options,c=d.cropThreshold,g=b||this.getExtremesFromAll||
	d.getExtremesFromAll,k=this.isCartesian;b=a&&a.val2lin;d=!(!a||!a.logarithmic);var f=0,r=this.xData,h=this.yData,l=this.requireSorting;var m=!1;var p=r.length;if(a){m=a.getExtremes();var z=m.min;var t=m.max;m=!(!a.categories||a.names.length)}if(k&&this.sorted&&!g&&(!c||p>c||this.forceCrop))if(r[p-1]<z||r[0]>t)r=[],h=[];else if(this.yData&&(r[0]<z||r[p-1]>t)){var n=this.cropData(this.xData,this.yData,z,t);r=n.xData;h=n.yData;f=n.start;n=!0}for(c=r.length||1;--c;)if(a=d?b(r[c])-b(r[c-1]):r[c]-r[c-1],
	0<a&&("undefined"===typeof w||a<w))var w=a;else 0>a&&l&&!m&&(e(15,!1,this.chart),l=!1);return{xData:r,yData:h,cropped:n,cropStart:f,closestPointRange:w}};a.prototype.processData=function(b){var a=this.xAxis;if(this.isCartesian&&!this.isDirty&&!a.isDirty&&!this.yAxis.isDirty&&!b)return!1;b=this.getProcessedData();this.cropped=b.cropped;this.cropStart=b.cropStart;this.processedXData=b.xData;this.processedYData=b.yData;this.closestPointRange=this.basePointRange=b.closestPointRange;r(this,"afterProcessData")};
	a.prototype.cropData=function(b,a,d,c,e){var g=b.length,k,f=0,r=g;e=L(e,this.cropShoulder);for(k=0;k<g;k++)if(b[k]>=d){f=Math.max(0,k-e);break}for(d=k;d<g;d++)if(b[d]>c){r=d+e;break}return{xData:b.slice(f,r),yData:a.slice(f,r),start:f,end:r}};a.prototype.generatePoints=function(){var a=this.options,d=this.processedData||a.data,c=this.processedXData,e=this.processedYData,g=this.pointClass,k=c.length,f=this.cropStart||0,h=this.hasGroupedData,l=a.keys,m=[];a=a.dataGrouping&&a.dataGrouping.groupAll?f:
	0;var p,z,t=this.data;if(!t&&!h){var n=[];n.length=d.length;t=this.data=n}l&&h&&(this.options.keys=!1);for(z=0;z<k;z++){n=f+z;if(h){var w=(new g).init(this,[c[z]].concat(aa(e[z])));w.dataGroup=this.groupMap[a+z];w.dataGroup.options&&(w.options=w.dataGroup.options,b(w,w.dataGroup.options),delete w.dataLabels)}else(w=t[n])||"undefined"===typeof d[n]||(t[n]=w=(new g).init(this,d[n],c[z]));w&&(w.index=h?a+z:n,m[z]=w)}this.options.keys=l;if(t&&(k!==(p=t.length)||h))for(z=0;z<p;z++)z!==f||h||(z+=k),t[z]&&
	(t[z].destroyElements(),t[z].plotX=void 0);this.data=t;this.points=m;r(this,"afterGeneratePoints")};a.prototype.getXExtremes=function(b){return{min:K(b),max:H(b)}};a.prototype.getExtremes=function(b,a){var d=this.xAxis,c=this.yAxis,e=this.processedXData||this.xData,g=[],k=this.requireSorting?this.cropShoulder:0;c=c?c.positiveValuesOnly:!1;var f,h=0,l=0,m=0;b=b||this.stackedYData||this.processedYData||[];var p=b.length;if(d){var z=d.getExtremes();h=z.min;l=z.max}for(f=0;f<p;f++){var t=e[f];z=b[f];
	var n=(N(z)||I(z))&&(z.length||0<z||!c);t=a||this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||!d||(e[f+k]||t)>=h&&(e[f-k]||t)<=l;if(n&&t)if(n=z.length)for(;n--;)N(z[n])&&(g[m++]=z[n]);else g[m++]=z}b={activeYData:g,dataMin:K(g),dataMax:H(g)};r(this,"afterGetExtremes",{dataExtremes:b});return b};a.prototype.applyExtremes=function(){var b=this.getExtremes();this.dataMin=b.dataMin;this.dataMax=b.dataMax;return b};a.prototype.getFirstValidPoint=function(b){for(var a=b.length,d=
	0,c=null;null===c&&d<a;)c=b[d],d++;return c};a.prototype.translate=function(){this.processedXData||this.processData();this.generatePoints();var b=this.options,a=b.stacking,d=this.xAxis,c=d.categories,e=this.enabledDataSorting,g=this.yAxis,f=this.points,h=f.length,l=this.pointPlacementToXValue(),m=!!l,p=b.threshold,z=b.startFromThreshold?p:0,t=this.zoneAxis||"y",n,u,q=Number.MAX_VALUE;for(n=0;n<h;n++){var D=f[n],v=D.x,G=void 0,P=void 0,O=D.y,x=D.low,A=a&&g.stacking&&g.stacking.stacks[(this.negStacks&&
	O<(z?0:p)?"-":"")+this.stackKey];if(g.positiveValuesOnly&&!g.validatePositiveValue(O)||d.positiveValuesOnly&&!d.validatePositiveValue(v))D.isNull=!0;D.plotX=u=w(y(d.translate(v,0,0,0,1,l,"flags"===this.type),-1E5,1E5));if(a&&this.visible&&A&&A[v]){var B=this.getStackIndicator(B,v,this.index);!D.isNull&&B.key&&(G=A[v],P=G.points[B.key]);G&&I(P)&&(x=P[0],O=P[1],x===z&&B.key===A[v].base&&(x=L(N(p)?p:g.min)),g.positiveValuesOnly&&k(x)&&0>=x&&(x=void 0),D.total=D.stackTotal=L(G.total),D.percentage=k(D.y)&&
	G.total?D.y/G.total*100:void 0,D.stackY=O,this.irregularWidths||G.setOffset(this.pointXOffset||0,this.barW||0,void 0,void 0,void 0,this.xAxis))}D.yBottom=k(x)?y(g.translate(x,0,1,0,1),-1E5,1E5):void 0;this.dataModify&&(O=this.dataModify.modifyValue(O,n));D.plotY=void 0;N(O)&&(G=g.translate(O,!1,!0,!1,!0),"undefined"!==typeof G&&(D.plotY=y(G,-1E5,1E5)));D.isInside=this.isPointInside(D);D.clientX=m?w(d.translate(v,0,0,0,1,l)):u;D.negative=D[t]<(b[t+"Threshold"]||p||0);D.category=L(c&&c[D.x],D.x);if(!D.isNull&&
	!1!==D.visible){"undefined"!==typeof K&&(q=Math.min(q,Math.abs(u-K)));var K=u}D.zone=this.zones.length?D.getZone():void 0;!D.graphic&&this.group&&e&&(D.isNew=!0)}this.closestPointRangePx=q;r(this,"afterTranslate")};a.prototype.getValidPoints=function(b,a,d){var c=this.chart;return(b||this.points||[]).filter(function(b){return a&&!c.isInsidePlot(b.plotX,b.plotY,{inverted:c.inverted})?!1:!1!==b.visible&&(d||!b.isNull)})};a.prototype.getClipBox=function(){var b=this.chart,a=this.xAxis,d=this.yAxis,c=
	O(b.clipBox);a&&a.len!==b.plotSizeX&&(c.width=a.len);d&&d.len!==b.plotSizeY&&(c.height=d.len);return c};a.prototype.getSharedClipKey=function(){return this.sharedClipKey=(this.options.xAxis||0)+","+(this.options.yAxis||0)};a.prototype.setClip=function(){var b=this.chart,a=this.group,d=this.markerGroup,c=b.sharedClips;b=b.renderer;var e=this.getClipBox(),g=this.getSharedClipKey(),f=c[g];f?f.animate(e):c[g]=f=b.clipRect(e);a&&a.clip(!1===this.options.clip?void 0:f);d&&d.clip()};a.prototype.animate=
	function(b){var a=this.chart,d=this.group,e=this.markerGroup,g=a.inverted,f=c(this.options.animation),k=[this.getSharedClipKey(),f.duration,f.easing,f.defer].join(),r=a.sharedClips[k],h=a.sharedClips[k+"m"];if(b&&d)f=this.getClipBox(),r?r.attr("height",f.height):(f.width=0,g&&(f.x=a.plotHeight),r=a.renderer.clipRect(f),a.sharedClips[k]=r,h=a.renderer.clipRect({x:-99,y:-99,width:g?a.plotWidth+199:99,height:g?99:a.plotHeight+199}),a.sharedClips[k+"m"]=h),d.clip(r),e&&e.clip(h);else if(r&&!r.hasClass("highcharts-animating")){a=
	this.getClipBox();var l=f.step;e&&e.element.childNodes.length&&(f.step=function(b,a){l&&l.apply(a,arguments);"width"===a.prop&&h&&h.element&&h.attr(g?"height":"width",b+99)});r.addClass("highcharts-animating").animate(a,f)}};a.prototype.afterAnimate=function(){var b=this;this.setClip();U(this.chart.sharedClips,function(a,d,c){a&&!b.chart.container.querySelector('[clip-path="url(#'.concat(a.id,')"]'))&&(a.destroy(),delete c[d])});this.finishedAnimating=!0;r(this,"afterAnimate")};a.prototype.drawPoints=
	function(b){void 0===b&&(b=this.points);var a=this.chart,d=a.styledMode,c=this.colorAxis,e=this.options.marker,g=this[this.specialGroup||"markerGroup"],f=this.xAxis,k=L(e.enabled,!f||f.isRadial?!0:null,this.closestPointRangePx>=e.enabledThreshold*e.radius),r,h;if(!1!==e.enabled||this._hasPointMarkers)for(r=0;r<b.length;r++){var l=b[r];var m=(h=l.graphic)?"animate":"attr";var p=l.marker||{};var z=!!l.marker;if((k&&"undefined"===typeof p.enabled||p.enabled)&&!l.isNull&&!1!==l.visible){var t=L(p.symbol,
	this.symbol,"rect");var n=this.markerAttribs(l,l.selected&&"select");this.enabledDataSorting&&(l.startXPos=f.reversed?-(n.width||0):f.width);var w=!1!==l.isInside;!h&&w&&(0<(n.width||0)||l.hasImage)&&(l.graphic=h=a.renderer.symbol(t,n.x,n.y,n.width,n.height,z?p:e).add(g),this.enabledDataSorting&&a.hasRendered&&(h.attr({x:l.startXPos}),m="animate"));h&&"animate"===m&&h[w?"show":"hide"](w).animate(n);if(h)if(p=this.pointAttribs(l,d||!l.selected?void 0:"select"),d)c&&h.css({fill:p.fill});else h[m](p);
	h&&h.addClass(l.getClassName(),!0)}else h&&(l.graphic=h.destroy())}};a.prototype.markerAttribs=function(b,a){var d=this.options,c=d.marker,e=b.marker||{},g=e.symbol||c.symbol,f={},k=L(e.radius,c&&c.radius);a&&(c=c.states[a],a=e.states&&e.states[a],k=L(a&&a.radius,c&&c.radius,k&&k+(c&&c.radiusPlus||0)));b.hasImage=g&&0===g.indexOf("url");b.hasImage&&(k=0);b=b.pos();N(k)&&b&&(f.x=b[0]-k,f.y=b[1]-k,d.crisp&&(f.x=Math.floor(f.x)));k&&(f.width=f.height=2*k);return f};a.prototype.pointAttribs=function(b,
	a){var d=this.options.marker,c=b&&b.options,e=c&&c.marker||{},g=c&&c.color,f=b&&b.color,k=b&&b.zone&&b.zone.color,r=this.color;b=L(e.lineWidth,d.lineWidth);c=1;r=g||k||f||r;g=e.fillColor||d.fillColor||r;f=e.lineColor||d.lineColor||r;a=a||"normal";d=d.states[a]||{};a=e.states&&e.states[a]||{};b=L(a.lineWidth,d.lineWidth,b+L(a.lineWidthPlus,d.lineWidthPlus,0));g=a.fillColor||d.fillColor||g;f=a.lineColor||d.lineColor||f;c=L(a.opacity,d.opacity,c);return{stroke:f,"stroke-width":b,fill:g,opacity:c}};a.prototype.destroy=
	function(b){var a=this,d=a.chart,c=/AppleWebKit\/533/.test(D.navigator.userAgent),e=a.data||[],f,k,h,l;r(a,"destroy",{keepEventsForUpdate:b});this.removeEvents(b);(a.axisTypes||[]).forEach(function(b){(l=a[b])&&l.series&&(g(l.series,a),l.isDirty=l.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(k=e.length;k--;)(h=e[k])&&h.destroy&&h.destroy();a.clips&&a.clips.forEach(function(b){return b.destroy()});n.clearTimeout(a.animationTimeout);U(a,function(b,a){b instanceof u&&!b.survive&&
	(f=c&&"group"===a?"hide":"destroy",b[f]())});d.hoverSeries===a&&(d.hoverSeries=void 0);g(d.series,a);d.orderSeries();U(a,function(d,c){b&&"hcEvents"===c||delete a[c]})};a.prototype.applyZones=function(){var b=this,a=this.chart,d=a.renderer,c=this.zones,e=this.clips||[],g=this.graph,f=this.area,k=Math.max(a.plotWidth,a.plotHeight),r=this[(this.zoneAxis||"y")+"Axis"],h=a.inverted,l,m,p,z,t,n,w,u,I=!1;if(c.length&&(g||f)&&r&&"undefined"!==typeof r.min){var D=r.reversed;var q=r.horiz;g&&!this.showLine&&
	g.hide();f&&f.hide();var v=r.getExtremes();c.forEach(function(c,N){l=D?q?a.plotWidth:0:q?0:r.toPixels(v.min)||0;l=y(L(m,l),0,k);m=y(Math.round(r.toPixels(L(c.value,v.max),!0)||0),0,k);I&&(l=m=r.toPixels(v.max));z=Math.abs(l-m);t=Math.min(l,m);n=Math.max(l,m);r.isXAxis?(p={x:h?n:t,y:0,width:z,height:k},q||(p.x=a.plotHeight-p.x)):(p={x:0,y:h?n:t,width:k,height:z},q&&(p.y=a.plotWidth-p.y));h&&d.isVML&&(p=r.isXAxis?{x:0,y:D?t:n,height:p.width,width:a.chartWidth}:{x:p.y-a.plotLeft-a.spacingBox.x,y:0,width:p.height,
	height:a.chartHeight});e[N]?e[N].animate(p):e[N]=d.clipRect(p);w=b["zone-area-"+N];u=b["zone-graph-"+N];g&&u&&u.clip(e[N]);f&&w&&w.clip(e[N]);I=c.value>v.max;b.resetZones&&0===m&&(m=void 0)});this.clips=e}else b.visible&&(g&&g.show(),f&&f.show())};a.prototype.plotGroup=function(b,a,d,c,e){var g=this[b],f=!g;d={visibility:d,zIndex:c||.1};"undefined"===typeof this.opacity||this.chart.styledMode||"inactive"===this.state||(d.opacity=this.opacity);f&&(this[b]=g=this.chart.renderer.g().add(e));g.addClass("highcharts-"+
	a+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(k(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr(d)[f?"attr":"animate"](this.getPlotBox(a));return g};a.prototype.getPlotBox=function(b){var a=this.xAxis,d=this.yAxis,c=this.chart;b=c.inverted&&!c.polar&&a&&!1!==this.invertible&&"series"===b;c.inverted&&(a=d,d=this.xAxis);return{translateX:a?a.left:c.plotLeft,translateY:d?
	d.top:c.plotTop,rotation:b?90:0,rotationOriginX:b?(a.len-d.len)/2:0,rotationOriginY:b?(a.len+d.len)/2:0,scaleX:b?-1:1,scaleY:1}};a.prototype.removeEvents=function(b){b||S(this);this.eventsToUnbind.length&&(this.eventsToUnbind.forEach(function(b){b()}),this.eventsToUnbind.length=0)};a.prototype.render=function(){var b=this,a=b.chart,d=b.options,e=c(d.animation),g=b.visible?"inherit":"hidden",f=d.zIndex,k=b.hasRendered,h=a.seriesGroup;a=!b.finishedAnimating&&a.renderer.isSVG?e.duration:0;r(this,"render");
	b.plotGroup("group","series",g,f,h);b.markerGroup=b.plotGroup("markerGroup","markers",g,f,h);!1!==d.clip&&b.setClip();b.animate&&a&&b.animate(!0);b.drawGraph&&(b.drawGraph(),b.applyZones());b.visible&&b.drawPoints();b.drawDataLabels&&b.drawDataLabels();b.redrawPoints&&b.redrawPoints();b.drawTracker&&!1!==b.options.enableMouseTracking&&b.drawTracker();b.animate&&a&&b.animate();k||(a&&e.defer&&(a+=e.defer),b.animationTimeout=ba(function(){b.afterAnimate()},a||0));b.isDirty=!1;b.hasRendered=!0;r(b,"afterRender")};
	a.prototype.redraw=function(){var b=this.isDirty||this.isDirtyData;this.translate();this.render();b&&delete this.kdTree};a.prototype.searchPoint=function(b,a){var d=this.xAxis,c=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?d.len-b.chartY+d.pos:b.chartX-d.pos,plotY:e?c.len-b.chartX+c.pos:b.chartY-c.pos},a,b)};a.prototype.buildKDTree=function(b){function a(b,c,e){var g=b&&b.length;if(g){var f=d.kdAxisArray[c%e];b.sort(function(b,a){return b[f]-a[f]});g=Math.floor(g/2);return{point:b[g],
	left:a(b.slice(0,g),c+1,e),right:a(b.slice(g+1),c+1,e)}}}this.buildingKdTree=!0;var d=this,c=-1<d.options.findNearestPointBy.indexOf("y")?2:1;delete d.kdTree;ba(function(){d.kdTree=a(d.getValidPoints(null,!d.directTouch),c,c);d.buildingKdTree=!1},d.options.kdNow||b&&"touchstart"===b.type?0:1)};a.prototype.searchKDTree=function(b,a,d){function c(b,a,d,h){var l=a.point,m=e.kdAxisArray[d%h],p=l,z=k(b[g])&&k(l[g])?Math.pow(b[g]-l[g],2):null;var t=k(b[f])&&k(l[f])?Math.pow(b[f]-l[f],2):null;t=(z||0)+(t||
	0);l.dist=k(t)?Math.sqrt(t):Number.MAX_VALUE;l.distX=k(z)?Math.sqrt(z):Number.MAX_VALUE;m=b[m]-l[m];t=0>m?"left":"right";z=0>m?"right":"left";a[t]&&(t=c(b,a[t],d+1,h),p=t[r]<p[r]?t:l);a[z]&&Math.sqrt(m*m)<p[r]&&(b=c(b,a[z],d+1,h),p=b[r]<p[r]?b:p);return p}var e=this,g=this.kdAxisArray[0],f=this.kdAxisArray[1],r=a?"distX":"dist";a=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree(d);if(this.kdTree)return c(b,this.kdTree,a,a)};a.prototype.pointPlacementToXValue=
	function(){var b=this.options,a=b.pointRange,d=this.xAxis;b=b.pointPlacement;"between"===b&&(b=d.reversed?-.5:.5);return N(b)?b*(a||d.pointRange):0};a.prototype.isPointInside=function(b){var a=this.chart,d=this.xAxis,c=this.yAxis;return"undefined"!==typeof b.plotY&&"undefined"!==typeof b.plotX&&0<=b.plotY&&b.plotY<=(c?c.len:a.plotHeight)&&0<=b.plotX&&b.plotX<=(d?d.len:a.plotWidth)};a.prototype.drawTracker=function(){var b=this,a=b.options,d=a.trackByArea,c=[].concat(d?b.areaPath:b.graphPath),e=b.chart,
	g=e.pointer,k=e.renderer,h=e.options.tooltip.snap,l=b.tracker,m=function(a){if(e.hoverSeries!==b)b.onMouseOver()},z="rgba(192,192,192,"+(f?.0001:.002)+")";l?l.attr({d:c}):b.graph&&(b.tracker=k.path(c).attr({visibility:b.visible?"inherit":"hidden",zIndex:2}).addClass(d?"highcharts-tracker-area":"highcharts-tracker-line").add(b.group),e.styledMode||b.tracker.attr({"stroke-linecap":"round","stroke-linejoin":"round",stroke:z,fill:d?z:"none","stroke-width":b.graph.strokeWidth()+(d?0:2*h)}),[b.tracker,
	b.markerGroup,b.dataLabelsGroup].forEach(function(b){if(b&&(b.addClass("highcharts-tracker").on("mouseover",m).on("mouseout",function(b){g.onTrackerMouseOut(b)}),a.cursor&&!e.styledMode&&b.css({cursor:a.cursor}),p))b.on("touchstart",m)}));r(this,"afterDrawTracker")};a.prototype.addPoint=function(b,a,d,c,e){var g=this.options,f=this.data,k=this.chart,h=this.xAxis;h=h&&h.hasNames&&h.names;var l=g.data,m=this.xData,p;a=L(a,!0);var z={series:this};this.pointClass.prototype.applyOptions.apply(z,[b]);var t=
	z.x;var n=m.length;if(this.requireSorting&&t<m[n-1])for(p=!0;n&&m[n-1]>t;)n--;this.updateParallelArrays(z,"splice",n,0,0);this.updateParallelArrays(z,n);h&&z.name&&(h[t]=z.name);l.splice(n,0,b);if(p||this.processedData)this.data.splice(n,0,null),this.processData();"point"===g.legendType&&this.generatePoints();d&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(z,"shift"),l.shift()));!1!==e&&r(this,"addPoint",{point:z});this.isDirtyData=this.isDirty=!0;a&&k.redraw(c)};a.prototype.removePoint=
	function(b,a,d){var c=this,e=c.data,g=e[b],f=c.points,k=c.chart,r=function(){f&&f.length===e.length&&f.splice(b,1);e.splice(b,1);c.options.data.splice(b,1);c.updateParallelArrays(g||{series:c},"splice",b,1);g&&g.destroy();c.isDirty=!0;c.isDirtyData=!0;a&&k.redraw()};h(d,k);a=L(a,!0);g?g.firePointEvent("remove",null,r):r()};a.prototype.remove=function(b,a,d,c){function e(){g.destroy(c);f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();L(b,!0)&&f.redraw(a)}var g=this,f=g.chart;!1!==d?r(g,"remove",null,
	e):e()};a.prototype.update=function(a,d){a=t(a,this.userOptions);r(this,"update",{options:a});var c=this,g=c.chart,f=c.userOptions,k=c.initialType||c.type,h=g.options.plotOptions,l=v[k].prototype,m=c.finishedAnimating&&{animation:!1},p={},z=["eventOptions","navigatorSeries","baseSeries"],n=a.type||f.type||g.options.chart.type,w=!(this.hasDerivedData||n&&n!==this.type||"undefined"!==typeof a.pointStart||"undefined"!==typeof a.pointInterval||"undefined"!==typeof a.relativeXValue||a.joinBy||a.mapData||
	c.hasOptionChanged("dataGrouping")||c.hasOptionChanged("pointStart")||c.hasOptionChanged("pointInterval")||c.hasOptionChanged("pointIntervalUnit")||c.hasOptionChanged("keys"));n=n||k;w&&(z.push("data","isDirtyData","points","processedData","processedXData","processedYData","xIncrement","cropped","_hasPointMarkers","_hasPointLabels","clips","nodes","layout","level","mapMap","mapData","minY","maxY","minX","maxX"),!1!==a.visible&&z.push("area","graph"),c.parallelArrays.forEach(function(b){z.push(b+"Data")}),
	a.data&&(a.dataSorting&&b(c.options.dataSorting,a.dataSorting),this.setData(a.data,!1)));a=O(f,m,{index:"undefined"===typeof f.index?c.index:f.index,pointStart:L(h&&h.series&&h.series.pointStart,f.pointStart,c.xData[0])},!w&&{data:c.options.data},a);w&&a.data&&(a.data=c.options.data);z=["group","markerGroup","dataLabelsGroup","transformGroup","shadowGroup"].concat(z);z.forEach(function(b){z[b]=c[b];delete c[b]});h=!1;if(v[n]){if(h=n!==c.type,c.remove(!1,!1,!1,!0),h)if(Object.setPrototypeOf)Object.setPrototypeOf(c,
	v[n].prototype);else{m=Object.hasOwnProperty.call(c,"hcEvents")&&c.hcEvents;for(u in l)c[u]=void 0;b(c,v[n].prototype);m?c.hcEvents=m:delete c.hcEvents}}else e(17,!0,g,{missingModuleFor:n});z.forEach(function(b){c[b]=z[b]});c.init(g,a);if(w&&this.points){a=c.options;if(!1===a.visible)p.graphic=1,p.dataLabel=1;else if(!c._hasPointLabels){l=a.marker;var u=a.dataLabels;f=f.marker||{};!l||!1!==l.enabled&&f.symbol===l.symbol&&f.height===l.height&&f.width===l.width||(p.graphic=1);u&&!1===u.enabled&&(p.dataLabel=
	1)}f=0;for(l=this.points;f<l.length;f++)(u=l[f])&&u.series&&(u.resolveColor(),Object.keys(p).length&&u.destroyElements(p),!1===a.showInLegend&&u.legendItem&&g.legend.destroyItem(u))}c.initialType=k;g.linkSeries();h&&c.linkedSeries.length&&(c.isDirtyData=!0);r(this,"afterUpdate");L(d,!0)&&g.redraw(w?void 0:!1)};a.prototype.setName=function(b){this.name=this.options.name=this.userOptions.name=b;this.chart.isDirtyLegend=!0};a.prototype.hasOptionChanged=function(b){var a=this.options[b],d=this.chart.options.plotOptions,
	c=this.userOptions[b];return c?a!==c:a!==L(d&&d[this.type]&&d[this.type][b],d&&d.series&&d.series[b],a)};a.prototype.onMouseOver=function(){var b=this.chart,a=b.hoverSeries;b.pointer.setHoverChartIndex();if(a&&a!==this)a.onMouseOut();this.options.events.mouseOver&&r(this,"mouseOver");this.setState("hover");b.hoverSeries=this};a.prototype.onMouseOut=function(){var b=this.options,a=this.chart,d=a.tooltip,c=a.hoverPoint;a.hoverSeries=null;if(c)c.onMouseOut();this&&b.events.mouseOut&&r(this,"mouseOut");
	!d||this.stickyTracking||d.shared&&!this.noSharedTooltip||d.hide();a.series.forEach(function(b){b.setState("",!0)})};a.prototype.setState=function(b,a){var d=this,c=d.options,e=d.graph,g=c.inactiveOtherPoints,f=c.states,k=L(f[b||"normal"]&&f[b||"normal"].animation,d.chart.options.chart.animation),r=c.lineWidth,h=0,l=c.opacity;b=b||"";if(d.state!==b&&([d.group,d.markerGroup,d.dataLabelsGroup].forEach(function(a){a&&(d.state&&a.removeClass("highcharts-series-"+d.state),b&&a.addClass("highcharts-series-"+
	b))}),d.state=b,!d.chart.styledMode)){if(f[b]&&!1===f[b].enabled)return;b&&(r=f[b].lineWidth||r+(f[b].lineWidthPlus||0),l=L(f[b].opacity,l));if(e&&!e.dashstyle&&N(r))for(c={"stroke-width":r},e.animate(c,k);d["zone-graph-"+h];)d["zone-graph-"+h].animate(c,k),h+=1;g||[d.group,d.markerGroup,d.dataLabelsGroup,d.labelBySeries].forEach(function(b){b&&b.animate({opacity:l},k)})}a&&g&&d.points&&d.setAllPointsToState(b||void 0)};a.prototype.setAllPointsToState=function(b){this.points.forEach(function(a){a.setState&&
	a.setState(b)})};a.prototype.setVisible=function(b,a){var d=this,c=d.chart,e=c.options.chart.ignoreHiddenSeries,g=d.visible,f=(d.visible=b=d.options.visible=d.userOptions.visible="undefined"===typeof b?!g:b)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(b){if(d[b])d[b][f]()});if(c.hoverSeries===d||(c.hoverPoint&&c.hoverPoint.series)===d)d.onMouseOut();d.legendItem&&c.legend.colorizeItem(d,b);d.isDirty=!0;d.options.stacking&&c.series.forEach(function(b){b.options.stacking&&
	b.visible&&(b.isDirty=!0)});d.linkedSeries.forEach(function(a){a.setVisible(b,!1)});e&&(c.isDirtyBox=!0);r(d,f);!1!==a&&c.redraw()};a.prototype.show=function(){this.setVisible(!0)};a.prototype.hide=function(){this.setVisible(!1)};a.prototype.select=function(b){this.selected=b=this.options.selected="undefined"===typeof b?!this.selected:b;this.checkbox&&(this.checkbox.checked=b);r(this,b?"select":"unselect")};a.prototype.shouldShowTooltip=function(b,a,d){void 0===d&&(d={});d.series=this;d.visiblePlotOnly=
	!0;return this.chart.isInsidePlot(b,a,d)};a.defaultOptions=F;a.types=x.seriesTypes;a.registerType=x.registerSeriesType;return a}();b(a.prototype,{axisTypes:["xAxis","yAxis"],coll:"series",colorCounter:0,cropShoulder:1,directTouch:!1,drawLegendSymbol:B.drawLineMarker,isCartesian:!0,kdAxisArray:["clientX","plotY"],parallelArrays:["x","y"],pointClass:C,requireSorting:!0,sorted:!0});x.series=a;"";"";return a});J(a,"Extensions/ScrollablePlotArea.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/Axis/Axis.js"],
	a["Core/Chart/Chart.js"],a["Core/Series/Series.js"],a["Core/Renderer/RendererRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C){var v=a.stop,x=C.addEvent,u=C.createElement,n=C.defined,c=C.merge,h=C.pick;x(A,"afterSetChartSize",function(a){var h=this.options.chart.scrollablePlotArea,m=h&&h.minWidth;h=h&&h.minHeight;if(!this.renderer.forExport){if(m){if(this.scrollablePixelsX=m=Math.max(0,m-this.chartWidth)){this.scrollablePlotBox=this.renderer.scrollablePlotBox=c(this.plotBox);this.plotBox.width=
	this.plotWidth+=m;this.inverted?this.clipBox.height+=m:this.clipBox.width+=m;var f={1:{name:"right",value:m}}}}else h&&(this.scrollablePixelsY=m=Math.max(0,h-this.chartHeight),n(m)&&(this.scrollablePlotBox=this.renderer.scrollablePlotBox=c(this.plotBox),this.plotBox.height=this.plotHeight+=m,this.inverted?this.clipBox.width+=m:this.clipBox.height+=m,f={2:{name:"bottom",value:m}}));f&&!a.skipAxes&&this.axes.forEach(function(a){f[a.side]?a.getPlotLinePath=function(){var c=f[a.side].name,h=this[c];this[c]=
	h-f[a.side].value;var l=q.prototype.getPlotLinePath.apply(this,arguments);this[c]=h;return l}:(a.setAxisSize(),a.setAxisTranslation())})}});x(A,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});A.prototype.setUpScrolling=function(){var a=this,c={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(c.overflowX="auto");this.scrollablePixelsY&&
	(c.overflowY="auto");this.scrollingParent=u("div",{className:"highcharts-scrolling-parent"},{position:"relative"},this.renderTo);this.scrollingContainer=u("div",{className:"highcharts-scrolling"},c,this.scrollingParent);var h;x(this.scrollingContainer,"scroll",function(){a.pointer&&(delete a.pointer.chartPosition,a.hoverPoint&&(h=a.hoverPoint),a.pointer.runPointActions(void 0,h,!0))});this.innerContainer=u("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);
	this.setUpScrolling=null};A.prototype.moveFixedElements=function(){var a=this.container,c=this.fixedRenderer,h=".highcharts-breadcrumbs-group .highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),f;this.scrollablePixelsX&&!this.inverted?
	f=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?f=".highcharts-xaxis":this.scrollablePixelsY&&!this.inverted?f=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(f=".highcharts-yaxis");f&&h.push(""+f+":not(.highcharts-radial-axis)",""+f+"-labels:not(.highcharts-radial-axis-labels)");h.forEach(function(f){[].forEach.call(a.querySelectorAll(f),function(a){(a.namespaceURI===c.SVG_NS?c.box:c.box.parentNode).appendChild(a);a.style.pointerEvents="auto"})})};A.prototype.applyFixed=function(){var a=
	!this.fixedDiv,c=this.options.chart,p=c.scrollablePlotArea,f=B.getRendererType();a?(this.fixedDiv=u("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:(c.style&&c.style.zIndex||0)+2,top:0},null,!0),this.scrollingContainer&&this.scrollingContainer.parentNode.insertBefore(this.fixedDiv,this.scrollingContainer),this.renderTo.style.overflow="visible",this.fixedRenderer=c=new f(this.fixedDiv,this.chartWidth,this.chartHeight,this.options.chart.style),
	this.scrollableMask=c.path().attr({fill:this.options.chart.backgroundColor||"#fff","fill-opacity":h(p.opacity,.85),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),x(this,"afterShowResetZoom",this.moveFixedElements),x(this,"afterApplyDrilldown",this.moveFixedElements),x(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);if(this.scrollableDirty||a)this.scrollableDirty=!1,this.moveFixedElements();c=this.chartWidth+(this.scrollablePixelsX||
	0);f=this.chartHeight+(this.scrollablePixelsY||0);v(this.container);this.container.style.width=c+"px";this.container.style.height=f+"px";this.renderer.boxWrapper.attr({width:c,height:f,viewBox:[0,0,c,f].join(" ")});this.chartBackground.attr({width:c,height:f});this.scrollingContainer.style.height=this.chartHeight+"px";a&&(p.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*p.scrollPositionX),p.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*p.scrollPositionY));
	f=this.axisOffset;a=this.plotTop-f[0]-1;p=this.plotLeft-f[3]-1;c=this.plotTop+this.plotHeight+f[2]+1;f=this.plotLeft+this.plotWidth+f[1]+1;var n=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),q=this.plotTop+this.plotHeight-(this.scrollablePixelsY||0);a=this.scrollablePixelsX?[["M",0,a],["L",this.plotLeft-1,a],["L",this.plotLeft-1,c],["L",0,c],["Z"],["M",n,a],["L",this.chartWidth,a],["L",this.chartWidth,c],["L",n,c],["Z"]]:this.scrollablePixelsY?[["M",p,0],["L",p,this.plotTop-1],["L",f,this.plotTop-
	1],["L",f,0],["Z"],["M",p,q],["L",p,this.chartHeight],["L",f,this.chartHeight],["L",f,q],["Z"]]:[["M",0,0]];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:a})};x(q,"afterInit",function(){this.chart.scrollableDirty=!0});x(E,"show",function(){this.chart.scrollableDirty=!0});""});J(a,"Core/Axis/Stacking/StackItem.js",[a["Core/FormatUtilities.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A){var v=a.format,B=q.series,C=A.destroyObjectProperties,F=A.pick,
	x=A.isNumber;a=function(){function a(a,c,h,m,l){var p=a.chart.inverted,f=a.reversed;this.axis=a;a=this.isNegative=!!h!==!!f;this.options=c=c||{};this.x=m;this.cumulative=this.total=null;this.points={};this.hasValidPoints=!1;this.stack=l;this.rightCliff=this.leftCliff=0;this.alignOptions={align:c.align||(p?a?"left":"right":"center"),verticalAlign:c.verticalAlign||(p?"middle":a?"bottom":"top"),y:c.y,x:c.x};this.textAlign=c.textAlign||(p?a?"right":"left":"center")}a.prototype.destroy=function(){C(this,
	this.axis)};a.prototype.render=function(a){var c=this.axis.chart,h=this.options,m=h.format;m=m?v(m,this,c):h.formatter.call(this);this.label?this.label.attr({text:m,visibility:"hidden"}):(this.label=c.renderer.label(m,null,void 0,h.shape,void 0,void 0,h.useHTML,!1,"stack-labels"),m={r:h.borderRadius||0,text:m,padding:F(h.padding,5),visibility:"hidden"},c.styledMode||(m.fill=h.backgroundColor,m.stroke=h.borderColor,m["stroke-width"]=h.borderWidth,this.label.css(h.style||{})),this.label.attr(m),this.label.added||
	this.label.add(a));this.label.labelrank=c.plotSizeY};a.prototype.setOffset=function(a,c,h,m,l,p){var f=this.alignOptions,n=this.axis,u=this.label,q=this.options,v=this.textAlign,y=n.chart;a=this.getStackBox({xOffset:a,width:c,boxBottom:h,boxTop:m,defaultX:l,xAxis:p});l=f.verticalAlign;u&&a&&(c=u.getBBox(),h=u.padding,m="justify"===F(q.overflow,"justify"),f.x=q.x||0,f.y=q.y||0,l=this.adjustStackPosition({labelBox:c,verticalAlign:l,textAlign:v}),v=l.x,l=l.y,a.x-=v,a.y-=l,u.align(f,!1,a),(v=y.isInsidePlot(u.alignAttr.x+
	f.x+v,u.alignAttr.y+f.y+l))||(m=!1),m&&B.prototype.justifyDataLabel.call(n,u,f,u.alignAttr,c,a),u.attr({x:u.alignAttr.x,y:u.alignAttr.y,rotation:q.rotation,rotationOriginX:c.width/2,rotationOriginY:c.height/2}),F(!m&&q.crop,!0)&&(v=x(u.x)&&x(u.y)&&y.isInsidePlot(u.x-h+u.width,u.y)&&y.isInsidePlot(u.x+h,u.y)),u[v?"show":"hide"]())};a.prototype.adjustStackPosition=function(a){var c=a.labelBox,h={bottom:0,middle:1,top:2,right:1,center:0,left:-1};return{x:c.width/2+c.width/2*h[a.textAlign],y:c.height/
	2*h[a.verticalAlign]}};a.prototype.getStackBox=function(a){var c=this.axis,h=c.chart,m=a.boxTop,l=a.defaultX,p=a.xOffset,f=a.width,n=a.boxBottom;m=c.stacking.usePercentage?100:F(m,this.total,0);m=c.toPixels(m);a=F(l,(a.xAxis||h.xAxis[0]).toPixels(this.x))+p;c=c.toPixels(n?n:0);c=Math.abs(m-c);n=this.isNegative;return h.inverted?{x:(n?m:m-c)-h.plotLeft,y:a-h.plotTop,width:c,height:f}:{x:a-h.plotLeft,y:(n?m-c:m)-h.plotTop,width:f,height:c}};return a}();"";return a});J(a,"Core/Axis/Stacking/StackingAxis.js",
	[a["Core/Animation/AnimationUtilities.js"],a["Core/Axis/Axis.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Axis/Stacking/StackItem.js"],a["Core/Utilities.js"]],function(a,q,A,E,B){function v(){var b=this,a=b.inverted;b.yAxis.forEach(function(b){b.stacking&&b.stacking.stacks&&b.hasVisibleSeries&&(b.stacking.oldStacks=b.stacking.stacks)});b.series.forEach(function(d){var c=d.xAxis&&d.xAxis.options||{};!d.options.stacking||!0!==d.visible&&!1!==b.options.chart.ignoreHiddenSeries||(d.stackKey=[d.type,
	k(d.options.stack,""),a?c.top:c.left,a?c.height:c.width].join())})}function F(){var b=this.stacking;if(b){var a=b.stacks;w(a,function(b,d){H(b);a[d]=null});b&&b.stackTotalGroup&&b.stackTotalGroup.destroy()}}function x(){"yAxis"!==this.coll||this.stacking||(this.stacking=new g(this))}function u(b,a,c,e){!G(b)||b.x!==a||e&&b.stackKey!==e?b={x:a,index:0,key:e,stackKey:e}:b.index++;b.key=[c,a,b.index].join();return b}function n(){var b=this,a=b.stackKey,c=b.yAxis.stacking.stacks,e=b.processedXData,g=
	b[b.options.stacking+"Stacker"],f;g&&[a,"-"+a].forEach(function(a){for(var d=e.length,k,r;d--;)k=e[d],f=b.getStackIndicator(f,k,b.index,a),(r=(k=c[a]&&c[a][k])&&k.points[f.key])&&g.call(b,r,k,d)})}function c(b,a,c){a=a.total?100/a.total:0;b[0]=D(b[0]*a);b[1]=D(b[1]*a);this.stackedYData[c]=b[1]}function h(){var b=this.yAxis.stacking;this.options.centerInCategory&&(this.is("column")||this.is("columnrange"))&&!this.options.stacking&&1<this.chart.series.length?p.setStackedPoints.call(this,"group"):b&&
	w(b.stacks,function(a,c){"group"===c.slice(-5)&&(w(a,function(b){return b.destroy()}),delete b.stacks[c])})}function m(b){var a=this.chart,c=b||this.options.stacking;if(c&&(!0===this.visible||!1===a.options.chart.ignoreHiddenSeries)){var e=this.processedXData,g=this.processedYData,f=[],h=g.length,l=this.options,m=l.threshold,p=k(l.startFromThreshold&&m,0);l=l.stack;b=b?""+this.type+",".concat(c):this.stackKey;var t="-"+b,n=this.negStacks;a="group"===c?a.yAxis[0]:this.yAxis;var w=a.stacking.stacks,
	u=a.stacking.oldStacks,q,v;a.stacking.stacksTouched+=1;for(v=0;v<h;v++){var x=e[v];var A=g[v];var B=this.getStackIndicator(B,x,this.index);var K=B.key;var H=(q=n&&A<(p?0:m))?t:b;w[H]||(w[H]={});w[H][x]||(u[H]&&u[H][x]?(w[H][x]=u[H][x],w[H][x].total=null):w[H][x]=new E(a,a.options.stackLabels,!!q,x,l));H=w[H][x];null!==A?(H.points[K]=H.points[this.index]=[k(H.cumulative,p)],G(H.cumulative)||(H.base=K),H.touched=a.stacking.stacksTouched,0<B.index&&!1===this.singleStacks&&(H.points[K][0]=H.points[this.index+
	","+x+",0"][0])):H.points[K]=H.points[this.index]=null;"percent"===c?(q=q?b:t,n&&w[q]&&w[q][x]?(q=w[q][x],H.total=q.total=Math.max(q.total,H.total)+Math.abs(A)||0):H.total=D(H.total+(Math.abs(A)||0))):"group"===c?(y(A)&&(A=A[0]),null!==A&&(H.total=(H.total||0)+1)):H.total=D(H.total+(A||0));H.cumulative="group"===c?(H.total||1)-1:k(H.cumulative,p)+(A||0);null!==A&&(H.points[K].push(H.cumulative),f[v]=H.cumulative,H.hasValidPoints=!0)}"percent"===c&&(a.stacking.usePercentage=!0);"group"!==c&&(this.stackedYData=
	f);a.stacking.oldStacks={}}}var l=a.getDeferredAnimation,p=A.series.prototype,f=B.addEvent,D=B.correctFloat,G=B.defined,H=B.destroyObjectProperties,K=B.fireEvent,y=B.isArray,t=B.isNumber,w=B.objectEach,k=B.pick,g=function(){function b(b){this.oldStacks={};this.stacks={};this.stacksTouched=0;this.axis=b}b.prototype.buildStacks=function(){var b=this.axis,a=b.series,c=b.options.reversedStacks,e=a.length,g;this.usePercentage=!1;for(g=e;g--;){var f=a[c?g:e-g-1];f.setStackedPoints();f.setGroupedPoints()}for(g=
	0;g<e;g++)a[g].modifyStacks();K(b,"afterBuildStacks")};b.prototype.cleanStacks=function(){if(this.oldStacks)var b=this.stacks=this.oldStacks;w(b,function(b){w(b,function(b){b.cumulative=b.total})})};b.prototype.resetStacks=function(){var b=this;w(this.stacks,function(a){w(a,function(d,c){t(d.touched)&&d.touched<b.stacksTouched?(d.destroy(),delete a[c]):(d.total=null,d.cumulative=null)})})};b.prototype.renderStackTotals=function(){var b=this.axis,a=b.chart,c=a.renderer,e=this.stacks;b=l(a,b.options.stackLabels&&
	b.options.stackLabels.animation||!1);var g=this.stackTotalGroup=this.stackTotalGroup||c.g("stack-labels").attr({zIndex:6,opacity:0}).add();g.translate(a.plotLeft,a.plotTop);w(e,function(b){w(b,function(b){b.render(g)})});g.animate({opacity:1},b)};return b}(),e;(function(b){var a=[];b.compose=function(b,d,e){-1===a.indexOf(b)&&(a.push(b),f(b,"init",x),f(b,"destroy",F));-1===a.indexOf(d)&&(a.push(d),d.prototype.getStacks=v);-1===a.indexOf(e)&&(a.push(e),b=e.prototype,b.getStackIndicator=u,b.modifyStacks=
	n,b.percentStacker=c,b.setGroupedPoints=h,b.setStackedPoints=m)}})(e||(e={}));return e});J(a,"Series/Line/LineSeries.js",[a["Core/Series/Series.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A){var v=this&&this.__extends||function(){var a=function(q,u){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&(a[h]=c[h])};return a(q,u)};return function(q,u){function n(){this.constructor=q}
	a(q,u);q.prototype=null===u?Object.create(u):(n.prototype=u.prototype,new n)}}(),B=A.defined,C=A.merge;A=function(q){function x(){var a=null!==q&&q.apply(this,arguments)||this;a.data=void 0;a.options=void 0;a.points=void 0;return a}v(x,q);x.prototype.drawGraph=function(){var a=this,n=this.options,c=(this.gappedPath||this.getGraphPath).call(this),h=this.chart.styledMode,m=[["graph","highcharts-graph"]];h||m[0].push(n.lineColor||this.color||"#cccccc",n.dashStyle);m=a.getZonesGraphs(m);m.forEach(function(l,
	m){var f=l[0],p=a[f],u=p?"animate":"attr";p?(p.endX=a.preventGraphAnimation?null:c.xMap,p.animate({d:c})):c.length&&(a[f]=p=a.chart.renderer.path(c).addClass(l[1]).attr({zIndex:1}).add(a.group));p&&!h&&(f={stroke:l[2],"stroke-width":n.lineWidth||0,fill:a.fillGraph&&a.color||"none"},l[3]?f.dashstyle=l[3]:"square"!==n.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),p[u](f).shadow(2>m&&n.shadow));p&&(p.startX=c.xMap,p.isArea=c.isArea)})};x.prototype.getGraphPath=function(a,n,c){var h=this,
	m=h.options,l=[],p=[],f,u=m.step;a=a||h.points;var q=a.reversed;q&&a.reverse();(u={right:1,center:2}[u]||u&&3)&&q&&(u=4-u);a=this.getValidPoints(a,!1,!(m.connectNulls&&!n&&!c));a.forEach(function(q,v){var y=q.plotX,t=q.plotY,w=a[v-1];(q.leftCliff||w&&w.rightCliff)&&!c&&(f=!0);q.isNull&&!B(n)&&0<v?f=!m.connectNulls:q.isNull&&!n?f=!0:(0===v||f?v=[["M",q.plotX,q.plotY]]:h.getPointSpline?v=[h.getPointSpline(a,q,v)]:u?(v=1===u?[["L",w.plotX,t]]:2===u?[["L",(w.plotX+y)/2,w.plotY],["L",(w.plotX+y)/2,t]]:
	[["L",y,w.plotY]],v.push(["L",y,t])):v=[["L",y,t]],p.push(q.x),u&&(p.push(q.x),2===u&&p.push(q.x)),l.push.apply(l,v),f=!1)});l.xMap=p;return h.graphPath=l};x.prototype.getZonesGraphs=function(a){this.zones.forEach(function(n,c){c=["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+c+" "+(n.className||"")];this.chart.styledMode||c.push(n.color||this.color,n.dashStyle||this.options.dashStyle);a.push(c)},this);return a};x.defaultOptions=C(a.defaultOptions,{});return x}(a);q.registerSeriesType("line",
	A);"";return A});J(a,"Series/Area/AreaSeries.js",[a["Core/Color/Color.js"],a["Core/Legend/LegendSymbol.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=this&&this.__extends||function(){var a=function(c,m){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var f in c)c.hasOwnProperty(f)&&(a[f]=c[f])};return a(c,m)};return function(c,m){function h(){this.constructor=c}a(c,m);c.prototype=null===m?Object.create(m):
	(h.prototype=m.prototype,new h)}}(),C=a.parse,F=A.seriesTypes.line;a=E.extend;var x=E.merge,u=E.objectEach,n=E.pick;E=function(a){function c(){var c=null!==a&&a.apply(this,arguments)||this;c.data=void 0;c.options=void 0;c.points=void 0;return c}v(c,a);c.prototype.drawGraph=function(){this.areaPath=[];a.prototype.drawGraph.apply(this);var c=this,h=this.areaPath,p=this.options,f=[["area","highcharts-area",this.color,p.fillColor]];this.zones.forEach(function(a,h){f.push(["zone-area-"+h,"highcharts-area highcharts-zone-area-"+
	h+" "+a.className,a.color||c.color,a.fillColor||p.fillColor])});f.forEach(function(a){var f=a[0],l={},m=c[f],u=m?"animate":"attr";m?(m.endX=c.preventGraphAnimation?null:h.xMap,m.animate({d:h})):(l.zIndex=0,m=c[f]=c.chart.renderer.path(h).addClass(a[1]).add(c.group),m.isArea=!0);c.chart.styledMode||(l.fill=n(a[3],C(a[2]).setOpacity(n(p.fillOpacity,.75)).get()));m[u](l);m.startX=h.xMap;m.shiftUnit=p.step?2:1})};c.prototype.getGraphPath=function(a){var c=F.prototype.getGraphPath,h=this.options,f=h.stacking,
	m=this.yAxis,u=[],q=[],v=this.index,y=m.stacking.stacks[this.stackKey],t=h.threshold,w=Math.round(m.getThreshold(h.threshold));h=n(h.connectNulls,"percent"===f);var k=function(b,c,e){var g=a[b];b=f&&y[g.x].points[v];var k=g[e+"Null"]||0;e=g[e+"Cliff"]||0;g=!0;if(e||k){var r=(k?b[0]:b[1])+e;var h=b[0]+e;g=!!k}else!f&&a[c]&&a[c].isNull&&(r=h=t);"undefined"!==typeof r&&(q.push({plotX:d,plotY:null===r?w:m.getThreshold(r),isNull:g,isCliff:!0}),u.push({plotX:d,plotY:null===h?w:m.getThreshold(h),doCurve:!1}))};
	a=a||this.points;f&&(a=this.getStackPoints(a));for(var g=0,e=a.length;g<e;++g){f||(a[g].leftCliff=a[g].rightCliff=a[g].leftNull=a[g].rightNull=void 0);var b=a[g].isNull;var d=n(a[g].rectPlotX,a[g].plotX);var r=f?n(a[g].yBottom,w):w;if(!b||h)h||k(g,g-1,"left"),b&&!f&&h||(q.push(a[g]),u.push({x:g,plotX:d,plotY:r})),h||k(g,g+1,"right")}k=c.call(this,q,!0,!0);u.reversed=!0;b=c.call(this,u,!0,!0);(r=b[0])&&"M"===r[0]&&(b[0]=["L",r[1],r[2]]);b=k.concat(b);b.length&&b.push(["Z"]);c=c.call(this,q,!1,h);b.xMap=
	k.xMap;this.areaPath=b;return c};c.prototype.getStackPoints=function(a){var c=this,h=[],f=[],m=this.xAxis,q=this.yAxis,v=q.stacking.stacks[this.stackKey],x={},y=q.series,t=y.length,w=q.options.reversedStacks?1:-1,k=y.indexOf(c);a=a||this.points;if(this.options.stacking){for(var g=0;g<a.length;g++)a[g].leftNull=a[g].rightNull=void 0,x[a[g].x]=a[g];u(v,function(b,a){null!==b.total&&f.push(a)});f.sort(function(b,a){return b-a});var e=y.map(function(b){return b.visible});f.forEach(function(b,a){var d=
	0,g,l;if(x[b]&&!x[b].isNull)h.push(x[b]),[-1,1].forEach(function(d){var r=1===d?"rightNull":"leftNull",h=v[f[a+d]],m=0;if(h)for(var p=k;0<=p&&p<t;){var z=y[p].index;g=h.points[z];g||(z===c.index?x[b][r]=!0:e[p]&&(l=v[b].points[z])&&(m-=l[1]-l[0]));p+=w}x[b][1===d?"rightCliff":"leftCliff"]=m});else{for(var p=k;0<=p&&p<t;){if(g=v[b].points[y[p].index]){d=g[1];break}p+=w}d=n(d,0);d=q.translate(d,0,1,0,1);h.push({isNull:!0,plotX:m.translate(b,0,0,0,1),x:b,plotY:d,yBottom:d})}})}return h};c.defaultOptions=
	x(F.defaultOptions,{threshold:0});return c}(F);a(E.prototype,{singleStacks:!1,drawLegendSymbol:q.drawRectangle});A.registerSeriesType("area",E);"";return E});J(a,"Series/Spline/SplineSeries.js",[a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q){var v=this&&this.__extends||function(){var a=function(q,u){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&(a[h]=c[h])};return a(q,u)};return function(q,
	u){function n(){this.constructor=q}a(q,u);q.prototype=null===u?Object.create(u):(n.prototype=u.prototype,new n)}}(),E=a.seriesTypes.line,B=q.merge,C=q.pick;q=function(a){function q(){var u=null!==a&&a.apply(this,arguments)||this;u.data=void 0;u.options=void 0;u.points=void 0;return u}v(q,a);q.prototype.getPointSpline=function(a,n,c){var h=n.plotX||0,m=n.plotY||0,l=a[c-1];c=a[c+1];if(l&&!l.isNull&&!1!==l.doCurve&&!n.isCliff&&c&&!c.isNull&&!1!==c.doCurve&&!n.isCliff){a=l.plotY||0;var p=c.plotX||0;c=
	c.plotY||0;var f=0;var u=(1.5*h+(l.plotX||0))/2.5;var q=(1.5*m+a)/2.5;p=(1.5*h+p)/2.5;var v=(1.5*m+c)/2.5;p!==u&&(f=(v-q)*(p-h)/(p-u)+m-v);q+=f;v+=f;q>a&&q>m?(q=Math.max(a,m),v=2*m-q):q<a&&q<m&&(q=Math.min(a,m),v=2*m-q);v>c&&v>m?(v=Math.max(c,m),q=2*m-v):v<c&&v<m&&(v=Math.min(c,m),q=2*m-v);n.rightContX=p;n.rightContY=v}n=["C",C(l.rightContX,l.plotX,0),C(l.rightContY,l.plotY,0),C(u,h,0),C(q,m,0),h,m];l.rightContX=l.rightContY=void 0;return n};q.defaultOptions=B(E.defaultOptions);return q}(E);a.registerSeriesType("spline",
	q);"";return q});J(a,"Series/AreaSpline/AreaSplineSeries.js",[a["Series/Spline/SplineSeries.js"],a["Core/Legend/LegendSymbol.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=this&&this.__extends||function(){var a=function(c,h){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&(a[h]=c[h])};return a(c,h)};return function(c,h){function m(){this.constructor=c}a(c,h);c.prototype=
	null===h?Object.create(h):(m.prototype=h.prototype,new m)}}(),C=A.seriesTypes,F=C.area;C=C.area.prototype;var x=E.extend,u=E.merge;E=function(n){function c(){var a=null!==n&&n.apply(this,arguments)||this;a.data=void 0;a.points=void 0;a.options=void 0;return a}v(c,n);c.defaultOptions=u(a.defaultOptions,F.defaultOptions);return c}(a);x(E.prototype,{getGraphPath:C.getGraphPath,getStackPoints:C.getStackPoints,drawGraph:C.drawGraph,drawLegendSymbol:q.drawRectangle});A.registerSeriesType("areaspline",E);
	"";return E});J(a,"Series/Column/ColumnSeriesDefaults.js",[],function(){"";return{borderRadius:0,centerInCategory:!1,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:void 0,verticalAlign:void 0,y:void 0},startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"}});J(a,"Series/Column/ColumnSeries.js",[a["Core/Animation/AnimationUtilities.js"],
	a["Core/Color/Color.js"],a["Series/Column/ColumnSeriesDefaults.js"],a["Core/Globals.js"],a["Core/Legend/LegendSymbol.js"],a["Core/Series/Series.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x){var u=this&&this.__extends||function(){var a=function(c,f){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var b in c)c.hasOwnProperty(b)&&(a[b]=c[b])};return a(c,f)};return function(c,f){function g(){this.constructor=
	c}a(c,f);c.prototype=null===f?Object.create(f):(g.prototype=f.prototype,new g)}}(),n=a.animObject,c=q.parse,h=E.hasTouch;a=E.noop;var m=x.clamp,l=x.defined,p=x.extend,f=x.fireEvent,v=x.isArray,G=x.isNumber,H=x.merge,K=x.pick,y=x.objectEach;x=function(a){function t(){var c=null!==a&&a.apply(this,arguments)||this;c.borderWidth=void 0;c.data=void 0;c.group=void 0;c.options=void 0;c.points=void 0;return c}u(t,a);t.prototype.animate=function(a){var c=this,e=this.yAxis,b=c.options,d=this.chart.inverted,
	f={},k=d?"translateX":"translateY";if(a)f.scaleY=.001,a=m(e.toPixels(b.threshold),e.pos,e.pos+e.len),d?f.translateX=a-e.len:f.translateY=a,c.clipBox&&c.setClip(),c.group.attr(f);else{var h=Number(c.group.attr(k));c.group.animate({scaleY:1},p(n(c.options.animation),{step:function(b,a){c.group&&(f[k]=h+a.pos*(e.pos-h),c.group.attr(f))}}))}};t.prototype.init=function(c,g){a.prototype.init.apply(this,arguments);var e=this;c=e.chart;c.hasRendered&&c.series.forEach(function(b){b.type===e.type&&(b.isDirty=
	!0)})};t.prototype.getColumnMetrics=function(){var a=this,c=a.options,e=a.xAxis,b=a.yAxis,d=e.options.reversedStacks;d=e.reversed&&!d||!e.reversed&&d;var f={},h,l=0;!1===c.grouping?l=1:a.chart.series.forEach(function(d){var c=d.yAxis,e=d.options;if(d.type===a.type&&(d.visible||!a.chart.options.chart.ignoreHiddenSeries)&&b.len===c.len&&b.pos===c.pos){if(e.stacking&&"group"!==e.stacking){h=d.stackKey;"undefined"===typeof f[h]&&(f[h]=l++);var g=f[h]}else!1!==e.grouping&&(g=l++);d.columnIndex=g}});var m=
	Math.min(Math.abs(e.transA)*(e.ordinal&&e.ordinal.slope||c.pointRange||e.closestPointRange||e.tickInterval||1),e.len),p=m*c.groupPadding,t=(m-2*p)/(l||1);c=Math.min(c.maxPointWidth||e.len,K(c.pointWidth,t*(1-2*c.pointPadding)));a.columnMetrics={width:c,offset:(t-c)/2+(p+((a.columnIndex||0)+(d?1:0))*t-m/2)*(d?-1:1),paddedWidth:t,columnCount:l};return a.columnMetrics};t.prototype.crispCol=function(a,c,e,b){var d=this.chart,g=this.borderWidth,f=-(g%2?.5:0);g=g%2?.5:1;d.inverted&&d.renderer.isVML&&(g+=
	1);this.options.crisp&&(e=Math.round(a+e)+f,a=Math.round(a)+f,e-=a);b=Math.round(c+b)+g;f=.5>=Math.abs(c)&&.5<b;c=Math.round(c)+g;b-=c;f&&b&&(--c,b+=1);return{x:a,y:c,width:e,height:b}};t.prototype.adjustForMissingColumns=function(a,c,e,b){var d=this,g=this.options.stacking;if(!e.isNull&&1<b.columnCount){var f=this.yAxis.options.reversedStacks,k=0,h=f?0:-b.columnCount;y(this.yAxis.stacking&&this.yAxis.stacking.stacks,function(b){if("number"===typeof e.x){var a=b[e.x.toString()];a&&(b=a.points[d.index],
	g?(b&&(k=h),a.hasValidPoints&&(f?h++:h--)):v(b)&&(b=Object.keys(a.points).filter(function(b){return!b.match(",")&&a.points[b]&&1<a.points[b].length}).map(parseFloat).sort(function(b,a){return a-b}),k=b.indexOf(d.index),h=b.length))}});a=(e.plotX||0)+((h-1)*b.paddedWidth+c)/2-c-k*b.paddedWidth}return a};t.prototype.translate=function(){var a=this,c=a.chart,e=a.options,b=a.dense=2>a.closestPointRange*a.xAxis.transA;b=a.borderWidth=K(e.borderWidth,b?0:1);var d=a.xAxis,f=a.yAxis,h=e.threshold,p=a.translatedThreshold=
	f.getThreshold(h),t=K(e.minPointLength,5),n=a.getColumnMetrics(),w=n.width,u=a.pointXOffset=n.offset,q=a.dataMin,y=a.dataMax,v=a.barW=Math.max(w,1+2*b);c.inverted&&(p-=.5);e.pointPadding&&(v=Math.ceil(v));C.prototype.translate.apply(a);a.points.forEach(function(b){var g=K(b.yBottom,p),k=999+Math.abs(g),r=b.plotX||0;k=m(b.plotY,-k,f.len+k);var z=Math.min(k,g),I=Math.max(k,g)-z,D=w,N=r+u,x=v;t&&Math.abs(I)<t&&(I=t,r=!f.reversed&&!b.negative||f.reversed&&b.negative,G(h)&&G(y)&&b.y===h&&y<=h&&(f.min||
	0)<h&&(q!==y||(f.max||0)<=h)&&(r=!r),z=Math.abs(z-p)>t?g-t:p-(r?t:0));l(b.options.pointWidth)&&(D=x=Math.ceil(b.options.pointWidth),N-=Math.round((D-w)/2));e.centerInCategory&&(N=a.adjustForMissingColumns(N,D,b,n));b.barX=N;b.pointWidth=D;b.tooltipPos=c.inverted?[m(f.len+f.pos-c.plotLeft-k,f.pos-c.plotLeft,f.len+f.pos-c.plotLeft),d.len+d.pos-c.plotTop-N-x/2,I]:[d.left-c.plotLeft+N+x/2,m(k+f.pos-c.plotTop,f.pos-c.plotTop,f.len+f.pos-c.plotTop),I];b.shapeType=a.pointClass.prototype.shapeType||"rect";
	b.shapeArgs=a.crispCol.apply(a,b.isNull?[N,p,x,0]:[N,z,x,I])})};t.prototype.drawGraph=function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")};t.prototype.pointAttribs=function(a,g){var e=this.options,b=this.pointAttrToOptions||{},d=b.stroke||"borderColor",f=b["stroke-width"]||"borderWidth",k=a&&a.color||this.color,h=a&&a[d]||e[d]||k;b=a&&a.options.dashStyle||e.dashStyle;var l=a&&a[f]||e[f]||this[f]||0,m=K(a&&a.opacity,e.opacity,1);if(a&&this.zones.length){var p=a.getZone();
	k=a.options.color||p&&(p.color||a.nonZonedColor)||this.color;p&&(h=p.borderColor||h,b=p.dashStyle||b,l=p.borderWidth||l)}g&&a&&(a=H(e.states[g],a.options.states&&a.options.states[g]||{}),g=a.brightness,k=a.color||"undefined"!==typeof g&&c(k).brighten(a.brightness).get()||k,h=a[d]||h,l=a[f]||l,b=a.dashStyle||b,m=K(a.opacity,m));d={fill:k,stroke:h,"stroke-width":l,opacity:m};b&&(d.dashstyle=b);return d};t.prototype.drawPoints=function(a){void 0===a&&(a=this.points);var c=this,e=this.chart,b=c.options,
	d=e.renderer,f=b.animationLimit||250,k;a.forEach(function(a){var g=a.graphic,r=!!g,h=g&&e.pointCount<f?"animate":"attr";if(G(a.plotY)&&null!==a.y){k=a.shapeArgs;g&&a.hasNewShapeType()&&(g=g.destroy());c.enabledDataSorting&&(a.startXPos=c.xAxis.reversed?-(k?k.width||0:0):c.xAxis.width);g||(a.graphic=g=d[a.shapeType](k).add(a.group||c.group))&&c.enabledDataSorting&&e.hasRendered&&e.pointCount<f&&(g.attr({x:a.startXPos}),r=!0,h="animate");if(g&&r)g[h](H(k));if(b.borderRadius)g[h]({r:b.borderRadius});
	e.styledMode||g[h](c.pointAttribs(a,a.selected&&"select")).shadow(!1!==a.allowShadow&&b.shadow,null,b.stacking&&!b.borderRadius);g&&(g.addClass(a.getClassName(),!0),g.attr({visibility:a.visible?"inherit":"hidden"}))}else g&&(a.graphic=g.destroy())})};t.prototype.drawTracker=function(a){void 0===a&&(a=this.points);var c=this,e=c.chart,b=e.pointer,d=function(a){var d=b.getPointFromEvent(a);"undefined"!==typeof d&&(b.isDirectTouch=!0,d.onMouseOver(a))},k;a.forEach(function(b){k=v(b.dataLabels)?b.dataLabels:
	b.dataLabel?[b.dataLabel]:[];b.graphic&&(b.graphic.element.point=b);k.forEach(function(a){a.div?a.div.point=b:a.element.point=b})});c._hasTracking||(c.trackerGroups.forEach(function(a){if(c[a]){c[a].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(h)c[a].on("touchstart",d);!e.styledMode&&c.options.cursor&&c[a].css({cursor:c.options.cursor})}}),c._hasTracking=!0);f(this,"afterDrawTracker")};t.prototype.remove=function(){var a=this,c=a.chart;c.hasRendered&&
	c.series.forEach(function(c){c.type===a.type&&(c.isDirty=!0)});C.prototype.remove.apply(a,arguments)};t.defaultOptions=H(C.defaultOptions,A);return t}(C);p(x.prototype,{cropShoulder:0,directTouch:!0,drawLegendSymbol:B.drawRectangle,getSymbol:a,negStacks:!0,trackerGroups:["group","dataLabelsGroup"]});F.registerSeriesType("column",x);"";return x});J(a,"Core/Series/DataLabel.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/FormatUtilities.js"],a["Core/Utilities.js"]],function(a,q,A){var v=a.getDeferredAnimation,
	B=q.format,C=A.defined,F=A.extend,x=A.fireEvent,u=A.isArray,n=A.isString,c=A.merge,h=A.objectEach,m=A.pick,l=A.splat,p;(function(a){function f(a,c,e,b,d){var g=this,f=this.chart,k=this.isCartesian&&f.inverted,h=this.enabledDataSorting,l=a.plotX,p=a.plotY,t=e.rotation,n=e.align,w=C(l)&&C(p)&&f.isInsidePlot(l,Math.round(p),{inverted:k,paneCoordinates:!0,series:g});p=function(b){h&&g.xAxis&&!u&&g.setDataLabelStartPos(a,c,d,w,b)};var u="justify"===m(e.overflow,h?"none":"justify");l=this.visible&&!1!==
	a.visible&&C(l)&&(a.series.forceDL||h&&!u||w||m(e.inside,!!this.options.stacking)&&b&&f.isInsidePlot(l,k?b.x+1:b.y+b.height-1,{inverted:k,paneCoordinates:!0,series:g}));k=a.pos();if(l&&k){t&&c.attr({align:n});n=c.getBBox(!0);var q=[0,0];var y=f.renderer.fontMetrics(f.styledMode?void 0:e.style.fontSize,c).b;b=F({x:k[0],y:Math.round(k[1]),width:0,height:0},b);F(e,{width:n.width,height:n.height});t?(u=!1,q=f.renderer.rotCorr(y,t),y={x:b.x+(e.x||0)+b.width/2+q.x,y:b.y+(e.y||0)+{top:0,middle:.5,bottom:1}[e.verticalAlign]*
	b.height},q=[n.x-Number(c.attr("x")),n.y-Number(c.attr("y"))],p(y),c[d?"attr":"animate"](y)):(p(b),c.align(e,void 0,b),y=c.alignAttr);u&&0<=b.height?this.justifyDataLabel(c,e,y,n,b,d):m(e.crop,!0)&&(b=y.x,p=y.y,b+=q[0],p+=q[1],l=f.isInsidePlot(b,p,{paneCoordinates:!0,series:g})&&f.isInsidePlot(b+n.width,p+n.height,{paneCoordinates:!0,series:g}));if(e.shape&&!t)c[d?"attr":"animate"]({anchorX:k[0],anchorY:k[1]})}d&&h&&(c.placed=!1);l||h&&!u?c.show():(c.hide(),c.placed=!1)}function p(a,c){var e=c.filter;
	return e?(c=e.operator,a=a[e.property],e=e.value,">"===c&&a>e||"<"===c&&a<e||">="===c&&a>=e||"<="===c&&a<=e||"=="===c&&a==e||"==="===c&&a===e?!0:!1):!0}function q(a){void 0===a&&(a=this.points);var c=this,e=c.chart,b=c.options,d=c.hasRendered||0,f=e.renderer,k=e.options.chart,t=k.backgroundColor;k=k.plotBackgroundColor;var w=f.getContrast(n(k)&&k||n(t)&&t||"#000000"),q=b.dataLabels,D;t=q.animation;t=q.defer?v(e,t,c):{defer:0,duration:0};q=y(y(e.options.plotOptions&&e.options.plotOptions.series&&e.options.plotOptions.series.dataLabels,
	e.options.plotOptions&&e.options.plotOptions[c.type]&&e.options.plotOptions[c.type].dataLabels),q);x(this,"drawDataLabels");if(u(q)||q.enabled||c._hasPointLabels){var A=c.plotGroup("dataLabelsGroup","data-labels",d?"inherit":"hidden",q.zIndex||6);A.attr({opacity:+d});!d&&(d=c.dataLabelsGroup)&&(c.visible&&A.show(),d[b.animation?"animate":"attr"]({opacity:1},t));a.forEach(function(a){D=l(y(q,a.dlOptions||a.options&&a.options.dataLabels));D.forEach(function(d,g){var k=d.enabled&&(!a.isNull||a.dataLabelOnNull)&&
	p(a,d),r=a.connectors?a.connectors[g]:a.connector,l=a.dataLabels?a.dataLabels[g]:a.dataLabel,t=!l,z=m(d.distance,a.labelDistance);if(k){var n=a.getLabelConfig();var u=m(d[a.formatPrefix+"Format"],d.format);n=C(u)?B(u,n,e):(d[a.formatPrefix+"Formatter"]||d.formatter).call(n,d);u=d.style;var q=d.rotation;e.styledMode||(u.color=m(d.color,u.color,c.color,"#000000"),"contrast"===u.color?(a.contrastColor=f.getContrast(a.color||c.color),u.color=!C(z)&&d.inside||0>z||b.stacking?a.contrastColor:w):delete a.contrastColor,
	b.cursor&&(u.cursor=b.cursor));var y={r:d.borderRadius||0,rotation:q,padding:d.padding,zIndex:1};if(!e.styledMode){z=d.backgroundColor;var v=d.borderColor;y.fill="auto"===z?a.color:z;y.stroke="auto"===v?a.color:v;y["stroke-width"]=d.borderWidth}h(y,function(b,a){"undefined"===typeof b&&delete y[a]})}!l||k&&C(n)&&!!l.div===!!d.useHTML&&(l.rotation&&d.rotation||l.rotation===d.rotation)||(t=!0,a.dataLabel=l=a.dataLabel&&a.dataLabel.destroy(),a.dataLabels&&(1===a.dataLabels.length?delete a.dataLabels:
	delete a.dataLabels[g]),g||delete a.dataLabel,r&&(a.connector=a.connector.destroy(),a.connectors&&(1===a.connectors.length?delete a.connectors:delete a.connectors[g])));k&&C(n)?(l?y.text=n:(a.dataLabels=a.dataLabels||[],l=a.dataLabels[g]=q?f.text(n,0,0,d.useHTML).addClass("highcharts-data-label"):f.label(n,0,0,d.shape,null,null,d.useHTML,null,"data-label"),g||(a.dataLabel=l),l.addClass(" highcharts-data-label-color-"+a.colorIndex+" "+(d.className||"")+(d.useHTML?" highcharts-tracker":""))),l.options=
	d,l.attr(y),e.styledMode||l.css(u).shadow(d.shadow),(g=d[a.formatPrefix+"TextPath"]||d.textPath)&&!d.useHTML&&(l.setTextPath(a.getDataLabelPath&&a.getDataLabelPath(l)||a.graphic,g),a.dataLabelPath&&!g.enabled&&(a.dataLabelPath=a.dataLabelPath.destroy())),l.added||l.add(A),c.alignDataLabel(a,l,d,null,t)):l&&l.hide()})})}x(this,"afterDrawDataLabels")}function A(a,c,e,b,d,f){var g=this.chart,k=c.align,r=c.verticalAlign,h=a.box?0:a.padding||0,l=c.x;l=void 0===l?0:l;var m=c.y;m=void 0===m?0:m;var p=(e.x||
	0)+h;if(0>p){"right"===k&&0<=l?(c.align="left",c.inside=!0):l-=p;var t=!0}p=(e.x||0)+b.width-h;p>g.plotWidth&&("left"===k&&0>=l?(c.align="right",c.inside=!0):l+=g.plotWidth-p,t=!0);p=e.y+h;0>p&&("bottom"===r&&0<=m?(c.verticalAlign="top",c.inside=!0):m-=p,t=!0);p=(e.y||0)+b.height-h;p>g.plotHeight&&("top"===r&&0>=m?(c.verticalAlign="bottom",c.inside=!0):m+=g.plotHeight-p,t=!0);t&&(c.x=l,c.y=m,a.placed=!f,a.align(c,void 0,d));return t}function y(a,g){var e=[],b;if(u(a)&&!u(g))e=a.map(function(b){return c(b,
	g)});else if(u(g)&&!u(a))e=g.map(function(b){return c(a,b)});else if(u(a)||u(g))for(b=Math.max(a.length,g.length);b--;)e[b]=c(a[b],g[b]);else e=c(a,g);return e}function t(a,c,e,b,d){var g=this.chart,f=g.inverted,k=this.xAxis,h=k.reversed,l=f?c.height/2:c.width/2;a=(a=a.pointWidth)?a/2:0;c.startXPos=f?d.x:h?-l-a:k.width-l+a;c.startYPos=f?h?this.yAxis.height-l+a:-l-a:d.y;b?"hidden"===c.visibility&&(c.show(),c.attr({opacity:0}).animate({opacity:1})):c.attr({opacity:1}).animate({opacity:0},void 0,c.hide);
	g.hasRendered&&(e&&c.attr({x:c.startXPos,y:c.startYPos}),c.placed=!0)}var w=[];a.compose=function(a){if(-1===w.indexOf(a)){var c=a.prototype;w.push(a);c.alignDataLabel=f;c.drawDataLabels=q;c.justifyDataLabel=A;c.setDataLabelStartPos=t}}})(p||(p={}));"";return p});J(a,"Series/Column/ColumnDataLabel.js",[a["Core/Series/DataLabel.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A){var v=q.series,B=A.merge,C=A.pick,F;(function(q){function u(a,h,m,l,p){var c=this.chart.inverted,
	n=a.series,u=(n.xAxis?n.xAxis.len:this.chart.plotSizeX)||0;n=(n.yAxis?n.yAxis.len:this.chart.plotSizeY)||0;var q=a.dlBox||a.shapeArgs,x=C(a.below,a.plotY>C(this.translatedThreshold,n)),y=C(m.inside,!!this.options.stacking);q&&(l=B(q),0>l.y&&(l.height+=l.y,l.y=0),q=l.y+l.height-n,0<q&&q<l.height&&(l.height-=q),c&&(l={x:n-l.y-l.height,y:u-l.x-l.width,width:l.height,height:l.width}),y||(c?(l.x+=x?0:l.width,l.width=0):(l.y+=x?l.height:0,l.height=0)));m.align=C(m.align,!c||y?"center":x?"right":"left");
	m.verticalAlign=C(m.verticalAlign,c||y?"middle":x?"top":"bottom");v.prototype.alignDataLabel.call(this,a,h,m,l,p);m.inside&&a.contrastColor&&h.css({color:a.contrastColor})}var n=[];q.compose=function(c){a.compose(v);-1===n.indexOf(c)&&(n.push(c),c.prototype.alignDataLabel=u)}})(F||(F={}));return F});J(a,"Series/Bar/BarSeries.js",[a["Series/Column/ColumnSeries.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A){var v=this&&this.__extends||function(){var a=function(q,u){a=
	Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&(a[h]=c[h])};return a(q,u)};return function(q,u){function n(){this.constructor=q}a(q,u);q.prototype=null===u?Object.create(u):(n.prototype=u.prototype,new n)}}(),B=A.extend,C=A.merge;A=function(q){function x(){var a=null!==q&&q.apply(this,arguments)||this;a.data=void 0;a.options=void 0;a.points=void 0;return a}v(x,q);x.defaultOptions=C(a.defaultOptions,{});return x}(a);
	B(A.prototype,{inverted:!0});q.registerSeriesType("bar",A);"";return A});J(a,"Series/Scatter/ScatterSeriesDefaults.js",[],function(){"";return{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}}});J(a,"Series/Scatter/ScatterSeries.js",[a["Series/Scatter/ScatterSeriesDefaults.js"],a["Core/Series/SeriesRegistry.js"],
	a["Core/Utilities.js"]],function(a,q,A){var v=this&&this.__extends||function(){var a=function(c,h){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&(a[h]=c[h])};return a(c,h)};return function(c,h){function m(){this.constructor=c}a(c,h);c.prototype=null===h?Object.create(h):(m.prototype=h.prototype,new m)}}(),B=q.seriesTypes,C=B.column,F=B.line;B=A.addEvent;var x=A.extend,u=A.merge;A=function(n){function c(){var a=
	null!==n&&n.apply(this,arguments)||this;a.data=void 0;a.options=void 0;a.points=void 0;return a}v(c,n);c.prototype.applyJitter=function(){var a=this,c=this.options.jitter,l=this.points.length;c&&this.points.forEach(function(h,f){["x","y"].forEach(function(m,p){var n="plot"+m.toUpperCase();if(c[m]&&!h.isNull){var u=a[m+"Axis"];var q=c[m]*u.transA;if(u&&!u.isLog){var t=Math.max(0,h[n]-q);u=Math.min(u.len,h[n]+q);p=1E4*Math.sin(f+p*l);h[n]=t+(u-t)*(p-Math.floor(p));"x"===m&&(h.clientX=h.plotX)}}})})};
	c.prototype.drawGraph=function(){this.options.lineWidth?n.prototype.drawGraph.call(this):this.graph&&(this.graph=this.graph.destroy())};c.defaultOptions=u(F.defaultOptions,a);return c}(F);x(A.prototype,{drawTracker:C.prototype.drawTracker,sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1});B(A,"afterTranslate",function(){this.applyJitter()});q.registerSeriesType("scatter",A);return A});J(a,"Series/CenteredUtilities.js",[a["Core/Globals.js"],
	a["Core/Series/Series.js"],a["Core/Utilities.js"]],function(a,q,A){var v=a.deg2rad,B=A.fireEvent,C=A.isNumber,F=A.pick,x=A.relativeLength,u;(function(a){a.getCenter=function(){var a=this.options,h=this.chart,m=2*(a.slicedOffset||0),l=h.plotWidth-2*m,p=h.plotHeight-2*m,f=a.center,n=Math.min(l,p),u=a.thickness,v=a.size,A=a.innerSize||0;"string"===typeof v&&(v=parseFloat(v));"string"===typeof A&&(A=parseFloat(A));a=[F(f[0],"50%"),F(f[1],"50%"),F(v&&0>v?void 0:a.size,"100%"),F(A&&0>A?void 0:a.innerSize||
	0,"0%")];!h.angular||this instanceof q||(a[3]=0);for(f=0;4>f;++f)v=a[f],h=2>f||2===f&&/%$/.test(v),a[f]=x(v,[l,p,n,a[2]][f])+(h?m:0);a[3]>a[2]&&(a[3]=a[2]);C(u)&&2*u<a[2]&&0<u&&(a[3]=a[2]-2*u);B(this,"afterGetCenter",{positions:a});return a};a.getStartAndEndRadians=function(a,h){a=C(a)?a:0;h=C(h)&&h>a&&360>h-a?h:a+360;return{start:v*(a+-90),end:v*(h+-90)}}})(u||(u={}));"";return u});J(a,"Series/Pie/PiePoint.js",[a["Core/Animation/AnimationUtilities.js"],a["Core/Series/Point.js"],a["Core/Utilities.js"]],
	function(a,q,A){var v=this&&this.__extends||function(){var a=function(c,m){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var f in c)c.hasOwnProperty(f)&&(a[f]=c[f])};return a(c,m)};return function(c,m){function h(){this.constructor=c}a(c,m);c.prototype=null===m?Object.create(m):(h.prototype=m.prototype,new h)}}(),B=a.setAnimation,C=A.addEvent,F=A.defined;a=A.extend;var x=A.isNumber,u=A.pick,n=A.relativeLength;q=function(a){function c(){var c=
	null!==a&&a.apply(this,arguments)||this;c.labelDistance=void 0;c.options=void 0;c.series=void 0;return c}v(c,a);c.prototype.getConnectorPath=function(){var a=this.labelPosition,c=this.series.options.dataLabels,h=this.connectorShapes,f=c.connectorShape;h[f]&&(f=h[f]);return f.call(this,{x:a.final.x,y:a.final.y,alignment:a.alignment},a.connectorPosition,c)};c.prototype.getTranslate=function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}};c.prototype.haloPath=function(a){var c=
	this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:c.r-1,start:c.start,end:c.end})};c.prototype.init=function(){var c=this;a.prototype.init.apply(this,arguments);this.name=u(this.name,"Slice");var h=function(a){c.slice("select"===a.type)};C(this,"select",h);C(this,"unselect",h);return this};c.prototype.isValid=function(){return x(this.y)&&0<=this.y};c.prototype.setVisible=function(a,c){var h=this,f=this.series,l=f.chart,m=f.options.ignoreHiddenPoint;
	c=u(c,m);a!==this.visible&&(this.visible=this.options.visible=a="undefined"===typeof a?!this.visible:a,f.options.data[f.data.indexOf(this)]=this.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(c){if(h[c])h[c][a?"show":"hide"](a)}),this.legendItem&&l.legend.colorizeItem(this,a),a||"hover"!==this.state||this.setState(""),m&&(f.isDirty=!0),c&&l.redraw())};c.prototype.slice=function(a,c,h){var f=this.series;B(h,f.chart);u(c,!0);this.sliced=this.options.sliced=F(a)?a:!this.sliced;
	f.options.data[f.data.indexOf(this)]=this.options;this.graphic&&this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())};return c}(q);a(q.prototype,{connectorShapes:{fixedOffset:function(a,h,m){var c=h.breakAt;h=h.touchingSliceAt;return[["M",a.x,a.y],m.softConnector?["C",a.x+("left"===a.alignment?-5:5),a.y,2*c.x-h.x,2*c.y-h.y,c.x,c.y]:["L",c.x,c.y],["L",h.x,h.y]]},straight:function(a,h){h=h.touchingSliceAt;return[["M",a.x,a.y],["L",h.x,h.y]]},crookedLine:function(a,
	h,m){h=h.touchingSliceAt;var c=this.series,p=c.center[0],f=c.chart.plotWidth,u=c.chart.plotLeft;c=a.alignment;var q=this.shapeArgs.r;m=n(m.crookDistance,1);f="left"===c?p+q+(f+u-p-q)*(1-m):u+(p-q)*m;m=["L",f,a.y];p=!0;if("left"===c?f>a.x||f<h.x:f<a.x||f>h.x)p=!1;a=[["M",a.x,a.y]];p&&a.push(m);a.push(["L",h.x,h.y]);return a}}});return q});J(a,"Series/Pie/PieSeriesDefaults.js",[],function(){"";return{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,connectorShape:"fixedOffset",
	crookDistance:"70%",distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},softConnector:!0,x:0},fillColor:void 0,ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}}});J(a,"Series/Pie/PieSeries.js",[a["Series/CenteredUtilities.js"],a["Series/Column/ColumnSeries.js"],a["Core/Globals.js"],
	a["Core/Legend/LegendSymbol.js"],a["Series/Pie/PiePoint.js"],a["Series/Pie/PieSeriesDefaults.js"],a["Core/Series/Series.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Renderer/SVG/Symbols.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x,u,n){var c=this&&this.__extends||function(){var a=function(c,f){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var f in c)c.hasOwnProperty(f)&&(a[f]=c[f])};return a(c,f)};return function(c,f){function h(){this.constructor=
	c}a(c,f);c.prototype=null===f?Object.create(f):(h.prototype=f.prototype,new h)}}(),h=a.getStartAndEndRadians;A=A.noop;var m=n.clamp,l=n.extend,p=n.fireEvent,f=n.merge,v=n.pick,G=n.relativeLength;n=function(a){function l(){var c=null!==a&&a.apply(this,arguments)||this;c.center=void 0;c.data=void 0;c.maxLabelDistance=void 0;c.options=void 0;c.points=void 0;return c}c(l,a);l.prototype.animate=function(a){var c=this,f=c.points,k=c.startAngleRad;a||f.forEach(function(a){var e=a.graphic,b=a.shapeArgs;e&&
	b&&(e.attr({r:v(a.startR,c.center&&c.center[3]/2),start:k,end:k}),e.animate({r:b.r,start:b.start,end:b.end},c.options.animation))})};l.prototype.drawEmpty=function(){var a=this.startAngleRad,c=this.endAngleRad,f=this.options;if(0===this.total&&this.center){var k=this.center[0];var g=this.center[1];this.graph||(this.graph=this.chart.renderer.arc(k,g,this.center[1]/2,0,a,c).addClass("highcharts-empty-series").add(this.group));this.graph.attr({d:u.arc(k,g,this.center[2]/2,0,{start:a,end:c,innerR:this.center[3]/
	2})});this.chart.styledMode||this.graph.attr({"stroke-width":f.borderWidth,fill:f.fillColor||"none",stroke:f.color||"#cccccc"})}else this.graph&&(this.graph=this.graph.destroy())};l.prototype.drawPoints=function(){var a=this.chart.renderer;this.points.forEach(function(c){c.graphic&&c.hasNewShapeType()&&(c.graphic=c.graphic.destroy());c.graphic||(c.graphic=a[c.shapeType](c.shapeArgs).add(c.series.group),c.delayedRendering=!0)})};l.prototype.generatePoints=function(){a.prototype.generatePoints.call(this);
	this.updateTotals()};l.prototype.getX=function(a,c,f){var k=this.center,g=this.radii?this.radii[f.index]||0:k[2]/2;a=Math.asin(m((a-k[1])/(g+f.labelDistance),-1,1));return k[0]+(c?-1:1)*Math.cos(a)*(g+f.labelDistance)+(0<f.labelDistance?(c?-1:1)*this.options.dataLabels.padding:0)};l.prototype.hasData=function(){return!!this.processedXData.length};l.prototype.redrawPoints=function(){var a=this,c=a.chart,h=c.renderer,k=a.options.shadow,g,e,b,d;this.drawEmpty();!k||a.shadowGroup||c.styledMode||(a.shadowGroup=
	h.g("shadow").attr({zIndex:-1}).add(a.group));a.points.forEach(function(r){var l={};e=r.graphic;if(!r.isNull&&e){var m=void 0;d=r.shapeArgs;g=r.getTranslate();c.styledMode||(m=r.shadowGroup,k&&!m&&(m=r.shadowGroup=h.g("shadow").add(a.shadowGroup)),m&&m.attr(g),b=a.pointAttribs(r,r.selected&&"select"));r.delayedRendering?(e.setRadialReference(a.center).attr(d).attr(g),c.styledMode||e.attr(b).attr({"stroke-linejoin":"round"}).shadow(k,m),r.delayedRendering=!1):(e.setRadialReference(a.center),c.styledMode||
	f(!0,l,b),f(!0,l,d,g),e.animate(l));e.attr({visibility:r.visible?"inherit":"hidden"});e.addClass(r.getClassName(),!0)}else e&&(r.graphic=e.destroy())})};l.prototype.sortByAngle=function(a,c){a.sort(function(a,f){return"undefined"!==typeof a.angle&&(f.angle-a.angle)*c})};l.prototype.translate=function(a){p(this,"translate");this.generatePoints();var c=this.options,f=c.slicedOffset,k=f+(c.borderWidth||0),g=h(c.startAngle,c.endAngle),e=this.startAngleRad=g.start;g=(this.endAngleRad=g.end)-e;var b=this.points,
	d=c.dataLabels.distance;c=c.ignoreHiddenPoint;var r=b.length,l,m=0;a||(this.center=a=this.getCenter());for(l=0;l<r;l++){var n=b[l];var u=e+m*g;!n.isValid()||c&&!n.visible||(m+=n.percentage/100);var q=e+m*g;var y={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*u)/1E3,end:Math.round(1E3*q)/1E3};n.shapeType="arc";n.shapeArgs=y;n.labelDistance=v(n.options.dataLabels&&n.options.dataLabels.distance,d);n.labelDistance=G(n.labelDistance,y.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||
	0,n.labelDistance);q=(q+u)/2;q>1.5*Math.PI?q-=2*Math.PI:q<-Math.PI/2&&(q+=2*Math.PI);n.slicedTranslation={translateX:Math.round(Math.cos(q)*f),translateY:Math.round(Math.sin(q)*f)};y=Math.cos(q)*a[2]/2;var D=Math.sin(q)*a[2]/2;n.tooltipPos=[a[0]+.7*y,a[1]+.7*D];n.half=q<-Math.PI/2||q>Math.PI/2?1:0;n.angle=q;u=Math.min(k,n.labelDistance/5);n.labelPosition={natural:{x:a[0]+y+Math.cos(q)*n.labelDistance,y:a[1]+D+Math.sin(q)*n.labelDistance},"final":{},alignment:0>n.labelDistance?"center":n.half?"right":
	"left",connectorPosition:{breakAt:{x:a[0]+y+Math.cos(q)*u,y:a[1]+D+Math.sin(q)*u},touchingSliceAt:{x:a[0]+y,y:a[1]+D}}}}p(this,"afterTranslate")};l.prototype.updateTotals=function(){var a=this.points,c=a.length,f=this.options.ignoreHiddenPoint,k,g=0;for(k=0;k<c;k++){var e=a[k];!e.isValid()||f&&!e.visible||(g+=e.y)}this.total=g;for(k=0;k<c;k++)e=a[k],e.percentage=0<g&&(e.visible||!f)?e.y/g*100:0,e.total=g};l.defaultOptions=f(F.defaultOptions,C);return l}(F);l(n.prototype,{axisTypes:[],directTouch:!0,
	drawGraph:void 0,drawLegendSymbol:E.drawRectangle,drawTracker:q.prototype.drawTracker,getCenter:a.getCenter,getSymbol:A,isCartesian:!1,noSharedTooltip:!0,pointAttribs:q.prototype.pointAttribs,pointClass:B,requireSorting:!1,searchPoint:A,trackerGroups:["group","dataLabelsGroup"]});x.registerSeriesType("pie",n);return n});J(a,"Series/Pie/PieDataLabel.js",[a["Core/Series/DataLabel.js"],a["Core/Globals.js"],a["Core/Renderer/RendererUtilities.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],
	function(a,q,A,E,B){var v=q.noop,F=A.distribute,x=E.series,u=B.arrayMax,n=B.clamp,c=B.defined,h=B.merge,m=B.pick,l=B.relativeLength,p;(function(f){function p(){var a=this,f=a.data,k=a.chart,g=a.options.dataLabels||{},e=g.connectorPadding,b=k.plotWidth,d=k.plotHeight,r=k.plotLeft,l=Math.round(k.chartWidth/3),p=a.center,n=p[2]/2,q=p[1],y=[[],[]],v=[0,0,0,0],D=a.dataLabelPositioners,A,B,G,C,E,H,K,J,V,W,Z,T;a.visible&&(g.enabled||a._hasPointLabels)&&(f.forEach(function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&
	(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),x.prototype.drawDataLabels.apply(a),f.forEach(function(a){a.dataLabel&&(a.visible?(y[a.half].push(a),a.dataLabel._pos=null,!c(g.style.width)&&!c(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>l&&(a.dataLabel.css({width:Math.round(.7*l)+"px"}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&
	delete a.dataLabels))}),y.forEach(function(f,h){var l=f.length,t=[],z;if(l){a.sortByAngle(f,h-.5);if(0<a.maxLabelDistance){var u=Math.max(0,q-n-a.maxLabelDistance);var w=Math.min(q+n+a.maxLabelDistance,k.plotHeight);f.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,q-n-a.labelDistance),a.bottom=Math.min(q+n+a.labelDistance,k.plotHeight),z=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+z/2,size:z,rank:a.y},t.push(a.distributeBox))});u=
	w+z-u;F(t,u,u/5)}for(Z=0;Z<l;Z++){A=f[Z];H=A.labelPosition;C=A.dataLabel;W=!1===A.visible?"hidden":"inherit";V=u=H.natural.y;t&&c(A.distributeBox)&&("undefined"===typeof A.distributeBox.pos?W="hidden":(K=A.distributeBox.size,V=D.radialDistributionY(A)));delete A.positionIndex;if(g.justify)J=D.justify(A,n,p);else switch(g.alignTo){case "connectors":J=D.alignToConnectors(f,h,b,r);break;case "plotEdges":J=D.alignToPlotEdges(C,h,b,r);break;default:J=D.radialDistributionX(a,A,V,u)}C._attr={visibility:W,
	align:H.alignment};T=A.options.dataLabels||{};C._pos={x:J+m(T.x,g.x)+({left:e,right:-e}[H.alignment]||0),y:V+m(T.y,g.y)-10};H.final.x=J;H.final.y=V;m(g.crop,!0)&&(E=C.getBBox().width,u=null,J-E<e&&1===h?(u=Math.round(E-J+e),v[3]=Math.max(u,v[3])):J+E>b-e&&0===h&&(u=Math.round(J+E-b+e),v[1]=Math.max(u,v[1])),0>V-K/2?v[0]=Math.max(Math.round(-V+K/2),v[0]):V+K/2>d&&(v[2]=Math.max(Math.round(V+K/2-d),v[2])),C.sideOverflow=u)}}}),0===u(v)||this.verifyDataLabelOverflow(v))&&(this.placeDataLabels(),this.points.forEach(function(b){T=
	h(g,b.options.dataLabels);if(B=m(T.connectorWidth,1)){var c;G=b.connector;if((C=b.dataLabel)&&C._pos&&b.visible&&0<b.labelDistance){W=C._attr.visibility;if(c=!G)b.connector=G=k.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+b.colorIndex+(b.className?" "+b.className:"")).add(a.dataLabelsGroup),k.styledMode||G.attr({"stroke-width":B,stroke:T.connectorColor||b.color||"#666666"});G[c?"attr":"animate"]({d:b.getConnectorPath()});G.attr("visibility",W)}else G&&(b.connector=
	G.destroy())}}))}function q(){this.points.forEach(function(a){var c=a.dataLabel,f;c&&a.visible&&((f=c._pos)?(c.sideOverflow&&(c._attr.width=Math.max(c.getBBox().width-c.sideOverflow,0),c.css({width:c._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),c.shortened=!0),c.attr(c._attr),c[c.moved?"animate":"attr"](f),c.moved=!0):c&&c.attr({y:-9999}));delete a.distributeBox},this)}function A(a){var c=this.center,f=this.options,g=f.center,e=f.minSize||80,b=null!==
	f.size;if(!b){if(null!==g[0])var d=Math.max(c[2]-Math.max(a[1],a[3]),e);else d=Math.max(c[2]-a[1]-a[3],e),c[0]+=(a[3]-a[1])/2;null!==g[1]?d=n(d,e,c[2]-Math.max(a[0],a[2])):(d=n(d,e,c[2]-a[0]-a[2]),c[1]+=(a[0]-a[2])/2);d<c[2]?(c[2]=d,c[3]=Math.min(f.thickness?Math.max(0,d-2*f.thickness):Math.max(0,l(f.innerSize||0,d)),d),this.translate(c),this.drawDataLabels&&this.drawDataLabels()):b=!0}return b}var B=[],y={radialDistributionY:function(a){return a.top+a.distributeBox.pos},radialDistributionX:function(a,
	c,f,g){return a.getX(f<c.top+2||f>c.bottom-2?g:f,c.half,c)},justify:function(a,c,f){return f[0]+(a.half?-1:1)*(c+a.labelDistance)},alignToPlotEdges:function(a,c,f,g){a=a.getBBox().width;return c?a+g:f-a-g},alignToConnectors:function(a,c,f,g){var e=0,b;a.forEach(function(a){b=a.dataLabel.getBBox().width;b>e&&(e=b)});return c?e+g:f-e-g}};f.compose=function(c){a.compose(x);-1===B.indexOf(c)&&(B.push(c),c=c.prototype,c.dataLabelPositioners=y,c.alignDataLabel=v,c.drawDataLabels=p,c.placeDataLabels=q,c.verifyDataLabelOverflow=
	A)}})(p||(p={}));return p});J(a,"Extensions/OverlappingDataLabels.js",[a["Core/Chart/Chart.js"],a["Core/Utilities.js"]],function(a,q){function v(a,c){var h=!1;if(a){var m=a.newOpacity;a.oldOpacity!==m&&(a.alignAttr&&a.placed?(a[m?"removeClass":"addClass"]("highcharts-data-label-hidden"),h=!0,a.alignAttr.opacity=m,a[a.isOld?"animate":"attr"](a.alignAttr,null,function(){c.styledMode||a.css({pointerEvents:m?"auto":"none"})}),B(c,"afterHideOverlappingLabel")):a.attr({opacity:m}));a.isOld=!0}return h}
	var E=q.addEvent,B=q.fireEvent,C=q.isArray,F=q.isNumber,x=q.objectEach,u=q.pick;E(a,"render",function(){var a=this,c=[];(this.labelCollectors||[]).forEach(function(a){c=c.concat(a())});(this.yAxis||[]).forEach(function(a){a.stacking&&a.options.stackLabels&&!a.options.stackLabels.allowOverlap&&x(a.stacking.stacks,function(a){x(a,function(a){a.label&&c.push(a.label)})})});(this.series||[]).forEach(function(h){var m=h.options.dataLabels;h.visible&&(!1!==m.enabled||h._hasPointLabels)&&(m=function(h){return h.forEach(function(h){h.visible&&
	(C(h.dataLabels)?h.dataLabels:h.dataLabel?[h.dataLabel]:[]).forEach(function(f){var l=f.options;f.labelrank=u(l.labelrank,h.labelrank,h.shapeArgs&&h.shapeArgs.height);l.allowOverlap?(f.oldOpacity=f.opacity,f.newOpacity=1,v(f,a)):c.push(f)})})},m(h.nodes||[]),m(h.points))});this.hideOverlappingLabels(c)});a.prototype.hideOverlappingLabels=function(a){var c=this,h=a.length,m=c.renderer,l,p,f,n=!1;var u=function(a){var c,f=a.box?0:a.padding||0,k=c=0,g;if(a&&(!a.alignAttr||a.placed)){var e=a.alignAttr||
	{x:a.attr("x"),y:a.attr("y")};var b=a.parentGroup;a.width||(c=a.getBBox(),a.width=c.width,a.height=c.height,c=m.fontMetrics(null,a.element).h);var d=a.width-2*f;(g={left:"0",center:"0.5",right:"1"}[a.alignValue])?k=+g*d:F(a.x)&&Math.round(a.x)!==a.translateX&&(k=a.x-a.translateX);return{x:e.x+(b.translateX||0)+f-(k||0),y:e.y+(b.translateY||0)+f-c,width:a.width-2*f,height:a.height-2*f}}};for(p=0;p<h;p++)if(l=a[p])l.oldOpacity=l.opacity,l.newOpacity=1,l.absoluteBox=u(l);a.sort(function(a,c){return(c.labelrank||
	0)-(a.labelrank||0)});for(p=0;p<h;p++){var q=(u=a[p])&&u.absoluteBox;for(l=p+1;l<h;++l){var x=(f=a[l])&&f.absoluteBox;!q||!x||u===f||0===u.newOpacity||0===f.newOpacity||"hidden"===u.visibility||"hidden"===f.visibility||x.x>=q.x+q.width||x.x+x.width<=q.x||x.y>=q.y+q.height||x.y+x.height<=q.y||((u.labelrank<f.labelrank?u:f).newOpacity=0)}}a.forEach(function(a){v(a,c)&&(n=!0)});n&&B(c,"afterHideAllOverlappingLabels")}});J(a,"Core/Responsive.js",[a["Core/Utilities.js"]],function(a){var q=a.extend,v=a.find,
	E=a.isArray,B=a.isObject,C=a.merge,F=a.objectEach,x=a.pick,u=a.splat,n=a.uniqueKey,c;(function(a){var c=[];a.compose=function(a){-1===c.indexOf(a)&&(c.push(a),q(a.prototype,h.prototype));return a};var h=function(){function a(){}a.prototype.currentOptions=function(a){function c(a,h,l,m){var k;F(a,function(a,e){if(!m&&-1<f.collectionsWithUpdate.indexOf(e)&&h[e])for(a=u(a),l[e]=[],k=0;k<Math.max(a.length,h[e].length);k++)h[e][k]&&(void 0===a[k]?l[e][k]=h[e][k]:(l[e][k]={},c(a[k],h[e][k],l[e][k],m+1)));
	else B(a)?(l[e]=E(a)?[]:{},c(a,h[e]||{},l[e],m+1)):l[e]="undefined"===typeof h[e]?null:h[e]})}var f=this,h={};c(a,this.options,h,0);return h};a.prototype.matchResponsiveRule=function(a,c){var f=a.condition;(f.callback||function(){return this.chartWidth<=x(f.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=x(f.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=x(f.minWidth,0)&&this.chartHeight>=x(f.minHeight,0)}).call(this)&&c.push(a._id)};a.prototype.setResponsive=function(a,c){var f=this,h=this.options.responsive,
	l=this.currentResponsive,m=[];!c&&h&&h.rules&&h.rules.forEach(function(a){"undefined"===typeof a._id&&(a._id=n());f.matchResponsiveRule(a,m)},this);c=C.apply(void 0,m.map(function(a){return v((h||{}).rules||[],function(c){return c._id===a})}).map(function(a){return a&&a.chartOptions}));c.isResponsiveOptions=!0;m=m.toString()||void 0;m!==(l&&l.ruleIds)&&(l&&this.update(l.undoOptions,a,!0),m?(l=this.currentOptions(c),l.isResponsiveOptions=!0,this.currentResponsive={ruleIds:m,mergedOptions:c,undoOptions:l},
	this.update(c,a,!0)):this.currentResponsive=void 0)};return a}()})(c||(c={}));"";"";return c});J(a,"masters/highcharts.src.js",[a["Core/Globals.js"],a["Core/Utilities.js"],a["Core/Defaults.js"],a["Core/Animation/Fx.js"],a["Core/Animation/AnimationUtilities.js"],a["Core/Renderer/HTML/AST.js"],a["Core/FormatUtilities.js"],a["Core/Renderer/RendererUtilities.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Renderer/SVG/SVGRenderer.js"],a["Core/Renderer/HTML/HTMLElement.js"],a["Core/Renderer/HTML/HTMLRenderer.js"],
	a["Core/Axis/Axis.js"],a["Core/Axis/DateTimeAxis.js"],a["Core/Axis/LogarithmicAxis.js"],a["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],a["Core/Axis/Tick.js"],a["Core/Tooltip.js"],a["Core/Series/Point.js"],a["Core/Pointer.js"],a["Core/MSPointer.js"],a["Core/Legend/Legend.js"],a["Core/Chart/Chart.js"],a["Core/Axis/Stacking/StackingAxis.js"],a["Core/Axis/Stacking/StackItem.js"],a["Core/Series/Series.js"],a["Core/Series/SeriesRegistry.js"],a["Series/Column/ColumnSeries.js"],a["Series/Column/ColumnDataLabel.js"],
	a["Series/Pie/PieSeries.js"],a["Series/Pie/PieDataLabel.js"],a["Core/Series/DataLabel.js"],a["Core/Responsive.js"],a["Core/Color/Color.js"],a["Core/Time.js"]],function(a,q,A,E,B,C,F,x,u,n,c,h,m,l,p,f,D,G,H,K,y,t,w,k,g,e,b,d,r,z,I,N,P,O,U){a.animate=B.animate;a.animObject=B.animObject;a.getDeferredAnimation=B.getDeferredAnimation;a.setAnimation=B.setAnimation;a.stop=B.stop;a.timers=E.timers;a.AST=C;a.Axis=m;a.Chart=w;a.chart=w.chart;a.Fx=E;a.Legend=t;a.PlotLineOrBand=f;a.Point=H;a.Pointer=y.isRequired()?
	y:K;a.Series=e;a.StackItem=g;a.SVGElement=u;a.SVGRenderer=n;a.Tick=D;a.Time=U;a.Tooltip=G;a.Color=O;a.color=O.parse;h.compose(n);c.compose(u);a.defaultOptions=A.defaultOptions;a.getOptions=A.getOptions;a.time=A.defaultTime;a.setOptions=A.setOptions;a.dateFormat=F.dateFormat;a.format=F.format;a.numberFormat=F.numberFormat;a.addEvent=q.addEvent;a.arrayMax=q.arrayMax;a.arrayMin=q.arrayMin;a.attr=q.attr;a.clearTimeout=q.clearTimeout;a.correctFloat=q.correctFloat;a.createElement=q.createElement;a.css=
	q.css;a.defined=q.defined;a.destroyObjectProperties=q.destroyObjectProperties;a.discardElement=q.discardElement;a.distribute=x.distribute;a.erase=q.erase;a.error=q.error;a.extend=q.extend;a.extendClass=q.extendClass;a.find=q.find;a.fireEvent=q.fireEvent;a.getMagnitude=q.getMagnitude;a.getStyle=q.getStyle;a.inArray=q.inArray;a.isArray=q.isArray;a.isClass=q.isClass;a.isDOMElement=q.isDOMElement;a.isFunction=q.isFunction;a.isNumber=q.isNumber;a.isObject=q.isObject;a.isString=q.isString;a.keys=q.keys;
	a.merge=q.merge;a.normalizeTickInterval=q.normalizeTickInterval;a.objectEach=q.objectEach;a.offset=q.offset;a.pad=q.pad;a.pick=q.pick;a.pInt=q.pInt;a.relativeLength=q.relativeLength;a.removeEvent=q.removeEvent;a.seriesType=b.seriesType;a.splat=q.splat;a.stableSort=q.stableSort;a.syncTimeout=q.syncTimeout;a.timeUnits=q.timeUnits;a.uniqueKey=q.uniqueKey;a.useSerialIds=q.useSerialIds;a.wrap=q.wrap;r.compose(d);N.compose(e);l.compose(m);p.compose(m);I.compose(z);f.compose(m);P.compose(w);k.compose(m,
	w,e);return a});J(a,"Core/Axis/BrokenAxis.js",[a["Core/Axis/Stacking/StackItem.js"],a["Core/Utilities.js"]],function(a,q){var v=q.addEvent,E=q.find,B=q.fireEvent,C=q.isArray,F=q.isNumber,x=q.pick,u;(function(n){function c(){"undefined"!==typeof this.brokenAxis&&this.brokenAxis.setBreaks(this.options.breaks,!1)}function h(){this.brokenAxis&&this.brokenAxis.hasBreaks&&(this.options.ordinal=!1)}function m(){var a=this.brokenAxis;if(a&&a.hasBreaks){for(var c=this.tickPositions,f=this.tickPositions.info,
	k=[],g=0;g<c.length;g++)a.isInAnyBreak(c[g])||k.push(c[g]);this.tickPositions=k;this.tickPositions.info=f}}function l(){this.brokenAxis||(this.brokenAxis=new K(this))}function p(){var a=this.options.connectNulls,c=this.points,f=this.xAxis,k=this.yAxis;if(this.isDirty)for(var g=c.length;g--;){var e=c[g],b=!(null===e.y&&!1===a)&&(f&&f.brokenAxis&&f.brokenAxis.isInAnyBreak(e.x,!0)||k&&k.brokenAxis&&k.brokenAxis.isInAnyBreak(e.y,!0));e.visible=b?!1:!1!==e.options.visible}}function f(){this.drawBreaks(this.xAxis,
	["x"]);this.drawBreaks(this.yAxis,x(this.pointArrayMap,["y"]))}function u(a,c){var f=this,k=f.points,g,e,b,d;if(a&&a.brokenAxis&&a.brokenAxis.hasBreaks){var h=a.brokenAxis;c.forEach(function(c){g=h&&h.breakArray||[];e=a.isXAxis?a.min:x(f.options.threshold,a.min);k.forEach(function(f){d=x(f["stack"+c.toUpperCase()],f[c]);g.forEach(function(c){if(F(e)&&F(d)){b=!1;if(e<c.from&&d>c.to||e>c.from&&d<c.from)b="pointBreak";else if(e<c.from&&d>c.from&&d<c.to||e>c.from&&d>c.to&&d<c.from)b="pointInBreak";b&&
	B(a,b,{point:f,brk:c})}})})})}}function q(){var c=this.currentDataGrouping,f=c&&c.gapSize;c=this.points.slice();var h=this.yAxis,k=this.options.gapSize,g=c.length-1,e;if(k&&0<g)for("value"!==this.options.gapUnit&&(k*=this.basePointRange),f&&f>k&&f>=this.basePointRange&&(k=f),e=void 0;g--;)e&&!1!==e.visible||(e=c[g+1]),f=c[g],!1!==e.visible&&!1!==f.visible&&(e.x-f.x>k&&(e=(f.x+e.x)/2,c.splice(g+1,0,{isNull:!0,x:e}),h.stacking&&this.options.stacking&&(e=h.stacking.stacks[this.stackKey][e]=new a(h,h.options.stackLabels,
	!1,e,this.stack),e.total=0)),e=f);return this.getGraphPath(c)}var A=[];n.compose=function(a,n){-1===A.indexOf(a)&&(A.push(a),a.keepProps.push("brokenAxis"),v(a,"init",l),v(a,"afterInit",c),v(a,"afterSetTickPositions",m),v(a,"afterSetOptions",h));if(-1===A.indexOf(n)){A.push(n);var t=n.prototype;t.drawBreaks=u;t.gappedPath=q;v(n,"afterGeneratePoints",p);v(n,"afterRender",f)}return a};var K=function(){function a(a){this.hasBreaks=!1;this.axis=a}a.isInBreak=function(a,c){var f=a.repeat||Infinity,g=a.from,
	e=a.to-a.from;c=c>=g?(c-g)%f:f-(g-c)%f;return a.inclusive?c<=e:c<e&&0!==c};a.lin2Val=function(c){var f=this.brokenAxis;f=f&&f.breakArray;if(!f||!F(c))return c;var k;for(k=0;k<f.length;k++){var g=f[k];if(g.from>=c)break;else g.to<c?c+=g.len:a.isInBreak(g,c)&&(c+=g.len)}return c};a.val2Lin=function(c){var f=this.brokenAxis;f=f&&f.breakArray;if(!f||!F(c))return c;var k=c,g;for(g=0;g<f.length;g++){var e=f[g];if(e.to<=c)k-=e.len;else if(e.from>=c)break;else if(a.isInBreak(e,c)){k-=c-e.from;break}}return k};
	a.prototype.findBreakAt=function(a,c){return E(c,function(c){return c.from<a&&a<c.to})};a.prototype.isInAnyBreak=function(c,f){var k=this.axis,g=k.options.breaks||[],e=g.length,b;if(e&&F(c)){for(;e--;)if(a.isInBreak(g[e],c)){var d=!0;b||(b=x(g[e].showPoints,!k.isXAxis))}var h=d&&f?d&&!b:d}return h};a.prototype.setBreaks=function(c,f){var k=this,g=k.axis,e=C(c)&&!!c.length;g.isDirty=k.hasBreaks!==e;k.hasBreaks=e;g.options.breaks=g.userOptions.breaks=c;g.forceRedraw=!0;g.series.forEach(function(a){a.isDirty=
	!0});e||g.val2lin!==a.val2Lin||(delete g.val2lin,delete g.lin2val);e&&(g.userOptions.ordinal=!1,g.lin2val=a.lin2Val,g.val2lin=a.val2Lin,g.setExtremes=function(a,c,e,f,h){if(k.hasBreaks){for(var b=this.options.breaks||[],d;d=k.findBreakAt(a,b);)a=d.to;for(;d=k.findBreakAt(c,b);)c=d.from;c<a&&(c=a)}g.constructor.prototype.setExtremes.call(this,a,c,e,f,h)},g.setAxisTranslation=function(){g.constructor.prototype.setAxisTranslation.call(this);k.unitLength=void 0;if(k.hasBreaks){var b=g.options.breaks||
	[],c=[],e=[],f=x(g.pointRangePadding,0),h=0,l,m=g.userMin||g.min,p=g.userMax||g.max,n;b.forEach(function(b){l=b.repeat||Infinity;F(m)&&F(p)&&(a.isInBreak(b,m)&&(m+=b.to%l-m%l),a.isInBreak(b,p)&&(p-=p%l-b.from%l))});b.forEach(function(a){t=a.from;l=a.repeat||Infinity;if(F(m)&&F(p)){for(;t-l>m;)t-=l;for(;t<m;)t+=l;for(n=t;n<p;n+=l)c.push({value:n,move:"in"}),c.push({value:n+a.to-a.from,move:"out",size:a.breakSize})}});c.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?
	0:1):a.value-b.value});var u=0;var t=m;c.forEach(function(a){u+="in"===a.move?1:-1;1===u&&"in"===a.move&&(t=a.value);0===u&&F(t)&&(e.push({from:t,to:a.value,len:a.value-t-(a.size||0)}),h+=a.value-t-(a.size||0))});k.breakArray=e;F(m)&&F(p)&&F(g.min)&&(k.unitLength=p-m-h+f,B(g,"afterBreaks"),g.staticScale?g.transA=g.staticScale:k.unitLength&&(g.transA*=(p-g.min+f)/k.unitLength),f&&(g.minPixelPadding=g.transA*(g.minPointOffset||0)),g.min=m,g.max=p)}});x(f,!0)&&g.chart.redraw()};return a}();n.Additions=
	K})(u||(u={}));return u});J(a,"masters/modules/broken-axis.src.js",[a["Core/Globals.js"],a["Core/Axis/BrokenAxis.js"]],function(a,q){q.compose(a.Axis,a.Series)});J(a,"Extensions/DataGrouping/ApproximationRegistry.js",[],function(){return{}});J(a,"Extensions/DataGrouping/ApproximationDefaults.js",[a["Extensions/DataGrouping/ApproximationRegistry.js"],a["Core/Utilities.js"]],function(a,q){function v(a){var c=a.length;a=E(a);u(a)&&c&&(a=F(a/c));return a}function E(a){var c=a.length;if(!c&&a.hasNulls)var h=
	null;else if(c)for(h=0;c--;)h+=a[c];return h}var B=q.arrayMax,C=q.arrayMin,F=q.correctFloat,x=q.extend,u=q.isNumber;q={average:v,averages:function(){var a=[];[].forEach.call(arguments,function(c){a.push(v(c))});return"undefined"===typeof a[0]?void 0:a},close:function(a){return a.length?a[a.length-1]:a.hasNulls?null:void 0},high:function(a){return a.length?B(a):a.hasNulls?null:void 0},hlc:function(n,c,h){n=a.high(n);c=a.low(c);h=a.close(h);if(u(n)||u(c)||u(h))return[n,c,h]},low:function(a){return a.length?
	C(a):a.hasNulls?null:void 0},ohlc:function(n,c,h,m){n=a.open(n);c=a.high(c);h=a.low(h);m=a.close(m);if(u(n)||u(c)||u(h)||u(m))return[n,c,h,m]},open:function(a){return a.length?a[0]:a.hasNulls?null:void 0},range:function(n,c){n=a.low(n);c=a.high(c);if(u(n)||u(c))return[n,c];if(null===n&&null===c)return null},sum:E};x(a,q);return q});J(a,"Extensions/DataGrouping/DataGroupingDefaults.js",[],function(){return{common:{groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %b %e, %H:%M:%S.%L","%A, %b %e, %H:%M:%S.%L",
	"-%H:%M:%S.%L"],second:["%A, %b %e, %H:%M:%S","%A, %b %e, %H:%M:%S","-%H:%M:%S"],minute:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],hour:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],day:["%A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],week:["Week from %A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],month:["%B %Y","%B","-%B %Y"],year:["%Y","%Y","-%Y"]}},seriesSpecific:{line:{},spline:{},area:{},areaspline:{},arearange:{},column:{groupPixelWidth:10},columnrange:{groupPixelWidth:10},candlestick:{groupPixelWidth:10},
	ohlc:{groupPixelWidth:5},hlc:{groupPixelWidth:5},heikinashi:{groupPixelWidth:10}},units:[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1]],["week",[1]],["month",[1,3,6]],["year",null]]}});J(a,"Extensions/DataGrouping/DataGroupingAxisComposition.js",[a["Extensions/DataGrouping/DataGroupingDefaults.js"],a["Core/Utilities.js"]],function(a,q){function v(a){var c=this,h=c.series;h.forEach(function(a){a.groupPixelWidth=
	void 0});h.forEach(function(f){f.groupPixelWidth=c.getGroupPixelWidth&&c.getGroupPixelWidth();f.groupPixelWidth&&(f.hasProcessed=!0);f.applyGrouping(!!a.hasExtremesChanged)})}function E(){for(var c=this.series,h=c.length,p=0,f=!1,u,q;h--;)if(q=c[h].options.dataGrouping)if(p=Math.max(p,n(q.groupPixelWidth,a.common.groupPixelWidth)),u=(c[h].processedXData||c[h].data).length,c[h].groupPixelWidth||u>this.chart.plotSizeX/p||u&&q.forced)f=!0;return f?p:0}function B(){this.series.forEach(function(a){a.hasProcessed=
	!1})}function C(a,c){var l;c=n(c,!0);a||(a={forced:!1,units:null});if(this instanceof h)for(l=this.series.length;l--;)this.series[l].update({dataGrouping:a},!1);else this.chart.options.series.forEach(function(c){c.dataGrouping="boolean"===typeof a?a:u(a,c.dataGrouping)});this.ordinal&&(this.ordinal.slope=void 0);c&&this.chart.redraw()}var F=q.addEvent,x=q.extend,u=q.merge,n=q.pick,c=[],h;return{compose:function(a){h=a;-1===c.indexOf(a)&&(c.push(a),F(a,"afterSetScale",B),F(a,"postProcessData",v),x(a.prototype,
	{applyGrouping:v,getGroupPixelWidth:E,setDataGrouping:C}))}}});J(a,"Extensions/DataGrouping/DataGroupingSeriesComposition.js",[a["Extensions/DataGrouping/ApproximationRegistry.js"],a["Extensions/DataGrouping/DataGroupingDefaults.js"],a["Core/Axis/DateTimeAxis.js"],a["Core/Defaults.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C){function v(a){var c=this.chart,g=this.options.dataGrouping,e=!1!==this.allowDG&&g&&K(g.enabled,c.options.isStock),b=this.visible||!c.options.chart.ignoreHiddenSeries,
	d=this.currentDataGrouping,h=!1;e&&!this.requireSorting&&(this.requireSorting=h=!0);a=!1===!(this.isCartesian&&!this.isDirty&&!this.xAxis.isDirty&&!this.yAxis.isDirty&&!a)||!e;h&&(this.requireSorting=!1);if(!a){this.destroyGroupedData();var l=g.groupAll?this.xData:this.processedXData,n=g.groupAll?this.yData:this.processedYData;e=c.plotSizeX;a=this.xAxis;var u=a.options.ordinal,t=this.groupPixelWidth;h=void 0;if(t&&l&&l.length&&e){this.isDirty=h=!0;this.points=null;var w=a.getExtremes();var y=w.min;
	w=w.max;u=u&&a.ordinal&&a.ordinal.getGroupIntervalFactor(y,w,this)||1;e=a.getTimeTicks(A.Additions.prototype.normalizeTimeTickInterval(t*(w-y)/e*u,g.units||q.units),Math.min(y,l[0]),Math.max(w,l[l.length-1]),a.options.startOfWeek,l,this.closestPointRange);t=m.groupData.apply(this,[l,n,e,g.approximation]);l=t.groupedXData;n=t.groupedYData;u=0;g&&g.smoothed&&l.length&&(g.firstAnchor="firstPoint",g.anchor="middle",g.lastAnchor="lastPoint",f(32,!1,c,{"dataGrouping.smoothed":"use dataGrouping.anchor"}));
	c=l;var v=this.options.dataGrouping;y=this.currentDataGrouping&&this.currentDataGrouping.gapSize;if(v&&this.xData&&y&&this.groupMap){var D=c.length-1;var x=v.anchor;var B=K(v.firstAnchor,x);v=K(v.lastAnchor,x);if(x&&"start"!==x){var C=y*{middle:.5,end:1}[x];for(x=c.length-1;x--&&0<x;)c[x]+=C}if(B&&"start"!==B&&this.xData[0]>=c[0]){x=this.groupMap[0].start;C=this.groupMap[0].length;var E=void 0;G(x)&&G(C)&&(E=x+(C-1));c[0]={middle:c[0]+.5*y,end:c[0]+y,firstPoint:this.xData[0],lastPoint:E&&this.xData[E]}[B]}v&&
	"start"!==v&&y&&c[D]>=w-y&&(w=this.groupMap[this.groupMap.length-1].start,c[D]={middle:c[D]+.5*y,end:c[D]+y,firstPoint:w&&this.xData[w],lastPoint:this.xData[this.xData.length-1]}[v])}for(w=1;w<e.length;w++)e.info.segmentStarts&&-1!==e.info.segmentStarts.indexOf(w)||(u=Math.max(e[w]-e[w-1],u));w=e.info;w.gapSize=u;this.closestPointRange=e.info.totalRange;this.groupMap=t.groupMap;if(b){b=l;if(p(b[0])&&G(a.min)&&G(a.dataMin)&&b[0]<a.min){if(!p(a.options.min)&&a.min<=a.dataMin||a.min===a.dataMin)a.min=
	Math.min(b[0],a.min);a.dataMin=Math.min(b[0],a.dataMin)}if(p(b[b.length-1])&&G(a.max)&&G(a.dataMax)&&b[b.length-1]>a.max){if(!p(a.options.max)&&G(a.dataMax)&&a.max>=a.dataMax||a.max===a.dataMax)a.max=Math.max(b[b.length-1],a.max);a.dataMax=Math.max(b[b.length-1],a.dataMax)}}g.groupAll&&(this.allGroupedData=n,g=this.cropData(l,n,a.min,a.max,1),l=g.xData,n=g.yData,this.cropStart=g.start);this.processedXData=l;this.processedYData=n}else this.groupMap=null;this.hasGroupedData=h;this.currentDataGrouping=
	w;this.preventGraphAnimation=(d&&d.totalRange)!==(w&&w.totalRange)}}function x(){this.groupedData&&(this.groupedData.forEach(function(a,c){a&&(this.groupedData[c]=a.destroy?a.destroy():null)},this),this.groupedData.length=0)}function u(){y.apply(this);this.destroyGroupedData();this.groupedData=this.hasGroupedData?this.points:null}function n(){return this.is("arearange")?"range":this.is("ohlc")?"ohlc":this.is("hlc")?"hlc":this.is("column")?"sum":"average"}function c(c,f,g,e){var b=this,d=b.data,h=
	b.options&&b.options.data,k=[],l=[],m=[],n=c.length,u=!!f,t=[],q=b.pointArrayMap,w=q&&q.length,y=["x"].concat(q||["y"]),v=this.options.dataGrouping&&this.options.dataGrouping.groupAll,x=0,D=0;e="function"===typeof e?e:e&&a[e]?a[e]:a[b.getDGApproximation&&b.getDGApproximation()||"average"];if(w)for(var A=q.length;A--;)t.push([]);else t.push([]);A=w||1;for(var B=0;B<=n;B++)if(!(c[B]<g[0])){for(;"undefined"!==typeof g[x+1]&&c[B]>=g[x+1]||B===n;){var C=g[x];b.dataGroupInfo={start:v?D:b.cropStart+D,length:t[0].length};
	var E=e.apply(b,t);b.pointClass&&!p(b.dataGroupInfo.options)&&(b.dataGroupInfo.options=H(b.pointClass.prototype.optionsToObject.call({series:b},b.options.data[b.cropStart+D])),y.forEach(function(a){delete b.dataGroupInfo.options[a]}));"undefined"!==typeof E&&(k.push(C),l.push(E),m.push(b.dataGroupInfo));D=B;for(C=0;C<A;C++)t[C].length=0,t[C].hasNulls=!1;x+=1;if(B===n)break}if(B===n)break;if(q){C=b.options.dataGrouping&&b.options.dataGrouping.groupAll?B:b.cropStart+B;E=d&&d[C]||b.pointClass.prototype.applyOptions.apply({series:b},
	[h[C]]);var F=void 0;for(C=0;C<w;C++)F=E[q[C]],G(F)?t[C].push(F):null===F&&(t[C].hasNulls=!0)}else C=u?f[B]:null,G(C)?t[0].push(C):null===C&&(t[0].hasNulls=!0)}return{groupedXData:k,groupedYData:l,groupMap:m}}function h(a){a=a.options;var c=this.type,g=this.chart.options.plotOptions,e=this.useCommonDataGrouping&&q.common,b=q.seriesSpecific,d=E.defaultOptions.plotOptions[c].dataGrouping;if(g&&(b[c]||e)){var f=this.chart.rangeSelector;d||(d=H(q.common,b[c]));a.dataGrouping=H(e,d,g.series&&g.series.dataGrouping,
	g[c].dataGrouping,this.userOptions.dataGrouping,!a.isInternal&&f&&G(f.selected)&&f.buttonOptions[f.selected].dataGrouping)}}var m=B.series.prototype,l=C.addEvent,p=C.defined,f=C.error,D=C.extend,G=C.isNumber,H=C.merge,K=C.pick,y=m.generatePoints,t=[];return{compose:function(a){var k=a.prototype.pointClass;-1===t.indexOf(k)&&(t.push(k),l(k,"update",function(){if(this.dataGroup)return f(24,!1,this.series.chart),!1}));-1===t.indexOf(a)&&(t.push(a),l(a,"afterSetOptions",h),l(a,"destroy",x),D(a.prototype,
	{applyGrouping:v,destroyGroupedData:x,generatePoints:u,getDGApproximation:n,groupData:c}))},groupData:c}});J(a,"Extensions/DataGrouping/DataGrouping.js",[a["Extensions/DataGrouping/DataGroupingAxisComposition.js"],a["Extensions/DataGrouping/DataGroupingDefaults.js"],a["Extensions/DataGrouping/DataGroupingSeriesComposition.js"],a["Core/FormatUtilities.js"],a["Core/Utilities.js"]],function(a,q,A,E,B){function v(a){var c=this.chart,h=c.time,p=a.labelConfig,f=p.series,v=f.tooltipOptions,x=f.options.dataGrouping,
	A=f.xAxis,B=v.xDateFormat,y=v[a.isFooter?"footerFormat":"headerFormat"];if(A&&"datetime"===A.options.type&&x&&n(p.key)){var t=f.currentDataGrouping;x=x.dateTimeLabelFormats||q.common.dateTimeLabelFormats;if(t)if(v=x[t.unitName],1===t.count)B=v[0];else{B=v[1];var w=v[2]}else!B&&x&&A.dateTime&&(B=A.dateTime.getXDateFormat(p.x,v.dateTimeLabelFormats));B=h.dateFormat(B,p.key);w&&(B+=h.dateFormat(w,p.key+t.totalRange-1));f.chart.styledMode&&(y=this.styledModeFormat(y));a.text=F(y,{point:u(p.point,{key:B}),
	series:f},c);a.preventDefault()}}var F=E.format,x=B.addEvent,u=B.extend,n=B.isNumber,c=[];E={compose:function(h,m,l){a.compose(h);A.compose(m);-1===c.indexOf(l)&&(c.push(l),x(l,"headerFormatter",v))},groupData:A.groupData};"";"";return E});J(a,"masters/modules/datagrouping.src.js",[a["Core/Globals.js"],a["Extensions/DataGrouping/ApproximationDefaults.js"],a["Extensions/DataGrouping/ApproximationRegistry.js"],a["Extensions/DataGrouping/DataGrouping.js"]],function(a,q,A,E){a.dataGrouping={approximationDefaults:q,
	approximations:A};E.compose(a.Axis,a.Series,a.Tooltip)});J(a,"Series/DataModifyComposition.js",[a["Core/Axis/Axis.js"],a["Core/Series/Point.js"],a["Core/Series/Series.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=q.prototype.tooltipFormatter,C=E.addEvent,F=E.arrayMax,x=E.arrayMin,u=E.correctFloat,n=E.defined,c=E.isArray,h=E.isNumber,m=E.isString,l=E.pick,p;(function(a){function f(a,b,c){this.isXAxis||(this.series.forEach(function(c){"compare"===a&&"boolean"!==typeof b?c.setCompare(b,!1):"cumulative"!==
	a||m(b)||c.setCumulative(b,!1)}),l(c,!0)&&this.chart.redraw())}function p(a){var b=this,c=b.series.chart.numberFormatter,d=function(d){a=a.replace("{point."+d+"}",(0<b[d]&&"change"===d?"+":"")+c(b[d],l(b.series.tooltipOptions.changeDecimals,2)))};n(b.change)&&d("change");n(b.cumulativeSum)&&d("cumulativeSum");return v.apply(this,[a])}function q(){var a=this.options.compare;if("percent"===a||"value"===a||this.options.cumulative){var c=new b(this);"percent"===a||"value"===a?c.initCompare(a):c.initCumulative()}this.dataModify=
	c}function A(a){a=a.dataExtremes;var d=a.activeYData;if(this.dataModify&&a){var e=void 0;this.options.compare?e=[this.dataModify.modifyValue(a.dataMin),this.dataModify.modifyValue(a.dataMax)]:this.options.cumulative&&c(d)&&2<=d.length&&(e=b.getCumulativeExtremes(d));e&&(a.dataMin=x(e),a.dataMax=F(e))}}function y(a,b){this.options.compare=this.userOptions.compare=a;this.update({},l(b,!0));!this.dataModify||"value"!==a&&"percent"!==a?this.points.forEach(function(a){delete a.change}):this.dataModify.initCompare(a)}
	function t(){if(this.xAxis&&this.processedYData&&this.dataModify){var a=this.processedXData,b=this.processedYData,c=b.length,e=!0===this.options.compareStart?0:1,g=-1,f;this.pointArrayMap&&(g=this.pointArrayMap.indexOf(this.options.pointValKey||this.pointValKey||"y"));for(f=0;f<c-e;f++){var k=b[f]&&-1<g?b[f][g]:b[f];if(h(k)&&0!==k&&a[f+e]>=(this.xAxis.min||0)){this.dataModify.compareValue=k;break}}}}function w(a,b){this.setModifier("compare",a,b)}function k(a,b){a=l(a,!1);this.options.cumulative=
	this.userOptions.cumulative=a;this.update({},l(b,!0));this.dataModify?this.dataModify.initCumulative():this.points.forEach(function(a){delete a.cumulativeSum})}function g(a,b){this.setModifier("cumulative",a,b)}var e=[];a.compose=function(a,b,c){if(-1===e.indexOf(a)){e.push(a);var d=a.prototype;d.setCompare=y;d.setCumulative=k;C(a,"afterInit",q);C(a,"afterGetExtremes",A);C(a,"afterProcessData",t)}-1===e.indexOf(b)&&(e.push(b),b=b.prototype,b.setCompare=w,b.setModifier=f,b.setCumulative=g);-1===e.indexOf(c)&&
	(e.push(c),c.prototype.tooltipFormatter=p);return a};var b=function(){function a(a){this.series=a}a.prototype.modifyValue=function(){return 0};a.getCumulativeExtremes=function(a){var b=Infinity,c=-Infinity;a.reduce(function(a,d){d=a+d;b=Math.min(b,d,a);c=Math.max(c,d,a);return d});return[b,c]};a.prototype.initCompare=function(a){this.modifyValue=function(b,c){null===b&&(b=0);var d=this.compareValue;return"undefined"!==typeof b&&"undefined"!==typeof d?(b="value"===a?b-d:b/d*100-(100===this.series.options.compareBase?
	0:100),"undefined"!==typeof c&&(c=this.series.points[c])&&(c.change=b),b):0}};a.prototype.initCumulative=function(){this.modifyValue=function(a,b){null===a&&(a=0);if(void 0!==a&&void 0!==b){var c=0<b?this.series.points[b-1]:null;c&&c.cumulativeSum&&(a=u(c.cumulativeSum+a));if(b=this.series.points[b])b.cumulativeSum=a;return a}return 0}};return a}();a.Additions=b})(p||(p={}));"";return p});J(a,"Core/Axis/NavigatorAxisComposition.js",[a["Core/Globals.js"],a["Core/Utilities.js"]],function(a,q){function v(){this.navigatorAxis||
	(this.navigatorAxis=new h(this))}function E(a){var c=this.chart.options,h=c.navigator,f=this.navigatorAxis,m=c.chart.zooming.pinchType,n=c.rangeSelector;c=c.chart.zooming.type;this.isXAxis&&(h&&h.enabled||n&&n.enabled)&&("y"===c?a.zoomed=!1:(!B&&"xy"===c||B&&"xy"===m)&&this.options.range&&(h=f.previousZoom,x(a.newMin)?f.previousZoom=[this.min,this.max]:h&&(a.newMin=h[0],a.newMax=h[1],f.previousZoom=void 0)));"undefined"!==typeof a.zoomed&&a.preventDefault()}var B=a.isTouchDevice,C=q.addEvent,F=q.correctFloat,
	x=q.defined,u=q.isNumber,n=q.pick,c=[],h=function(){function a(a){this.axis=a}a.compose=function(a){-1===c.indexOf(a)&&(c.push(a),a.keepProps.push("navigatorAxis"),C(a,"init",v),C(a,"zoom",E))};a.prototype.destroy=function(){this.axis=void 0};a.prototype.toFixedRange=function(a,c,f,h){var l=this.axis,m=l.chart;a=n(f,l.translate(a,!0,!l.horiz));c=n(h,l.translate(c,!0,!l.horiz));m=m&&m.fixedRange;l=(l.pointRange||0)/2;var p=m&&(c-a)/m;x(f)||(a=F(a+l));x(h)||(c=F(c-l));.7<p&&1.3>p&&(h?a=c-m:c=a+m);u(a)&&
	u(c)||(a=c=void 0);return{min:a,max:c}};return a}();return h});J(a,"Stock/Navigator/NavigatorDefaults.js",[a["Core/Color/Color.js"],a["Core/Series/SeriesRegistry.js"]],function(a,q){a=a.parse;q=q.seriesTypes;q={height:40,margin:25,maskInside:!0,handles:{width:7,height:15,symbols:["navigator-handle","navigator-handle"],enabled:!0,lineWidth:1,backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:a("#6685c2").setOpacity(.3).get(),outlineColor:"#cccccc",outlineWidth:1,series:{type:"undefined"===typeof q.areaspline?
	"line":"areaspline",fillOpacity:.05,lineWidth:1,compare:null,dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,firstAnchor:"firstPoint",anchor:"middle",lastAnchor:"lastPoint",units:[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2,3,4]],["week",[1,2,3]],["month",[1,3,6]],["year",null]]},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",
	lineColor:null,marker:{enabled:!1},threshold:null},xAxis:{overscroll:0,className:"highcharts-navigator-xaxis",tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",style:{color:"#999999"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}};"";return q});J(a,"Stock/Navigator/NavigatorSymbols.js",
	[],function(){return{"navigator-handle":function(a,q,A,E,B){void 0===B&&(B={});a=B.width?B.width/2:A;q=Math.round(a/3)+.5;E=B.height||E;return[["M",-a-1,.5],["L",a,.5],["L",a,E+.5],["L",-a-1,E+.5],["L",-a-1,.5],["M",-q,4],["L",-q,E-3],["M",q-1,4],["L",q-1,E-3]]}}});J(a,"Stock/Navigator/NavigatorComposition.js",[a["Core/Defaults.js"],a["Core/Globals.js"],a["Core/Axis/NavigatorAxisComposition.js"],a["Stock/Navigator/NavigatorDefaults.js"],a["Stock/Navigator/NavigatorSymbols.js"],a["Core/Renderer/RendererRegistry.js"],
	a["Core/Utilities.js"]],function(a,q,A,E,B,C,F){function v(){this.navigator&&this.navigator.setBaseSeries(null,!1)}function u(){var a=this.legend,b=this.navigator;if(b){var c=a&&a.options;var g=b.xAxis;var f=b.yAxis;var h=b.scrollbarHeight;this.inverted?(b.left=b.opposite?this.chartWidth-h-b.height:this.spacing[3]+h,b.top=this.plotTop+h):(b.left=w(g.left,this.plotLeft+h),b.top=b.navigatorOptions.top||this.chartHeight-b.height-h-this.spacing[2]-(this.rangeSelector&&this.extraBottomMargin?this.rangeSelector.getHeight():
	0)-(c&&"bottom"===c.verticalAlign&&"proximate"!==c.layout&&c.enabled&&!c.floating?a.legendHeight+w(c.margin,10):0)-(this.titleOffset?this.titleOffset[2]:0));g&&f&&(this.inverted?g.options.left=f.options.left=b.left:g.options.top=f.options.top=b.top,g.setAxisSize(),f.setAxisSize())}}function n(a){this.navigator||this.scroller||!this.options.navigator.enabled&&!this.options.scrollbar.enabled||(this.scroller=this.navigator=new g(this),w(a.redraw,!0)&&this.redraw(a.animation))}function c(){var a=this.options;
	if(a.navigator.enabled||a.scrollbar.enabled)this.scroller=this.navigator=new g(this)}function h(){var a=this.options,b=a.navigator,c=a.rangeSelector;if((b&&b.enabled||c&&c.enabled)&&(!G&&"x"===a.chart.zooming.type||G&&"x"===a.chart.zooming.pinchType))return!1}function m(a){var b=a.navigator;b&&a.xAxis[0]&&(a=a.xAxis[0].getExtremes(),b.render(a.min,a.max))}function l(a){var b=a.options.navigator||{},c=a.options.scrollbar||{};this.navigator||this.scroller||!b.enabled&&!c.enabled||(t(!0,this.options.navigator,
	b),t(!0,this.options.scrollbar,c),delete a.options.navigator,delete a.options.scrollbar)}function p(){this.chart.navigator&&!this.options.isInternal&&this.chart.navigator.setBaseSeries(null,!1)}var f=a.defaultOptions,D=a.setOptions,G=q.isTouchDevice,H=C.getRendererType,K=F.addEvent,y=F.extend,t=F.merge,w=F.pick,k=[],g;return{compose:function(a,b,d,r){A.compose(a);g=d;-1===k.indexOf(b)&&(k.push(b),b.prototype.callbacks.push(m),K(b,"afterAddSeries",v),K(b,"afterSetChartSize",u),K(b,"afterUpdate",n),
	K(b,"beforeRender",c),K(b,"beforeShowResetZoom",h),K(b,"update",l));-1===k.indexOf(r)&&(k.push(r),K(r,"afterUpdate",p));-1===k.indexOf(H)&&(k.push(H),y(H().prototype.symbols,B));-1===k.indexOf(D)&&(k.push(D),y(f,{navigator:E}))}}});J(a,"Core/Axis/ScrollbarAxis.js",[a["Core/Utilities.js"]],function(a){var q=a.addEvent,v=a.defined,E=a.pick;return function(){function a(){}a.compose=function(A,B){if(-1===a.composed.indexOf(A))a.composed.push(A);else return A;var x=function(a){var n=E(a.options&&a.options.min,
	a.min),c=E(a.options&&a.options.max,a.max);return{axisMin:n,axisMax:c,scrollMin:v(a.dataMin)?Math.min(n,a.min,a.dataMin,E(a.threshold,Infinity)):n,scrollMax:v(a.dataMax)?Math.max(c,a.max,a.dataMax,E(a.threshold,-Infinity)):c}};q(A,"afterInit",function(){var a=this;a.options&&a.options.scrollbar&&a.options.scrollbar.enabled&&(a.options.scrollbar.vertical=!a.horiz,a.options.startOnTick=a.options.endOnTick=!1,a.scrollbar=new B(a.chart.renderer,a.options.scrollbar,a.chart),q(a.scrollbar,"changed",function(n){var c=
	x(a),h=c.axisMax,m=c.scrollMin,l=c.scrollMax-m;v(c.axisMin)&&v(h)&&(a.horiz&&!a.reversed||!a.horiz&&a.reversed?(c=m+l*this.to,m+=l*this.from):(c=m+l*(1-this.from),m+=l*(1-this.to)),this.shouldUpdateExtremes(n.DOMType)?a.setExtremes(m,c,!0,"mousemove"!==n.DOMType&&"touchmove"!==n.DOMType,n):this.setRange(this.from,this.to))}))});q(A,"afterRender",function(){var a=x(this),n=a.scrollMin,c=a.scrollMax;a=this.scrollbar;var h=this.axisTitleMargin+(this.titleOffset||0),m=this.chart.scrollbarsOffsets,l=this.options.margin||
	0;a&&(this.horiz?(this.opposite||(m[1]+=h),a.position(this.left,this.top+this.height+2+m[1]-(this.opposite?l:0),this.width,this.height),this.opposite||(m[1]+=l),h=1):(this.opposite&&(m[0]+=h),a.position(a.options.opposite?this.left+this.width+2+m[0]-(this.opposite?0:l):this.opposite?0:l,this.top,this.width,this.height),this.opposite&&(m[0]+=l),h=0),m[h]+=a.size+a.options.margin,isNaN(n)||isNaN(c)||!v(this.min)||!v(this.max)||this.min===this.max?a.setRange(0,1):(m=(this.min-n)/(c-n),n=(this.max-n)/
	(c-n),this.horiz&&!this.reversed||!this.horiz&&this.reversed?a.setRange(m,n):a.setRange(1-n,1-m)))});q(A,"afterGetOffset",function(){var a=this.scrollbar&&!this.scrollbar.options.opposite;a=this.horiz?2:a?3:1;var n=this.scrollbar;n&&(this.chart.scrollbarsOffsets=[0,0],this.chart.axisOffset[a]+=n.size+n.options.margin)});return A};a.composed=[];return a}()});J(a,"Stock/Scrollbar/ScrollbarDefaults.js",[a["Core/Globals.js"]],function(a){return{height:a.isTouchDevice?20:14,barBorderRadius:0,buttonBorderRadius:0,
	liveRedraw:void 0,margin:10,minWidth:6,opposite:!0,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:1,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"#333333",trackBackgroundColor:"#f2f2f2",trackBorderColor:"#f2f2f2",trackBorderWidth:1}});J(a,"Stock/Scrollbar/Scrollbar.js",[a["Core/Defaults.js"],a["Core/Globals.js"],a["Core/Axis/ScrollbarAxis.js"],a["Stock/Scrollbar/ScrollbarDefaults.js"],a["Core/Utilities.js"]],
	function(a,q,A,E,B){var v=a.defaultOptions,F=B.addEvent,x=B.correctFloat,u=B.defined,n=B.destroyObjectProperties,c=B.fireEvent,h=B.merge,m=B.pick,l=B.removeEvent;a=function(){function a(a,c,h){this._events=[];this.chart=void 0;this.from=this.chartY=this.chartX=0;this.scrollbar=this.renderer=this.options=this.group=void 0;this.scrollbarButtons=[];this.scrollbarGroup=void 0;this.scrollbarLeft=0;this.scrollbarRifles=void 0;this.scrollbarStrokeWidth=1;this.to=this.size=this.scrollbarTop=0;this.track=
	void 0;this.trackBorderWidth=1;this.userOptions=void 0;this.y=this.x=0;this.init(a,c,h)}a.compose=function(c){A.compose(c,a)};a.swapXY=function(a,c){c&&a.forEach(function(a){for(var c=a.length,f,h=0;h<c;h+=2)f=a[h+1],"number"===typeof f&&(a[h+1]=a[h+2],a[h+2]=f)});return a};a.prototype.addEvents=function(){var a=this.options.inverted?[1,0]:[0,1],c=this.scrollbarButtons,h=this.scrollbarGroup.element,l=this.track.element,m=this.mouseDownHandler.bind(this),p=this.mouseMoveHandler.bind(this),n=this.mouseUpHandler.bind(this);
	a=[[c[a[0]].element,"click",this.buttonToMinClick.bind(this)],[c[a[1]].element,"click",this.buttonToMaxClick.bind(this)],[l,"click",this.trackClick.bind(this)],[h,"mousedown",m],[h.ownerDocument,"mousemove",p],[h.ownerDocument,"mouseup",n]];q.hasTouch&&a.push([h,"touchstart",m],[h.ownerDocument,"touchmove",p],[h.ownerDocument,"touchend",n]);a.forEach(function(a){F.apply(null,a)});this._events=a};a.prototype.buttonToMaxClick=function(a){var f=(this.to-this.from)*m(this.options.step,.2);this.updatePosition(this.from+
	f,this.to+f);c(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:a})};a.prototype.buttonToMinClick=function(a){var f=x(this.to-this.from)*m(this.options.step,.2);this.updatePosition(x(this.from-f),x(this.to-f));c(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:a})};a.prototype.cursorToScrollbarPosition=function(a){var c=this.options;c=c.minWidth>this.calculatedWidth?c.minWidth:0;return{chartX:(a.chartX-this.x-this.xOffset)/(this.barWidth-c),chartY:(a.chartY-
	this.y-this.yOffset)/(this.barWidth-c)}};a.prototype.destroy=function(){var a=this,c=a.chart.scroller;a.removeEvents();["track","scrollbarRifles","scrollbar","scrollbarGroup","group"].forEach(function(c){a[c]&&a[c].destroy&&(a[c]=a[c].destroy())});c&&a===c.scrollbar&&(c.scrollbar=null,n(c.scrollbarButtons))};a.prototype.drawScrollbarButton=function(c){var f=this.renderer,h=this.scrollbarButtons,l=this.options,m=this.size,p=f.g().add(this.group);h.push(p);p=f.rect().addClass("highcharts-scrollbar-button").add(p);
	this.chart.styledMode||p.attr({stroke:l.buttonBorderColor,"stroke-width":l.buttonBorderWidth,fill:l.buttonBackgroundColor});p.attr(p.crisp({x:-.5,y:-.5,width:m+1,height:m+1,r:l.buttonBorderRadius},p.strokeWidth()));p=f.path(a.swapXY([["M",m/2+(c?-1:1),m/2-3],["L",m/2+(c?-1:1),m/2+3],["L",m/2+(c?2:-2),m/2]],l.vertical)).addClass("highcharts-scrollbar-arrow").add(h[c]);this.chart.styledMode||p.attr({fill:l.buttonArrowColor})};a.prototype.init=function(a,c,l){this.scrollbarButtons=[];this.renderer=a;
	this.userOptions=c;this.options=h(E,v.scrollbar,c);this.chart=l;this.size=m(this.options.size,this.options.height);c.enabled&&(this.render(),this.addEvents())};a.prototype.mouseDownHandler=function(a){a=this.chart.pointer.normalize(a);a=this.cursorToScrollbarPosition(a);this.chartX=a.chartX;this.chartY=a.chartY;this.initPositions=[this.from,this.to];this.grabbedCenter=!0};a.prototype.mouseMoveHandler=function(a){var f=this.chart.pointer.normalize(a),h=this.options.vertical?"chartY":"chartX",l=this.initPositions||
	[];!this.grabbedCenter||a.touches&&0===a.touches[0][h]||(f=this.cursorToScrollbarPosition(f)[h],h=this[h],h=f-h,this.hasDragged=!0,this.updatePosition(l[0]+h,l[1]+h),this.hasDragged&&c(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMType:a.type,DOMEvent:a}))};a.prototype.mouseUpHandler=function(a){this.hasDragged&&c(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMType:a.type,DOMEvent:a});this.grabbedCenter=this.hasDragged=this.chartX=this.chartY=null};a.prototype.position=
	function(a,c,h,l){var f=this.options.vertical,m=this.rendered?"animate":"attr",p=l,n=0;this.group.show();this.x=a;this.y=c+this.trackBorderWidth;this.width=h;this.height=l;this.xOffset=p;this.yOffset=n;f?(this.width=this.yOffset=h=n=this.size,this.xOffset=p=0,this.barWidth=l-2*h,this.x=a+=this.options.margin):(this.height=this.xOffset=l=p=this.size,this.barWidth=h-2*l,this.y+=this.options.margin);this.group[m]({translateX:a,translateY:this.y});this.track[m]({width:h,height:l});this.scrollbarButtons[1][m]({translateX:f?
	0:h-p,translateY:f?l-n:0})};a.prototype.removeEvents=function(){this._events.forEach(function(a){l.apply(null,a)});this._events.length=0};a.prototype.render=function(){var c=this.renderer,h=this.options,l=this.size,m=this.chart.styledMode,p=c.g("scrollbar").attr({zIndex:h.zIndex}).hide().add();this.group=p;this.track=c.rect().addClass("highcharts-scrollbar-track").attr({x:0,r:h.trackBorderRadius||0,height:l,width:l}).add(p);m||this.track.attr({fill:h.trackBackgroundColor,stroke:h.trackBorderColor,
	"stroke-width":h.trackBorderWidth});this.trackBorderWidth=this.track.strokeWidth();this.track.attr({y:-this.trackBorderWidth%2/2});this.scrollbarGroup=c.g().add(p);this.scrollbar=c.rect().addClass("highcharts-scrollbar-thumb").attr({height:l,width:l,r:h.barBorderRadius||0}).add(this.scrollbarGroup);this.scrollbarRifles=c.path(a.swapXY([["M",-3,l/4],["L",-3,2*l/3],["M",0,l/4],["L",0,2*l/3],["M",3,l/4],["L",3,2*l/3]],h.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);m||(this.scrollbar.attr({fill:h.barBackgroundColor,
	stroke:h.barBorderColor,"stroke-width":h.barBorderWidth}),this.scrollbarRifles.attr({stroke:h.rifleColor,"stroke-width":1}));this.scrollbarStrokeWidth=this.scrollbar.strokeWidth();this.scrollbarGroup.translate(-this.scrollbarStrokeWidth%2/2,-this.scrollbarStrokeWidth%2/2);this.drawScrollbarButton(0);this.drawScrollbarButton(1)};a.prototype.setRange=function(a,c){var f=this.options,h=f.vertical,l=f.minWidth,m=this.barWidth,p=!this.rendered||this.hasDragged||this.chart.navigator&&this.chart.navigator.hasDragged?
	"attr":"animate";if(u(m)){var n=m*Math.min(c,1);a=Math.max(a,0);var k=Math.ceil(m*a);this.calculatedWidth=n=x(n-k);n<l&&(k=(m-l+n)*a,n=l);l=Math.floor(k+this.xOffset+this.yOffset);m=n/2-.5;this.from=a;this.to=c;h?(this.scrollbarGroup[p]({translateY:l}),this.scrollbar[p]({height:n}),this.scrollbarRifles[p]({translateY:m}),this.scrollbarTop=l,this.scrollbarLeft=0):(this.scrollbarGroup[p]({translateX:l}),this.scrollbar[p]({width:n}),this.scrollbarRifles[p]({translateX:m}),this.scrollbarLeft=l,this.scrollbarTop=
	0);12>=n?this.scrollbarRifles.hide():this.scrollbarRifles.show();!1===f.showFull&&(0>=a&&1<=c?this.group.hide():this.group.show());this.rendered=!0}};a.prototype.shouldUpdateExtremes=function(a){return m(this.options.liveRedraw,q.svg&&!q.isTouchDevice&&!this.chart.boosted)||"mouseup"===a||"touchend"===a||!u(a)};a.prototype.trackClick=function(a){var f=this.chart.pointer.normalize(a),h=this.to-this.from,l=this.y+this.scrollbarTop,m=this.x+this.scrollbarLeft;this.options.vertical&&f.chartY>l||!this.options.vertical&&
	f.chartX>m?this.updatePosition(this.from+h,this.to+h):this.updatePosition(this.from-h,this.to-h);c(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:a})};a.prototype.update=function(a){this.destroy();this.init(this.chart.renderer,h(!0,this.options,a),this.chart)};a.prototype.updatePosition=function(a,c){1<c&&(a=x(1-x(c-a)),c=1);0>a&&(c=x(c-a),a=0);this.from=a;this.to=c};a.defaultOptions=E;return a}();v.scrollbar=h(!0,a.defaultOptions,v.scrollbar);return a});J(a,"Stock/Navigator/Navigator.js",
	[a["Core/Axis/Axis.js"],a["Core/Defaults.js"],a["Core/Globals.js"],a["Core/Axis/NavigatorAxisComposition.js"],a["Stock/Navigator/NavigatorComposition.js"],a["Stock/Scrollbar/Scrollbar.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F){function v(a){for(var b=[],c=1;c<arguments.length;c++)b[c-1]=arguments[c];b=[].filter.call(b,y);if(b.length)return Math[a].apply(0,b)}var u=q.defaultOptions,n=A.hasTouch,c=A.isTouchDevice,h=F.addEvent,m=F.clamp,l=F.correctFloat,p=F.defined,f=F.destroyObjectProperties,
	D=F.erase,G=F.extend,H=F.find,K=F.isArray,y=F.isNumber,t=F.merge,w=F.pick,k=F.removeEvent,g=F.splat;return function(){function e(a){this.zoomedMin=this.zoomedMax=this.yAxis=this.xAxis=this.top=this.size=this.shades=this.rendered=this.range=this.outlineHeight=this.outline=this.opposite=this.navigatorSize=this.navigatorSeries=this.navigatorOptions=this.navigatorGroup=this.navigatorEnabled=this.left=this.height=this.handles=this.chart=this.baseSeries=void 0;this.init(a)}e.compose=function(a,c,g){B.compose(a,
	c,e,g)};e.prototype.drawHandle=function(a,c,e,g){var b=this.navigatorOptions.handles.height;this.handles[c][g](e?{translateX:Math.round(this.left+this.height/2),translateY:Math.round(this.top+parseInt(a,10)+.5-b)}:{translateX:Math.round(this.left+parseInt(a,10)),translateY:Math.round(this.top+this.height/2-b/2-1)})};e.prototype.drawOutline=function(a,c,e,g){var b=this.navigatorOptions.maskInside,d=this.outline.strokeWidth(),f=d/2,h=d%2/2;d=this.outlineHeight;var k=this.scrollbarHeight||0,l=this.size,
	r=this.left-k,m=this.top;e?(r-=f,e=m+c+h,c=m+a+h,h=[["M",r+d,m-k-h],["L",r+d,e],["L",r,e],["L",r,c],["L",r+d,c],["L",r+d,m+l+k]],b&&h.push(["M",r+d,e-f],["L",r+d,c+f])):(a+=r+k-h,c+=r+k-h,m+=f,h=[["M",r,m],["L",a,m],["L",a,m+d],["L",c,m+d],["L",c,m],["L",r+l+2*k,m]],b&&h.push(["M",a-f,m],["L",c+f,m]));this.outline[g]({d:h})};e.prototype.drawMasks=function(a,c,e,g){var b=this.left,d=this.top,f=this.height;if(e){var h=[b,b,b];var k=[d,d+a,d+c];var r=[f,f,f];var l=[a,c-a,this.size-c]}else h=[b,b+a,b+
	c],k=[d,d,d],r=[a,c-a,this.size-c],l=[f,f,f];this.shades.forEach(function(a,b){a[g]({x:h[b],y:k[b],width:r[b],height:l[b]})})};e.prototype.renderElements=function(){var a=this,c=a.navigatorOptions,e=c.maskInside,g=a.chart,f=g.renderer,h={cursor:g.inverted?"ns-resize":"ew-resize"},k=a.navigatorGroup=f.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();[!e,e,!e].forEach(function(b,d){var e=f.rect().addClass("highcharts-navigator-mask"+(1===d?"-inside":"-outside")).add(k);g.styledMode||(e.attr({fill:b?
	c.maskFill:"rgba(0,0,0,0)"}),1===d&&e.css(h));a.shades[d]=e});a.outline=f.path().addClass("highcharts-navigator-outline").add(k);g.styledMode||a.outline.attr({"stroke-width":c.outlineWidth,stroke:c.outlineColor});if(c.handles&&c.handles.enabled){var l=c.handles,m=l.height,p=l.width;[0,1].forEach(function(b){a.handles[b]=f.symbol(l.symbols[b],-p/2-1,0,p,m,l);g.inverted&&a.handles[b].attr({rotation:90,rotationOriginX:Math.floor(-p/2),rotationOriginY:(m+p)/2});a.handles[b].attr({zIndex:7-b}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+
	["left","right"][b]).add(k);g.styledMode||a.handles[b].attr({fill:l.backgroundColor,stroke:l.borderColor,"stroke-width":l.lineWidth}).css(h)})}};e.prototype.update=function(a){(this.series||[]).forEach(function(a){a.baseSeries&&delete a.baseSeries.navigatorSeries});this.destroy();t(!0,this.chart.options.navigator,a);this.init(this.chart)};e.prototype.render=function(a,c,e,g){var b=this.chart,d=this.xAxis,f=d.pointRange||0,h=d.navigatorAxis.fake?b.xAxis[0]:d,k=this.navigatorEnabled,r=this.rendered,
	n=b.inverted,t=b.xAxis[0].minRange,q=b.xAxis[0].options.maxRange,u=this.scrollbarHeight,z;if(!this.hasDragged||p(e)){a=l(a-f/2);c=l(c+f/2);if(!y(a)||!y(c))if(r)e=0,g=w(d.width,h.width);else return;this.left=w(d.left,b.plotLeft+u+(n?b.plotWidth:0));var v=this.size=z=w(d.len,(n?b.plotHeight:b.plotWidth)-2*u);b=n?u:z+2*u;e=w(e,d.toPixels(a,!0));g=w(g,d.toPixels(c,!0));y(e)&&Infinity!==Math.abs(e)||(e=0,g=b);a=d.toValue(e,!0);c=d.toValue(g,!0);var x=Math.abs(l(c-a));x<t?this.grabbedLeft?e=d.toPixels(c-
	t-f,!0):this.grabbedRight&&(g=d.toPixels(a+t+f,!0)):p(q)&&l(x-f)>q&&(this.grabbedLeft?e=d.toPixels(c-q-f,!0):this.grabbedRight&&(g=d.toPixels(a+q+f,!0)));this.zoomedMax=m(Math.max(e,g),0,v);this.zoomedMin=m(this.fixedWidth?this.zoomedMax-this.fixedWidth:Math.min(e,g),0,v);this.range=this.zoomedMax-this.zoomedMin;v=Math.round(this.zoomedMax);e=Math.round(this.zoomedMin);k&&(this.navigatorGroup.attr({visibility:"inherit"}),r=r&&!this.hasDragged?"animate":"attr",this.drawMasks(e,v,n,r),this.drawOutline(e,
	v,n,r),this.navigatorOptions.handles.enabled&&(this.drawHandle(e,0,n,r),this.drawHandle(v,1,n,r)));this.scrollbar&&(n?(n=this.top-u,h=this.left-u+(k||!h.opposite?0:(h.titleOffset||0)+h.axisTitleMargin),u=z+2*u):(n=this.top+(k?this.height:-u),h=this.left-u),this.scrollbar.position(h,n,b,u),this.scrollbar.setRange(this.zoomedMin/(z||1),this.zoomedMax/(z||1)));this.rendered=!0}};e.prototype.addMouseEvents=function(){var a=this,c=a.chart,e=c.container,g=[],f,k;a.mouseMoveHandler=f=function(b){a.onMouseMove(b)};
	a.mouseUpHandler=k=function(b){a.onMouseUp(b)};g=a.getPartsEvents("mousedown");g.push(h(c.renderTo,"mousemove",f),h(e.ownerDocument,"mouseup",k));n&&(g.push(h(c.renderTo,"touchmove",f),h(e.ownerDocument,"touchend",k)),g.concat(a.getPartsEvents("touchstart")));a.eventsToUnbind=g;a.series&&a.series[0]&&g.push(h(a.series[0].xAxis,"foundExtremes",function(){c.navigator.modifyNavigatorAxisExtremes()}))};e.prototype.getPartsEvents=function(a){var b=this,c=[];["shades","handles"].forEach(function(d){b[d].forEach(function(e,
	g){c.push(h(e.element,a,function(a){b[d+"Mousedown"](a,g)}))})});return c};e.prototype.shadesMousedown=function(a,c){a=this.chart.pointer.normalize(a);var b=this.chart,d=this.xAxis,e=this.zoomedMin,g=this.size,f=this.range,h=this.left,k=a.chartX;b.inverted&&(k=a.chartY,h=this.top);if(1===c)this.grabbedCenter=k,this.fixedWidth=f,this.dragOffset=k-e;else{a=k-h-f/2;if(0===c)a=Math.max(0,a);else if(2===c&&a+f>=g)if(a=g-f,this.reversedExtremes){a-=f;var l=this.getUnionExtremes().dataMin}else var m=this.getUnionExtremes().dataMax;
	a!==e&&(this.fixedWidth=f,c=d.navigatorAxis.toFixedRange(a,a+f,l,m),p(c.min)&&b.xAxis[0].setExtremes(Math.min(c.min,c.max),Math.max(c.min,c.max),!0,null,{trigger:"navigator"}))}};e.prototype.handlesMousedown=function(a,c){this.chart.pointer.normalize(a);a=this.chart;var b=a.xAxis[0],d=this.reversedExtremes;0===c?(this.grabbedLeft=!0,this.otherHandlePos=this.zoomedMax,this.fixedExtreme=d?b.min:b.max):(this.grabbedRight=!0,this.otherHandlePos=this.zoomedMin,this.fixedExtreme=d?b.max:b.min);a.fixedRange=
	null};e.prototype.onMouseMove=function(a){var b=this,e=b.chart,g=b.navigatorSize,f=b.range,h=b.dragOffset,k=e.inverted,l=b.left;a.touches&&0===a.touches[0].pageX||(a=e.pointer.normalize(a),e=a.chartX,k&&(l=b.top,e=a.chartY),b.grabbedLeft?(b.hasDragged=!0,b.render(0,0,e-l,b.otherHandlePos)):b.grabbedRight?(b.hasDragged=!0,b.render(0,0,b.otherHandlePos,e-l)):b.grabbedCenter&&(b.hasDragged=!0,e<h?e=h:e>g+h-f&&(e=g+h-f),b.render(0,0,e-h,e-h+f)),b.hasDragged&&b.scrollbar&&w(b.scrollbar.options.liveRedraw,
	A.svg&&!c&&!this.chart.boosted)&&(a.DOMType=a.type,setTimeout(function(){b.onMouseUp(a)},0)))};e.prototype.onMouseUp=function(a){var b=this.chart,c=this.xAxis,e=this.scrollbar,g=a.DOMEvent||a,f=b.inverted,h=this.rendered&&!this.hasDragged?"animate":"attr";if(this.hasDragged&&(!e||!e.hasDragged)||"scrollbar"===a.trigger){e=this.getUnionExtremes();if(this.zoomedMin===this.otherHandlePos)var k=this.fixedExtreme;else if(this.zoomedMax===this.otherHandlePos)var l=this.fixedExtreme;this.zoomedMax===this.size&&
	(l=this.reversedExtremes?e.dataMin:e.dataMax);0===this.zoomedMin&&(k=this.reversedExtremes?e.dataMax:e.dataMin);c=c.navigatorAxis.toFixedRange(this.zoomedMin,this.zoomedMax,k,l);p(c.min)&&b.xAxis[0].setExtremes(Math.min(c.min,c.max),Math.max(c.min,c.max),!0,this.hasDragged?!1:null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:g})}"mousemove"!==a.DOMType&&"touchmove"!==a.DOMType&&(this.grabbedLeft=this.grabbedRight=this.grabbedCenter=this.fixedWidth=this.fixedExtreme=this.otherHandlePos=
	this.hasDragged=this.dragOffset=null);this.navigatorEnabled&&y(this.zoomedMin)&&y(this.zoomedMax)&&(b=Math.round(this.zoomedMin),a=Math.round(this.zoomedMax),this.shades&&this.drawMasks(b,a,f,h),this.outline&&this.drawOutline(b,a,f,h),this.navigatorOptions.handles.enabled&&Object.keys(this.handles).length===this.handles.length&&(this.drawHandle(b,0,f,h),this.drawHandle(a,1,f,h)))};e.prototype.removeEvents=function(){this.eventsToUnbind&&(this.eventsToUnbind.forEach(function(a){a()}),this.eventsToUnbind=
	void 0);this.removeBaseSeriesEvents()};e.prototype.removeBaseSeriesEvents=function(){var a=this.baseSeries||[];this.navigatorEnabled&&a[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&a.forEach(function(a){k(a,"updatedData",this.updatedDataHandler)},this),a[0].xAxis&&k(a[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes))};e.prototype.init=function(b){var c=b.options,e=c.navigator||{},g=e.enabled,f=c.scrollbar||{},k=f.enabled;c=g&&e.height||0;var l=k&&f.height||0;this.handles=[];this.shades=
	[];this.chart=b;this.setBaseSeries();this.height=c;this.scrollbarHeight=l;this.scrollbarEnabled=k;this.navigatorEnabled=g;this.navigatorOptions=e;this.scrollbarOptions=f;this.outlineHeight=c+l;this.opposite=w(e.opposite,!(g||!b.inverted));var m=this;g=m.baseSeries;f=b.xAxis.length;k=b.yAxis.length;var p=g&&g[0]&&g[0].xAxis||b.xAxis[0]||{options:{}};b.isDirtyBox=!0;m.navigatorEnabled?(m.xAxis=new a(b,t({breaks:p.options.breaks,ordinal:p.options.ordinal},e.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",
	isX:!0,type:"datetime",index:f,isInternal:!0,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},b.inverted?{offsets:[l,0,-l,0],width:c}:{offsets:[0,-l,0,l],height:c})),m.yAxis=new a(b,t(e.yAxis,{id:"navigator-y-axis",alignTicks:!1,offset:0,index:k,isInternal:!0,reversed:w(e.yAxis&&e.yAxis.reversed,b.yAxis[0]&&b.yAxis[0].reversed,!1),zoomEnabled:!1},b.inverted?{width:c}:{height:c})),g||e.series.data?m.updateNavigatorSeries(!1):0===b.series.length&&
	(m.unbindRedraw=h(b,"beforeRedraw",function(){0<b.series.length&&!m.series&&(m.setBaseSeries(),m.unbindRedraw())})),m.reversedExtremes=b.inverted&&!m.xAxis.reversed||!b.inverted&&m.xAxis.reversed,m.renderElements(),m.addMouseEvents()):(m.xAxis={chart:b,navigatorAxis:{fake:!0},translate:function(a,c){var d=b.xAxis[0],e=d.getExtremes(),g=d.len-2*l,f=v("min",d.options.min,e.dataMin);d=v("max",d.options.max,e.dataMax)-f;return c?a*d/g+f:g*(a-f)/d},toPixels:function(a){return this.translate(a)},toValue:function(a){return this.translate(a,
	!0)}},m.xAxis.navigatorAxis.axis=m.xAxis,m.xAxis.navigatorAxis.toFixedRange=E.prototype.toFixedRange.bind(m.xAxis.navigatorAxis));b.options.scrollbar.enabled&&(b.scrollbar=m.scrollbar=new C(b.renderer,t(b.options.scrollbar,{margin:m.navigatorEnabled?0:10,vertical:b.inverted}),b),h(m.scrollbar,"changed",function(a){var b=m.size,c=b*this.to;b*=this.from;m.hasDragged=m.scrollbar.hasDragged;m.render(0,0,b,c);this.shouldUpdateExtremes(a.DOMType)&&setTimeout(function(){m.onMouseUp(a)})}));m.addBaseSeriesEvents();
	m.addChartEvents()};e.prototype.getUnionExtremes=function(a){var b=this.chart.xAxis[0],c=this.xAxis,e=c.options,g=b.options,f;a&&null===b.dataMin||(f={dataMin:w(e&&e.min,v("min",g.min,b.dataMin,c.dataMin,c.min)),dataMax:w(e&&e.max,v("max",g.max,b.dataMax,c.dataMax,c.max))});return f};e.prototype.setBaseSeries=function(a,c){var b=this.chart,d=this.baseSeries=[];a=a||b.options&&b.options.navigator.baseSeries||(b.series.length?H(b.series,function(a){return!a.options.isInternal}).index:0);(b.series||
	[]).forEach(function(b,c){b.options.isInternal||!b.options.showInNavigator&&(c!==a&&b.options.id!==a||!1===b.options.showInNavigator)||d.push(b)});this.xAxis&&!this.xAxis.navigatorAxis.fake&&this.updateNavigatorSeries(!0,c)};e.prototype.updateNavigatorSeries=function(a,c){var b=this,d=b.chart,e=b.baseSeries,f={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:void 0,isInternal:!0,states:{inactive:{opacity:1}}},
	h=b.series=(b.series||[]).filter(function(a){var c=a.baseSeries;return 0>e.indexOf(c)?(c&&(k(c,"updatedData",b.updatedDataHandler),delete c.navigatorSeries),a.chart&&a.destroy(),!1):!0}),l,m,p=b.navigatorOptions.series,n;e&&e.length&&e.forEach(function(a){var k=a.navigatorSeries,r=G({color:a.color,visible:a.visible},K(p)?u.navigator.series:p);k&&!1===b.navigatorOptions.adaptToUpdatedData||(f.name="Navigator "+e.length,l=a.options||{},n=l.navigatorOptions||{},r.dataLabels=g(r.dataLabels),m=t(l,f,r,
	n),m.pointRange=w(r.pointRange,n.pointRange,u.plotOptions[m.type||"line"].pointRange),r=n.data||r.data,b.hasNavigatorData=b.hasNavigatorData||!!r,m.data=r||l.data&&l.data.slice(0),k&&k.options?k.update(m,c):(a.navigatorSeries=d.initSeries(m),a.navigatorSeries.baseSeries=a,h.push(a.navigatorSeries)))});if(p.data&&(!e||!e.length)||K(p))b.hasNavigatorData=!1,p=g(p),p.forEach(function(a,c){f.name="Navigator "+(h.length+1);m=t(u.navigator.series,{color:d.series[c]&&!d.series[c].options.isInternal&&d.series[c].color||
	d.options.colors[c]||d.options.colors[0]},f,a);m.data=a.data;m.data&&(b.hasNavigatorData=!0,h.push(d.initSeries(m)))});a&&this.addBaseSeriesEvents()};e.prototype.addBaseSeriesEvents=function(){var a=this,c=this,e=c.baseSeries||[];e[0]&&e[0].xAxis&&e[0].eventsToUnbind.push(h(e[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes));e.forEach(function(b){b.eventsToUnbind.push(h(b,"show",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!0,!1)}));b.eventsToUnbind.push(h(b,"hide",function(){this.navigatorSeries&&
	this.navigatorSeries.setVisible(!1,!1)}));!1!==a.navigatorOptions.adaptToUpdatedData&&b.xAxis&&b.eventsToUnbind.push(h(b,"updatedData",a.updatedDataHandler));b.eventsToUnbind.push(h(b,"remove",function(){this.navigatorSeries&&(D(c.series,this.navigatorSeries),p(this.navigatorSeries.options)&&this.navigatorSeries.remove(!1),delete this.navigatorSeries)}))})};e.prototype.getBaseSeriesMin=function(a){return this.baseSeries.reduce(function(a,b){return Math.min(a,b.xData&&b.xData.length?b.xData[0]:a)},
	a)};e.prototype.modifyNavigatorAxisExtremes=function(){var a=this.xAxis;if("undefined"!==typeof a.getExtremes){var c=this.getUnionExtremes(!0);!c||c.dataMin===a.min&&c.dataMax===a.max||(a.min=c.dataMin,a.max=c.dataMax)}};e.prototype.modifyBaseAxisExtremes=function(){var a=this.chart.navigator,c=this.getExtremes(),e=c.dataMin,g=c.dataMax;c=c.max-c.min;var f=a.stickToMin,h=a.stickToMax,k=w(this.options.overscroll,0),l=a.series&&a.series[0],m=!!this.setExtremes;if(!this.eventArgs||"rangeSelectorButton"!==
	this.eventArgs.trigger){if(f){var p=e;var n=p+c}h&&(n=g+k,f||(p=Math.max(e,n-c,a.getBaseSeriesMin(l&&l.xData?l.xData[0]:-Number.MAX_VALUE))));m&&(f||h)&&y(p)&&(this.min=this.userMin=p,this.max=this.userMax=n)}a.stickToMin=a.stickToMax=null};e.prototype.updatedDataHandler=function(){var a=this.chart.navigator,c=this.navigatorSeries;a.stickToMax=w(this.chart.options.navigator&&this.chart.options.navigator.stickToMax,a.reversedExtremes?0===Math.round(a.zoomedMin):Math.round(a.zoomedMax)>=Math.round(a.size));
	a.stickToMin=a.shouldStickToMin(this,a);c&&!a.hasNavigatorData&&(c.options.pointStart=this.xData[0],c.setData(this.options.data,!1,null,!1))};e.prototype.shouldStickToMin=function(a,c){c=c.getBaseSeriesMin(a.xData[0]);var b=a.xAxis;a=b.max;var d=b.min;b=b.options.range;return y(a)&&y(d)?b&&0<a-c?a-c<b:d<=c:!1};e.prototype.addChartEvents=function(){this.eventsToUnbind||(this.eventsToUnbind=[]);this.eventsToUnbind.push(h(this.chart,"redraw",function(){var a=this.navigator,c=a&&(a.baseSeries&&a.baseSeries[0]&&
	a.baseSeries[0].xAxis||this.xAxis[0]);c&&a.render(c.min,c.max)}),h(this.chart,"getMargins",function(){var a=this.navigator,c=a.opposite?"plotTop":"marginBottom";this.inverted&&(c=a.opposite?"marginRight":"plotLeft");this[c]=(this[c]||0)+(a.navigatorEnabled||!this.inverted?a.outlineHeight:0)+a.navigatorOptions.margin}))};e.prototype.destroy=function(){var a=this;this.removeEvents();this.xAxis&&(D(this.chart.xAxis,this.xAxis),D(this.chart.axes,this.xAxis));this.yAxis&&(D(this.chart.yAxis,this.yAxis),
	D(this.chart.axes,this.yAxis));(this.series||[]).forEach(function(a){a.destroy&&a.destroy()});"series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" ").forEach(function(b){a[b]&&a[b].destroy&&a[b].destroy();a[b]=null});[this.handles].forEach(function(a){f(a)})};return e}()});J(a,"Stock/RangeSelector/RangeSelectorDefaults.js",[],function(){return{lang:{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"",rangeSelectorTo:"\u2192"},rangeSelector:{allButtonsEnabled:!1,
	buttons:void 0,buttonSpacing:5,dropdown:"responsive",enabled:void 0,verticalAlign:"top",buttonTheme:{width:28,height:18,padding:2,zIndex:7},floating:!1,x:0,y:0,height:void 0,inputBoxBorderColor:"none",inputBoxHeight:17,inputBoxWidth:void 0,inputDateFormat:"%b %e, %Y",inputDateParser:void 0,inputEditDateFormat:"%Y-%m-%d",inputEnabled:!0,inputPosition:{align:"right",x:0,y:0},inputSpacing:5,selected:void 0,buttonPosition:{align:"left",x:0,y:0},inputStyle:{color:"#335cad",cursor:"pointer"},labelStyle:{color:"#666666"}}}});
	J(a,"Stock/RangeSelector/RangeSelectorComposition.js",[a["Core/Defaults.js"],a["Stock/RangeSelector/RangeSelectorDefaults.js"],a["Core/Utilities.js"]],function(a,q,A){function v(){var a=this.range,c=a.type,e=this.max,b=this.chart.time,d=function(a,d){var e="year"===c?"FullYear":"Month",g=new b.Date(a),f=b.get(e,g);b.set(e,g,f+d);f===b.get(e,g)&&b.set("Date",g,0);return g.getTime()-a};if(G(a)){var f=e-a;var h=a}else a&&(f=e+d(e,-(a.count||1)),this.chart&&(this.chart.fixedRange=e-f));var l=K(this.dataMin,
	Number.MIN_VALUE);G(f)||(f=l);f<=l&&(f=l,"undefined"===typeof h&&(h=d(f,a.count)),this.newMax=Math.min(f+h,K(this.dataMax,Number.MAX_VALUE)));G(e)?!G(a)&&a&&a._offsetMin&&(f+=a._offsetMin):f=void 0;return f}function B(){this.options.rangeSelector&&this.options.rangeSelector.enabled&&(this.rangeSelector=new w(this))}function C(){var a=this.axes,c=this.rangeSelector;c&&(G(c.deferredYTDClick)&&(c.clickButton(c.deferredYTDClick),delete c.deferredYTDClick),a.forEach(function(a){a.updateNames();a.setScale()}),
	this.getAxisMargins(),c.render(),a=c.options.verticalAlign,c.options.floating||("bottom"===a?this.extraBottomMargin=!0:"middle"!==a&&(this.extraTopMargin=!0)))}function F(a){var c,e,b,d,f=a.rangeSelector,h=function(){f&&(c=a.xAxis[0].getExtremes(),e=a.legend,d=f&&f.options.verticalAlign,G(c.min)&&f.render(c.min,c.max),e.display&&"top"===d&&d===e.options.verticalAlign&&(b=H(a.spacingBox),b.y="vertical"===e.options.layout?a.plotTop:b.y+f.getHeight(),e.group.placed=!1,e.align(b)))};f&&(D(y,function(b){return b[0]===
	a})||y.push([a,[l(a.xAxis[0],"afterSetExtremes",function(a){f&&f.render(a.min,a.max)}),l(a,"redraw",h)]]),h())}function x(){for(var a=0,c=y.length;a<c;++a){var e=y[a];if(e[0]===this){e[1].forEach(function(a){return a()});y.splice(a,1);break}}}function u(){var a=this.rangeSelector;a&&(a=a.getHeight(),this.extraTopMargin&&(this.plotTop+=a),this.extraBottomMargin&&(this.marginBottom+=a))}function n(){var a=this.rangeSelector;a&&!a.options.floating&&(a.render(),a=a.options.verticalAlign,"bottom"===a?
	this.extraBottomMargin=!0:"middle"!==a&&(this.extraTopMargin=!0))}function c(a){var c=a.options.rangeSelector;a=this.extraBottomMargin;var e=this.extraTopMargin,b=this.rangeSelector;c&&c.enabled&&!p(b)&&this.options.rangeSelector&&(this.options.rangeSelector.enabled=!0,this.rangeSelector=b=new w(this));this.extraTopMargin=this.extraBottomMargin=!1;b&&(F(this),c=c&&c.verticalAlign||b.options&&b.options.verticalAlign,b.options.floating||("bottom"===c?this.extraBottomMargin=!0:"middle"!==c&&(this.extraTopMargin=
	!0)),this.extraBottomMargin!==a||this.extraTopMargin!==e)&&(this.isDirtyBox=!0)}var h=a.defaultOptions,m=a.setOptions,l=A.addEvent,p=A.defined,f=A.extend,D=A.find,G=A.isNumber,H=A.merge,K=A.pick,y=[],t=[],w;return{compose:function(a,g,e){w=e;-1===t.indexOf(a)&&(t.push(a),a.prototype.minFromRange=v);-1===t.indexOf(g)&&(t.push(g),l(g,"afterGetContainer",B),l(g,"beforeRender",C),l(g,"destroy",x),l(g,"getMargins",u),l(g,"render",n),l(g,"update",c),g.prototype.callbacks.push(F));-1===t.indexOf(m)&&(f(h,
	{rangeSelector:q.rangeSelector}),f(h.lang,q.lang))}}});J(a,"Stock/RangeSelector/RangeSelector.js",[a["Core/Axis/Axis.js"],a["Core/Defaults.js"],a["Core/Globals.js"],a["Stock/RangeSelector/RangeSelectorComposition.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C){function v(a){if(-1!==a.indexOf("%L"))return"text";var c="aAdewbBmoyY".split("").some(function(b){return-1!==a.indexOf("%"+b)}),e="HkIlMS".split("").some(function(b){return-1!==a.indexOf("%"+b)});return c&&
	e?"datetime-local":c?"date":e?"time":"text"}var x=q.defaultOptions,u=C.addEvent,n=C.createElement,c=C.css,h=C.defined,m=C.destroyObjectProperties,l=C.discardElement,p=C.extend,f=C.fireEvent,D=C.isNumber,G=C.merge,H=C.objectEach,K=C.pad,y=C.pick,t=C.pInt,w=C.splat;q=function(){function k(a){this.buttons=void 0;this.buttonOptions=k.prototype.defaultButtons;this.initialButtonGroupWidth=0;this.options=void 0;this.chart=a;this.init(a)}k.compose=function(a,c){E.compose(a,c,k)};k.prototype.clickButton=function(c,
	e){var b=this.chart,d=this.buttonOptions[c],g=b.xAxis[0],k=b.scroller&&b.scroller.getUnionExtremes()||g||{},l=d.type,m=d.dataGrouping,p=k.dataMin,n=k.dataMax,t=g&&Math.round(Math.min(g.max,y(n,g.max)));k=d._range;var q,v=!0;if(null!==p&&null!==n){b.fixedRange=k;this.setSelected(c);m&&(this.forcedDataGrouping=!0,a.prototype.setDataGrouping.call(g||{chart:this.chart},m,!1),this.frozenStates=d.preserveDataGrouping);if("month"===l||"year"===l)if(g){l={range:d,max:t,chart:b,dataMin:p,dataMax:n};var x=
	g.minFromRange.call(l);D(l.newMax)&&(t=l.newMax);v=!1}else k=d;else if(k)x=Math.max(t-k,p),t=Math.min(x+k,n),v=!1;else if("ytd"===l)if(g){if("undefined"===typeof n||"undefined"===typeof p)p=Number.MAX_VALUE,n=Number.MIN_VALUE,b.series.forEach(function(a){if(a=a.xData)p=Math.min(a[0],p),n=Math.max(a[a.length-1],n)}),e=!1;l=this.getYTDExtremes(n,p,b.time.useUTC);x=q=l.min;t=l.max}else{this.deferredYTDClick=c;return}else"all"===l&&g&&(b.navigator&&b.navigator.baseSeries[0]&&(b.navigator.baseSeries[0].xAxis.options.range=
	void 0),x=p,t=n);v&&d._offsetMin&&h(x)&&(x+=d._offsetMin);d._offsetMax&&h(t)&&(t+=d._offsetMax);this.dropdown&&(this.dropdown.selectedIndex=c+1);if(g)g.setExtremes(x,t,y(e,!0),void 0,{trigger:"rangeSelectorButton",rangeSelectorButton:d});else{var A=w(b.options.xAxis)[0];var B=A.range;A.range=k;var C=A.min;A.min=q;u(b,"load",function(){A.range=B;A.min=C})}f(this,"afterBtnClick")}};k.prototype.setSelected=function(a){this.selected=this.options.selected=a};k.prototype.init=function(a){var c=this,b=a.options.rangeSelector,
	d=b.buttons||c.defaultButtons.slice(),g=b.selected,h=function(){var a=c.minInput,b=c.maxInput;a&&a.blur&&f(a,"blur");b&&b.blur&&f(b,"blur")};c.chart=a;c.options=b;c.buttons=[];c.buttonOptions=d;this.eventsToUnbind=[];this.eventsToUnbind.push(u(a.container,"mousedown",h));this.eventsToUnbind.push(u(a,"resize",h));d.forEach(c.computeButtonRange);"undefined"!==typeof g&&d[g]&&this.clickButton(g,!1);this.eventsToUnbind.push(u(a,"load",function(){a.xAxis&&a.xAxis[0]&&u(a.xAxis[0],"setExtremes",function(b){this.max-
	this.min!==a.fixedRange&&"rangeSelectorButton"!==b.trigger&&"updatedData"!==b.trigger&&c.forcedDataGrouping&&!c.frozenStates&&this.setDataGrouping(!1,!1)})}))};k.prototype.updateButtonStates=function(){var a=this,c=this.chart,b=this.dropdown,d=c.xAxis[0],f=Math.round(d.max-d.min),h=!d.hasVisibleSeries,k=c.scroller&&c.scroller.getUnionExtremes()||d,l=k.dataMin,m=k.dataMax;c=a.getYTDExtremes(m,l,c.time.useUTC);var p=c.min,n=c.max,t=a.selected,u=a.options.allButtonsEnabled,q=a.buttons,w=D(t);a.buttonOptions.forEach(function(c,
	e){var g=c._range,k=c.type,r=c.count||1,z=q[e],v=c._offsetMax-c._offsetMin,x=e===t,y=g>m-l,A=g<d.minRange;c=0;var B=!1,D=!1;g=g===f;("month"===k||"year"===k)&&f+36E5>=864E5*{month:28,year:365}[k]*r-v&&f-36E5<=864E5*{month:31,year:366}[k]*r+v?g=!0:"ytd"===k?(g=n-p+v===f,B=!x):"all"===k&&(g=d.max-d.min>=m-l,D=!x&&w&&g);k=!u&&(y||A||D||h);r=x&&g||g&&!w&&!B||x&&a.frozenStates;k?c=3:r&&(w=!0,c=2);z.state!==c&&(z.setState(c),b&&(b.options[e+1].disabled=k,2===c&&(b.selectedIndex=e+1)),0===c&&t===e&&a.setSelected())})};
	k.prototype.computeButtonRange=function(a){var c=a.type,b=a.count||1,d={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5};if(d[c])a._range=d[c]*b;else if("month"===c||"year"===c)a._range=864E5*{month:30,year:365}[c]*b;a._offsetMin=y(a.offsetMin,0);a._offsetMax=y(a.offsetMax,0);a._range+=a._offsetMax-a._offsetMin};k.prototype.getInputValue=function(a){a="min"===a?this.minInput:this.maxInput;var c=this.chart.options.rangeSelector,b=this.chart.time;return a?("text"===a.type&&c.inputDateParser||
	this.defaultInputDateParser)(a.value,b.useUTC,b):0};k.prototype.setInputValue=function(a,c){var b=this.options,d=this.chart.time,e="min"===a?this.minInput:this.maxInput;a="min"===a?this.minDateBox:this.maxDateBox;if(e){var g=e.getAttribute("data-hc-time");g=h(g)?Number(g):void 0;h(c)&&(h(g)&&e.setAttribute("data-hc-time-previous",g),e.setAttribute("data-hc-time",c),g=c);e.value=d.dateFormat(this.inputTypeFormats[e.type]||b.inputEditDateFormat,g);a&&a.attr({text:d.dateFormat(b.inputDateFormat,g)})}};
	k.prototype.setInputExtremes=function(a,c,b){if(a="min"===a?this.minInput:this.maxInput){var d=this.inputTypeFormats[a.type],e=this.chart.time;d&&(c=e.dateFormat(d,c),a.min!==c&&(a.min=c),b=e.dateFormat(d,b),a.max!==b&&(a.max=b))}};k.prototype.showInput=function(a){var e="min"===a?this.minDateBox:this.maxDateBox;if((a="min"===a?this.minInput:this.maxInput)&&e&&this.inputGroup){var b="text"===a.type,d=this.inputGroup,g=d.translateX;d=d.translateY;var f=this.options.inputBoxWidth;c(a,{width:b?e.width+
	(f?-2:20)+"px":"auto",height:b?e.height-2+"px":"auto",border:"2px solid silver"});b&&f?c(a,{left:g+e.x+"px",top:d+"px"}):c(a,{left:Math.min(Math.round(e.x+g-(a.offsetWidth-e.width)/2),this.chart.chartWidth-a.offsetWidth)+"px",top:d-(a.offsetHeight-e.height)/2+"px"})}};k.prototype.hideInput=function(a){(a="min"===a?this.minInput:this.maxInput)&&c(a,{top:"-9999em",border:0,width:"1px",height:"1px"})};k.prototype.defaultInputDateParser=function(a,c,b){var d=a.split("/").join("-").split(" ").join("T");
	-1===d.indexOf("T")&&(d+="T00:00");if(c)d+="Z";else{var e;if(e=A.isSafari)e=d,e=!(6<e.length&&(e.lastIndexOf("-")===e.length-6||e.lastIndexOf("+")===e.length-6));e&&(e=(new Date(d)).getTimezoneOffset()/60,d+=0>=e?"+".concat(K(-e),":00"):"-".concat(K(e),":00"))}d=Date.parse(d);D(d)||(a=a.split("-"),d=Date.UTC(t(a[0]),t(a[1])-1,t(a[2])));b&&c&&D(d)&&(d+=b.getTimezoneOffset(d));return d};k.prototype.drawInput=function(a){function e(){var c=f.maxInput,d=f.minInput,e=b.xAxis[0],g=b.scroller&&b.scroller.xAxis?
	b.scroller.xAxis:e,h=g.dataMin;g=g.dataMax;var k=f.getInputValue(a);k!==Number(u.getAttribute("data-hc-time-previous"))&&D(k)&&(u.setAttribute("data-hc-time-previous",k),m&&c&&D(h)?k>Number(c.getAttribute("data-hc-time"))?k=void 0:k<h&&(k=h):d&&D(g)&&(k<Number(d.getAttribute("data-hc-time"))?k=void 0:k>g&&(k=g)),"undefined"!==typeof k&&e.setExtremes(m?k:e.min,m?e.max:k,void 0,void 0,{trigger:"rangeSelectorInput"}))}var b=this.chart,d=this.div,g=this.inputGroup,f=this,h=b.renderer.style||{},k=b.renderer,
	l=b.options.rangeSelector,m="min"===a,t=x.lang[m?"rangeSelectorFrom":"rangeSelectorTo"]||"";t=k.label(t,0).addClass("highcharts-range-label").attr({padding:t?2:0,height:t?l.inputBoxHeight:0}).add(g);k=k.label("",0).addClass("highcharts-range-input").attr({padding:2,width:l.inputBoxWidth,height:l.inputBoxHeight,"text-align":"center"}).on("click",function(){f.showInput(a);f[a+"Input"].focus()});b.styledMode||k.attr({stroke:l.inputBoxBorderColor,"stroke-width":1});k.add(g);var u=n("input",{name:a,className:"highcharts-range-selector"},
	void 0,d);u.setAttribute("type",v(l.inputDateFormat||"%b %e, %Y"));b.styledMode||(t.css(G(h,l.labelStyle)),k.css(G({color:"#333333"},h,l.inputStyle)),c(u,p({position:"absolute",border:0,boxShadow:"0 0 15px rgba(0,0,0,0.3)",width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:h.fontSize,fontFamily:h.fontFamily,top:"-9999em"},l.inputStyle)));u.onfocus=function(){f.showInput(a)};u.onblur=function(){u===A.doc.activeElement&&e();f.hideInput(a);f.setInputValue(a);u.blur()};var q=!1;u.onchange=
	function(){q||(e(),f.hideInput(a),u.blur())};u.onkeypress=function(a){13===a.keyCode&&e()};u.onkeydown=function(a){q=!0;38!==a.keyCode&&40!==a.keyCode||e()};u.onkeyup=function(){q=!1};return{dateBox:k,input:u,label:t}};k.prototype.getPosition=function(){var a=this.chart,c=a.options.rangeSelector;a="top"===c.verticalAlign?a.plotTop-a.axisOffset[0]:0;return{buttonTop:a+c.buttonPosition.y,inputTop:a+c.inputPosition.y-10}};k.prototype.getYTDExtremes=function(a,c,b){var d=this.chart.time,e=new d.Date(a),
	g=d.get("FullYear",e);b=b?d.Date.UTC(g,0,1):+new d.Date(g,0,1);c=Math.max(c,b);e=e.getTime();return{max:Math.min(a||e,e),min:c}};k.prototype.render=function(a,c){var b=this.chart,d=b.renderer,e=b.container,g=b.options,f=g.rangeSelector,k=y(g.chart.style&&g.chart.style.zIndex,0)+1;g=f.inputEnabled;if(!1!==f.enabled){this.rendered||(this.group=d.g("range-selector-group").attr({zIndex:7}).add(),this.div=n("div",void 0,{position:"relative",height:0,zIndex:k}),this.buttonOptions.length&&this.renderButtons(),
	e.parentNode&&e.parentNode.insertBefore(this.div,e),g&&(this.inputGroup=d.g("input-group").add(this.group),d=this.drawInput("min"),this.minDateBox=d.dateBox,this.minLabel=d.label,this.minInput=d.input,d=this.drawInput("max"),this.maxDateBox=d.dateBox,this.maxLabel=d.label,this.maxInput=d.input));if(g&&(this.setInputValue("min",a),this.setInputValue("max",c),a=b.scroller&&b.scroller.getUnionExtremes()||b.xAxis[0]||{},h(a.dataMin)&&h(a.dataMax)&&(b=b.xAxis[0].minRange||0,this.setInputExtremes("min",
	a.dataMin,Math.min(a.dataMax,this.getInputValue("max"))-b),this.setInputExtremes("max",Math.max(a.dataMin,this.getInputValue("min"))+b,a.dataMax)),this.inputGroup)){var l=0;[this.minLabel,this.minDateBox,this.maxLabel,this.maxDateBox].forEach(function(a){if(a){var b=a.getBBox().width;b&&(a.attr({x:l}),l+=b+f.inputSpacing)}})}this.alignElements();this.rendered=!0}};k.prototype.renderButtons=function(){var a=this,c=this.buttons,b=this.options,d=x.lang,h=this.chart.renderer,k=G(b.buttonTheme),l=k&&k.states,
	m=k.width||28;delete k.width;delete k.states;this.buttonGroup=h.g("range-selector-buttons").add(this.group);var p=this.dropdown=n("select",void 0,{position:"absolute",width:"1px",height:"1px",padding:0,border:0,top:"-9999em",cursor:"pointer",opacity:.0001},this.div);u(p,"touchstart",function(){p.style.fontSize="16px"});[[A.isMS?"mouseover":"mouseenter"],[A.isMS?"mouseout":"mouseleave"],["change","click"]].forEach(function(b){var d=b[0],e=b[1];u(p,d,function(){var b=c[a.currentButtonIndex()];b&&f(b.element,
	e||d)})});this.zoomText=h.label(d&&d.rangeSelectorZoom||"",0).attr({padding:b.buttonTheme.padding,height:b.buttonTheme.height,paddingLeft:0,paddingRight:0}).add(this.buttonGroup);this.chart.styledMode||(this.zoomText.css(b.labelStyle),k["stroke-width"]=y(k["stroke-width"],0));n("option",{textContent:this.zoomText.textStr,disabled:!0},void 0,p);this.buttonOptions.forEach(function(b,d){n("option",{textContent:b.title||b.text},void 0,p);c[d]=h.button(b.text,0,0,function(c){var e=b.events&&b.events.click,
	g;e&&(g=e.call(b,c));!1!==g&&a.clickButton(d);a.isActive=!0},k,l&&l.hover,l&&l.select,l&&l.disabled).attr({"text-align":"center",width:m}).add(a.buttonGroup);b.title&&c[d].attr("title",b.title)})};k.prototype.alignElements=function(){var a=this,c=this.buttonGroup,b=this.buttons,d=this.chart,f=this.group,h=this.inputGroup,k=this.options,l=this.zoomText,m=d.options,p=m.exporting&&!1!==m.exporting.enabled&&m.navigation&&m.navigation.buttonOptions;m=k.buttonPosition;var n=k.inputPosition,t=k.verticalAlign,
	u=function(b,c){return p&&a.titleCollision(d)&&"top"===t&&"right"===c.align&&c.y-b.getBBox().height-12<(p.y||0)+(p.height||0)+d.spacing[0]?-40:0},q=d.plotLeft;if(f&&m&&n){var w=m.x-d.spacing[3];if(c){this.positionButtons();if(!this.initialButtonGroupWidth){var v=0;l&&(v+=l.getBBox().width+5);b.forEach(function(a,c){v+=a.width;c!==b.length-1&&(v+=k.buttonSpacing)});this.initialButtonGroupWidth=v}q-=d.spacing[3];this.updateButtonStates();l=u(c,m);this.alignButtonGroup(l);f.placed=c.placed=d.hasLoaded}c=
	0;h&&(c=u(h,n),"left"===n.align?w=q:"right"===n.align&&(w=-Math.max(d.axisOffset[1],-c)),h.align({y:n.y,width:h.getBBox().width,align:n.align,x:n.x+w-2},!0,d.spacingBox),h.placed=d.hasLoaded);this.handleCollision(c);f.align({verticalAlign:t},!0,d.spacingBox);h=f.alignAttr.translateY;c=f.getBBox().height+20;u=0;"bottom"===t&&(u=(u=d.legend&&d.legend.options)&&"bottom"===u.verticalAlign&&u.enabled&&!u.floating?d.legend.legendHeight+y(u.margin,10):0,c=c+u-20,u=h-c-(k.floating?0:k.y)-(d.titleOffset?d.titleOffset[2]:
	0)-10);if("top"===t)k.floating&&(u=0),d.titleOffset&&d.titleOffset[0]&&(u=d.titleOffset[0]),u+=d.margin[0]-d.spacing[0]||0;else if("middle"===t)if(n.y===m.y)u=h;else if(n.y||m.y)u=0>n.y||0>m.y?u-Math.min(n.y,m.y):h-c;f.translate(k.x,k.y+Math.floor(u));m=this.minInput;n=this.maxInput;h=this.dropdown;k.inputEnabled&&m&&n&&(m.style.marginTop=f.translateY+"px",n.style.marginTop=f.translateY+"px");h&&(h.style.marginTop=f.translateY+"px")}};k.prototype.alignButtonGroup=function(a,c){var b=this.chart,d=
	this.buttonGroup,e=this.options.buttonPosition,g=b.plotLeft-b.spacing[3],f=e.x-b.spacing[3];"right"===e.align?f+=a-g:"center"===e.align&&(f-=g/2);d&&d.align({y:e.y,width:y(c,this.initialButtonGroupWidth),align:e.align,x:f},!0,b.spacingBox)};k.prototype.positionButtons=function(){var a=this.buttons,c=this.chart,b=this.options,d=this.zoomText,f=c.hasLoaded?"animate":"attr",h=b.buttonPosition,k=c=c.plotLeft;d&&"hidden"!==d.visibility&&(d[f]({x:y(c+h.x,c)}),k+=h.x+d.getBBox().width+5);d=0;for(h=this.buttonOptions.length;d<
	h;++d)if("hidden"!==a[d].visibility)a[d][f]({x:k}),k+=a[d].width+b.buttonSpacing;else a[d][f]({x:c})};k.prototype.handleCollision=function(a){var c=this,b=this.chart,d=this.buttonGroup,g=this.inputGroup,f=this.options,h=f.buttonPosition,k=f.dropdown,l=f.inputPosition;f=function(){var a=0;c.buttons.forEach(function(b){b=b.getBBox();b.width>a&&(a=b.width)});return a};var m=function(b){if(g&&d){var c=g.alignAttr.translateX+g.alignOptions.x-a+g.getBBox().x+2,e=g.alignOptions.width,f=d.alignAttr.translateX+
	d.getBBox().x;return f+b>c&&c+e>f&&h.y<l.y+g.getBBox().height}return!1},p=function(){g&&d&&g.attr({translateX:g.alignAttr.translateX+(b.axisOffset[1]>=-a?0:-a),translateY:g.alignAttr.translateY+d.getBBox().height+10})};if(d){if("always"===k){this.collapseButtons(a);m(f())&&p();return}"never"===k&&this.expandButtons()}g&&d?l.align===h.align||m(this.initialButtonGroupWidth+20)?"responsive"===k?(this.collapseButtons(a),m(f())&&p()):p():"responsive"===k&&this.expandButtons():d&&"responsive"===k&&(this.initialButtonGroupWidth>
	b.plotWidth?this.collapseButtons(a):this.expandButtons())};k.prototype.collapseButtons=function(a){var c=this.buttons,b=this.buttonOptions,d=this.chart,g=this.dropdown,f=this.options,h=this.zoomText,k=d.userOptions.rangeSelector&&d.userOptions.rangeSelector.buttonTheme||{},l=function(a){return{text:a?""+a+" \u25be":"\u25be",width:"auto",paddingLeft:y(f.buttonTheme.paddingLeft,k.padding,8),paddingRight:y(f.buttonTheme.paddingRight,k.padding,8)}};h&&h.hide();var m=!1;b.forEach(function(a,b){b=c[b];
	2!==b.state?b.hide():(b.show(),b.attr(l(a.text)),m=!0)});m||(g&&(g.selectedIndex=0),c[0].show(),c[0].attr(l(this.zoomText&&this.zoomText.textStr)));b=f.buttonPosition.align;this.positionButtons();"right"!==b&&"center"!==b||this.alignButtonGroup(a,c[this.currentButtonIndex()].getBBox().width);this.showDropdown()};k.prototype.expandButtons=function(){var a=this.buttons,c=this.buttonOptions,b=this.options,d=this.zoomText;this.hideDropdown();d&&d.show();c.forEach(function(c,d){d=a[d];d.show();d.attr({text:c.text,
	width:b.buttonTheme.width||28,paddingLeft:y(b.buttonTheme.paddingLeft,"unset"),paddingRight:y(b.buttonTheme.paddingRight,"unset")});2>d.state&&d.setState(0)});this.positionButtons()};k.prototype.currentButtonIndex=function(){var a=this.dropdown;return a&&0<a.selectedIndex?a.selectedIndex-1:0};k.prototype.showDropdown=function(){var a=this.buttonGroup,e=this.buttons,b=this.chart,d=this.dropdown;if(a&&d){var f=a.translateX;a=a.translateY;e=e[this.currentButtonIndex()].getBBox();c(d,{left:b.plotLeft+
	f+"px",top:a+.5+"px",width:e.width+"px",height:e.height+"px"});this.hasVisibleDropdown=!0}};k.prototype.hideDropdown=function(){var a=this.dropdown;a&&(c(a,{top:"-9999em",width:"1px",height:"1px"}),this.hasVisibleDropdown=!1)};k.prototype.getHeight=function(){var a=this.options,c=this.group,b=a.y,d=a.buttonPosition.y,f=a.inputPosition.y;if(a.height)return a.height;this.alignElements();a=c?c.getBBox(!0).height+13+b:0;c=Math.min(f,d);if(0>f&&0>d||0<f&&0<d)a+=Math.abs(c);return a};k.prototype.titleCollision=
	function(a){return!(a.options.title.text||a.options.subtitle.text)};k.prototype.update=function(a){var c=this.chart;G(!0,c.options.rangeSelector,a);this.destroy();this.init(c);this.render()};k.prototype.destroy=function(){var a=this,c=a.minInput,b=a.maxInput;a.eventsToUnbind&&(a.eventsToUnbind.forEach(function(a){return a()}),a.eventsToUnbind=void 0);m(a.buttons);c&&(c.onfocus=c.onblur=c.onchange=null);b&&(b.onfocus=b.onblur=b.onchange=null);H(a,function(b,c){b&&"chart"!==c&&(b instanceof B?b.destroy():
	b instanceof X.HTMLElement&&l(b));b!==k.prototype[c]&&(a[c]=null)},this)};return k}();p(q.prototype,{defaultButtons:[{type:"month",count:1,text:"1m",title:"View 1 month"},{type:"month",count:3,text:"3m",title:"View 3 months"},{type:"month",count:6,text:"6m",title:"View 6 months"},{type:"ytd",text:"YTD",title:"View year to date"},{type:"year",count:1,text:"1y",title:"View 1 year"},{type:"all",text:"All",title:"View all"}],inputTypeFormats:{"datetime-local":"%Y-%m-%dT%H:%M:%S",date:"%Y-%m-%d",time:"%H:%M:%S"}});
	"";return q});J(a,"Core/Axis/OrdinalAxis.js",[a["Core/Axis/Axis.js"],a["Core/Globals.js"],a["Core/Series/Series.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=E.addEvent,C=E.correctFloat,F=E.css,x=E.defined,u=E.error,n=E.pick,c=E.timeUnits,h=[],m;(function(a){function l(a,d,e,g,f,h,k){void 0===f&&(f=[]);void 0===h&&(h=0);var b={},l=this.options.tickPixelInterval,m=this.chart.time,p=[],r,n,t=0,q=[],w=-Number.MAX_VALUE;if(!this.options.ordinal&&!this.options.breaks||!f||3>f.length||"undefined"===
	typeof d)return m.getTimeTicks.apply(m,arguments);var z=f.length;for(r=0;r<z;r++){var v=r&&f[r-1]>e;f[r]<d&&(t=r);if(r===z-1||f[r+1]-f[r]>5*h||v){if(f[r]>w){for(n=m.getTimeTicks(a,f[t],f[r],g);n.length&&n[0]<=w;)n.shift();n.length&&(w=n[n.length-1]);p.push(q.length);q=q.concat(n)}t=r+1}if(v)break}if(n){n=n.info;if(k&&n.unitRange<=c.hour){r=q.length-1;for(t=1;t<r;t++)if(m.dateFormat("%d",q[t])!==m.dateFormat("%d",q[t-1])){b[q[t]]="day";var y=!0}y&&(b[q[0]]="day");n.higherRanks=b}n.segmentStarts=p;
	q.info=n}else u(12,!1,this.chart);if(k&&x(l)){n=q.length;m=[];t=[];r=void 0;for(y=n;y--;)p=this.translate(q[y]),r&&(t[y]=r-p),m[y]=r=p;t.sort();t=t[Math.floor(t.length/2)];t<.6*l&&(t=null);y=q[n-1]>e?n-1:n;for(r=void 0;y--;)p=m[y],n=Math.abs(r-p),r&&n<.8*l&&(null===t||n<.8*t)?(b[q[y]]&&!b[q[y+1]]?(n=y+1,r=p):n=y,q.splice(n,1)):r=p}return q}function f(a){var b=this.ordinal.positions;if(!b)return a;var c=b.length-1;if(0>a)a=b[0];else if(a>c)a=b[c];else{c=Math.floor(a);var e=a-c}return"undefined"!==
	typeof e&&"undefined"!==typeof b[c]?b[c]+(e?e*(b[c+1]-b[c]):0):a}function m(a){var b=this.ordinal,c=b.positions;if(!c)return a;var e=(a-(this.old?this.old.min:this.min))*(this.old?this.old.transA:this.transA)+this.minPixelPadding;0<e&&e<this.left+this.len||(b.extendedOrdinalPositions||(b.extendedOrdinalPositions=b.getExtendedPositions()),c=b.extendedOrdinalPositions);if(c&&c.length){a=b.getIndexOfPoint(e,c);b=C(a%1);if(0<=a&&a<c.length-1)return c[Math.floor(a)]+b*(c[Math.ceil(a)]-c[Math.floor(a)]);
	b=c.length;e=c[0];c=c[b-1];var g=(c-e)/(b-1);return 0>a?e+g*a:c+g*(a-b)}return a}function B(b,c){var d=a.Additions.findIndexOf(b,c,!0);return b[d]===c?d:d+(c-b[d])/(b[d+1]-b[d])}function E(){this.ordinal||(this.ordinal=new a.Additions(this))}function K(){this.isXAxis&&x(this.options.overscroll)&&this.max===this.dataMax&&(!this.chart.mouseIsDown||this.isInternal)&&(!this.eventArgs||this.eventArgs&&"navigator"!==this.eventArgs.trigger)&&(this.max+=this.options.overscroll,!this.isInternal&&x(this.userMin)&&
	(this.min+=this.options.overscroll))}function y(){this.horiz&&!this.isDirty&&(this.isDirty=this.isOrdinal&&this.chart.navigator&&!this.chart.navigator.adaptToUpdatedData)}function t(){this.ordinal&&(this.ordinal.beforeSetTickPositions(),this.tickInterval=this.ordinal.postProcessTickInterval(this.tickInterval))}function w(a){var b=this.xAxis[0],c=b.options.overscroll,e=a.originalEvent.chartX,g=this.options.chart.panning,f=!1;if(g&&"y"!==g.type&&b.options.ordinal&&b.series.length){var h=this.mouseDownX,
	k=b.getExtremes(),l=k.dataMax,m=k.min,p=k.max,n=this.hoverPoints,t=b.closestPointRange||b.ordinal&&b.ordinal.overscrollPointsRange;h=(h-e)/(b.translationSlope*(b.ordinal.slope||t));t=b.ordinal.getExtendedPositions();t={ordinal:{positions:t,extendedOrdinalPositions:t}};var u=b.index2val,q=b.val2lin,w=void 0,v=w=void 0,y=void 0;t.ordinal.positions?1<Math.abs(h)&&(n&&n.forEach(function(a){a.setState()}),0>h?(v=t,y=b.ordinal.positions?b:t):(v=b.ordinal.positions?b:t,y=t),w=y.ordinal.positions,l>w[w.length-
	1]&&w.push(l),this.fixedRange=p-m,w=b.navigatorAxis.toFixedRange(void 0,void 0,u.apply(v,[q.apply(v,[m,!0])+h]),u.apply(y,[q.apply(y,[p,!0])+h])),w.min>=Math.min(k.dataMin,m)&&w.max<=Math.max(l,p)+c&&b.setExtremes(w.min,w.max,!0,!1,{trigger:"pan"}),this.mouseDownX=e,F(this.container,{cursor:"move"})):f=!0}else f=!0;f||g&&/y/.test(g.type)?c&&(b.max=b.dataMax+c):a.preventDefault()}function k(){var a=this.xAxis;a&&a.options.ordinal&&(delete a.ordinal.index,delete a.ordinal.extendedOrdinalPositions)}
	function g(a,c){var b=this.ordinal,d=b.positions,e=b.slope,g=b.extendedOrdinalPositions;if(!d)return a;var f=d.length;if(d[0]<=a&&d[f-1]>=a)a=B(d,a);else{g||(g=b.getExtendedPositions&&b.getExtendedPositions(),b.extendedOrdinalPositions=g);if(!g||!g.length)return a;f=g.length;e||(e=(g[f-1]-g[0])/f);d=B(g,d[0]);a>=g[0]&&a<=g[f-1]?a=B(g,a)-d:a<g[0]?(a=g[0]-a,a=-d-a/e):(a-=g[f-1],a=a/e+f-d)}return c?a:e*(a||0)+b.offset}a.compose=function(a,c,e){if(-1===h.indexOf(a)){h.push(a);var b=a.prototype;b.getTimeTicks=
	l;b.index2val=f;b.lin2val=m;b.val2lin=g;b.ordinal2lin=b.val2lin;v(a,"afterInit",E);v(a,"foundExtremes",K);v(a,"afterSetScale",y);v(a,"initialAxisTranslation",t)}-1===h.indexOf(e)&&(h.push(e),v(e,"pan",w));-1===h.indexOf(c)&&(h.push(c),v(c,"updatedData",k));return a};var e=function(){function a(a){this.index={};this.axis=a}a.prototype.beforeSetTickPositions=function(){var a=this.axis,b=a.ordinal,c=a.getExtremes(),e=c.min,g=c.max,f=a.isXAxis&&!!a.options.breaks;c=a.options.ordinal;var h=a.chart.options.chart.ignoreHiddenSeries,
	k,l,m=[],p=Number.MAX_VALUE,t=!1,u=!1,q=!1;if(c||f){var w=0;a.series.forEach(function(a,b){k=[];0<b&&"highcharts-navigator-series"!==a.options.id&&1<a.processedXData.length&&(u=w!==a.processedXData[1]-a.processedXData[0]);w=a.processedXData[1]-a.processedXData[0];a.boosted&&(q=a.boosted);if(!(h&&!1===a.visible||!1===a.takeOrdinalPosition&&!f)&&(m=m.concat(a.processedXData),v=m.length,m.sort(function(a,b){return a-b}),p=Math.min(p,n(a.closestPointRange,p)),v)){for(b=0;b<v-1;)m[b]!==m[b+1]&&k.push(m[b+
	1]),b++;k[0]!==m[0]&&k.unshift(m[0]);m=k}});u&&q&&(m.pop(),m.shift());var v=m.length;if(2<v){var y=m[1]-m[0];for(l=v-1;l--&&!t;)m[l+1]-m[l]!==y&&(t=!0);!a.options.keepOrdinalPadding&&(m[0]-e>y||g-m[m.length-1]>y)&&(t=!0)}else a.options.overscroll&&(2===v?p=m[1]-m[0]:1===v?(p=a.options.overscroll,m=[m[0],m[0]+p]):p=b.overscrollPointsRange);t||a.forceOrdinal?(a.options.overscroll&&(b.overscrollPointsRange=p,m=m.concat(b.getOverscrollPositions())),b.positions=m,y=a.ordinal2lin(Math.max(e,m[0]),!0),l=
	Math.max(a.ordinal2lin(Math.min(g,m[m.length-1]),!0),1),b.slope=g=(g-e)/(l-y),b.offset=e-y*g):(b.overscrollPointsRange=n(a.closestPointRange,b.overscrollPointsRange),b.positions=a.ordinal.slope=b.offset=void 0)}a.isOrdinal=c&&t;b.groupIntervalFactor=null};a.findIndexOf=function(a,b,c){for(var d=0,e=a.length-1,g;d<e;)g=Math.ceil((d+e)/2),a[g]<=b?d=g:e=g-1;return a[d]===b?d:c?d:-1};a.prototype.getExtendedPositions=function(){var a=this,b=a.axis,c=b.constructor.prototype,e=b.chart,g=b.series[0].currentDataGrouping,
	f=g?g.count+g.unitName:"raw",h=b.options.overscroll,k=b.getExtremes(),l=void 0,m=a.index;m||(m=a.index={});if(!m[f]){var p={series:[],chart:e,forceOrdinal:!1,getExtremes:function(){return{min:k.dataMin,max:k.dataMax+h}},getGroupPixelWidth:c.getGroupPixelWidth,getTimeTicks:c.getTimeTicks,options:{ordinal:!0},ordinal:{getGroupIntervalFactor:this.getGroupIntervalFactor},ordinal2lin:c.ordinal2lin,getIndexOfPoint:c.getIndexOfPoint,val2lin:c.val2lin};p.ordinal.axis=p;b.series.forEach(function(b){l={xAxis:p,
	xData:b.xData.slice(),chart:e,destroyGroupedData:q.noop,getProcessedData:A.prototype.getProcessedData,applyGrouping:A.prototype.applyGrouping};l.xData=l.xData.concat(a.getOverscrollPositions());l.options={dataGrouping:g?{firstAnchor:"firstPoint",anchor:"middle",lastAnchor:"lastPoint",enabled:!0,forced:!0,approximation:"open",units:[[g.unitName,[g.count]]]}:{enabled:!1}};p.series.push(l);b.processData.apply(l)});l.closestPointRange!==l.basePointRange&&l.currentDataGrouping&&(p.forceOrdinal=!0);b.ordinal.beforeSetTickPositions.apply({axis:p});
	m[f]=p.ordinal.positions}return m[f]};a.prototype.getGroupIntervalFactor=function(a,b,c){c=c.processedXData;var d=c.length,e=[];var g=this.groupIntervalFactor;if(!g){for(g=0;g<d-1;g++)e[g]=c[g+1]-c[g];e.sort(function(a,b){return a-b});e=e[Math.floor(d/2)];a=Math.max(a,c[0]);b=Math.min(b,c[d-1]);this.groupIntervalFactor=g=d*e/(b-a)}return g};a.prototype.getIndexOfPoint=function(b,c){var d=this.axis,e=this.positions?this.positions[0]:0,g=d.series[0].points&&d.series[0].points[0]&&d.series[0].points[0].plotX||
	d.minPixelPadding;1<d.series.length&&d.series.forEach(function(a){a.points&&x(a.points[0])&&x(a.points[0].plotX)&&a.points[0].plotX<g&&a.points[0].plotX>=n(d.min,-Infinity)&&(g=a.points[0].plotX)});b=(b-g)/(d.translationSlope*(this.slope||d.closestPointRange||this.overscrollPointsRange));return a.findIndexOf(c,e)+b};a.prototype.getOverscrollPositions=function(){var a=this.axis,b=a.options.overscroll,c=this.overscrollPointsRange,e=[],g=a.dataMax;if(x(c))for(;g<=a.dataMax+b;)g+=c,e.push(g);return e};
	a.prototype.postProcessTickInterval=function(a){var b=this.axis,c=this.slope;return c?b.options.breaks?b.closestPointRange||a:a/(c/b.closestPointRange):a};return a}();a.Additions=e})(m||(m={}));return m});J(a,"Series/HLC/HLCPoint.js",[a["Core/Series/SeriesRegistry.js"]],function(a){var q=this&&this.__extends||function(){var a=function(q,v){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,q){a.__proto__=q}||function(a,q){for(var v in q)q.hasOwnProperty(v)&&(a[v]=q[v])};return a(q,
	v)};return function(q,v){function A(){this.constructor=q}a(q,v);q.prototype=null===v?Object.create(v):(A.prototype=v.prototype,new A)}}();return function(a){function v(){var q=null!==a&&a.apply(this,arguments)||this;q.close=void 0;q.high=void 0;q.low=void 0;q.options=void 0;q.plotClose=void 0;q.series=void 0;return q}q(v,a);return v}(a.seriesTypes.column.prototype.pointClass)});J(a,"Series/HLC/HLCSeriesDefaults.js",[],function(){"";return{lineWidth:1,tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'},
	threshold:null,states:{hover:{lineWidth:3}},stickyTracking:!0}});J(a,"Series/HLC/HLCSeries.js",[a["Series/HLC/HLCPoint.js"],a["Series/HLC/HLCSeriesDefaults.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=this&&this.__extends||function(){var a=function(n,c){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&(a[h]=c[h])};return a(n,c)};return function(n,c){function h(){this.constructor=
	n}a(n,c);n.prototype=null===c?Object.create(c):(h.prototype=c.prototype,new h)}}(),C=A.seriesTypes.column,F=E.extend,x=E.merge;E=function(a){function n(){var c=null!==a&&a.apply(this,arguments)||this;c.data=void 0;c.options=void 0;c.points=void 0;c.yData=void 0;return c}v(n,a);n.prototype.extendStem=function(a,h,m){var c=a[0];a=a[1];"number"===typeof c[2]&&(c[2]=Math.max(m+h,c[2]));"number"===typeof a[2]&&(a[2]=Math.min(m-h,a[2]))};n.prototype.getPointPath=function(a,h){h=h.strokeWidth();var c=a.series,
	l=h%2/2,p=Math.round(a.plotX)-l,f=Math.round(a.shapeArgs.width/2),n=[["M",p,Math.round(a.yBottom)],["L",p,Math.round(a.plotHigh)]];null!==a.close&&(a=Math.round(a.plotClose)+l,n.push(["M",p,a],["L",p+f,a]),c.extendStem(n,h/2,a));return n};n.prototype.drawSinglePoint=function(a){var c=a.series,m=c.chart,l=a.graphic;"undefined"!==typeof a.plotY&&(l||(a.graphic=l=m.renderer.path().add(c.group)),m.styledMode||l.attr(c.pointAttribs(a,a.selected&&"select")),c=c.getPointPath(a,l),l[l?"animate":"attr"]({d:c}).addClass(a.getClassName(),
	!0))};n.prototype.drawPoints=function(){this.points.forEach(this.drawSinglePoint)};n.prototype.init=function(){a.prototype.init.apply(this,arguments);this.options.stacking=void 0};n.prototype.pointAttribs=function(c,h){c=a.prototype.pointAttribs.call(this,c,h);delete c.fill;return c};n.prototype.toYData=function(a){return[a.high,a.low,a.close]};n.prototype.translate=function(){var c=this,h=c.yAxis,m=this.pointArrayMap&&this.pointArrayMap.slice()||[],l=m.map(function(a){return"plot".concat(a.charAt(0).toUpperCase()+
	a.slice(1))});l.push("yBottom");m.push("low");a.prototype.translate.apply(c);c.points.forEach(function(a){m.forEach(function(f,m){f=a[f];null!==f&&(c.dataModify&&(f=c.dataModify.modifyValue(f)),a[l[m]]=h.toPixels(f,!0))});a.tooltipPos[1]=a.plotHigh+h.pos-c.chart.plotTop})};n.defaultOptions=x(C.defaultOptions,q);return n}(C);F(E.prototype,{pointClass:a,animate:null,directTouch:!1,pointArrayMap:["high","low","close"],pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},pointValKey:"close"});
	A.registerSeriesType("hlc",E);return E});J(a,"Series/OHLC/OHLCPoint.js",[a["Core/Series/SeriesRegistry.js"]],function(a){var q=this&&this.__extends||function(){var a=function(q,v){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,q){a.__proto__=q}||function(a,q){for(var v in q)q.hasOwnProperty(v)&&(a[v]=q[v])};return a(q,v)};return function(q,v){function A(){this.constructor=q}a(q,v);q.prototype=null===v?Object.create(v):(A.prototype=v.prototype,new A)}}();return function(a){function v(){var q=
	null!==a&&a.apply(this,arguments)||this;q.open=void 0;q.options=void 0;q.plotOpen=void 0;q.series=void 0;return q}q(v,a);v.prototype.getClassName=function(){return a.prototype.getClassName.call(this)+(this.open<this.close?" highcharts-point-up":" highcharts-point-down")};v.prototype.resolveUpColor=function(){this.open<this.close&&!this.options.color&&this.series.options.upColor&&(this.color=this.series.options.upColor)};v.prototype.resolveColor=function(){a.prototype.resolveColor.call(this);this.resolveUpColor()};
	v.prototype.getZone=function(){var q=a.prototype.getZone.call(this);this.resolveUpColor();return q};v.prototype.applyOptions=function(){a.prototype.applyOptions.apply(this,arguments);this.resolveColor&&this.resolveColor();return this};return v}(a.seriesTypes.hlc.prototype.pointClass)});J(a,"Series/OHLC/OHLCSeriesDefaults.js",[],function(){"";return{tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'}}});
	J(a,"Series/OHLC/OHLCSeries.js",[a["Series/OHLC/OHLCPoint.js"],a["Series/OHLC/OHLCSeriesDefaults.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E){function v(a){a=a.options;var c=a.dataGrouping;c&&a.useOhlcData&&"highcharts-navigator-series"!==a.id&&(c.approximation="ohlc")}function C(a){a=a.options;a.useOhlcData&&"highcharts-navigator-series"!==a.id&&n(this,{pointValKey:m.prototype.pointValKey,pointArrayMap:m.prototype.pointArrayMap,toYData:m.prototype.toYData})}var F=
	this&&this.__extends||function(){var a=function(c,f){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var f in c)c.hasOwnProperty(f)&&(a[f]=c[f])};return a(c,f)};return function(c,f){function h(){this.constructor=c}a(c,f);c.prototype=null===f?Object.create(f):(h.prototype=f.prototype,new h)}}(),x=A.seriesTypes.hlc,u=E.addEvent,n=E.extend,c=E.merge,h=[],m=function(a){function l(){var c=null!==a&&a.apply(this,arguments)||this;c.data=void 0;c.options=
	void 0;c.points=void 0;return c}F(l,a);l.compose=function(a){for(var c=1;c<arguments.length;c++);-1===h.indexOf(a)&&(h.push(a),u(a,"afterSetOptions",v),u(a,"init",C))};l.prototype.getPointPath=function(c,h){var f=a.prototype.getPointPath.call(this,c,h);h=h.strokeWidth();var l=h%2/2,m=Math.round(c.plotX)-l,p=Math.round(c.shapeArgs.width/2);null!==c.open&&(c=Math.round(c.plotOpen)+l,f.push(["M",m,c],["L",m-p,c]),a.prototype.extendStem.call(this,f,h/2,c));return f};l.prototype.pointAttribs=function(c,
	h){h=a.prototype.pointAttribs.call(this,c,h);var f=this.options;delete h.fill;!c.options.color&&f.upColor&&c.open<c.close&&(h.stroke=f.upColor);return h};l.prototype.toYData=function(a){return[a.open,a.high,a.low,a.close]};l.defaultOptions=c(x.defaultOptions,q);return l}(x);n(m.prototype,{pointClass:a,pointArrayMap:["open","high","low","close"]});A.registerSeriesType("ohlc",m);return m});J(a,"Series/Candlestick/CandlestickSeriesDefaults.js",[a["Core/Defaults.js"],a["Core/Utilities.js"]],function(a,
	q){"";return{states:{hover:{lineWidth:2}},threshold:null,lineColor:"#000000",lineWidth:1,upColor:"#ffffff",stickyTracking:!0}});J(a,"Series/Candlestick/CandlestickSeries.js",[a["Series/Candlestick/CandlestickSeriesDefaults.js"],a["Core/Defaults.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q,A,E){var v=this&&this.__extends||function(){var a=function(c,h){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var h in c)c.hasOwnProperty(h)&&
	(a[h]=c[h])};return a(c,h)};return function(c,h){function m(){this.constructor=c}a(c,h);c.prototype=null===h?Object.create(h):(m.prototype=h.prototype,new m)}}(),C=q.defaultOptions;q=A.seriesTypes;var F=q.column,x=q.ohlc,u=E.merge;E=function(n){function c(){var a=null!==n&&n.apply(this,arguments)||this;a.data=void 0;a.options=void 0;a.points=void 0;return a}v(c,n);c.prototype.pointAttribs=function(a,c){var h=F.prototype.pointAttribs.call(this,a,c),m=this.options,f=a.open<a.close,n=m.lineColor||this.color,
	q=a.color||this.color;h["stroke-width"]=m.lineWidth;h.fill=a.options.color||(f?m.upColor||q:q);h.stroke=a.options.lineColor||(f?m.upLineColor||n:n);c&&(a=m.states[c],h.fill=a.color||h.fill,h.stroke=a.lineColor||h.stroke,h["stroke-width"]=a.lineWidth||h["stroke-width"]);return h};c.prototype.drawPoints=function(){for(var a=this.chart,c=this.yAxis.reversed,l=0,p=this.points;l<p.length;l++){var f=p[l],n=f.graphic,q=!n;if("undefined"!==typeof f.plotY){n||(f.graphic=n=a.renderer.path().add(this.group));
	this.chart.styledMode||n.attr(this.pointAttribs(f,f.selected&&"select")).shadow(this.options.shadow);var u=n.strokeWidth()%2/2;var v=Math.round(f.plotX)-u;var y=f.plotOpen;var t=f.plotClose;var w=Math.min(y,t);y=Math.max(y,t);var k=Math.round(f.shapeArgs.width/2);t=c?y!==f.yBottom:Math.round(w)!==Math.round(f.plotHigh);var g=c?Math.round(w)!==Math.round(f.plotHigh):y!==f.yBottom;w=Math.round(w)+u;y=Math.round(y)+u;u=[];u.push(["M",v-k,y],["L",v-k,w],["L",v+k,w],["L",v+k,y],["Z"],["M",v,w],["L",v,
	t?Math.round(c?f.yBottom:f.plotHigh):w],["M",v,y],["L",v,g?Math.round(c?f.plotHigh:f.yBottom):y]);n[q?"attr":"animate"]({d:u}).addClass(f.getClassName(),!0)}}};c.defaultOptions=u(x.defaultOptions,C.plotOptions,{tooltip:x.defaultOptions.tooltip},a);return c}(x);A.registerSeriesType("candlestick",E);return E});J(a,"Series/Flags/FlagsPoint.js",[a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,q){var v=this&&this.__extends||function(){var a=function(q,v){a=Object.setPrototypeOf||
	{__proto__:[]}instanceof Array&&function(a,q){a.__proto__=q}||function(a,q){for(var n in q)q.hasOwnProperty(n)&&(a[n]=q[n])};return a(q,v)};return function(q,v){function x(){this.constructor=q}a(q,v);q.prototype=null===v?Object.create(v):(x.prototype=v.prototype,new x)}}(),E=q.isNumber;return function(a){function q(){var q=null!==a&&a.apply(this,arguments)||this;q.options=void 0;q.series=void 0;q.ttBelow=!1;return q}v(q,a);q.prototype.isValid=function(){return E(this.y)||"undefined"===typeof this.y};
	q.prototype.hasNewShapeType=function(){var a=this.options.shape||this.series.options.shape;return this.graphic&&a&&a!==this.graphic.symbolKey};return q}(a.seriesTypes.column.prototype.pointClass)});J(a,"Series/Flags/FlagsSeriesDefaults.js",[],function(){"";return{pointRange:0,allowOverlapX:!1,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}"},threshold:null,y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd6eb"}},style:{fontSize:"11px",
	fontWeight:"bold"}}});J(a,"Series/Flags/FlagsSymbols.js",[a["Core/Renderer/RendererRegistry.js"]],function(a){var q;(function(q){function v(a,q,u,n,c){var h=c&&c.anchorX||a;c=c&&c.anchorY||q;var m=this.circle(h-1,c-1,2,2);m.push(["M",h,c],["L",a,q+n],["L",a,q],["L",a+u,q],["L",a+u,q+n],["L",a,q+n],["Z"]);return m}function A(a,q){a[q+"pin"]=function(u,n,c,h,m){var l=m&&m.anchorX;m=m&&m.anchorY;"circle"===q&&h>c&&(u-=Math.round((h-c)/2),c=h);var p=a[q](u,n,c,h);if(l&&m){var f=l;"circle"===q?f=u+c/2:
	(u=p[0],c=p[1],"M"===u[0]&&"L"===c[0]&&(f=(u[1]+c[1])/2));p.push(["M",f,n>m?n:n+h],["L",l,m]);p=p.concat(a.circle(l-1,m-1,2,2))}return p}}var C=[];q.compose=function(q){if(-1===C.indexOf(q)){C.push(q);var x=q.prototype.symbols;x.flag=v;A(x,"circle");A(x,"square")}var u=a.getRendererType();C.indexOf(u)&&(C.push(u),x=q.prototype.symbols,q=u.prototype.symbols,q.circlepin=x.circlepin,q.flag=x.flag.bind(x),q.squarepin=x.squarepin)}})(q||(q={}));return q});J(a,"Series/OnSeriesComposition.js",[a["Series/Column/ColumnSeries.js"],
	a["Core/Series/Series.js"],a["Core/Utilities.js"]],function(a,q,A){var v=a.prototype,B=q.prototype,C=A.defined,F=A.stableSort,x;(function(a){function n(a){return B.getPlotBox.call(this.options.onSeries&&this.chart.get(this.options.onSeries)||this,a)}function c(){v.translate.apply(this);var a=this,c=a.options,h=a.chart,f=a.points,n=c.onSeries,q=(n=n&&h.get(n))&&n.options.step,u=n&&n.points,x=h.inverted,y=a.xAxis,t=a.yAxis;h=f.length-1;var w;c=c.onKey||"y";var k=u&&u.length,g=0,e;if(n&&n.visible&&k){g=
	(n.pointXOffset||0)+(n.barW||0)/2;var b=n.currentDataGrouping;var d=u[k-1].x+(b?b.totalRange:0);F(f,function(a,b){return a.x-b.x});for(c="plot"+c[0].toUpperCase()+c.substr(1);k--&&f[h];){var r=u[k];b=f[h];b.y=r.y;if(r.x<=b.x&&"undefined"!==typeof r[c]){if(b.x<=d&&(b.plotY=r[c],r.x<b.x&&!q&&(e=u[k+1])&&"undefined"!==typeof e[c])){var z=(b.x-r.x)/(e.x-r.x);b.plotY+=z*(e[c]-r[c]);b.y+=z*(e.y-r.y)}h--;k++;if(0>h)break}}}f.forEach(function(b,c){b.plotX+=g;if("undefined"===typeof b.plotY||x)0<=b.plotX&&
	b.plotX<=y.len?x?(b.plotY=y.translate(b.x,0,1,0,1),b.plotX=C(b.y)?t.translate(b.y,0,0,0,1):0):b.plotY=(y.opposite?0:a.yAxis.len)+y.offset:b.shapeArgs={};if((w=f[c-1])&&w.plotX===b.plotX){"undefined"===typeof w.stackIndex&&(w.stackIndex=0);var d=w.stackIndex+1}b.stackIndex=d});this.onSeries=n}var h=[];a.compose=function(a){if(-1===h.indexOf(a)){h.push(a);var l=a.prototype;l.getPlotBox=n;l.translate=c}return a};a.getPlotBox=n;a.translate=c})(x||(x={}));return x});J(a,"Series/Flags/FlagsSeries.js",[a["Series/Flags/FlagsPoint.js"],
	a["Series/Flags/FlagsSeriesDefaults.js"],a["Series/Flags/FlagsSymbols.js"],a["Core/Globals.js"],a["Series/OnSeriesComposition.js"],a["Core/Renderer/RendererUtilities.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Renderer/SVG/SVGElement.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x,u){var n=this&&this.__extends||function(){var a=function(c,f){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,c){a.__proto__=c}||function(a,c){for(var f in c)c.hasOwnProperty(f)&&(a[f]=c[f])};
	return a(c,f)};return function(c,f){function h(){this.constructor=c}a(c,f);c.prototype=null===f?Object.create(f):(h.prototype=f.prototype,new h)}}();E=E.noop;var c=C.distribute,h=F.series,m=F.seriesTypes.column,l=u.addEvent,p=u.defined;C=u.extend;var f=u.merge,v=u.objectEach,G=u.wrap;u=function(a){function u(){var c=null!==a&&a.apply(this,arguments)||this;c.data=void 0;c.options=void 0;c.points=void 0;return c}n(u,a);u.prototype.animate=function(a){a&&this.setClip()};u.prototype.drawPoints=function(){var a=
	this.points,h=this.chart,l=h.renderer,k=h.inverted,g=this.options,e=g.y,b=this.yAxis,d={},m=[],n;for(n=a.length;n--;){var q=a[n];var u=(k?q.plotY:q.plotX)>this.xAxis.len;var A=q.plotX;var B=q.stackIndex;var C=q.options.shape||g.shape;var D=q.plotY;"undefined"!==typeof D&&(D=q.plotY+e-("undefined"!==typeof B&&B*g.stackDistance));q.anchorX=B?void 0:q.plotX;var E=B?void 0:q.plotY;var F="flag"!==C;B=q.graphic;"undefined"!==typeof D&&0<=A&&!u?(B&&q.hasNewShapeType()&&(B=B.destroy()),B||(B=q.graphic=l.label("",
	null,null,C,null,null,g.useHTML).addClass("highcharts-point").add(this.markerGroup),q.graphic.div&&(q.graphic.div.point=q),B.isNew=!0),B.attr({align:F?"center":"left",width:g.width,height:g.height,"text-align":g.textAlign}),h.styledMode||B.attr(this.pointAttribs(q)).css(f(g.style,q.style)).shadow(g.shadow),0<A&&(A-=B.strokeWidth()%2),C={y:D,anchorY:E},g.allowOverlapX&&(C.x=A,C.anchorX=q.anchorX),B.attr({text:q.options.title||g.title||"A"})[B.isNew?"attr":"animate"](C),g.allowOverlapX||(d[q.plotX]?
	d[q.plotX].size=Math.max(d[q.plotX].size,B.width):d[q.plotX]={align:F?.5:0,size:B.width,target:A,anchorX:A}),q.tooltipPos=[A,D+b.pos-h.plotTop]):B&&(q.graphic=B.destroy())}if(!g.allowOverlapX){var H=100;v(d,function(a){a.plotX=a.anchorX;m.push(a);H=Math.max(a.size,H)});c(m,k?b.len:this.xAxis.len,H);for(h=0;h<a.length;h++)l=a[h],e=l.plotX,(e=(k=l.graphic)&&d[e])&&k&&(p(e.pos)?k[k.isNew?"attr":"animate"]({x:e.pos+(e.align||0)*e.size,anchorX:l.anchorX}).show().isNew=!1:k.hide().isNew=!0)}g.useHTML&&
	this.markerGroup&&G(this.markerGroup,"on",function(a){return x.prototype.on.apply(a.apply(this,[].slice.call(arguments,1)),[].slice.call(arguments,1))})};u.prototype.drawTracker=function(){var c=this.points;a.prototype.drawTracker.call(this);for(var f=function(a){var g=a.graphic;g&&(a.unbindMouseOver&&a.unbindMouseOver(),a.unbindMouseOver=l(g.element,"mouseover",function(){0<a.stackIndex&&!a.raised&&(a._y=g.y,g.attr({y:a._y-8}),a.raised=!0);for(var e=0;e<c.length;e++){var b=c[e];b!==a&&b.raised&&
	b.graphic&&(b.graphic.attr({y:b._y}),b.raised=!1)}}))},h=0;h<c.length;h++)f(c[h])};u.prototype.pointAttribs=function(a,c){var f=this.options,h=a&&a.color||this.color,g=f.lineColor,e=a&&a.lineWidth;a=a&&a.fillColor||f.fillColor;c&&(a=f.states[c].fillColor,g=f.states[c].lineColor,e=f.states[c].lineWidth);return{fill:a||h,stroke:g||h,"stroke-width":e||f.lineWidth||0}};u.prototype.setClip=function(){h.prototype.setClip.apply(this,arguments);!1!==this.options.clip&&this.sharedClipKey&&this.markerGroup&&
	this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey])};u.compose=A.compose;u.defaultOptions=f(m.defaultOptions,q);return u}(m);B.compose(u);C(u.prototype,{allowDG:!1,forceCrop:!0,invertible:!1,noSharedTooltip:!0,pointClass:a,sorted:!1,takeOrdinalPosition:!1,trackerGroups:["markerGroup"],buildKDTree:E,init:h.prototype.init});F.registerSeriesType("flags",u);"";return u});J(a,"Core/Chart/StockChart.js",[a["Core/Axis/Axis.js"],a["Core/Chart/Chart.js"],a["Core/FormatUtilities.js"],a["Core/Defaults.js"],
	a["Stock/Navigator/NavigatorDefaults.js"],a["Stock/RangeSelector/RangeSelectorDefaults.js"],a["Stock/Scrollbar/ScrollbarDefaults.js"],a["Core/Series/Series.js"],a["Core/Renderer/SVG/SVGRenderer.js"],a["Core/Utilities.js"]],function(a,q,A,E,B,C,F,x,u,n){function c(a,c){return"xAxis"===a?{minPadding:0,maxPadding:0,overscroll:0,ordinal:!0,title:{text:null},labels:{overflow:"justify"},showLastLabel:!0}:"yAxis"===a?{labels:{y:-2},opposite:w(c.opposite,!0),showLastLabel:!(!c.categories&&"category"!==c.type),
	title:{text:null}}:{}}function h(a,c){return"xAxis"===a?(a={type:"datetime",categories:void 0},w(c.navigator&&c.navigator.enabled,B.enabled,!0)&&(a.startOnTick=!1,a.endOnTick=!1),a):{}}var m=this&&this.__extends||function(){var a=function(c,b){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=b}||function(a,b){for(var c in b)b.hasOwnProperty(c)&&(a[c]=b[c])};return a(c,b)};return function(c,b){function d(){this.constructor=c}a(c,b);c.prototype=null===b?Object.create(b):
	(d.prototype=b.prototype,new d)}}(),l=A.format,p=E.getOptions;A=n.addEvent;var f=n.clamp,v=n.defined,G=n.extend,H=n.find,J=n.isNumber,y=n.isString,t=n.merge,w=n.pick,k=n.splat;n=function(a){function e(){return null!==a&&a.apply(this,arguments)||this}m(e,a);e.prototype.init=function(b,d){var e=p(),g=b.xAxis,f=b.yAxis,l=w(b.navigator&&b.navigator.enabled,B.enabled,!0);b.xAxis=b.yAxis=void 0;l=t({chart:{panning:{enabled:!0,type:"x"},zooming:{pinchType:"x"}},navigator:{enabled:l},scrollbar:{enabled:w(F.enabled,
	!0)},rangeSelector:{enabled:w(C.rangeSelector.enabled,!0)},title:{text:null},tooltip:{split:w(e.tooltip.split,!0),crosshairs:!0},legend:{enabled:!1}},b,{isStock:!0});b.xAxis=g;b.yAxis=f;l.xAxis=k(b.xAxis||{}).map(function(a,d){return t(c("xAxis",a),e.xAxis,e.xAxis&&e.xAxis[d],a,h("xAxis",b))});l.yAxis=k(b.yAxis||{}).map(function(a,b){return t(c("yAxis",a),e.yAxis,e.yAxis&&e.yAxis[b],a)});a.prototype.init.call(this,l,d)};e.prototype.createAxis=function(b,d){d.axis=t(c(b,d.axis),d.axis,h(b,this.userOptions));
	return a.prototype.createAxis.call(this,b,d)};return e}(q);(function(a){a.stockChart=function(c,b,d){return new a(c,b,d)}})(n||(n={}));A(x,"setOptions",function(a){var c;this.chart.options.isStock&&(this.is("column")||this.is("columnrange")?c={borderWidth:0,shadow:!1}:this.is("scatter")||this.is("sma")||(c={marker:{enabled:!1,radius:2}}),c&&(a.plotOptions[this.type]=t(a.plotOptions[this.type],c)))});A(a,"autoLabelAlign",function(a){var c=this.chart,b=this.options;c=c._labelPanes=c._labelPanes||{};
	var d=this.options.labels;this.chart.options.isStock&&"yAxis"===this.coll&&(b=b.top+","+b.height,!c[b]&&d.enabled&&(15===d.x&&(d.x=0),"undefined"===typeof d.align&&(d.align="right"),c[b]=this,a.align="right",a.preventDefault()))});A(a,"destroy",function(){var a=this.chart,c=this.options&&this.options.top+","+this.options.height;c&&a._labelPanes&&a._labelPanes[c]===this&&delete a._labelPanes[c]});A(a,"getPlotLinePath",function(a){function c(a){var c="xAxis"===a?"yAxis":"xAxis";a=b.options[c];return J(a)?
	[g[c][a]]:y(a)?[g.get(a)]:d.map(function(a){return a[c]})}var b=this,d=this.isLinked&&!this.series?this.linkedParent.series:this.series,g=b.chart,h=g.renderer,k=b.left,l=b.top,m,n,p,q,t=[],u=[],x=a.translatedValue,A=a.value,B=a.force;if(g.options.isStock&&!1!==a.acrossPanes&&"xAxis"===b.coll||"yAxis"===b.coll){a.preventDefault();u=c(b.coll);var C=b.isXAxis?g.yAxis:g.xAxis;C.forEach(function(a){if(v(a.options.id)?-1===a.options.id.indexOf("navigator"):1){var c=a.isXAxis?"yAxis":"xAxis";c=v(a.options[c])?
	g[c][a.options[c]]:g[c][0];b===c&&u.push(a)}});var D=u.length?[]:[b.isXAxis?g.yAxis[0]:g.xAxis[0]];u.forEach(function(a){-1!==D.indexOf(a)||H(D,function(b){return b.pos===a.pos&&b.len===a.len})||D.push(a)});var E=w(x,b.translate(A,void 0,void 0,a.old));J(E)&&(b.horiz?D.forEach(function(a){var c;n=a.pos;q=n+a.len;m=p=Math.round(E+b.transB);"pass"!==B&&(m<k||m>k+b.width)&&(B?m=p=f(m,k,k+b.width):c=!0);c||t.push(["M",m,n],["L",p,q])}):D.forEach(function(a){var c;m=a.pos;p=m+a.len;n=q=Math.round(l+b.height-
	E);"pass"!==B&&(n<l||n>l+b.height)&&(B?n=q=f(n,l,l+b.height):c=!0);c||t.push(["M",m,n],["L",p,q])}));a.path=0<t.length?h.crispPolyLine(t,a.lineWidth||1):null}});u.prototype.crispPolyLine=function(a,c){for(var b=0;b<a.length;b+=2){var d=a[b],e=a[b+1];d[1]===e[1]&&(d[1]=e[1]=Math.round(d[1])-c%2/2);d[2]===e[2]&&(d[2]=e[2]=Math.round(d[2])+c%2/2)}return a};A(a,"afterHideCrosshair",function(){this.crossLabel&&(this.crossLabel=this.crossLabel.hide())});A(a,"afterDrawCrosshair",function(a){var c,b;if(this.crosshair&&
	this.crosshair.label&&this.crosshair.label.enabled&&this.cross&&J(this.min)&&J(this.max)){var d=this.chart,f=this.logarithmic,g=this.crosshair.label,h=this.horiz,k=this.opposite,m=this.left,n=this.top,p=this.crossLabel,q=g.format,t="",u="inside"===this.options.tickPosition,v=!1!==this.crosshair.snap,y=0,x=a.e||this.cross&&this.cross.e;a=a.point;var A=this.min,B=this.max;f&&(A=f.lin2log(A),B=f.lin2log(B));f=h?"center":k?"right"===this.labelAlign?"right":"left":"left"===this.labelAlign?"left":"center";
	p||(p=this.crossLabel=d.renderer.label("",0,void 0,g.shape||"callout").addClass("highcharts-crosshair-label highcharts-color-"+(a&&a.series?a.series.colorIndex:this.series[0]&&this.series[0].colorIndex)).attr({align:g.align||f,padding:w(g.padding,8),r:w(g.borderRadius,3),zIndex:2}).add(this.labelGroup),d.styledMode||p.attr({fill:g.backgroundColor||a&&a.series&&a.series.color||"#666666",stroke:g.borderColor||"","stroke-width":g.borderWidth||0}).css(G({color:"#ffffff",fontWeight:"normal",fontSize:"11px",
	textAlign:"center"},g.style||{})));h?(f=v?(a.plotX||0)+m:x.chartX,n+=k?0:this.height):(f=k?this.width+m:0,n=v?(a.plotY||0)+n:x.chartY);q||g.formatter||(this.dateTime&&(t="%b %d, %Y"),q="{value"+(t?":"+t:"")+"}");t=v?this.isXAxis?a.x:a.y:this.toValue(h?x.chartX:x.chartY);v=a&&a.series?a.series.isPointInside(a):J(t)&&t>A&&t<B;x="";q?x=l(q,{value:t},d):g.formatter&&J(t)&&(x=g.formatter.call(this,t));p.attr({text:x,x:f,y:n,visibility:v?"inherit":"hidden"});g=p.getBBox();if(J(p.y))if(h){if(u&&!k||!u&&
	k)n=p.y-g.height}else n=p.y-g.height/2;h?(c=m-g.x,b=m+this.width-g.x):(c="left"===this.labelAlign?m:0,b="right"===this.labelAlign?m+this.width:d.chartWidth);p.translateX<c&&(y=c-p.translateX);p.translateX+g.width>=b&&(y=-(p.translateX+g.width-b));p.attr({x:f+y,y:n,anchorX:h?f:this.opposite?0:d.chartWidth,anchorY:h?this.opposite?d.chartHeight:0:n+g.height/2})}});x.prototype.forceCropping=function(){var a=this.chart,c=this.options.dataGrouping;return!1!==this.allowDG&&c&&w(c.enabled,a.options.isStock)};
	A(q,"update",function(a){a=a.options;"scrollbar"in a&&this.navigator&&(t(!0,this.options.scrollbar,a.scrollbar),this.navigator.update({}),delete a.scrollbar)});return n});J(a,"masters/modules/stock.src.js",[a["Core/Globals.js"],a["Series/DataModifyComposition.js"],a["Stock/Navigator/Navigator.js"],a["Stock/RangeSelector/RangeSelector.js"],a["Stock/Scrollbar/Scrollbar.js"],a["Core/Axis/OrdinalAxis.js"],a["Series/OHLC/OHLCSeries.js"],a["Series/Flags/FlagsSeries.js"],a["Core/Chart/StockChart.js"]],function(a,
	q,A,E,B,C,F,x,u){a.Navigator=A;a.RangeSelector=E;a.Scrollbar=B;a.StockChart=a.stockChart=u.stockChart;q.compose(a.Series,a.Axis,a.Point);x.compose(a.Renderer);A.compose(a.Axis,a.Chart,a.Series);F.compose(a.Series);C.compose(a.Axis,a.Series,a.Chart);E.compose(a.Axis,a.Chart);B.compose(a.Axis)});J(a,"masters/highstock.src.js",[a["masters/highcharts.src.js"]],function(a){a.product="Highstock";return a});a["masters/highstock.src.js"]._modules=a;return a["masters/highstock.src.js"]});
	//# sourceMappingURL=highstock.js.map

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0cc812f8c2992bf06a8d19fa1936c897.png";

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fec058e4a0fab814bbe625c4483ed62.png";

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// m-irstock.e4ce594d371350707b7d.js